//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.17.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IDomenClient {
    dajSveDomene(naziv: string | null | undefined, skraceniNaziv: string | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfDomenResponse>;
    izmeniDomen(command: IzmeniDomenCommand): Observable<GenericActionResponseRP>;
    kreirajDomen(command: KreirajDomenCommand): Observable<GenericActionResponseRP>;
    obrisiDomen(command: ObrisiDomenCommand): Observable<GenericActionResponseRP>;
}

@Injectable({
    providedIn: 'root'
})
export class DomenClient implements IDomenClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:9112";
    }

    dajSveDomene(naziv: string | null | undefined, skraceniNaziv: string | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfDomenResponse> {
        let url_ = this.baseUrl + "/api/Domen/DajSveDomene?";
        if (naziv !== undefined && naziv !== null)
            url_ += "Naziv=" + encodeURIComponent("" + naziv) + "&";
        if (skraceniNaziv !== undefined && skraceniNaziv !== null)
            url_ += "SkraceniNaziv=" + encodeURIComponent("" + skraceniNaziv) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajSveDomene(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSveDomene(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfDomenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfDomenResponse>;
        }));
    }

    protected processDajSveDomene(response: HttpResponseBase): Observable<PagedResponseOfDomenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfDomenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfDomenResponse>(null as any);
    }

    izmeniDomen(command: IzmeniDomenCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Domen/IzmeniDomen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIzmeniDomen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIzmeniDomen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processIzmeniDomen(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    kreirajDomen(command: KreirajDomenCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Domen/KreirajDomen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKreirajDomen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKreirajDomen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processKreirajDomen(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    obrisiDomen(command: ObrisiDomenCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Domen/ObrisiDomen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObrisiDomen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObrisiDomen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processObrisiDomen(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }
}

export interface IElementPorukeClient {
    dajElementePoruke(sifraPoruke: string | null | undefined, verzija: string | null | undefined, vratitiDoOsnovnogTipa: boolean | undefined, vratitiSamoAktivneElemente: boolean | undefined): Observable<DajElementePorukeResponse>;
    dajElementePorukeZaStablo(idPoruke: number | undefined, vratitiSamoAktivneElemente: boolean | undefined): Observable<ElementPorukeZaStabloResponse[]>;
    dajElementePorukeZaListu(sifraPoruke: string | null | undefined, verzija: string | null | undefined, vratitiDoOsnovnogTipa: boolean | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<DajElementePorukeZaListuResponse>;
    sacuvajElementPoruke(command: SacuvajElementPorukeCommand): Observable<GenericActionResponseRP>;
    dajElementPorukeZaId(id: number | undefined): Observable<ElementPorukeZaIdResponse>;
    obrisiElementPoruke(command: ObrisiElementPorukeCommand): Observable<GenericActionResponseRP>;
    deaktivirajElementPoruke(command: DeaktivirajElementPorukeCommand): Observable<GenericActionResponseRP>;
    reaktivirajElementPoruke(command: ReaktivirajElementPorukeCommand): Observable<GenericActionResponseRP>;
    objaviElementePoruke(command: ObjaviElementePorukeCommand): Observable<GenericActionResponseRP>;
    sacuvajSvojstvaReferentnogPojmaKaoElementePoruke(command: SacuvajSvojstvaReferentnogPojmaKaoElementePorukeCommand): Observable<GenericActionResponseSE>;
    daLiPostojeElementiUPripremiZaIdPoruke(idPoruke: number | undefined): Observable<boolean>;
    zamenaRednihBrojevaElemenataPoruke(command: ZamenaRednihBrojevaElemenataPorukeCommand): Observable<GenericActionResponseSE>;
}

@Injectable({
    providedIn: 'root'
})
export class ElementPorukeClient implements IElementPorukeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:9112";
    }

    dajElementePoruke(sifraPoruke: string | null | undefined, verzija: string | null | undefined, vratitiDoOsnovnogTipa: boolean | undefined, vratitiSamoAktivneElemente: boolean | undefined): Observable<DajElementePorukeResponse> {
        let url_ = this.baseUrl + "/api/ElementPoruke/DajElementePoruke?";
        if (sifraPoruke !== undefined && sifraPoruke !== null)
            url_ += "SifraPoruke=" + encodeURIComponent("" + sifraPoruke) + "&";
        if (verzija !== undefined && verzija !== null)
            url_ += "Verzija=" + encodeURIComponent("" + verzija) + "&";
        if (vratitiDoOsnovnogTipa === null)
            throw new Error("The parameter 'vratitiDoOsnovnogTipa' cannot be null.");
        else if (vratitiDoOsnovnogTipa !== undefined)
            url_ += "VratitiDoOsnovnogTipa=" + encodeURIComponent("" + vratitiDoOsnovnogTipa) + "&";
        if (vratitiSamoAktivneElemente === null)
            throw new Error("The parameter 'vratitiSamoAktivneElemente' cannot be null.");
        else if (vratitiSamoAktivneElemente !== undefined)
            url_ += "VratitiSamoAktivneElemente=" + encodeURIComponent("" + vratitiSamoAktivneElemente) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajElementePoruke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajElementePoruke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajElementePorukeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajElementePorukeResponse>;
        }));
    }

    protected processDajElementePoruke(response: HttpResponseBase): Observable<DajElementePorukeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DajElementePorukeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajElementePorukeResponse>(null as any);
    }

    dajElementePorukeZaStablo(idPoruke: number | undefined, vratitiSamoAktivneElemente: boolean | undefined): Observable<ElementPorukeZaStabloResponse[]> {
        let url_ = this.baseUrl + "/api/ElementPoruke/DajElementePorukeZaStablo?";
        if (idPoruke === null)
            throw new Error("The parameter 'idPoruke' cannot be null.");
        else if (idPoruke !== undefined)
            url_ += "IdPoruke=" + encodeURIComponent("" + idPoruke) + "&";
        if (vratitiSamoAktivneElemente === null)
            throw new Error("The parameter 'vratitiSamoAktivneElemente' cannot be null.");
        else if (vratitiSamoAktivneElemente !== undefined)
            url_ += "VratitiSamoAktivneElemente=" + encodeURIComponent("" + vratitiSamoAktivneElemente) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajElementePorukeZaStablo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajElementePorukeZaStablo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementPorukeZaStabloResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementPorukeZaStabloResponse[]>;
        }));
    }

    protected processDajElementePorukeZaStablo(response: HttpResponseBase): Observable<ElementPorukeZaStabloResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ElementPorukeZaStabloResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElementPorukeZaStabloResponse[]>(null as any);
    }

    dajElementePorukeZaListu(sifraPoruke: string | null | undefined, verzija: string | null | undefined, vratitiDoOsnovnogTipa: boolean | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<DajElementePorukeZaListuResponse> {
        let url_ = this.baseUrl + "/api/ElementPoruke/DajElementePorukeZaListu?";
        if (sifraPoruke !== undefined && sifraPoruke !== null)
            url_ += "SifraPoruke=" + encodeURIComponent("" + sifraPoruke) + "&";
        if (verzija !== undefined && verzija !== null)
            url_ += "Verzija=" + encodeURIComponent("" + verzija) + "&";
        if (vratitiDoOsnovnogTipa === null)
            throw new Error("The parameter 'vratitiDoOsnovnogTipa' cannot be null.");
        else if (vratitiDoOsnovnogTipa !== undefined)
            url_ += "VratitiDoOsnovnogTipa=" + encodeURIComponent("" + vratitiDoOsnovnogTipa) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajElementePorukeZaListu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajElementePorukeZaListu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajElementePorukeZaListuResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajElementePorukeZaListuResponse>;
        }));
    }

    protected processDajElementePorukeZaListu(response: HttpResponseBase): Observable<DajElementePorukeZaListuResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DajElementePorukeZaListuResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajElementePorukeZaListuResponse>(null as any);
    }

    sacuvajElementPoruke(command: SacuvajElementPorukeCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/ElementPoruke/SacuvajElementPoruke";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSacuvajElementPoruke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSacuvajElementPoruke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processSacuvajElementPoruke(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    dajElementPorukeZaId(id: number | undefined): Observable<ElementPorukeZaIdResponse> {
        let url_ = this.baseUrl + "/api/ElementPoruke/DajElementPorukeZaId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajElementPorukeZaId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajElementPorukeZaId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementPorukeZaIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementPorukeZaIdResponse>;
        }));
    }

    protected processDajElementPorukeZaId(response: HttpResponseBase): Observable<ElementPorukeZaIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElementPorukeZaIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElementPorukeZaIdResponse>(null as any);
    }

    obrisiElementPoruke(command: ObrisiElementPorukeCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/ElementPoruke/ObrisiElementPoruke";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObrisiElementPoruke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObrisiElementPoruke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processObrisiElementPoruke(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    deaktivirajElementPoruke(command: DeaktivirajElementPorukeCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/ElementPoruke/DeaktivirajElementPoruke";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeaktivirajElementPoruke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeaktivirajElementPoruke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processDeaktivirajElementPoruke(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    reaktivirajElementPoruke(command: ReaktivirajElementPorukeCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/ElementPoruke/ReaktivirajElementPoruke";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReaktivirajElementPoruke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReaktivirajElementPoruke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processReaktivirajElementPoruke(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    objaviElementePoruke(command: ObjaviElementePorukeCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/ElementPoruke/ObjaviElementePoruke";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObjaviElementePoruke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObjaviElementePoruke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processObjaviElementePoruke(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    sacuvajSvojstvaReferentnogPojmaKaoElementePoruke(command: SacuvajSvojstvaReferentnogPojmaKaoElementePorukeCommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/ElementPoruke/SacuvajSvojstvaReferentnogPojmaKaoElementePoruke";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSacuvajSvojstvaReferentnogPojmaKaoElementePoruke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSacuvajSvojstvaReferentnogPojmaKaoElementePoruke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processSacuvajSvojstvaReferentnogPojmaKaoElementePoruke(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }

    daLiPostojeElementiUPripremiZaIdPoruke(idPoruke: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ElementPoruke/DaLiPostojeElementiUPripremiZaIdPoruke?";
        if (idPoruke === null)
            throw new Error("The parameter 'idPoruke' cannot be null.");
        else if (idPoruke !== undefined)
            url_ += "IdPoruke=" + encodeURIComponent("" + idPoruke) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDaLiPostojeElementiUPripremiZaIdPoruke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDaLiPostojeElementiUPripremiZaIdPoruke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDaLiPostojeElementiUPripremiZaIdPoruke(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    zamenaRednihBrojevaElemenataPoruke(command: ZamenaRednihBrojevaElemenataPorukeCommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/ElementPoruke/ZamenaRednihBrojevaElemenataPoruke";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processZamenaRednihBrojevaElemenataPoruke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processZamenaRednihBrojevaElemenataPoruke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processZamenaRednihBrojevaElemenataPoruke(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }
}

export interface IIzvozPorukaClient {
    dajJsonPorukeZaPorukaId(porukaId: number): Observable<string>;
    dajJsonSchemuPorukeZaPorukaId(porukaId: number): Observable<string>;
    dajXmlPorukeZaPorukaId(porukaId: number): Observable<string>;
    dajXsdSemuPorukeZaPorukaId(porukaId: number): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class IzvozPorukaClient implements IIzvozPorukaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:9112";
    }

    dajJsonPorukeZaPorukaId(porukaId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/IzvozPoruka/DefinicijaPorukeJson/{porukaId}";
        if (porukaId === undefined || porukaId === null)
            throw new Error("The parameter 'porukaId' must be defined.");
        url_ = url_.replace("{porukaId}", encodeURIComponent("" + porukaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajJsonPorukeZaPorukaId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajJsonPorukeZaPorukaId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDajJsonPorukeZaPorukaId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    dajJsonSchemuPorukeZaPorukaId(porukaId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/IzvozPoruka/DefinicijaPorukeJsonSema/{porukaId}";
        if (porukaId === undefined || porukaId === null)
            throw new Error("The parameter 'porukaId' must be defined.");
        url_ = url_.replace("{porukaId}", encodeURIComponent("" + porukaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajJsonSchemuPorukeZaPorukaId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajJsonSchemuPorukeZaPorukaId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDajJsonSchemuPorukeZaPorukaId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    dajXmlPorukeZaPorukaId(porukaId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/IzvozPoruka/DefinicijaPorukeXml/{porukaId}";
        if (porukaId === undefined || porukaId === null)
            throw new Error("The parameter 'porukaId' must be defined.");
        url_ = url_.replace("{porukaId}", encodeURIComponent("" + porukaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajXmlPorukeZaPorukaId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajXmlPorukeZaPorukaId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDajXmlPorukeZaPorukaId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    dajXsdSemuPorukeZaPorukaId(porukaId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/IzvozPoruka/DefinicijaPorukeXsdSema/{porukaId}";
        if (porukaId === undefined || porukaId === null)
            throw new Error("The parameter 'porukaId' must be defined.");
        url_ = url_.replace("{porukaId}", encodeURIComponent("" + porukaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajXsdSemuPorukeZaPorukaId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajXsdSemuPorukeZaPorukaId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDajXsdSemuPorukeZaPorukaId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

export interface IKlasifikacijeClient {
    pretragaKlasifikacija(naziv: string | null | undefined, opis: string | null | undefined, statusSifre: string[] | null | undefined, nadredjenaKlasifikacijaId: number | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfKlasifikacijaResponse>;
    dajKlasifikacijeZaListu(query: DajKlasifikacijeZaListuQuery | null | undefined): Observable<KlasifikacijaResponse[]>;
    dajKlasifikacijeZaStablo(sifraKlasifikacije: string | null | undefined): Observable<KlasifikacijaResponse[]>;
    sacuvajKlasifikaciju(command: SacuvajKlasifikacijuCommand): Observable<GenericActionResponseSE>;
    dajKlasifikacijuPoSifri(sifra: string | null | undefined): Observable<KlasifikacijaResponse>;
    obrisiKlasifikaciju(command: ObrisiKlasifikacijuCommand): Observable<GenericActionResponseSE>;
}

@Injectable({
    providedIn: 'root'
})
export class KlasifikacijeClient implements IKlasifikacijeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:9112";
    }

    pretragaKlasifikacija(naziv: string | null | undefined, opis: string | null | undefined, statusSifre: string[] | null | undefined, nadredjenaKlasifikacijaId: number | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfKlasifikacijaResponse> {
        let url_ = this.baseUrl + "/api/Klasifikacije/PretragaKlasifikacija?";
        if (naziv !== undefined && naziv !== null)
            url_ += "Naziv=" + encodeURIComponent("" + naziv) + "&";
        if (opis !== undefined && opis !== null)
            url_ += "Opis=" + encodeURIComponent("" + opis) + "&";
        if (statusSifre !== undefined && statusSifre !== null)
            statusSifre && statusSifre.forEach(item => { url_ += "StatusSifre=" + encodeURIComponent("" + item) + "&"; });
        if (nadredjenaKlasifikacijaId !== undefined && nadredjenaKlasifikacijaId !== null)
            url_ += "NadredjenaKlasifikacijaId=" + encodeURIComponent("" + nadredjenaKlasifikacijaId) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPretragaKlasifikacija(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPretragaKlasifikacija(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfKlasifikacijaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfKlasifikacijaResponse>;
        }));
    }

    protected processPretragaKlasifikacija(response: HttpResponseBase): Observable<PagedResponseOfKlasifikacijaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfKlasifikacijaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfKlasifikacijaResponse>(null as any);
    }

    dajKlasifikacijeZaListu(query: DajKlasifikacijeZaListuQuery | null | undefined): Observable<KlasifikacijaResponse[]> {
        let url_ = this.baseUrl + "/api/Klasifikacije/DajKlasifikacijeZaListu?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajKlasifikacijeZaListu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajKlasifikacijeZaListu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KlasifikacijaResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KlasifikacijaResponse[]>;
        }));
    }

    protected processDajKlasifikacijeZaListu(response: HttpResponseBase): Observable<KlasifikacijaResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KlasifikacijaResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<KlasifikacijaResponse[]>(null as any);
    }

    dajKlasifikacijeZaStablo(sifraKlasifikacije: string | null | undefined): Observable<KlasifikacijaResponse[]> {
        let url_ = this.baseUrl + "/api/Klasifikacije/DajKlasifikacijeZaStablo?";
        if (sifraKlasifikacije !== undefined && sifraKlasifikacije !== null)
            url_ += "SifraKlasifikacije=" + encodeURIComponent("" + sifraKlasifikacije) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajKlasifikacijeZaStablo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajKlasifikacijeZaStablo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KlasifikacijaResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KlasifikacijaResponse[]>;
        }));
    }

    protected processDajKlasifikacijeZaStablo(response: HttpResponseBase): Observable<KlasifikacijaResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KlasifikacijaResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<KlasifikacijaResponse[]>(null as any);
    }

    sacuvajKlasifikaciju(command: SacuvajKlasifikacijuCommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/Klasifikacije";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSacuvajKlasifikaciju(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSacuvajKlasifikaciju(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processSacuvajKlasifikaciju(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }

    dajKlasifikacijuPoSifri(sifra: string | null | undefined): Observable<KlasifikacijaResponse> {
        let url_ = this.baseUrl + "/api/Klasifikacije/DajKlasifikacijuPoSifri?";
        if (sifra !== undefined && sifra !== null)
            url_ += "Sifra=" + encodeURIComponent("" + sifra) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajKlasifikacijuPoSifri(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajKlasifikacijuPoSifri(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KlasifikacijaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KlasifikacijaResponse>;
        }));
    }

    protected processDajKlasifikacijuPoSifri(response: HttpResponseBase): Observable<KlasifikacijaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KlasifikacijaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<KlasifikacijaResponse>(null as any);
    }

    obrisiKlasifikaciju(command: ObrisiKlasifikacijuCommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/Klasifikacije/ObrisiKlasifikaciju";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObrisiKlasifikaciju(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObrisiKlasifikaciju(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processObrisiKlasifikaciju(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }
}

export interface IOgranicenjeClient {
    snimiOgranicenjeProstogPojma(command: SnimiOgranicenjeProstogPojmaCommand): Observable<GenericActionResponseRP>;
    vratiListuOgranicenjaZaIdPojma(idPojma: number | undefined): Observable<OgranicenjePojmaResponse[]>;
    obrisiOgranicenje(command: ObrisiOgranicenjePojmaCommand): Observable<GenericActionResponseRP>;
    izmeniOgranicenje(command: IzmeniOgranicenjeCommand): Observable<GenericActionResponseRP>;
}

@Injectable({
    providedIn: 'root'
})
export class OgranicenjeClient implements IOgranicenjeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:9112";
    }

    snimiOgranicenjeProstogPojma(command: SnimiOgranicenjeProstogPojmaCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Ogranicenje/SnimiOgranicenjeProstogPojma";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSnimiOgranicenjeProstogPojma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSnimiOgranicenjeProstogPojma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processSnimiOgranicenjeProstogPojma(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    vratiListuOgranicenjaZaIdPojma(idPojma: number | undefined): Observable<OgranicenjePojmaResponse[]> {
        let url_ = this.baseUrl + "/api/Ogranicenje/VratiListuOgranicenjaZaIdPojma?";
        if (idPojma === null)
            throw new Error("The parameter 'idPojma' cannot be null.");
        else if (idPojma !== undefined)
            url_ += "IdPojma=" + encodeURIComponent("" + idPojma) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVratiListuOgranicenjaZaIdPojma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVratiListuOgranicenjaZaIdPojma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OgranicenjePojmaResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OgranicenjePojmaResponse[]>;
        }));
    }

    protected processVratiListuOgranicenjaZaIdPojma(response: HttpResponseBase): Observable<OgranicenjePojmaResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OgranicenjePojmaResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OgranicenjePojmaResponse[]>(null as any);
    }

    obrisiOgranicenje(command: ObrisiOgranicenjePojmaCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Ogranicenje/ObrisiOgranicenje";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObrisiOgranicenje(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObrisiOgranicenje(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processObrisiOgranicenje(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    izmeniOgranicenje(command: IzmeniOgranicenjeCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Ogranicenje/IzmeniOgranicenje";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIzmeniOgranicenje(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIzmeniOgranicenje(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processIzmeniOgranicenje(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }
}

export interface IPojamClient {
    sacuvajPojam(command: SacuvajPojamCommand): Observable<GenericActionResponseRP>;
    pretraziRecnikPojmova(jeSlozen: boolean | null | undefined, neiskorisceni: boolean | undefined, ogranicenjeSifarnikom: number[] | null | undefined, definicija: string | null | undefined, domenId: number | null | undefined, nazivPojma: string | null | undefined, kljucnaRec: string | null | undefined, sifraEvidencije: string | null | undefined, statusi: string[] | null | undefined, vrstaPojma: boolean | null | undefined, sifraIzabranogPojmaZaSlozeni: string | null | undefined, vrsteTipa: number[] | null | undefined, osnovniPojamId: number | null | undefined, jeSifarnickiPojam: boolean | null | undefined, skupVrednostiOgranicenSifarnikom: boolean | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfPretragaPojmovaResponse>;
    dajPojamPoSifri(sifra: string | null | undefined, verzija: string | null | undefined): Observable<DajPojamPoSifriResponse>;
    dajPojamZaId(pojamId: number | undefined): Observable<DajPojamZaIdResponse>;
    dajSveIzvedeneTipove(id: number | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfVezanEntitetResponse>;
    dajSveIzvedenePojmoveIzIdPojma(id: number | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfVezanEntitetResponse>;
    dajSvaSvojstvaGdeJeSvojstvoTipa(id: number | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfVezanEntitetResponse>;
    dajPojmoveZaStatuse(statusi: string[] | null | undefined): Observable<DajSvePojmovePoStatusuResponse>;
    obrisiPojam(command: ObrisiPojamCommand): Observable<GenericActionResponseRP>;
    objaviPojam(command: ObjaviPojamCommand): Observable<GenericActionResponseRP>;
    kreirajNovuVerzijuPojma(command: NapraviNovuVerzijuPojmaCommand): Observable<GenericActionResponseRP>;
    dajSveVerzijePojma(sifra: string | null | undefined): Observable<DajSveVerzijePojmaResponse>;
    pretragaPojmovaUpisanihURecnik(domenId: number | null | undefined, nazivPojma: string | null | undefined, definicijaPojma: string | null | undefined, skupVrednostiOgranicen: number[] | null | undefined, pojamSeKoristiKaoReferentniUEvidenciji: boolean | null | undefined, evidencijaId: number | null | undefined, kljucnaRec: string | null | undefined, ogranicenjeSifarnikom: number[] | null | undefined, sifraEvidencije: string | null | undefined, vrsteTipa: number[] | null | undefined, daLiPrikazivatiAsocijacije: boolean | undefined, izvedenIzId: number | null | undefined, jeZaSuzenje: boolean | null | undefined, jeSifarnickiPojam: boolean | null | undefined, jeTipZaSifarnickiPojam: boolean | null | undefined, tipId: number | null | undefined, pojamId: number | null | undefined, jeZavisan: boolean | null | undefined, daLiTrebaIzvedenIzPoDubini: boolean | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfPretragaPojmovaUpisanihURecnikResponse>;
    vratiPojamUpisanURecnikZaId(id: number | undefined): Observable<PretragaPojmovaUpisanihURecnikResponse>;
    deaktivirajPojam(command: DeaktivirajPojamCommand): Observable<GenericActionResponseRP>;
    reaktivirajPojam(command: ReaktivirajPojamCommand): Observable<GenericActionResponseRP>;
    daLiJePojamObjavljen(idPojma: number | undefined): Observable<GenericActionResponseRP>;
    izvozPojmovaUExcel(lang: string | null | undefined, jeSlozen: boolean | null | undefined, neiskorisceni: boolean | undefined, ogranicenjeSifarnikom: number | null | undefined, domenId: number | null | undefined, nazivPojma: string | null | undefined, kljucnaRec: string | null | undefined, sifraEvidencije: string | null | undefined, statusi: string[] | null | undefined, vrstaPojma: boolean | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<string>;
    izvozOdobrenihPojmovaUExcel(lang: string | null | undefined, domenId: number | null | undefined, nazivPojma: string | null | undefined, skupVrednostiOgranicen: number[] | null | undefined, kljucnaRec: string | null | undefined, sifraEvidencije: string | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<string>;
    daLiPostojiVerzijaOvogPojmaSaStatusom(sifraPojma: string | null | undefined, statusId: number | undefined): Observable<boolean>;
    dajPojamZaPovezivanjeSaElementom(sifra: string | null | undefined): Observable<DajPojamZaPovezivanjeSaElementomQueryResponse>;
    dajPojmoveZaPreuzimanjeSvojstvaIzReferentnogPojma(id: number | undefined): Observable<DajPojmoveZaPreuzimanjeSvojstvaIzReferentnogPojmaResponse>;
    dajSifarnickuEvidencijuIElement(id: number | undefined): Observable<PojamOgranicenjeSifarnikomResponse>;
    dovuciPojmoveKojiImajuTipKaoSvojeSvojstvo(idTipa: number | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfIzvedenPojamResponse>;
    daLiSuIspunjeniUsloviZaKreiranjeSifarnika(sifraPojma: string | null | undefined): Observable<GenericActionResponseRP>;
    dajSifarnikIElementCijiJePoslovniTipKvalifikator(poslovniTipId: number | undefined): Observable<SifarnikIElementCijiJePoslovniTipKvalifikatorResponse>;
    vratiPoslovniTipZaElementEvidencije(elementId: number | undefined): Observable<VratiPoslovniTipZaElementEvidencijeResponse>;
    klonirajPojam(command: KlonirajPojamCommand): Observable<GenericActionResponseRP>;
    dajTipZaUcitavanjePodstabla(sifra: string | null | undefined): Observable<DajTipZaUcitavanjePodstablaResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class PojamClient implements IPojamClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:9112";
    }

    sacuvajPojam(command: SacuvajPojamCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Pojam/SacuvajPojam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSacuvajPojam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSacuvajPojam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processSacuvajPojam(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    pretraziRecnikPojmova(jeSlozen: boolean | null | undefined, neiskorisceni: boolean | undefined, ogranicenjeSifarnikom: number[] | null | undefined, definicija: string | null | undefined, domenId: number | null | undefined, nazivPojma: string | null | undefined, kljucnaRec: string | null | undefined, sifraEvidencije: string | null | undefined, statusi: string[] | null | undefined, vrstaPojma: boolean | null | undefined, sifraIzabranogPojmaZaSlozeni: string | null | undefined, vrsteTipa: number[] | null | undefined, osnovniPojamId: number | null | undefined, jeSifarnickiPojam: boolean | null | undefined, skupVrednostiOgranicenSifarnikom: boolean | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfPretragaPojmovaResponse> {
        let url_ = this.baseUrl + "/api/Pojam/PretragaPojmova?";
        if (jeSlozen !== undefined && jeSlozen !== null)
            url_ += "JeSlozen=" + encodeURIComponent("" + jeSlozen) + "&";
        if (neiskorisceni === null)
            throw new Error("The parameter 'neiskorisceni' cannot be null.");
        else if (neiskorisceni !== undefined)
            url_ += "Neiskorisceni=" + encodeURIComponent("" + neiskorisceni) + "&";
        if (ogranicenjeSifarnikom !== undefined && ogranicenjeSifarnikom !== null)
            ogranicenjeSifarnikom && ogranicenjeSifarnikom.forEach(item => { url_ += "OgranicenjeSifarnikom=" + encodeURIComponent("" + item) + "&"; });
        if (definicija !== undefined && definicija !== null)
            url_ += "Definicija=" + encodeURIComponent("" + definicija) + "&";
        if (domenId !== undefined && domenId !== null)
            url_ += "DomenId=" + encodeURIComponent("" + domenId) + "&";
        if (nazivPojma !== undefined && nazivPojma !== null)
            url_ += "NazivPojma=" + encodeURIComponent("" + nazivPojma) + "&";
        if (kljucnaRec !== undefined && kljucnaRec !== null)
            url_ += "KljucnaRec=" + encodeURIComponent("" + kljucnaRec) + "&";
        if (sifraEvidencije !== undefined && sifraEvidencije !== null)
            url_ += "SifraEvidencije=" + encodeURIComponent("" + sifraEvidencije) + "&";
        if (statusi !== undefined && statusi !== null)
            statusi && statusi.forEach(item => { url_ += "Statusi=" + encodeURIComponent("" + item) + "&"; });
        if (vrstaPojma !== undefined && vrstaPojma !== null)
            url_ += "VrstaPojma=" + encodeURIComponent("" + vrstaPojma) + "&";
        if (sifraIzabranogPojmaZaSlozeni !== undefined && sifraIzabranogPojmaZaSlozeni !== null)
            url_ += "SifraIzabranogPojmaZaSlozeni=" + encodeURIComponent("" + sifraIzabranogPojmaZaSlozeni) + "&";
        if (vrsteTipa !== undefined && vrsteTipa !== null)
            vrsteTipa && vrsteTipa.forEach(item => { url_ += "VrsteTipa=" + encodeURIComponent("" + item) + "&"; });
        if (osnovniPojamId !== undefined && osnovniPojamId !== null)
            url_ += "OsnovniPojamId=" + encodeURIComponent("" + osnovniPojamId) + "&";
        if (jeSifarnickiPojam !== undefined && jeSifarnickiPojam !== null)
            url_ += "JeSifarnickiPojam=" + encodeURIComponent("" + jeSifarnickiPojam) + "&";
        if (skupVrednostiOgranicenSifarnikom !== undefined && skupVrednostiOgranicenSifarnikom !== null)
            url_ += "SkupVrednostiOgranicenSifarnikom=" + encodeURIComponent("" + skupVrednostiOgranicenSifarnikom) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPretraziRecnikPojmova(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPretraziRecnikPojmova(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfPretragaPojmovaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfPretragaPojmovaResponse>;
        }));
    }

    protected processPretraziRecnikPojmova(response: HttpResponseBase): Observable<PagedResponseOfPretragaPojmovaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfPretragaPojmovaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfPretragaPojmovaResponse>(null as any);
    }

    dajPojamPoSifri(sifra: string | null | undefined, verzija: string | null | undefined): Observable<DajPojamPoSifriResponse> {
        let url_ = this.baseUrl + "/api/Pojam/DajPojamPoSifri?";
        if (sifra !== undefined && sifra !== null)
            url_ += "Sifra=" + encodeURIComponent("" + sifra) + "&";
        if (verzija !== undefined && verzija !== null)
            url_ += "Verzija=" + encodeURIComponent("" + verzija) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajPojamPoSifri(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajPojamPoSifri(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajPojamPoSifriResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajPojamPoSifriResponse>;
        }));
    }

    protected processDajPojamPoSifri(response: HttpResponseBase): Observable<DajPojamPoSifriResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DajPojamPoSifriResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajPojamPoSifriResponse>(null as any);
    }

    dajPojamZaId(pojamId: number | undefined): Observable<DajPojamZaIdResponse> {
        let url_ = this.baseUrl + "/api/Pojam/DajPojamZaId?";
        if (pojamId === null)
            throw new Error("The parameter 'pojamId' cannot be null.");
        else if (pojamId !== undefined)
            url_ += "PojamId=" + encodeURIComponent("" + pojamId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajPojamZaId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajPojamZaId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajPojamZaIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajPojamZaIdResponse>;
        }));
    }

    protected processDajPojamZaId(response: HttpResponseBase): Observable<DajPojamZaIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DajPojamZaIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajPojamZaIdResponse>(null as any);
    }

    dajSveIzvedeneTipove(id: number | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfVezanEntitetResponse> {
        let url_ = this.baseUrl + "/api/Pojam/DajSveIzvedeneTipove?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajSveIzvedeneTipove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSveIzvedeneTipove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfVezanEntitetResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfVezanEntitetResponse>;
        }));
    }

    protected processDajSveIzvedeneTipove(response: HttpResponseBase): Observable<PagedResponseOfVezanEntitetResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfVezanEntitetResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfVezanEntitetResponse>(null as any);
    }

    dajSveIzvedenePojmoveIzIdPojma(id: number | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfVezanEntitetResponse> {
        let url_ = this.baseUrl + "/api/Pojam/DajSveIzvedenePojmoveIzIdPojma?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajSveIzvedenePojmoveIzIdPojma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSveIzvedenePojmoveIzIdPojma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfVezanEntitetResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfVezanEntitetResponse>;
        }));
    }

    protected processDajSveIzvedenePojmoveIzIdPojma(response: HttpResponseBase): Observable<PagedResponseOfVezanEntitetResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfVezanEntitetResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfVezanEntitetResponse>(null as any);
    }

    dajSvaSvojstvaGdeJeSvojstvoTipa(id: number | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfVezanEntitetResponse> {
        let url_ = this.baseUrl + "/api/Pojam/DajSvaSvojstvaGdeJeSvojstvoTipa?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajSvaSvojstvaGdeJeSvojstvoTipa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSvaSvojstvaGdeJeSvojstvoTipa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfVezanEntitetResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfVezanEntitetResponse>;
        }));
    }

    protected processDajSvaSvojstvaGdeJeSvojstvoTipa(response: HttpResponseBase): Observable<PagedResponseOfVezanEntitetResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfVezanEntitetResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfVezanEntitetResponse>(null as any);
    }

    dajPojmoveZaStatuse(statusi: string[] | null | undefined): Observable<DajSvePojmovePoStatusuResponse> {
        let url_ = this.baseUrl + "/api/Pojam/DajSvePojmoveZaStatuse?";
        if (statusi !== undefined && statusi !== null)
            statusi && statusi.forEach(item => { url_ += "Statusi=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajPojmoveZaStatuse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajPojmoveZaStatuse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajSvePojmovePoStatusuResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajSvePojmovePoStatusuResponse>;
        }));
    }

    protected processDajPojmoveZaStatuse(response: HttpResponseBase): Observable<DajSvePojmovePoStatusuResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DajSvePojmovePoStatusuResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajSvePojmovePoStatusuResponse>(null as any);
    }

    obrisiPojam(command: ObrisiPojamCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Pojam/ObrisiPojam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObrisiPojam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObrisiPojam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processObrisiPojam(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    objaviPojam(command: ObjaviPojamCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Pojam/ObjaviPojam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObjaviPojam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObjaviPojam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processObjaviPojam(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    kreirajNovuVerzijuPojma(command: NapraviNovuVerzijuPojmaCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Pojam/KreirajNovuVerzijuPojma";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKreirajNovuVerzijuPojma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKreirajNovuVerzijuPojma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processKreirajNovuVerzijuPojma(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    dajSveVerzijePojma(sifra: string | null | undefined): Observable<DajSveVerzijePojmaResponse> {
        let url_ = this.baseUrl + "/api/Pojam/DajSveVerzijePojma?";
        if (sifra !== undefined && sifra !== null)
            url_ += "Sifra=" + encodeURIComponent("" + sifra) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajSveVerzijePojma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSveVerzijePojma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajSveVerzijePojmaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajSveVerzijePojmaResponse>;
        }));
    }

    protected processDajSveVerzijePojma(response: HttpResponseBase): Observable<DajSveVerzijePojmaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DajSveVerzijePojmaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajSveVerzijePojmaResponse>(null as any);
    }

    pretragaPojmovaUpisanihURecnik(domenId: number | null | undefined, nazivPojma: string | null | undefined, definicijaPojma: string | null | undefined, skupVrednostiOgranicen: number[] | null | undefined, pojamSeKoristiKaoReferentniUEvidenciji: boolean | null | undefined, evidencijaId: number | null | undefined, kljucnaRec: string | null | undefined, ogranicenjeSifarnikom: number[] | null | undefined, sifraEvidencije: string | null | undefined, vrsteTipa: number[] | null | undefined, daLiPrikazivatiAsocijacije: boolean | undefined, izvedenIzId: number | null | undefined, jeZaSuzenje: boolean | null | undefined, jeSifarnickiPojam: boolean | null | undefined, jeTipZaSifarnickiPojam: boolean | null | undefined, tipId: number | null | undefined, pojamId: number | null | undefined, jeZavisan: boolean | null | undefined, daLiTrebaIzvedenIzPoDubini: boolean | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfPretragaPojmovaUpisanihURecnikResponse> {
        let url_ = this.baseUrl + "/api/Pojam/PretragaPojmovaUpisanihURecnik?";
        if (domenId !== undefined && domenId !== null)
            url_ += "DomenId=" + encodeURIComponent("" + domenId) + "&";
        if (nazivPojma !== undefined && nazivPojma !== null)
            url_ += "NazivPojma=" + encodeURIComponent("" + nazivPojma) + "&";
        if (definicijaPojma !== undefined && definicijaPojma !== null)
            url_ += "DefinicijaPojma=" + encodeURIComponent("" + definicijaPojma) + "&";
        if (skupVrednostiOgranicen !== undefined && skupVrednostiOgranicen !== null)
            skupVrednostiOgranicen && skupVrednostiOgranicen.forEach(item => { url_ += "SkupVrednostiOgranicen=" + encodeURIComponent("" + item) + "&"; });
        if (pojamSeKoristiKaoReferentniUEvidenciji !== undefined && pojamSeKoristiKaoReferentniUEvidenciji !== null)
            url_ += "PojamSeKoristiKaoReferentniUEvidenciji=" + encodeURIComponent("" + pojamSeKoristiKaoReferentniUEvidenciji) + "&";
        if (evidencijaId !== undefined && evidencijaId !== null)
            url_ += "EvidencijaId=" + encodeURIComponent("" + evidencijaId) + "&";
        if (kljucnaRec !== undefined && kljucnaRec !== null)
            url_ += "KljucnaRec=" + encodeURIComponent("" + kljucnaRec) + "&";
        if (ogranicenjeSifarnikom !== undefined && ogranicenjeSifarnikom !== null)
            ogranicenjeSifarnikom && ogranicenjeSifarnikom.forEach(item => { url_ += "OgranicenjeSifarnikom=" + encodeURIComponent("" + item) + "&"; });
        if (sifraEvidencije !== undefined && sifraEvidencije !== null)
            url_ += "SifraEvidencije=" + encodeURIComponent("" + sifraEvidencije) + "&";
        if (vrsteTipa !== undefined && vrsteTipa !== null)
            vrsteTipa && vrsteTipa.forEach(item => { url_ += "VrsteTipa=" + encodeURIComponent("" + item) + "&"; });
        if (daLiPrikazivatiAsocijacije === null)
            throw new Error("The parameter 'daLiPrikazivatiAsocijacije' cannot be null.");
        else if (daLiPrikazivatiAsocijacije !== undefined)
            url_ += "DaLiPrikazivatiAsocijacije=" + encodeURIComponent("" + daLiPrikazivatiAsocijacije) + "&";
        if (izvedenIzId !== undefined && izvedenIzId !== null)
            url_ += "IzvedenIzId=" + encodeURIComponent("" + izvedenIzId) + "&";
        if (jeZaSuzenje !== undefined && jeZaSuzenje !== null)
            url_ += "JeZaSuzenje=" + encodeURIComponent("" + jeZaSuzenje) + "&";
        if (jeSifarnickiPojam !== undefined && jeSifarnickiPojam !== null)
            url_ += "JeSifarnickiPojam=" + encodeURIComponent("" + jeSifarnickiPojam) + "&";
        if (jeTipZaSifarnickiPojam !== undefined && jeTipZaSifarnickiPojam !== null)
            url_ += "JeTipZaSifarnickiPojam=" + encodeURIComponent("" + jeTipZaSifarnickiPojam) + "&";
        if (tipId !== undefined && tipId !== null)
            url_ += "TipId=" + encodeURIComponent("" + tipId) + "&";
        if (pojamId !== undefined && pojamId !== null)
            url_ += "PojamId=" + encodeURIComponent("" + pojamId) + "&";
        if (jeZavisan !== undefined && jeZavisan !== null)
            url_ += "JeZavisan=" + encodeURIComponent("" + jeZavisan) + "&";
        if (daLiTrebaIzvedenIzPoDubini !== undefined && daLiTrebaIzvedenIzPoDubini !== null)
            url_ += "DaLiTrebaIzvedenIzPoDubini=" + encodeURIComponent("" + daLiTrebaIzvedenIzPoDubini) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPretragaPojmovaUpisanihURecnik(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPretragaPojmovaUpisanihURecnik(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfPretragaPojmovaUpisanihURecnikResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfPretragaPojmovaUpisanihURecnikResponse>;
        }));
    }

    protected processPretragaPojmovaUpisanihURecnik(response: HttpResponseBase): Observable<PagedResponseOfPretragaPojmovaUpisanihURecnikResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfPretragaPojmovaUpisanihURecnikResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfPretragaPojmovaUpisanihURecnikResponse>(null as any);
    }

    vratiPojamUpisanURecnikZaId(id: number | undefined): Observable<PretragaPojmovaUpisanihURecnikResponse> {
        let url_ = this.baseUrl + "/api/Pojam/VratiPojamUpisanURecnikZaId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVratiPojamUpisanURecnikZaId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVratiPojamUpisanURecnikZaId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PretragaPojmovaUpisanihURecnikResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PretragaPojmovaUpisanihURecnikResponse>;
        }));
    }

    protected processVratiPojamUpisanURecnikZaId(response: HttpResponseBase): Observable<PretragaPojmovaUpisanihURecnikResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PretragaPojmovaUpisanihURecnikResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PretragaPojmovaUpisanihURecnikResponse>(null as any);
    }

    deaktivirajPojam(command: DeaktivirajPojamCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Pojam/DeaktivirajPojam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeaktivirajPojam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeaktivirajPojam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processDeaktivirajPojam(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    reaktivirajPojam(command: ReaktivirajPojamCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Pojam/ReaktivirajPojam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReaktivirajPojam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReaktivirajPojam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processReaktivirajPojam(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    daLiJePojamObjavljen(idPojma: number | undefined): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Pojam/DaLiJePojamObjavljen?";
        if (idPojma === null)
            throw new Error("The parameter 'idPojma' cannot be null.");
        else if (idPojma !== undefined)
            url_ += "IdPojma=" + encodeURIComponent("" + idPojma) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDaLiJePojamObjavljen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDaLiJePojamObjavljen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processDaLiJePojamObjavljen(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    izvozPojmovaUExcel(lang: string | null | undefined, jeSlozen: boolean | null | undefined, neiskorisceni: boolean | undefined, ogranicenjeSifarnikom: number | null | undefined, domenId: number | null | undefined, nazivPojma: string | null | undefined, kljucnaRec: string | null | undefined, sifraEvidencije: string | null | undefined, statusi: string[] | null | undefined, vrstaPojma: boolean | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Pojam/IzvozPojmovaUExcel?";
        if (lang !== undefined && lang !== null)
            url_ += "Lang=" + encodeURIComponent("" + lang) + "&";
        if (jeSlozen !== undefined && jeSlozen !== null)
            url_ += "JeSlozen=" + encodeURIComponent("" + jeSlozen) + "&";
        if (neiskorisceni === null)
            throw new Error("The parameter 'neiskorisceni' cannot be null.");
        else if (neiskorisceni !== undefined)
            url_ += "Neiskorisceni=" + encodeURIComponent("" + neiskorisceni) + "&";
        if (ogranicenjeSifarnikom !== undefined && ogranicenjeSifarnikom !== null)
            url_ += "OgranicenjeSifarnikom=" + encodeURIComponent("" + ogranicenjeSifarnikom) + "&";
        if (domenId !== undefined && domenId !== null)
            url_ += "DomenId=" + encodeURIComponent("" + domenId) + "&";
        if (nazivPojma !== undefined && nazivPojma !== null)
            url_ += "NazivPojma=" + encodeURIComponent("" + nazivPojma) + "&";
        if (kljucnaRec !== undefined && kljucnaRec !== null)
            url_ += "KljucnaRec=" + encodeURIComponent("" + kljucnaRec) + "&";
        if (sifraEvidencije !== undefined && sifraEvidencije !== null)
            url_ += "SifraEvidencije=" + encodeURIComponent("" + sifraEvidencije) + "&";
        if (statusi !== undefined && statusi !== null)
            statusi && statusi.forEach(item => { url_ += "Statusi=" + encodeURIComponent("" + item) + "&"; });
        if (vrstaPojma !== undefined && vrstaPojma !== null)
            url_ += "VrstaPojma=" + encodeURIComponent("" + vrstaPojma) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIzvozPojmovaUExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIzvozPojmovaUExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processIzvozPojmovaUExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    izvozOdobrenihPojmovaUExcel(lang: string | null | undefined, domenId: number | null | undefined, nazivPojma: string | null | undefined, skupVrednostiOgranicen: number[] | null | undefined, kljucnaRec: string | null | undefined, sifraEvidencije: string | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Pojam/IzvozOdorenihPojmovaUExcel?";
        if (lang !== undefined && lang !== null)
            url_ += "Lang=" + encodeURIComponent("" + lang) + "&";
        if (domenId !== undefined && domenId !== null)
            url_ += "DomenId=" + encodeURIComponent("" + domenId) + "&";
        if (nazivPojma !== undefined && nazivPojma !== null)
            url_ += "NazivPojma=" + encodeURIComponent("" + nazivPojma) + "&";
        if (skupVrednostiOgranicen !== undefined && skupVrednostiOgranicen !== null)
            skupVrednostiOgranicen && skupVrednostiOgranicen.forEach(item => { url_ += "SkupVrednostiOgranicen=" + encodeURIComponent("" + item) + "&"; });
        if (kljucnaRec !== undefined && kljucnaRec !== null)
            url_ += "KljucnaRec=" + encodeURIComponent("" + kljucnaRec) + "&";
        if (sifraEvidencije !== undefined && sifraEvidencije !== null)
            url_ += "SifraEvidencije=" + encodeURIComponent("" + sifraEvidencije) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIzvozOdobrenihPojmovaUExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIzvozOdobrenihPojmovaUExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processIzvozOdobrenihPojmovaUExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    daLiPostojiVerzijaOvogPojmaSaStatusom(sifraPojma: string | null | undefined, statusId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Pojam/DaLiPostojiVerzijaOvogPojmaSaStatusom?";
        if (sifraPojma !== undefined && sifraPojma !== null)
            url_ += "SifraPojma=" + encodeURIComponent("" + sifraPojma) + "&";
        if (statusId === null)
            throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDaLiPostojiVerzijaOvogPojmaSaStatusom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDaLiPostojiVerzijaOvogPojmaSaStatusom(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDaLiPostojiVerzijaOvogPojmaSaStatusom(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    dajPojamZaPovezivanjeSaElementom(sifra: string | null | undefined): Observable<DajPojamZaPovezivanjeSaElementomQueryResponse> {
        let url_ = this.baseUrl + "/api/Pojam/DajPojamZaPovezivanjeSaElementom?";
        if (sifra !== undefined && sifra !== null)
            url_ += "Sifra=" + encodeURIComponent("" + sifra) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajPojamZaPovezivanjeSaElementom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajPojamZaPovezivanjeSaElementom(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajPojamZaPovezivanjeSaElementomQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajPojamZaPovezivanjeSaElementomQueryResponse>;
        }));
    }

    protected processDajPojamZaPovezivanjeSaElementom(response: HttpResponseBase): Observable<DajPojamZaPovezivanjeSaElementomQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DajPojamZaPovezivanjeSaElementomQueryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajPojamZaPovezivanjeSaElementomQueryResponse>(null as any);
    }

    dajPojmoveZaPreuzimanjeSvojstvaIzReferentnogPojma(id: number | undefined): Observable<DajPojmoveZaPreuzimanjeSvojstvaIzReferentnogPojmaResponse> {
        let url_ = this.baseUrl + "/api/Pojam/DajPojmoveZaPreuzimanjeSvojstvaIzReferentnogPojma?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajPojmoveZaPreuzimanjeSvojstvaIzReferentnogPojma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajPojmoveZaPreuzimanjeSvojstvaIzReferentnogPojma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajPojmoveZaPreuzimanjeSvojstvaIzReferentnogPojmaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajPojmoveZaPreuzimanjeSvojstvaIzReferentnogPojmaResponse>;
        }));
    }

    protected processDajPojmoveZaPreuzimanjeSvojstvaIzReferentnogPojma(response: HttpResponseBase): Observable<DajPojmoveZaPreuzimanjeSvojstvaIzReferentnogPojmaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DajPojmoveZaPreuzimanjeSvojstvaIzReferentnogPojmaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajPojmoveZaPreuzimanjeSvojstvaIzReferentnogPojmaResponse>(null as any);
    }

    dajSifarnickuEvidencijuIElement(id: number | undefined): Observable<PojamOgranicenjeSifarnikomResponse> {
        let url_ = this.baseUrl + "/api/Pojam/DajSifarnickuEvidencijuIElement?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajSifarnickuEvidencijuIElement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSifarnickuEvidencijuIElement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PojamOgranicenjeSifarnikomResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PojamOgranicenjeSifarnikomResponse>;
        }));
    }

    protected processDajSifarnickuEvidencijuIElement(response: HttpResponseBase): Observable<PojamOgranicenjeSifarnikomResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PojamOgranicenjeSifarnikomResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PojamOgranicenjeSifarnikomResponse>(null as any);
    }

    dovuciPojmoveKojiImajuTipKaoSvojeSvojstvo(idTipa: number | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfIzvedenPojamResponse> {
        let url_ = this.baseUrl + "/api/Pojam/DovuciPojmoveKojiImajuTipKaoSvojeSvojstvo?";
        if (idTipa === null)
            throw new Error("The parameter 'idTipa' cannot be null.");
        else if (idTipa !== undefined)
            url_ += "IdTipa=" + encodeURIComponent("" + idTipa) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDovuciPojmoveKojiImajuTipKaoSvojeSvojstvo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDovuciPojmoveKojiImajuTipKaoSvojeSvojstvo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfIzvedenPojamResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfIzvedenPojamResponse>;
        }));
    }

    protected processDovuciPojmoveKojiImajuTipKaoSvojeSvojstvo(response: HttpResponseBase): Observable<PagedResponseOfIzvedenPojamResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfIzvedenPojamResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfIzvedenPojamResponse>(null as any);
    }

    daLiSuIspunjeniUsloviZaKreiranjeSifarnika(sifraPojma: string | null | undefined): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Pojam/DaLiSuIspunjeniUsloviZaKreiranjeSifarnika?";
        if (sifraPojma !== undefined && sifraPojma !== null)
            url_ += "SifraPojma=" + encodeURIComponent("" + sifraPojma) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDaLiSuIspunjeniUsloviZaKreiranjeSifarnika(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDaLiSuIspunjeniUsloviZaKreiranjeSifarnika(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processDaLiSuIspunjeniUsloviZaKreiranjeSifarnika(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    dajSifarnikIElementCijiJePoslovniTipKvalifikator(poslovniTipId: number | undefined): Observable<SifarnikIElementCijiJePoslovniTipKvalifikatorResponse> {
        let url_ = this.baseUrl + "/api/Pojam/DajSifarnikIElementCijiJePoslovniTipKvalifikator?";
        if (poslovniTipId === null)
            throw new Error("The parameter 'poslovniTipId' cannot be null.");
        else if (poslovniTipId !== undefined)
            url_ += "PoslovniTipId=" + encodeURIComponent("" + poslovniTipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajSifarnikIElementCijiJePoslovniTipKvalifikator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSifarnikIElementCijiJePoslovniTipKvalifikator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SifarnikIElementCijiJePoslovniTipKvalifikatorResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SifarnikIElementCijiJePoslovniTipKvalifikatorResponse>;
        }));
    }

    protected processDajSifarnikIElementCijiJePoslovniTipKvalifikator(response: HttpResponseBase): Observable<SifarnikIElementCijiJePoslovniTipKvalifikatorResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SifarnikIElementCijiJePoslovniTipKvalifikatorResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SifarnikIElementCijiJePoslovniTipKvalifikatorResponse>(null as any);
    }

    vratiPoslovniTipZaElementEvidencije(elementId: number | undefined): Observable<VratiPoslovniTipZaElementEvidencijeResponse> {
        let url_ = this.baseUrl + "/api/Pojam/VratiPoslovniTipZaElementEvidencije?";
        if (elementId === null)
            throw new Error("The parameter 'elementId' cannot be null.");
        else if (elementId !== undefined)
            url_ += "ElementId=" + encodeURIComponent("" + elementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVratiPoslovniTipZaElementEvidencije(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVratiPoslovniTipZaElementEvidencije(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VratiPoslovniTipZaElementEvidencijeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VratiPoslovniTipZaElementEvidencijeResponse>;
        }));
    }

    protected processVratiPoslovniTipZaElementEvidencije(response: HttpResponseBase): Observable<VratiPoslovniTipZaElementEvidencijeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VratiPoslovniTipZaElementEvidencijeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VratiPoslovniTipZaElementEvidencijeResponse>(null as any);
    }

    klonirajPojam(command: KlonirajPojamCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Pojam/KlonirajPojam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKlonirajPojam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKlonirajPojam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processKlonirajPojam(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    dajTipZaUcitavanjePodstabla(sifra: string | null | undefined): Observable<DajTipZaUcitavanjePodstablaResponse> {
        let url_ = this.baseUrl + "/api/Pojam/DajTipZaUcitavanjePodstabla?";
        if (sifra !== undefined && sifra !== null)
            url_ += "Sifra=" + encodeURIComponent("" + sifra) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajTipZaUcitavanjePodstabla(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajTipZaUcitavanjePodstabla(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajTipZaUcitavanjePodstablaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajTipZaUcitavanjePodstablaResponse>;
        }));
    }

    protected processDajTipZaUcitavanjePodstabla(response: HttpResponseBase): Observable<DajTipZaUcitavanjePodstablaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DajTipZaUcitavanjePodstablaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajTipZaUcitavanjePodstablaResponse>(null as any);
    }
}

export interface IPorukaClient {
    pretraziRecnikPoruka(domenId: number | null | undefined, nazivPoruke: string | null | undefined, definicija: string | null | undefined, kljucneReci: string[] | null | undefined, statusi: string[] | null | undefined, datumPocetkaVazenja: Date | null | undefined, datumZavrsetkaVazenja: Date | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfPretragaPorukaResponse>;
    dajPorukuPoSifri(sifra: string | null | undefined, verzija: string | null | undefined): Observable<DajPorukuPoSifriResponse>;
    sacuvajPoruku(command: SacuvajPorukuCommand): Observable<GenericActionResponseRP>;
    dajSveVerzijePoruke(sifra: string | null | undefined): Observable<DajSveVerzijePorukeResponse>;
    obrisiPoruku(command: ObrisiPorukuCommand): Observable<GenericActionResponseRP>;
    objaviPoruku(command: ObjaviPorukuCommand): Observable<GenericActionResponseRP>;
    deaktivirajPoruku(command: DeaktivirajPorukuCommand): Observable<GenericActionResponseRP>;
    reaktivirajPoruku(command: ReaktivirajPorukuCommand): Observable<GenericActionResponseRP>;
    dajPorukeNaKojimaSePojamKoristi(pojamId: number | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfPorukaKojaSeKoristiNaPojmuResponse>;
    vratiPorukeZaListuSifara(sifrePoruka: string[] | null | undefined): Observable<VratiPorukeZaListuSifaraResponse>;
    pretragaKljucnihReciPoruka(rec: string | null | undefined): Observable<string[]>;
    kreirajNovuVerzijuPoruke(id: number): Observable<GenericActionResponseRP>;
    klonirajPoruku(id: number): Observable<GenericActionResponseRP>;
    dajPorukuPoIDu(id: number | undefined): Observable<DajPorukuPoIDuResponse>;
    vratiPorukeZaListuIdeva(idPoruka: number[] | null | undefined): Observable<VratiPorukeZaListuSifaraResponse>;
    dajServiseKojiKoristePoruku(porukaId: number | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfServisNaPoruciResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class PorukaClient implements IPorukaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:9112";
    }

    pretraziRecnikPoruka(domenId: number | null | undefined, nazivPoruke: string | null | undefined, definicija: string | null | undefined, kljucneReci: string[] | null | undefined, statusi: string[] | null | undefined, datumPocetkaVazenja: Date | null | undefined, datumZavrsetkaVazenja: Date | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfPretragaPorukaResponse> {
        let url_ = this.baseUrl + "/api/Poruka/PretragaPoruka?";
        if (domenId !== undefined && domenId !== null)
            url_ += "DomenId=" + encodeURIComponent("" + domenId) + "&";
        if (nazivPoruke !== undefined && nazivPoruke !== null)
            url_ += "NazivPoruke=" + encodeURIComponent("" + nazivPoruke) + "&";
        if (definicija !== undefined && definicija !== null)
            url_ += "Definicija=" + encodeURIComponent("" + definicija) + "&";
        if (kljucneReci !== undefined && kljucneReci !== null)
            kljucneReci && kljucneReci.forEach(item => { url_ += "KljucneReci=" + encodeURIComponent("" + item) + "&"; });
        if (statusi !== undefined && statusi !== null)
            statusi && statusi.forEach(item => { url_ += "Statusi=" + encodeURIComponent("" + item) + "&"; });
        if (datumPocetkaVazenja !== undefined && datumPocetkaVazenja !== null)
            url_ += "DatumPocetkaVazenja=" + encodeURIComponent(datumPocetkaVazenja ? "" + datumPocetkaVazenja.toISOString() : "") + "&";
        if (datumZavrsetkaVazenja !== undefined && datumZavrsetkaVazenja !== null)
            url_ += "DatumZavrsetkaVazenja=" + encodeURIComponent(datumZavrsetkaVazenja ? "" + datumZavrsetkaVazenja.toISOString() : "") + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPretraziRecnikPoruka(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPretraziRecnikPoruka(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfPretragaPorukaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfPretragaPorukaResponse>;
        }));
    }

    protected processPretraziRecnikPoruka(response: HttpResponseBase): Observable<PagedResponseOfPretragaPorukaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfPretragaPorukaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfPretragaPorukaResponse>(null as any);
    }

    dajPorukuPoSifri(sifra: string | null | undefined, verzija: string | null | undefined): Observable<DajPorukuPoSifriResponse> {
        let url_ = this.baseUrl + "/api/Poruka/DajPorukuPoSifri?";
        if (sifra !== undefined && sifra !== null)
            url_ += "Sifra=" + encodeURIComponent("" + sifra) + "&";
        if (verzija !== undefined && verzija !== null)
            url_ += "Verzija=" + encodeURIComponent("" + verzija) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajPorukuPoSifri(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajPorukuPoSifri(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajPorukuPoSifriResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajPorukuPoSifriResponse>;
        }));
    }

    protected processDajPorukuPoSifri(response: HttpResponseBase): Observable<DajPorukuPoSifriResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DajPorukuPoSifriResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajPorukuPoSifriResponse>(null as any);
    }

    sacuvajPoruku(command: SacuvajPorukuCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Poruka/SacuvajPoruku";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSacuvajPoruku(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSacuvajPoruku(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processSacuvajPoruku(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    dajSveVerzijePoruke(sifra: string | null | undefined): Observable<DajSveVerzijePorukeResponse> {
        let url_ = this.baseUrl + "/api/Poruka/DajSveVerzijePoruke?";
        if (sifra !== undefined && sifra !== null)
            url_ += "Sifra=" + encodeURIComponent("" + sifra) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajSveVerzijePoruke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSveVerzijePoruke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajSveVerzijePorukeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajSveVerzijePorukeResponse>;
        }));
    }

    protected processDajSveVerzijePoruke(response: HttpResponseBase): Observable<DajSveVerzijePorukeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DajSveVerzijePorukeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajSveVerzijePorukeResponse>(null as any);
    }

    obrisiPoruku(command: ObrisiPorukuCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Poruka/ObrisiPoruku";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObrisiPoruku(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObrisiPoruku(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processObrisiPoruku(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    objaviPoruku(command: ObjaviPorukuCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Poruka/ObjaviPoruku";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObjaviPoruku(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObjaviPoruku(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processObjaviPoruku(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    deaktivirajPoruku(command: DeaktivirajPorukuCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Poruka/DeaktivirajPoruku";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeaktivirajPoruku(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeaktivirajPoruku(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processDeaktivirajPoruku(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    reaktivirajPoruku(command: ReaktivirajPorukuCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Poruka/ReaktivirajPoruku";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReaktivirajPoruku(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReaktivirajPoruku(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processReaktivirajPoruku(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    dajPorukeNaKojimaSePojamKoristi(pojamId: number | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfPorukaKojaSeKoristiNaPojmuResponse> {
        let url_ = this.baseUrl + "/api/Poruka/DajPorukeNaKojimaSePojamKoristi?";
        if (pojamId === null)
            throw new Error("The parameter 'pojamId' cannot be null.");
        else if (pojamId !== undefined)
            url_ += "PojamId=" + encodeURIComponent("" + pojamId) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajPorukeNaKojimaSePojamKoristi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajPorukeNaKojimaSePojamKoristi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfPorukaKojaSeKoristiNaPojmuResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfPorukaKojaSeKoristiNaPojmuResponse>;
        }));
    }

    protected processDajPorukeNaKojimaSePojamKoristi(response: HttpResponseBase): Observable<PagedResponseOfPorukaKojaSeKoristiNaPojmuResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfPorukaKojaSeKoristiNaPojmuResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfPorukaKojaSeKoristiNaPojmuResponse>(null as any);
    }

    vratiPorukeZaListuSifara(sifrePoruka: string[] | null | undefined): Observable<VratiPorukeZaListuSifaraResponse> {
        let url_ = this.baseUrl + "/api/Poruka/VratiPorukeZaListuSifara?";
        if (sifrePoruka !== undefined && sifrePoruka !== null)
            sifrePoruka && sifrePoruka.forEach(item => { url_ += "SifrePoruka=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVratiPorukeZaListuSifara(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVratiPorukeZaListuSifara(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VratiPorukeZaListuSifaraResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VratiPorukeZaListuSifaraResponse>;
        }));
    }

    protected processVratiPorukeZaListuSifara(response: HttpResponseBase): Observable<VratiPorukeZaListuSifaraResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VratiPorukeZaListuSifaraResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VratiPorukeZaListuSifaraResponse>(null as any);
    }

    pretragaKljucnihReciPoruka(rec: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Poruka/PretragaKljucnihReciPoruka?";
        if (rec !== undefined && rec !== null)
            url_ += "Rec=" + encodeURIComponent("" + rec) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPretragaKljucnihReciPoruka(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPretragaKljucnihReciPoruka(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processPretragaKljucnihReciPoruka(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    kreirajNovuVerzijuPoruke(id: number): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Poruka/KreirajNovuVerzijuPoruke/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKreirajNovuVerzijuPoruke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKreirajNovuVerzijuPoruke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processKreirajNovuVerzijuPoruke(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    klonirajPoruku(id: number): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Poruka/KlonirajPoruku/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKlonirajPoruku(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKlonirajPoruku(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processKlonirajPoruku(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    dajPorukuPoIDu(id: number | undefined): Observable<DajPorukuPoIDuResponse> {
        let url_ = this.baseUrl + "/api/Poruka/DajPorukuPoIDu?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajPorukuPoIDu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajPorukuPoIDu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajPorukuPoIDuResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajPorukuPoIDuResponse>;
        }));
    }

    protected processDajPorukuPoIDu(response: HttpResponseBase): Observable<DajPorukuPoIDuResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DajPorukuPoIDuResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajPorukuPoIDuResponse>(null as any);
    }

    vratiPorukeZaListuIdeva(idPoruka: number[] | null | undefined): Observable<VratiPorukeZaListuSifaraResponse> {
        let url_ = this.baseUrl + "/api/Poruka/VratiPorukeZaListuIDeva?";
        if (idPoruka !== undefined && idPoruka !== null)
            idPoruka && idPoruka.forEach(item => { url_ += "IdPoruka=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVratiPorukeZaListuIdeva(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVratiPorukeZaListuIdeva(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VratiPorukeZaListuSifaraResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VratiPorukeZaListuSifaraResponse>;
        }));
    }

    protected processVratiPorukeZaListuIdeva(response: HttpResponseBase): Observable<VratiPorukeZaListuSifaraResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VratiPorukeZaListuSifaraResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VratiPorukeZaListuSifaraResponse>(null as any);
    }

    dajServiseKojiKoristePoruku(porukaId: number | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfServisNaPoruciResponse> {
        let url_ = this.baseUrl + "/api/Poruka/DajServiseKojiKoristePoruku?";
        if (porukaId === null)
            throw new Error("The parameter 'porukaId' cannot be null.");
        else if (porukaId !== undefined)
            url_ += "PorukaId=" + encodeURIComponent("" + porukaId) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajServiseKojiKoristePoruku(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajServiseKojiKoristePoruku(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfServisNaPoruciResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfServisNaPoruciResponse>;
        }));
    }

    protected processDajServiseKojiKoristePoruku(response: HttpResponseBase): Observable<PagedResponseOfServisNaPoruciResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfServisNaPoruciResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfServisNaPoruciResponse>(null as any);
    }
}

export interface IPretragaClient {
    pretragaMetaregistra(domenId: number[] | null | undefined, kljucnaRec: string | null | undefined, vrstaEntiteta: string[] | null | undefined, statusiEntiteta: string[] | null | undefined): Observable<PagedResponseOfPretragaMetaregistraResponse>;
    izvozPretrageMetaregistraUExcel(domenId: number[] | null | undefined, kljucnaRec: string | null | undefined, vrstaEntiteta: string[] | null | undefined, statusiEntiteta: string[] | null | undefined): Observable<string>;
    dajTip(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse>;
    dajTipIzKogJeIzvedenTip(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse>;
    dajIzvedeneTipove(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse>;
    dajPojmoveIzvedeneIzTipa(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse>;
    dajSvojstvaIzvedenaIzTipa(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse>;
    dajNasledjenaSvojstvaTipa(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse>;
    dajPojam(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse>;
    dajPridruzenePojmove(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse>;
    dajIzKogJeTipaIzvedenPojam(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse>;
    dajEvidencijeKojeKoristePojam(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse>;
    dajPorukeIzvedeneIzPojma(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse>;
    dajSvojstvaPojma(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse>;
    dajPoruku(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse>;
    dajPojmoveZaPoruku(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse>;
    dajElementePoruke(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class PretragaClient implements IPretragaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:9112";
    }

    pretragaMetaregistra(domenId: number[] | null | undefined, kljucnaRec: string | null | undefined, vrstaEntiteta: string[] | null | undefined, statusiEntiteta: string[] | null | undefined): Observable<PagedResponseOfPretragaMetaregistraResponse> {
        let url_ = this.baseUrl + "/api/Pretraga/PretragaMetaregistra?";
        if (domenId !== undefined && domenId !== null)
            domenId && domenId.forEach(item => { url_ += "DomenId=" + encodeURIComponent("" + item) + "&"; });
        if (kljucnaRec !== undefined && kljucnaRec !== null)
            url_ += "KljucnaRec=" + encodeURIComponent("" + kljucnaRec) + "&";
        if (vrstaEntiteta !== undefined && vrstaEntiteta !== null)
            vrstaEntiteta && vrstaEntiteta.forEach(item => { url_ += "VrstaEntiteta=" + encodeURIComponent("" + item) + "&"; });
        if (statusiEntiteta !== undefined && statusiEntiteta !== null)
            statusiEntiteta && statusiEntiteta.forEach(item => { url_ += "StatusiEntiteta=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPretragaMetaregistra(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPretragaMetaregistra(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfPretragaMetaregistraResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfPretragaMetaregistraResponse>;
        }));
    }

    protected processPretragaMetaregistra(response: HttpResponseBase): Observable<PagedResponseOfPretragaMetaregistraResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfPretragaMetaregistraResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfPretragaMetaregistraResponse>(null as any);
    }

    izvozPretrageMetaregistraUExcel(domenId: number[] | null | undefined, kljucnaRec: string | null | undefined, vrstaEntiteta: string[] | null | undefined, statusiEntiteta: string[] | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Pretraga/IzvozPretrageMetaregistraUExcel?";
        if (domenId !== undefined && domenId !== null)
            domenId && domenId.forEach(item => { url_ += "DomenId=" + encodeURIComponent("" + item) + "&"; });
        if (kljucnaRec !== undefined && kljucnaRec !== null)
            url_ += "KljucnaRec=" + encodeURIComponent("" + kljucnaRec) + "&";
        if (vrstaEntiteta !== undefined && vrstaEntiteta !== null)
            vrstaEntiteta && vrstaEntiteta.forEach(item => { url_ += "VrstaEntiteta=" + encodeURIComponent("" + item) + "&"; });
        if (statusiEntiteta !== undefined && statusiEntiteta !== null)
            statusiEntiteta && statusiEntiteta.forEach(item => { url_ += "StatusiEntiteta=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIzvozPretrageMetaregistraUExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIzvozPretrageMetaregistraUExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processIzvozPretrageMetaregistraUExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    dajTip(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        let url_ = this.baseUrl + "/api/Pretraga/DajTip?";
        if (idEntiteta === null)
            throw new Error("The parameter 'idEntiteta' cannot be null.");
        else if (idEntiteta !== undefined)
            url_ += "IdEntiteta=" + encodeURIComponent("" + idEntiteta) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajTip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajTip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
        }));
    }

    protected processDajTip(response: HttpResponseBase): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfObjedinjenaPretragaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfObjedinjenaPretragaResponse>(null as any);
    }

    dajTipIzKogJeIzvedenTip(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        let url_ = this.baseUrl + "/api/Pretraga/DajTipIzKogJeIzvedenTip?";
        if (idEntiteta === null)
            throw new Error("The parameter 'idEntiteta' cannot be null.");
        else if (idEntiteta !== undefined)
            url_ += "IdEntiteta=" + encodeURIComponent("" + idEntiteta) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajTipIzKogJeIzvedenTip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajTipIzKogJeIzvedenTip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
        }));
    }

    protected processDajTipIzKogJeIzvedenTip(response: HttpResponseBase): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfObjedinjenaPretragaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfObjedinjenaPretragaResponse>(null as any);
    }

    dajIzvedeneTipove(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        let url_ = this.baseUrl + "/api/Pretraga/DajIzvedeneTipove?";
        if (idEntiteta === null)
            throw new Error("The parameter 'idEntiteta' cannot be null.");
        else if (idEntiteta !== undefined)
            url_ += "IdEntiteta=" + encodeURIComponent("" + idEntiteta) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajIzvedeneTipove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajIzvedeneTipove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
        }));
    }

    protected processDajIzvedeneTipove(response: HttpResponseBase): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfObjedinjenaPretragaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfObjedinjenaPretragaResponse>(null as any);
    }

    dajPojmoveIzvedeneIzTipa(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        let url_ = this.baseUrl + "/api/Pretraga/DajPojmoveIzvedeneIzTipa?";
        if (idEntiteta === null)
            throw new Error("The parameter 'idEntiteta' cannot be null.");
        else if (idEntiteta !== undefined)
            url_ += "IdEntiteta=" + encodeURIComponent("" + idEntiteta) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajPojmoveIzvedeneIzTipa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajPojmoveIzvedeneIzTipa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
        }));
    }

    protected processDajPojmoveIzvedeneIzTipa(response: HttpResponseBase): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfObjedinjenaPretragaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfObjedinjenaPretragaResponse>(null as any);
    }

    dajSvojstvaIzvedenaIzTipa(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        let url_ = this.baseUrl + "/api/Pretraga/DajSvojstvaIzvedenaIzTipa?";
        if (idEntiteta === null)
            throw new Error("The parameter 'idEntiteta' cannot be null.");
        else if (idEntiteta !== undefined)
            url_ += "IdEntiteta=" + encodeURIComponent("" + idEntiteta) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajSvojstvaIzvedenaIzTipa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSvojstvaIzvedenaIzTipa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
        }));
    }

    protected processDajSvojstvaIzvedenaIzTipa(response: HttpResponseBase): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfObjedinjenaPretragaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfObjedinjenaPretragaResponse>(null as any);
    }

    dajNasledjenaSvojstvaTipa(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        let url_ = this.baseUrl + "/api/Pretraga/DajNasledjenaSvojstvaTipa?";
        if (idEntiteta === null)
            throw new Error("The parameter 'idEntiteta' cannot be null.");
        else if (idEntiteta !== undefined)
            url_ += "IdEntiteta=" + encodeURIComponent("" + idEntiteta) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajNasledjenaSvojstvaTipa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajNasledjenaSvojstvaTipa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
        }));
    }

    protected processDajNasledjenaSvojstvaTipa(response: HttpResponseBase): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfObjedinjenaPretragaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfObjedinjenaPretragaResponse>(null as any);
    }

    dajPojam(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        let url_ = this.baseUrl + "/api/Pretraga/DajPojam?";
        if (idEntiteta === null)
            throw new Error("The parameter 'idEntiteta' cannot be null.");
        else if (idEntiteta !== undefined)
            url_ += "IdEntiteta=" + encodeURIComponent("" + idEntiteta) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajPojam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajPojam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
        }));
    }

    protected processDajPojam(response: HttpResponseBase): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfObjedinjenaPretragaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfObjedinjenaPretragaResponse>(null as any);
    }

    dajPridruzenePojmove(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        let url_ = this.baseUrl + "/api/Pretraga/DajPridruzenePojmove?";
        if (idEntiteta === null)
            throw new Error("The parameter 'idEntiteta' cannot be null.");
        else if (idEntiteta !== undefined)
            url_ += "IdEntiteta=" + encodeURIComponent("" + idEntiteta) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajPridruzenePojmove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajPridruzenePojmove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
        }));
    }

    protected processDajPridruzenePojmove(response: HttpResponseBase): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfObjedinjenaPretragaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfObjedinjenaPretragaResponse>(null as any);
    }

    dajIzKogJeTipaIzvedenPojam(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        let url_ = this.baseUrl + "/api/Pretraga/DajIzKogJeTipaIzvedenPojam?";
        if (idEntiteta === null)
            throw new Error("The parameter 'idEntiteta' cannot be null.");
        else if (idEntiteta !== undefined)
            url_ += "IdEntiteta=" + encodeURIComponent("" + idEntiteta) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajIzKogJeTipaIzvedenPojam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajIzKogJeTipaIzvedenPojam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
        }));
    }

    protected processDajIzKogJeTipaIzvedenPojam(response: HttpResponseBase): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfObjedinjenaPretragaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfObjedinjenaPretragaResponse>(null as any);
    }

    dajEvidencijeKojeKoristePojam(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        let url_ = this.baseUrl + "/api/Pretraga/DajEvidencijeKojeKoristePojam?";
        if (idEntiteta === null)
            throw new Error("The parameter 'idEntiteta' cannot be null.");
        else if (idEntiteta !== undefined)
            url_ += "IdEntiteta=" + encodeURIComponent("" + idEntiteta) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajEvidencijeKojeKoristePojam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajEvidencijeKojeKoristePojam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
        }));
    }

    protected processDajEvidencijeKojeKoristePojam(response: HttpResponseBase): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfObjedinjenaPretragaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfObjedinjenaPretragaResponse>(null as any);
    }

    dajPorukeIzvedeneIzPojma(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        let url_ = this.baseUrl + "/api/Pretraga/DajPorukeIzvedeneIzPojma?";
        if (idEntiteta === null)
            throw new Error("The parameter 'idEntiteta' cannot be null.");
        else if (idEntiteta !== undefined)
            url_ += "IdEntiteta=" + encodeURIComponent("" + idEntiteta) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajPorukeIzvedeneIzPojma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajPorukeIzvedeneIzPojma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
        }));
    }

    protected processDajPorukeIzvedeneIzPojma(response: HttpResponseBase): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfObjedinjenaPretragaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfObjedinjenaPretragaResponse>(null as any);
    }

    dajSvojstvaPojma(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        let url_ = this.baseUrl + "/api/Pretraga/DajSvojstvaPojma?";
        if (idEntiteta === null)
            throw new Error("The parameter 'idEntiteta' cannot be null.");
        else if (idEntiteta !== undefined)
            url_ += "IdEntiteta=" + encodeURIComponent("" + idEntiteta) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajSvojstvaPojma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSvojstvaPojma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
        }));
    }

    protected processDajSvojstvaPojma(response: HttpResponseBase): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfObjedinjenaPretragaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfObjedinjenaPretragaResponse>(null as any);
    }

    dajPoruku(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        let url_ = this.baseUrl + "/api/Pretraga/DajPoruku?";
        if (idEntiteta === null)
            throw new Error("The parameter 'idEntiteta' cannot be null.");
        else if (idEntiteta !== undefined)
            url_ += "IdEntiteta=" + encodeURIComponent("" + idEntiteta) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajPoruku(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajPoruku(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
        }));
    }

    protected processDajPoruku(response: HttpResponseBase): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfObjedinjenaPretragaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfObjedinjenaPretragaResponse>(null as any);
    }

    dajPojmoveZaPoruku(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        let url_ = this.baseUrl + "/api/Pretraga/DajPojmoveZaPoruku?";
        if (idEntiteta === null)
            throw new Error("The parameter 'idEntiteta' cannot be null.");
        else if (idEntiteta !== undefined)
            url_ += "IdEntiteta=" + encodeURIComponent("" + idEntiteta) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajPojmoveZaPoruku(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajPojmoveZaPoruku(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
        }));
    }

    protected processDajPojmoveZaPoruku(response: HttpResponseBase): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfObjedinjenaPretragaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfObjedinjenaPretragaResponse>(null as any);
    }

    dajElementePoruke(idEntiteta: number | undefined): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        let url_ = this.baseUrl + "/api/Pretraga/DajElementePoruke?";
        if (idEntiteta === null)
            throw new Error("The parameter 'idEntiteta' cannot be null.");
        else if (idEntiteta !== undefined)
            url_ += "IdEntiteta=" + encodeURIComponent("" + idEntiteta) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajElementePoruke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajElementePoruke(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfObjedinjenaPretragaResponse>;
        }));
    }

    protected processDajElementePoruke(response: HttpResponseBase): Observable<PagedResponseOfObjedinjenaPretragaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfObjedinjenaPretragaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfObjedinjenaPretragaResponse>(null as any);
    }
}

export interface ISifarniciClient {
    dajSveSifarnikeZaRecnikPojmova(query: DajSveSifarnikeZaRecnikPojmovaQuery | null | undefined): Observable<DajSveSifarnikeZaRecnikPojmovaResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class SifarniciClient implements ISifarniciClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:9112";
    }

    dajSveSifarnikeZaRecnikPojmova(query: DajSveSifarnikeZaRecnikPojmovaQuery | null | undefined): Observable<DajSveSifarnikeZaRecnikPojmovaResponse> {
        let url_ = this.baseUrl + "/api/Sifarnici/DajSveSifarnikeZaRecnikPojmova?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajSveSifarnikeZaRecnikPojmova(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSveSifarnikeZaRecnikPojmova(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajSveSifarnikeZaRecnikPojmovaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajSveSifarnikeZaRecnikPojmovaResponse>;
        }));
    }

    protected processDajSveSifarnikeZaRecnikPojmova(response: HttpResponseBase): Observable<DajSveSifarnikeZaRecnikPojmovaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DajSveSifarnikeZaRecnikPojmovaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajSveSifarnikeZaRecnikPojmovaResponse>(null as any);
    }
}

export interface ISluzbenaEvidencijaClient {
    sacuvajSluzbenuEvidenciju(command: SacuvajSluzbenuEvidencijuCommand): Observable<GenericActionResponseWithItemsSEOfString>;
    kreirajNovuVerzijuSluzbeneEvidencije(command: KreirajNovuVerzijuSluzbeneEvidencijeCommand): Observable<GenericActionResponseWithItemsSEOfSluzbenaEvidencijaResponse>;
    objaviSluzbenuEvidenciju(command: ObjaviSluzbenuEvidencijuCommand): Observable<GenericActionResponseSE>;
    deaktivirajSluzbenuEvidenciju(command: DeaktivirajSluzbenuEvidencijuCommand): Observable<GenericActionResponseSE>;
    obrisiSluzbenuEvidenciju(command: ObrisiSluzbenuEvidencijuCommand): Observable<GenericActionResponseSE>;
    reaktivirajSluzbenuEvidenciju(command: ReaktivirajSluzbenuEvidencijuCommand): Observable<GenericActionResponseWithItemsSEOfSluzbenaEvidencijaResponse>;
    pretragaObjavljenihSluzbenihEvidencija(nazivSluzbeneEvidencije: string | null | undefined, skraceniNazivSluzbeneEvidencije: string | null | undefined, nadleznogOrganaSifra: string | null | undefined, tipEvidencijeSifra: string[] | null | undefined, jeJavnoDostupno: boolean | null | undefined, jeDostupnoElektronski: boolean | null | undefined, klasifikacijaSifre: string[] | null | undefined, statusSifre: string[] | null | undefined, inicijalnoDeaktiviranje: boolean | null | undefined, ogranicenSifarnikomIds: number[] | null | undefined, pocetakVazenjaOd: Date | null | undefined, pocetakVazenjaDo: Date | null | undefined, krajVazenjaOd: Date | null | undefined, krajVazenjaDo: Date | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfPretragaObjavljenihSEQueryResponse>;
    izvozObjavljenihSluzbenihEvidencijaUExcel(lang: string | null | undefined, nazivSluzbeneEvidencije: string | null | undefined, skraceniNazivSluzbeneEvidencije: string | null | undefined, nadleznogOrganaSifra: string | null | undefined, tipEvidencijeSifra: string[] | null | undefined, jeJavnoDostupno: boolean | null | undefined, jeDostupnoElektronski: boolean | null | undefined, klasifikacijaSifre: string[] | null | undefined, statusSifre: string[] | null | undefined, inicijalnoDeaktiviranje: boolean | null | undefined, pocetakVazenjaOd: Date | null | undefined, pocetakVazenjaDo: Date | null | undefined, krajVazenjaOd: Date | null | undefined, krajVazenjaDo: Date | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<string>;
    dajSluzbenuEvidencijuPoSifri(sifra: string | null | undefined, verzija: string | null | undefined): Observable<DajSluzbenuEvidencijuPoSifriResponse>;
    vezaPojmaSaSluzbenimEvidencijama(idPojma: number | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfVezaPojmaSaSluzbenomEvidencijomResponse>;
    vezaSvojstvaSaSluzbenimEvidencijama(svojstvoId: number | undefined, nadredjenoSvojstvoId: number | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfVezaSvojstvaSaSluzbenomEvidencijomResponse>;
    pretragaObjavljenihSluzbenihEvidencijaPoNazivu(naziv: string | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfPretragaObjavljenihSluzbenihEvidencijaPoNazivuQueryResponse>;
    pretragaSluzbenihEvidencijaZaKS(naziv: string | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfPretragaSluzbenihEvidencijaZaKSQueryResponse>;
    daLiPostojiAktivnaSEZaOrgan(sifraOrgana: string | null | undefined, datumDeaktivacije: Date | undefined): Observable<boolean>;
    povratakEvidencijeNaStatusUPripremi(command: PovratakEvidencijeNaStatusUPripremiCommand): Observable<GenericActionResponseSE>;
    dajSifarnickuEvidencijuZaPojamId(sifarnickiPojamId: number | undefined): Observable<SluzbenaEvidencijaResponse>;
    obrisiKlasifikacijuIzSE(command: ObrisiKlasifikacijuIzSECommand): Observable<GenericActionResponseSE>;
    kreirajNovuVerzijuSadrzajaSluzbeneEvidencije(command: KreirajNovuVerzijuSadrzajaSluzbeneEvidencijeCommand): Observable<GenericActionResponseSE>;
    obrisiSadrzaj(command: ObrisiSadrzajSluzbeneEvidencijeCommand): Observable<GenericActionResponseSE>;
    objaviSadrzaj(command: ObjaviSadrzajSluzbeneEvidencijeCommand): Observable<GenericActionResponseSE>;
    deaktivirajSadrzaj(command: DeaktivirajSadrzajSluzbeneEvidencijeCommand): Observable<GenericActionResponseSE>;
    reaktivirajSadrzaj(command: ReaktivirajSadrzajSluzbeneEvidencijeCommand): Observable<GenericActionResponseSE>;
    dajSveVerzijeSluzbeneEvidencije(sifra: string | null | undefined): Observable<DajSveVerzijeSluzbeneEvidencijeResponse>;
    dajSveVerzijeSadrzajaSluzbeneEvidencije(sifraSluzbeneEvidencije: string | null | undefined): Observable<DajSveVerzijeSadrzajaSluzbeneEvidencijeResponse>;
    dajSadrzajSluzbeneEvidencije(sifraSadrzaja: string | null | undefined, verzija: string | null | undefined, vratiPoslednjuVerziju: boolean | undefined): Observable<DajSadrzajPoSifriResponse>;
    sacuvajSadrzaj(command: SacuvajSadrzajSluzbeneEvidencijeCommand): Observable<GenericActionResponseSE>;
    povratakSadrzajaEvidencijeNaStatusUPripremi(command: PovratakSadrzajaEvidencijeNaStatusUPripremiCommand): Observable<GenericActionResponseSE>;
    pretragaElemenataZaPovezivanje(sifraNadleznogOrgana: string | null | undefined, nazivSluzbeneEvidencije: string | null | undefined, nazivPojma: string | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfPretragaElemenataZaPovezivanjeQueryResponse>;
    dohvatanjeElemenataSluzbeneEvidencije(sifraSluzbeneEvidencije: string | null | undefined, nazivElementa: string | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfElementShortResponse>;
    sacuvajElement(command: SacuvajElementCommand): Observable<GenericActionResponseSE>;
    dajElement(sifraElementa: string | null | undefined, sifraSadrzaja: string | null | undefined, verzijaSadrzaja: string | null | undefined): Observable<DajElementPoSifriResponse>;
    obrisiElement(command: ObrisiElementCommand): Observable<GenericActionResponseSE>;
    obrisiElemente(command: ObrisiElementeCommand): Observable<GenericActionResponseSE>;
    sacuvajSvojstvaReferentnogPojma(command: SacuvajSvojstvaReferentnogPojmaKaoElementeCommand): Observable<GenericActionResponseSE>;
    dajAktivneElementeSifarnika(sifraSifarnika: string | null | undefined): Observable<ElementSifarnikaResponse[]>;
    oznaciIzvornostViseElemenata(command: OznaciIzvornostViseElemenataCommand): Observable<GenericActionResponseSE>;
    zamenaRednihBrojevaElemenataEvidencije(command: ZamenaRednihBrojevaElemenataEvidencijeCommand): Observable<GenericActionResponseSE>;
    dajStavkeSifarnika(sifarnikSifra: string | null | undefined, id: number | null | undefined, sifra: string | null | undefined, naziv: string | null | undefined, statusi: number[] | null | undefined, datumPocetkaVazenja: Date | null | undefined, datumPrestankaVazenja: Date | null | undefined, elementSifarnikaSifra: string | null | undefined, vrednostStavkeElementa: string | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfStavkaSifarnikaResponse>;
    dajStavkuSifarnika(id: number | undefined): Observable<DajStavkuSifarnikaPoSifriResponse>;
    sacuvajStavkuSifarnika(command: SacuvajStavkuSifarnikaCommand): Observable<GenericActionResponseSE>;
    obrisiStavkuSifarnika(command: ObrisiStavkuSifarnikaCommand): Observable<GenericActionResponseSE>;
}

@Injectable({
    providedIn: 'root'
})
export class SluzbenaEvidencijaClient implements ISluzbenaEvidencijaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:9112";
    }

    sacuvajSluzbenuEvidenciju(command: SacuvajSluzbenuEvidencijuCommand): Observable<GenericActionResponseWithItemsSEOfString> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/SacuvajSluzbenuEvidenciju";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSacuvajSluzbenuEvidenciju(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSacuvajSluzbenuEvidenciju(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseWithItemsSEOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseWithItemsSEOfString>;
        }));
    }

    protected processSacuvajSluzbenuEvidenciju(response: HttpResponseBase): Observable<GenericActionResponseWithItemsSEOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseWithItemsSEOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseWithItemsSEOfString>(null as any);
    }

    kreirajNovuVerzijuSluzbeneEvidencije(command: KreirajNovuVerzijuSluzbeneEvidencijeCommand): Observable<GenericActionResponseWithItemsSEOfSluzbenaEvidencijaResponse> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/KreirajNovuVerzijuSluzbeneEvidencije";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKreirajNovuVerzijuSluzbeneEvidencije(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKreirajNovuVerzijuSluzbeneEvidencije(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseWithItemsSEOfSluzbenaEvidencijaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseWithItemsSEOfSluzbenaEvidencijaResponse>;
        }));
    }

    protected processKreirajNovuVerzijuSluzbeneEvidencije(response: HttpResponseBase): Observable<GenericActionResponseWithItemsSEOfSluzbenaEvidencijaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseWithItemsSEOfSluzbenaEvidencijaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseWithItemsSEOfSluzbenaEvidencijaResponse>(null as any);
    }

    objaviSluzbenuEvidenciju(command: ObjaviSluzbenuEvidencijuCommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/ObjaviSluzbenuEvidenciju";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObjaviSluzbenuEvidenciju(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObjaviSluzbenuEvidenciju(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processObjaviSluzbenuEvidenciju(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }

    deaktivirajSluzbenuEvidenciju(command: DeaktivirajSluzbenuEvidencijuCommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/DeaktivirajSluzbenuEvidenciju";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeaktivirajSluzbenuEvidenciju(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeaktivirajSluzbenuEvidenciju(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processDeaktivirajSluzbenuEvidenciju(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }

    obrisiSluzbenuEvidenciju(command: ObrisiSluzbenuEvidencijuCommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/ObrisiSluzbenuEvidenciju";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObrisiSluzbenuEvidenciju(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObrisiSluzbenuEvidenciju(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processObrisiSluzbenuEvidenciju(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }

    reaktivirajSluzbenuEvidenciju(command: ReaktivirajSluzbenuEvidencijuCommand): Observable<GenericActionResponseWithItemsSEOfSluzbenaEvidencijaResponse> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/ReaktivirajSluzbenuEvidenciju";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReaktivirajSluzbenuEvidenciju(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReaktivirajSluzbenuEvidenciju(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseWithItemsSEOfSluzbenaEvidencijaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseWithItemsSEOfSluzbenaEvidencijaResponse>;
        }));
    }

    protected processReaktivirajSluzbenuEvidenciju(response: HttpResponseBase): Observable<GenericActionResponseWithItemsSEOfSluzbenaEvidencijaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseWithItemsSEOfSluzbenaEvidencijaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseWithItemsSEOfSluzbenaEvidencijaResponse>(null as any);
    }

    pretragaObjavljenihSluzbenihEvidencija(nazivSluzbeneEvidencije: string | null | undefined, skraceniNazivSluzbeneEvidencije: string | null | undefined, nadleznogOrganaSifra: string | null | undefined, tipEvidencijeSifra: string[] | null | undefined, jeJavnoDostupno: boolean | null | undefined, jeDostupnoElektronski: boolean | null | undefined, klasifikacijaSifre: string[] | null | undefined, statusSifre: string[] | null | undefined, inicijalnoDeaktiviranje: boolean | null | undefined, ogranicenSifarnikomIds: number[] | null | undefined, pocetakVazenjaOd: Date | null | undefined, pocetakVazenjaDo: Date | null | undefined, krajVazenjaOd: Date | null | undefined, krajVazenjaDo: Date | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfPretragaObjavljenihSEQueryResponse> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/PretragaObjavljenihSluzbenihEvidencija?";
        if (nazivSluzbeneEvidencije !== undefined && nazivSluzbeneEvidencije !== null)
            url_ += "NazivSluzbeneEvidencije=" + encodeURIComponent("" + nazivSluzbeneEvidencije) + "&";
        if (skraceniNazivSluzbeneEvidencije !== undefined && skraceniNazivSluzbeneEvidencije !== null)
            url_ += "SkraceniNazivSluzbeneEvidencije=" + encodeURIComponent("" + skraceniNazivSluzbeneEvidencije) + "&";
        if (nadleznogOrganaSifra !== undefined && nadleznogOrganaSifra !== null)
            url_ += "NadleznogOrganaSifra=" + encodeURIComponent("" + nadleznogOrganaSifra) + "&";
        if (tipEvidencijeSifra !== undefined && tipEvidencijeSifra !== null)
            tipEvidencijeSifra && tipEvidencijeSifra.forEach(item => { url_ += "TipEvidencijeSifra=" + encodeURIComponent("" + item) + "&"; });
        if (jeJavnoDostupno !== undefined && jeJavnoDostupno !== null)
            url_ += "JeJavnoDostupno=" + encodeURIComponent("" + jeJavnoDostupno) + "&";
        if (jeDostupnoElektronski !== undefined && jeDostupnoElektronski !== null)
            url_ += "JeDostupnoElektronski=" + encodeURIComponent("" + jeDostupnoElektronski) + "&";
        if (klasifikacijaSifre !== undefined && klasifikacijaSifre !== null)
            klasifikacijaSifre && klasifikacijaSifre.forEach(item => { url_ += "KlasifikacijaSifre=" + encodeURIComponent("" + item) + "&"; });
        if (statusSifre !== undefined && statusSifre !== null)
            statusSifre && statusSifre.forEach(item => { url_ += "StatusSifre=" + encodeURIComponent("" + item) + "&"; });
        if (inicijalnoDeaktiviranje !== undefined && inicijalnoDeaktiviranje !== null)
            url_ += "InicijalnoDeaktiviranje=" + encodeURIComponent("" + inicijalnoDeaktiviranje) + "&";
        if (ogranicenSifarnikomIds !== undefined && ogranicenSifarnikomIds !== null)
            ogranicenSifarnikomIds && ogranicenSifarnikomIds.forEach(item => { url_ += "OgranicenSifarnikomIds=" + encodeURIComponent("" + item) + "&"; });
        if (pocetakVazenjaOd !== undefined && pocetakVazenjaOd !== null)
            url_ += "PocetakVazenjaOd=" + encodeURIComponent(pocetakVazenjaOd ? "" + pocetakVazenjaOd.toISOString() : "") + "&";
        if (pocetakVazenjaDo !== undefined && pocetakVazenjaDo !== null)
            url_ += "PocetakVazenjaDo=" + encodeURIComponent(pocetakVazenjaDo ? "" + pocetakVazenjaDo.toISOString() : "") + "&";
        if (krajVazenjaOd !== undefined && krajVazenjaOd !== null)
            url_ += "KrajVazenjaOd=" + encodeURIComponent(krajVazenjaOd ? "" + krajVazenjaOd.toISOString() : "") + "&";
        if (krajVazenjaDo !== undefined && krajVazenjaDo !== null)
            url_ += "KrajVazenjaDo=" + encodeURIComponent(krajVazenjaDo ? "" + krajVazenjaDo.toISOString() : "") + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPretragaObjavljenihSluzbenihEvidencija(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPretragaObjavljenihSluzbenihEvidencija(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfPretragaObjavljenihSEQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfPretragaObjavljenihSEQueryResponse>;
        }));
    }

    protected processPretragaObjavljenihSluzbenihEvidencija(response: HttpResponseBase): Observable<PagedResponseOfPretragaObjavljenihSEQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfPretragaObjavljenihSEQueryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfPretragaObjavljenihSEQueryResponse>(null as any);
    }

    izvozObjavljenihSluzbenihEvidencijaUExcel(lang: string | null | undefined, nazivSluzbeneEvidencije: string | null | undefined, skraceniNazivSluzbeneEvidencije: string | null | undefined, nadleznogOrganaSifra: string | null | undefined, tipEvidencijeSifra: string[] | null | undefined, jeJavnoDostupno: boolean | null | undefined, jeDostupnoElektronski: boolean | null | undefined, klasifikacijaSifre: string[] | null | undefined, statusSifre: string[] | null | undefined, inicijalnoDeaktiviranje: boolean | null | undefined, pocetakVazenjaOd: Date | null | undefined, pocetakVazenjaDo: Date | null | undefined, krajVazenjaOd: Date | null | undefined, krajVazenjaDo: Date | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/izvozObjavljenihSluzbenihEvidencijaUExcel?";
        if (lang !== undefined && lang !== null)
            url_ += "Lang=" + encodeURIComponent("" + lang) + "&";
        if (nazivSluzbeneEvidencije !== undefined && nazivSluzbeneEvidencije !== null)
            url_ += "NazivSluzbeneEvidencije=" + encodeURIComponent("" + nazivSluzbeneEvidencije) + "&";
        if (skraceniNazivSluzbeneEvidencije !== undefined && skraceniNazivSluzbeneEvidencije !== null)
            url_ += "SkraceniNazivSluzbeneEvidencije=" + encodeURIComponent("" + skraceniNazivSluzbeneEvidencije) + "&";
        if (nadleznogOrganaSifra !== undefined && nadleznogOrganaSifra !== null)
            url_ += "NadleznogOrganaSifra=" + encodeURIComponent("" + nadleznogOrganaSifra) + "&";
        if (tipEvidencijeSifra !== undefined && tipEvidencijeSifra !== null)
            tipEvidencijeSifra && tipEvidencijeSifra.forEach(item => { url_ += "TipEvidencijeSifra=" + encodeURIComponent("" + item) + "&"; });
        if (jeJavnoDostupno !== undefined && jeJavnoDostupno !== null)
            url_ += "JeJavnoDostupno=" + encodeURIComponent("" + jeJavnoDostupno) + "&";
        if (jeDostupnoElektronski !== undefined && jeDostupnoElektronski !== null)
            url_ += "JeDostupnoElektronski=" + encodeURIComponent("" + jeDostupnoElektronski) + "&";
        if (klasifikacijaSifre !== undefined && klasifikacijaSifre !== null)
            klasifikacijaSifre && klasifikacijaSifre.forEach(item => { url_ += "KlasifikacijaSifre=" + encodeURIComponent("" + item) + "&"; });
        if (statusSifre !== undefined && statusSifre !== null)
            statusSifre && statusSifre.forEach(item => { url_ += "StatusSifre=" + encodeURIComponent("" + item) + "&"; });
        if (inicijalnoDeaktiviranje !== undefined && inicijalnoDeaktiviranje !== null)
            url_ += "InicijalnoDeaktiviranje=" + encodeURIComponent("" + inicijalnoDeaktiviranje) + "&";
        if (pocetakVazenjaOd !== undefined && pocetakVazenjaOd !== null)
            url_ += "PocetakVazenjaOd=" + encodeURIComponent(pocetakVazenjaOd ? "" + pocetakVazenjaOd.toISOString() : "") + "&";
        if (pocetakVazenjaDo !== undefined && pocetakVazenjaDo !== null)
            url_ += "PocetakVazenjaDo=" + encodeURIComponent(pocetakVazenjaDo ? "" + pocetakVazenjaDo.toISOString() : "") + "&";
        if (krajVazenjaOd !== undefined && krajVazenjaOd !== null)
            url_ += "KrajVazenjaOd=" + encodeURIComponent(krajVazenjaOd ? "" + krajVazenjaOd.toISOString() : "") + "&";
        if (krajVazenjaDo !== undefined && krajVazenjaDo !== null)
            url_ += "KrajVazenjaDo=" + encodeURIComponent(krajVazenjaDo ? "" + krajVazenjaDo.toISOString() : "") + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIzvozObjavljenihSluzbenihEvidencijaUExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIzvozObjavljenihSluzbenihEvidencijaUExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processIzvozObjavljenihSluzbenihEvidencijaUExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    dajSluzbenuEvidencijuPoSifri(sifra: string | null | undefined, verzija: string | null | undefined): Observable<DajSluzbenuEvidencijuPoSifriResponse> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/DajSluzbenuEvidencijuPoSifri?";
        if (sifra !== undefined && sifra !== null)
            url_ += "Sifra=" + encodeURIComponent("" + sifra) + "&";
        if (verzija !== undefined && verzija !== null)
            url_ += "Verzija=" + encodeURIComponent("" + verzija) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajSluzbenuEvidencijuPoSifri(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSluzbenuEvidencijuPoSifri(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajSluzbenuEvidencijuPoSifriResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajSluzbenuEvidencijuPoSifriResponse>;
        }));
    }

    protected processDajSluzbenuEvidencijuPoSifri(response: HttpResponseBase): Observable<DajSluzbenuEvidencijuPoSifriResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DajSluzbenuEvidencijuPoSifriResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajSluzbenuEvidencijuPoSifriResponse>(null as any);
    }

    vezaPojmaSaSluzbenimEvidencijama(idPojma: number | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfVezaPojmaSaSluzbenomEvidencijomResponse> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/VezaPojmaSaSluzbenimEvidencijama?";
        if (idPojma === null)
            throw new Error("The parameter 'idPojma' cannot be null.");
        else if (idPojma !== undefined)
            url_ += "IdPojma=" + encodeURIComponent("" + idPojma) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVezaPojmaSaSluzbenimEvidencijama(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVezaPojmaSaSluzbenimEvidencijama(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfVezaPojmaSaSluzbenomEvidencijomResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfVezaPojmaSaSluzbenomEvidencijomResponse>;
        }));
    }

    protected processVezaPojmaSaSluzbenimEvidencijama(response: HttpResponseBase): Observable<PagedResponseOfVezaPojmaSaSluzbenomEvidencijomResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfVezaPojmaSaSluzbenomEvidencijomResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfVezaPojmaSaSluzbenomEvidencijomResponse>(null as any);
    }

    vezaSvojstvaSaSluzbenimEvidencijama(svojstvoId: number | undefined, nadredjenoSvojstvoId: number | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfVezaSvojstvaSaSluzbenomEvidencijomResponse> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/VezaSvojstvaSaSluzbenimEvidencijama?";
        if (svojstvoId === null)
            throw new Error("The parameter 'svojstvoId' cannot be null.");
        else if (svojstvoId !== undefined)
            url_ += "SvojstvoId=" + encodeURIComponent("" + svojstvoId) + "&";
        if (nadredjenoSvojstvoId !== undefined && nadredjenoSvojstvoId !== null)
            url_ += "NadredjenoSvojstvoId=" + encodeURIComponent("" + nadredjenoSvojstvoId) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVezaSvojstvaSaSluzbenimEvidencijama(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVezaSvojstvaSaSluzbenimEvidencijama(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfVezaSvojstvaSaSluzbenomEvidencijomResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfVezaSvojstvaSaSluzbenomEvidencijomResponse>;
        }));
    }

    protected processVezaSvojstvaSaSluzbenimEvidencijama(response: HttpResponseBase): Observable<PagedResponseOfVezaSvojstvaSaSluzbenomEvidencijomResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfVezaSvojstvaSaSluzbenomEvidencijomResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfVezaSvojstvaSaSluzbenomEvidencijomResponse>(null as any);
    }

    pretragaObjavljenihSluzbenihEvidencijaPoNazivu(naziv: string | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfPretragaObjavljenihSluzbenihEvidencijaPoNazivuQueryResponse> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/PretragaObjavljenihSluzbenihEvidencijaPoNazivu?";
        if (naziv !== undefined && naziv !== null)
            url_ += "Naziv=" + encodeURIComponent("" + naziv) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPretragaObjavljenihSluzbenihEvidencijaPoNazivu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPretragaObjavljenihSluzbenihEvidencijaPoNazivu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfPretragaObjavljenihSluzbenihEvidencijaPoNazivuQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfPretragaObjavljenihSluzbenihEvidencijaPoNazivuQueryResponse>;
        }));
    }

    protected processPretragaObjavljenihSluzbenihEvidencijaPoNazivu(response: HttpResponseBase): Observable<PagedResponseOfPretragaObjavljenihSluzbenihEvidencijaPoNazivuQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfPretragaObjavljenihSluzbenihEvidencijaPoNazivuQueryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfPretragaObjavljenihSluzbenihEvidencijaPoNazivuQueryResponse>(null as any);
    }

    pretragaSluzbenihEvidencijaZaKS(naziv: string | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfPretragaSluzbenihEvidencijaZaKSQueryResponse> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/PretragaSluzbenihEvidencijaZaKS?";
        if (naziv !== undefined && naziv !== null)
            url_ += "Naziv=" + encodeURIComponent("" + naziv) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPretragaSluzbenihEvidencijaZaKS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPretragaSluzbenihEvidencijaZaKS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfPretragaSluzbenihEvidencijaZaKSQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfPretragaSluzbenihEvidencijaZaKSQueryResponse>;
        }));
    }

    protected processPretragaSluzbenihEvidencijaZaKS(response: HttpResponseBase): Observable<PagedResponseOfPretragaSluzbenihEvidencijaZaKSQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfPretragaSluzbenihEvidencijaZaKSQueryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfPretragaSluzbenihEvidencijaZaKSQueryResponse>(null as any);
    }

    daLiPostojiAktivnaSEZaOrgan(sifraOrgana: string | null | undefined, datumDeaktivacije: Date | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/DaLiPostojiAktivnaSEZaOrgan?";
        if (sifraOrgana !== undefined && sifraOrgana !== null)
            url_ += "SifraOrgana=" + encodeURIComponent("" + sifraOrgana) + "&";
        if (datumDeaktivacije === null)
            throw new Error("The parameter 'datumDeaktivacije' cannot be null.");
        else if (datumDeaktivacije !== undefined)
            url_ += "DatumDeaktivacije=" + encodeURIComponent(datumDeaktivacije ? "" + datumDeaktivacije.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDaLiPostojiAktivnaSEZaOrgan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDaLiPostojiAktivnaSEZaOrgan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDaLiPostojiAktivnaSEZaOrgan(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    povratakEvidencijeNaStatusUPripremi(command: PovratakEvidencijeNaStatusUPripremiCommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/PovratakEvidencijeNaStatusUPripremi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPovratakEvidencijeNaStatusUPripremi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPovratakEvidencijeNaStatusUPripremi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processPovratakEvidencijeNaStatusUPripremi(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }

    dajSifarnickuEvidencijuZaPojamId(sifarnickiPojamId: number | undefined): Observable<SluzbenaEvidencijaResponse> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/DajSifarnickuEvidencijuZaPojamId?";
        if (sifarnickiPojamId === null)
            throw new Error("The parameter 'sifarnickiPojamId' cannot be null.");
        else if (sifarnickiPojamId !== undefined)
            url_ += "SifarnickiPojamId=" + encodeURIComponent("" + sifarnickiPojamId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajSifarnickuEvidencijuZaPojamId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSifarnickuEvidencijuZaPojamId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SluzbenaEvidencijaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SluzbenaEvidencijaResponse>;
        }));
    }

    protected processDajSifarnickuEvidencijuZaPojamId(response: HttpResponseBase): Observable<SluzbenaEvidencijaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SluzbenaEvidencijaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SluzbenaEvidencijaResponse>(null as any);
    }

    obrisiKlasifikacijuIzSE(command: ObrisiKlasifikacijuIzSECommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/ObrisiKlasifikacijuIzSE";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObrisiKlasifikacijuIzSE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObrisiKlasifikacijuIzSE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processObrisiKlasifikacijuIzSE(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }

    kreirajNovuVerzijuSadrzajaSluzbeneEvidencije(command: KreirajNovuVerzijuSadrzajaSluzbeneEvidencijeCommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/KreirajNovuVerzijuSadrzaja";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKreirajNovuVerzijuSadrzajaSluzbeneEvidencije(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKreirajNovuVerzijuSadrzajaSluzbeneEvidencije(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processKreirajNovuVerzijuSadrzajaSluzbeneEvidencije(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }

    obrisiSadrzaj(command: ObrisiSadrzajSluzbeneEvidencijeCommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/ObrisiSadrzajSluzbeneEvidencije";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObrisiSadrzaj(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObrisiSadrzaj(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processObrisiSadrzaj(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }

    objaviSadrzaj(command: ObjaviSadrzajSluzbeneEvidencijeCommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/ObjaviSadrzajSluzbeneEvidencije";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObjaviSadrzaj(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObjaviSadrzaj(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processObjaviSadrzaj(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }

    deaktivirajSadrzaj(command: DeaktivirajSadrzajSluzbeneEvidencijeCommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/DeaktivirajSadrzajSluzbeneEvidencije";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeaktivirajSadrzaj(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeaktivirajSadrzaj(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processDeaktivirajSadrzaj(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }

    reaktivirajSadrzaj(command: ReaktivirajSadrzajSluzbeneEvidencijeCommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/ReaktivirajSadrzajSluzbeneEvidencije";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReaktivirajSadrzaj(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReaktivirajSadrzaj(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processReaktivirajSadrzaj(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }

    dajSveVerzijeSluzbeneEvidencije(sifra: string | null | undefined): Observable<DajSveVerzijeSluzbeneEvidencijeResponse> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/DajSveVerzijeSluzbeneEvidencije?";
        if (sifra !== undefined && sifra !== null)
            url_ += "Sifra=" + encodeURIComponent("" + sifra) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajSveVerzijeSluzbeneEvidencije(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSveVerzijeSluzbeneEvidencije(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajSveVerzijeSluzbeneEvidencijeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajSveVerzijeSluzbeneEvidencijeResponse>;
        }));
    }

    protected processDajSveVerzijeSluzbeneEvidencije(response: HttpResponseBase): Observable<DajSveVerzijeSluzbeneEvidencijeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DajSveVerzijeSluzbeneEvidencijeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajSveVerzijeSluzbeneEvidencijeResponse>(null as any);
    }

    dajSveVerzijeSadrzajaSluzbeneEvidencije(sifraSluzbeneEvidencije: string | null | undefined): Observable<DajSveVerzijeSadrzajaSluzbeneEvidencijeResponse> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/DajSveVerzijeSadrzajaSluzbeneEvidencije?";
        if (sifraSluzbeneEvidencije !== undefined && sifraSluzbeneEvidencije !== null)
            url_ += "SifraSluzbeneEvidencije=" + encodeURIComponent("" + sifraSluzbeneEvidencije) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajSveVerzijeSadrzajaSluzbeneEvidencije(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSveVerzijeSadrzajaSluzbeneEvidencije(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajSveVerzijeSadrzajaSluzbeneEvidencijeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajSveVerzijeSadrzajaSluzbeneEvidencijeResponse>;
        }));
    }

    protected processDajSveVerzijeSadrzajaSluzbeneEvidencije(response: HttpResponseBase): Observable<DajSveVerzijeSadrzajaSluzbeneEvidencijeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DajSveVerzijeSadrzajaSluzbeneEvidencijeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajSveVerzijeSadrzajaSluzbeneEvidencijeResponse>(null as any);
    }

    dajSadrzajSluzbeneEvidencije(sifraSadrzaja: string | null | undefined, verzija: string | null | undefined, vratiPoslednjuVerziju: boolean | undefined): Observable<DajSadrzajPoSifriResponse> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/DajSadrzajSluzbeneEvidencije?";
        if (sifraSadrzaja !== undefined && sifraSadrzaja !== null)
            url_ += "SifraSadrzaja=" + encodeURIComponent("" + sifraSadrzaja) + "&";
        if (verzija !== undefined && verzija !== null)
            url_ += "Verzija=" + encodeURIComponent("" + verzija) + "&";
        if (vratiPoslednjuVerziju === null)
            throw new Error("The parameter 'vratiPoslednjuVerziju' cannot be null.");
        else if (vratiPoslednjuVerziju !== undefined)
            url_ += "VratiPoslednjuVerziju=" + encodeURIComponent("" + vratiPoslednjuVerziju) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajSadrzajSluzbeneEvidencije(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSadrzajSluzbeneEvidencije(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajSadrzajPoSifriResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajSadrzajPoSifriResponse>;
        }));
    }

    protected processDajSadrzajSluzbeneEvidencije(response: HttpResponseBase): Observable<DajSadrzajPoSifriResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DajSadrzajPoSifriResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajSadrzajPoSifriResponse>(null as any);
    }

    sacuvajSadrzaj(command: SacuvajSadrzajSluzbeneEvidencijeCommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/SacuvajSadrzajSluzbeneEvidencije";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSacuvajSadrzaj(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSacuvajSadrzaj(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processSacuvajSadrzaj(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }

    povratakSadrzajaEvidencijeNaStatusUPripremi(command: PovratakSadrzajaEvidencijeNaStatusUPripremiCommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/PovratakSadrzajaEvidencijeNaStatusUPripremi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPovratakSadrzajaEvidencijeNaStatusUPripremi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPovratakSadrzajaEvidencijeNaStatusUPripremi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processPovratakSadrzajaEvidencijeNaStatusUPripremi(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }

    pretragaElemenataZaPovezivanje(sifraNadleznogOrgana: string | null | undefined, nazivSluzbeneEvidencije: string | null | undefined, nazivPojma: string | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfPretragaElemenataZaPovezivanjeQueryResponse> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/PretragaElemenataZaPovezivanje?";
        if (sifraNadleznogOrgana !== undefined && sifraNadleznogOrgana !== null)
            url_ += "SifraNadleznogOrgana=" + encodeURIComponent("" + sifraNadleznogOrgana) + "&";
        if (nazivSluzbeneEvidencije !== undefined && nazivSluzbeneEvidencije !== null)
            url_ += "NazivSluzbeneEvidencije=" + encodeURIComponent("" + nazivSluzbeneEvidencije) + "&";
        if (nazivPojma !== undefined && nazivPojma !== null)
            url_ += "NazivPojma=" + encodeURIComponent("" + nazivPojma) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPretragaElemenataZaPovezivanje(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPretragaElemenataZaPovezivanje(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfPretragaElemenataZaPovezivanjeQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfPretragaElemenataZaPovezivanjeQueryResponse>;
        }));
    }

    protected processPretragaElemenataZaPovezivanje(response: HttpResponseBase): Observable<PagedResponseOfPretragaElemenataZaPovezivanjeQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfPretragaElemenataZaPovezivanjeQueryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfPretragaElemenataZaPovezivanjeQueryResponse>(null as any);
    }

    dohvatanjeElemenataSluzbeneEvidencije(sifraSluzbeneEvidencije: string | null | undefined, nazivElementa: string | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfElementShortResponse> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/DohvatanjeElemenataSluzbeneEvidencije?";
        if (sifraSluzbeneEvidencije !== undefined && sifraSluzbeneEvidencije !== null)
            url_ += "SifraSluzbeneEvidencije=" + encodeURIComponent("" + sifraSluzbeneEvidencije) + "&";
        if (nazivElementa !== undefined && nazivElementa !== null)
            url_ += "NazivElementa=" + encodeURIComponent("" + nazivElementa) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDohvatanjeElemenataSluzbeneEvidencije(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDohvatanjeElemenataSluzbeneEvidencije(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfElementShortResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfElementShortResponse>;
        }));
    }

    protected processDohvatanjeElemenataSluzbeneEvidencije(response: HttpResponseBase): Observable<PagedResponseOfElementShortResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfElementShortResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfElementShortResponse>(null as any);
    }

    sacuvajElement(command: SacuvajElementCommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/SacuvajElement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSacuvajElement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSacuvajElement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processSacuvajElement(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }

    dajElement(sifraElementa: string | null | undefined, sifraSadrzaja: string | null | undefined, verzijaSadrzaja: string | null | undefined): Observable<DajElementPoSifriResponse> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/DajElement?";
        if (sifraElementa !== undefined && sifraElementa !== null)
            url_ += "SifraElementa=" + encodeURIComponent("" + sifraElementa) + "&";
        if (sifraSadrzaja !== undefined && sifraSadrzaja !== null)
            url_ += "SifraSadrzaja=" + encodeURIComponent("" + sifraSadrzaja) + "&";
        if (verzijaSadrzaja !== undefined && verzijaSadrzaja !== null)
            url_ += "VerzijaSadrzaja=" + encodeURIComponent("" + verzijaSadrzaja) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajElement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajElement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajElementPoSifriResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajElementPoSifriResponse>;
        }));
    }

    protected processDajElement(response: HttpResponseBase): Observable<DajElementPoSifriResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DajElementPoSifriResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajElementPoSifriResponse>(null as any);
    }

    obrisiElement(command: ObrisiElementCommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/ObrisiElement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObrisiElement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObrisiElement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processObrisiElement(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }

    obrisiElemente(command: ObrisiElementeCommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/ObrisiElemente";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObrisiElemente(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObrisiElemente(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processObrisiElemente(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }

    sacuvajSvojstvaReferentnogPojma(command: SacuvajSvojstvaReferentnogPojmaKaoElementeCommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/SacuvajSvojstvaReferentnogPojma";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSacuvajSvojstvaReferentnogPojma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSacuvajSvojstvaReferentnogPojma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processSacuvajSvojstvaReferentnogPojma(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }

    dajAktivneElementeSifarnika(sifraSifarnika: string | null | undefined): Observable<ElementSifarnikaResponse[]> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/DajAktivneElementeSifarnika?";
        if (sifraSifarnika !== undefined && sifraSifarnika !== null)
            url_ += "SifraSifarnika=" + encodeURIComponent("" + sifraSifarnika) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajAktivneElementeSifarnika(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajAktivneElementeSifarnika(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementSifarnikaResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementSifarnikaResponse[]>;
        }));
    }

    protected processDajAktivneElementeSifarnika(response: HttpResponseBase): Observable<ElementSifarnikaResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ElementSifarnikaResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElementSifarnikaResponse[]>(null as any);
    }

    oznaciIzvornostViseElemenata(command: OznaciIzvornostViseElemenataCommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/OznaciIzvornostViseElemenata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOznaciIzvornostViseElemenata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOznaciIzvornostViseElemenata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processOznaciIzvornostViseElemenata(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }

    zamenaRednihBrojevaElemenataEvidencije(command: ZamenaRednihBrojevaElemenataEvidencijeCommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/ZamenaRednihBrojevaElemenataEvidencije";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processZamenaRednihBrojevaElemenataEvidencije(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processZamenaRednihBrojevaElemenataEvidencije(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processZamenaRednihBrojevaElemenataEvidencije(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }

    dajStavkeSifarnika(sifarnikSifra: string | null | undefined, id: number | null | undefined, sifra: string | null | undefined, naziv: string | null | undefined, statusi: number[] | null | undefined, datumPocetkaVazenja: Date | null | undefined, datumPrestankaVazenja: Date | null | undefined, elementSifarnikaSifra: string | null | undefined, vrednostStavkeElementa: string | null | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<PagedResponseOfStavkaSifarnikaResponse> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/DajStavkeSifarnika?";
        if (sifarnikSifra !== undefined && sifarnikSifra !== null)
            url_ += "SifarnikSifra=" + encodeURIComponent("" + sifarnikSifra) + "&";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sifra !== undefined && sifra !== null)
            url_ += "Sifra=" + encodeURIComponent("" + sifra) + "&";
        if (naziv !== undefined && naziv !== null)
            url_ += "Naziv=" + encodeURIComponent("" + naziv) + "&";
        if (statusi !== undefined && statusi !== null)
            statusi && statusi.forEach(item => { url_ += "Statusi=" + encodeURIComponent("" + item) + "&"; });
        if (datumPocetkaVazenja !== undefined && datumPocetkaVazenja !== null)
            url_ += "DatumPocetkaVazenja=" + encodeURIComponent(datumPocetkaVazenja ? "" + datumPocetkaVazenja.toISOString() : "") + "&";
        if (datumPrestankaVazenja !== undefined && datumPrestankaVazenja !== null)
            url_ += "DatumPrestankaVazenja=" + encodeURIComponent(datumPrestankaVazenja ? "" + datumPrestankaVazenja.toISOString() : "") + "&";
        if (elementSifarnikaSifra !== undefined && elementSifarnikaSifra !== null)
            url_ += "ElementSifarnikaSifra=" + encodeURIComponent("" + elementSifarnikaSifra) + "&";
        if (vrednostStavkeElementa !== undefined && vrednostStavkeElementa !== null)
            url_ += "VrednostStavkeElementa=" + encodeURIComponent("" + vrednostStavkeElementa) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajStavkeSifarnika(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajStavkeSifarnika(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfStavkaSifarnikaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfStavkaSifarnikaResponse>;
        }));
    }

    protected processDajStavkeSifarnika(response: HttpResponseBase): Observable<PagedResponseOfStavkaSifarnikaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResponseOfStavkaSifarnikaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResponseOfStavkaSifarnikaResponse>(null as any);
    }

    dajStavkuSifarnika(id: number | undefined): Observable<DajStavkuSifarnikaPoSifriResponse> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/DajStavkuSifarnika?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajStavkuSifarnika(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajStavkuSifarnika(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajStavkuSifarnikaPoSifriResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajStavkuSifarnikaPoSifriResponse>;
        }));
    }

    protected processDajStavkuSifarnika(response: HttpResponseBase): Observable<DajStavkuSifarnikaPoSifriResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DajStavkuSifarnikaPoSifriResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajStavkuSifarnikaPoSifriResponse>(null as any);
    }

    sacuvajStavkuSifarnika(command: SacuvajStavkuSifarnikaCommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/SacuvajStavkuSifarnika";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSacuvajStavkuSifarnika(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSacuvajStavkuSifarnika(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processSacuvajStavkuSifarnika(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }

    obrisiStavkuSifarnika(command: ObrisiStavkuSifarnikaCommand): Observable<GenericActionResponseSE> {
        let url_ = this.baseUrl + "/api/SluzbenaEvidencija/ObrisiStavkuSifarnika";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObrisiStavkuSifarnika(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObrisiStavkuSifarnika(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseSE>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseSE>;
        }));
    }

    protected processObrisiStavkuSifarnika(response: HttpResponseBase): Observable<GenericActionResponseSE> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseSE.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseSE>(null as any);
    }
}

export interface ISvojstvoClient {
    sacuvajSvojstvo(command: SacuvajSvojstvoCommand): Observable<GenericActionResponseRP>;
    dajSvojstvaPojma(sifraPojma: string | null | undefined, verzija: string | null | undefined, vratitiDoOsnovnogTipa: boolean | undefined, vratitiDoPrimitivnogTipa: boolean | undefined, vratitiSamoAktivnaSvojstva: boolean | undefined, vratitiSamoAktivnaSvojstvaNaTipu: boolean | undefined): Observable<DajSvojstvaPojmaResponse>;
    dajSvojstvaPojmaZaStablo(id: number | undefined, vratitiSamoAktivnaSvojstva: boolean | undefined): Observable<DajSvojstvaTipaZaStabloResponse[]>;
    dajSvojstvaPojmaZaListu(sifraPojma: string | null | undefined, verzija: string | null | undefined, vratitiDoOsnovnogTipa: boolean | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<DajSvojstvaPojmaZaListuResponse>;
    dajSvojstvoZaId(id: number | undefined): Observable<SvojstvoPojmaShort>;
    daLiPostojeSvojstvaUPripremiZaIdPojma(idPojma: number | undefined): Observable<boolean>;
    obrisiSvojstvo(command: ObrisiSvojstvoCommand): Observable<GenericActionResponseRP>;
    deaktivirajSvojstvo(command: DeaktivirajSvojstvoCommand): Observable<GenericActionResponseRP>;
    reaktivirajSvojstvo(command: ReaktivirajSvojstvoCommand): Observable<GenericActionResponseRP>;
    objaviSvojstvaPojma(command: ObjaviSvojstvaPojmaCommand): Observable<GenericActionResponseRP>;
    dajSvojstvaPojmaZaElementId(elementId: number | undefined, rootPodstablaPutanja: string | null | undefined, vratitiSamoAktivnaSvojstva: boolean | undefined): Observable<DajSvojstvaPojmaResponse>;
    duplikacijaSvojstvaPojma(command: DuplikacijaSvojstvaPojmaCommand): Observable<GenericActionResponseRP>;
    dodavanjeSvojstavaSaPodstablaTipa(command: DodajSvojstvaTipaNaPojamKaoPodstabloCommand): Observable<GenericActionResponseRP>;
    zamenaRednihBrojevaSvojstava(command: ZamenaRednihBrojevaSvojstavaCommand): Observable<GenericActionResponseRP>;
    dajSvojstvaPojmaZaElementPorukeId(elementPorukeId: number | undefined, rootPodstablaPutanja: string | null | undefined, vratitiSamoAktivnaSvojstva: boolean | undefined): Observable<DajSvojstvaPojmaResponse>;
    dajPrviNivoSvojstvaTipaZaStablo(tipId: number | undefined, putanjaSlozenogTipa: string | null | undefined): Observable<SvojstvoZaStabloResponse[]>;
    dajPrviNivoSvojstvaTipaZaStabloZaIzborSvojstava(tipId: number | undefined, putanjaSlozenogTipa: string | null | undefined): Observable<SvojstvoZaStabloZaIzborResponse[]>;
}

@Injectable({
    providedIn: 'root'
})
export class SvojstvoClient implements ISvojstvoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:9112";
    }

    sacuvajSvojstvo(command: SacuvajSvojstvoCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Svojstvo/SacuvajSvojstvo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSacuvajSvojstvo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSacuvajSvojstvo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processSacuvajSvojstvo(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    dajSvojstvaPojma(sifraPojma: string | null | undefined, verzija: string | null | undefined, vratitiDoOsnovnogTipa: boolean | undefined, vratitiDoPrimitivnogTipa: boolean | undefined, vratitiSamoAktivnaSvojstva: boolean | undefined, vratitiSamoAktivnaSvojstvaNaTipu: boolean | undefined): Observable<DajSvojstvaPojmaResponse> {
        let url_ = this.baseUrl + "/api/Svojstvo/DajSvojstvaPojma?";
        if (sifraPojma !== undefined && sifraPojma !== null)
            url_ += "SifraPojma=" + encodeURIComponent("" + sifraPojma) + "&";
        if (verzija !== undefined && verzija !== null)
            url_ += "Verzija=" + encodeURIComponent("" + verzija) + "&";
        if (vratitiDoOsnovnogTipa === null)
            throw new Error("The parameter 'vratitiDoOsnovnogTipa' cannot be null.");
        else if (vratitiDoOsnovnogTipa !== undefined)
            url_ += "VratitiDoOsnovnogTipa=" + encodeURIComponent("" + vratitiDoOsnovnogTipa) + "&";
        if (vratitiDoPrimitivnogTipa === null)
            throw new Error("The parameter 'vratitiDoPrimitivnogTipa' cannot be null.");
        else if (vratitiDoPrimitivnogTipa !== undefined)
            url_ += "VratitiDoPrimitivnogTipa=" + encodeURIComponent("" + vratitiDoPrimitivnogTipa) + "&";
        if (vratitiSamoAktivnaSvojstva === null)
            throw new Error("The parameter 'vratitiSamoAktivnaSvojstva' cannot be null.");
        else if (vratitiSamoAktivnaSvojstva !== undefined)
            url_ += "VratitiSamoAktivnaSvojstva=" + encodeURIComponent("" + vratitiSamoAktivnaSvojstva) + "&";
        if (vratitiSamoAktivnaSvojstvaNaTipu === null)
            throw new Error("The parameter 'vratitiSamoAktivnaSvojstvaNaTipu' cannot be null.");
        else if (vratitiSamoAktivnaSvojstvaNaTipu !== undefined)
            url_ += "VratitiSamoAktivnaSvojstvaNaTipu=" + encodeURIComponent("" + vratitiSamoAktivnaSvojstvaNaTipu) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajSvojstvaPojma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSvojstvaPojma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajSvojstvaPojmaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajSvojstvaPojmaResponse>;
        }));
    }

    protected processDajSvojstvaPojma(response: HttpResponseBase): Observable<DajSvojstvaPojmaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DajSvojstvaPojmaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajSvojstvaPojmaResponse>(null as any);
    }

    dajSvojstvaPojmaZaStablo(id: number | undefined, vratitiSamoAktivnaSvojstva: boolean | undefined): Observable<DajSvojstvaTipaZaStabloResponse[]> {
        let url_ = this.baseUrl + "/api/Svojstvo/DajSvojstvaPojmaZaStablo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (vratitiSamoAktivnaSvojstva === null)
            throw new Error("The parameter 'vratitiSamoAktivnaSvojstva' cannot be null.");
        else if (vratitiSamoAktivnaSvojstva !== undefined)
            url_ += "VratitiSamoAktivnaSvojstva=" + encodeURIComponent("" + vratitiSamoAktivnaSvojstva) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajSvojstvaPojmaZaStablo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSvojstvaPojmaZaStablo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajSvojstvaTipaZaStabloResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajSvojstvaTipaZaStabloResponse[]>;
        }));
    }

    protected processDajSvojstvaPojmaZaStablo(response: HttpResponseBase): Observable<DajSvojstvaTipaZaStabloResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DajSvojstvaTipaZaStabloResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajSvojstvaTipaZaStabloResponse[]>(null as any);
    }

    dajSvojstvaPojmaZaListu(sifraPojma: string | null | undefined, verzija: string | null | undefined, vratitiDoOsnovnogTipa: boolean | undefined, keyword: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortBy: string | null | undefined, sortDirection: string | null | undefined): Observable<DajSvojstvaPojmaZaListuResponse> {
        let url_ = this.baseUrl + "/api/Svojstvo/DajSvojstvaPojmaZaListu?";
        if (sifraPojma !== undefined && sifraPojma !== null)
            url_ += "SifraPojma=" + encodeURIComponent("" + sifraPojma) + "&";
        if (verzija !== undefined && verzija !== null)
            url_ += "Verzija=" + encodeURIComponent("" + verzija) + "&";
        if (vratitiDoOsnovnogTipa === null)
            throw new Error("The parameter 'vratitiDoOsnovnogTipa' cannot be null.");
        else if (vratitiDoOsnovnogTipa !== undefined)
            url_ += "VratitiDoOsnovnogTipa=" + encodeURIComponent("" + vratitiDoOsnovnogTipa) + "&";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajSvojstvaPojmaZaListu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSvojstvaPojmaZaListu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajSvojstvaPojmaZaListuResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajSvojstvaPojmaZaListuResponse>;
        }));
    }

    protected processDajSvojstvaPojmaZaListu(response: HttpResponseBase): Observable<DajSvojstvaPojmaZaListuResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DajSvojstvaPojmaZaListuResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajSvojstvaPojmaZaListuResponse>(null as any);
    }

    dajSvojstvoZaId(id: number | undefined): Observable<SvojstvoPojmaShort> {
        let url_ = this.baseUrl + "/api/Svojstvo/DajSvojstvoZaId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajSvojstvoZaId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSvojstvoZaId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SvojstvoPojmaShort>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SvojstvoPojmaShort>;
        }));
    }

    protected processDajSvojstvoZaId(response: HttpResponseBase): Observable<SvojstvoPojmaShort> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SvojstvoPojmaShort.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SvojstvoPojmaShort>(null as any);
    }

    daLiPostojeSvojstvaUPripremiZaIdPojma(idPojma: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Svojstvo/DaLiPostojeSvojstvaUPripremiZaIdPojma?";
        if (idPojma === null)
            throw new Error("The parameter 'idPojma' cannot be null.");
        else if (idPojma !== undefined)
            url_ += "IdPojma=" + encodeURIComponent("" + idPojma) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDaLiPostojeSvojstvaUPripremiZaIdPojma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDaLiPostojeSvojstvaUPripremiZaIdPojma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDaLiPostojeSvojstvaUPripremiZaIdPojma(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    obrisiSvojstvo(command: ObrisiSvojstvoCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Svojstvo/ObrisiSvojstvo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObrisiSvojstvo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObrisiSvojstvo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processObrisiSvojstvo(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    deaktivirajSvojstvo(command: DeaktivirajSvojstvoCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Svojstvo/DeaktivirajSvojstvo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeaktivirajSvojstvo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeaktivirajSvojstvo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processDeaktivirajSvojstvo(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    reaktivirajSvojstvo(command: ReaktivirajSvojstvoCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Svojstvo/ReaktivirajSvojstvo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReaktivirajSvojstvo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReaktivirajSvojstvo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processReaktivirajSvojstvo(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    objaviSvojstvaPojma(command: ObjaviSvojstvaPojmaCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Svojstvo/ObjaviSvojstvaPojma";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObjaviSvojstvaPojma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObjaviSvojstvaPojma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processObjaviSvojstvaPojma(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    dajSvojstvaPojmaZaElementId(elementId: number | undefined, rootPodstablaPutanja: string | null | undefined, vratitiSamoAktivnaSvojstva: boolean | undefined): Observable<DajSvojstvaPojmaResponse> {
        let url_ = this.baseUrl + "/api/Svojstvo/DajSvojstvaPojmaZaElementId?";
        if (elementId === null)
            throw new Error("The parameter 'elementId' cannot be null.");
        else if (elementId !== undefined)
            url_ += "ElementId=" + encodeURIComponent("" + elementId) + "&";
        if (rootPodstablaPutanja !== undefined && rootPodstablaPutanja !== null)
            url_ += "RootPodstablaPutanja=" + encodeURIComponent("" + rootPodstablaPutanja) + "&";
        if (vratitiSamoAktivnaSvojstva === null)
            throw new Error("The parameter 'vratitiSamoAktivnaSvojstva' cannot be null.");
        else if (vratitiSamoAktivnaSvojstva !== undefined)
            url_ += "VratitiSamoAktivnaSvojstva=" + encodeURIComponent("" + vratitiSamoAktivnaSvojstva) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajSvojstvaPojmaZaElementId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSvojstvaPojmaZaElementId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajSvojstvaPojmaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajSvojstvaPojmaResponse>;
        }));
    }

    protected processDajSvojstvaPojmaZaElementId(response: HttpResponseBase): Observable<DajSvojstvaPojmaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DajSvojstvaPojmaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajSvojstvaPojmaResponse>(null as any);
    }

    duplikacijaSvojstvaPojma(command: DuplikacijaSvojstvaPojmaCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Svojstvo/DuplikacijaSvojstvaPojma";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplikacijaSvojstvaPojma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplikacijaSvojstvaPojma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processDuplikacijaSvojstvaPojma(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    dodavanjeSvojstavaSaPodstablaTipa(command: DodajSvojstvaTipaNaPojamKaoPodstabloCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Svojstvo/DodavanjeSvojstavaSaPodstablaTipa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDodavanjeSvojstavaSaPodstablaTipa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDodavanjeSvojstavaSaPodstablaTipa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processDodavanjeSvojstavaSaPodstablaTipa(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    zamenaRednihBrojevaSvojstava(command: ZamenaRednihBrojevaSvojstavaCommand): Observable<GenericActionResponseRP> {
        let url_ = this.baseUrl + "/api/Svojstvo/ZamenaRednihBrojevaSvojstava";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processZamenaRednihBrojevaSvojstava(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processZamenaRednihBrojevaSvojstava(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenericActionResponseRP>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenericActionResponseRP>;
        }));
    }

    protected processZamenaRednihBrojevaSvojstava(response: HttpResponseBase): Observable<GenericActionResponseRP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericActionResponseRP.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenericActionResponseRP>(null as any);
    }

    dajSvojstvaPojmaZaElementPorukeId(elementPorukeId: number | undefined, rootPodstablaPutanja: string | null | undefined, vratitiSamoAktivnaSvojstva: boolean | undefined): Observable<DajSvojstvaPojmaResponse> {
        let url_ = this.baseUrl + "/api/Svojstvo/DajSvojstvaPojmaZaElementPorukeId?";
        if (elementPorukeId === null)
            throw new Error("The parameter 'elementPorukeId' cannot be null.");
        else if (elementPorukeId !== undefined)
            url_ += "ElementPorukeId=" + encodeURIComponent("" + elementPorukeId) + "&";
        if (rootPodstablaPutanja !== undefined && rootPodstablaPutanja !== null)
            url_ += "RootPodstablaPutanja=" + encodeURIComponent("" + rootPodstablaPutanja) + "&";
        if (vratitiSamoAktivnaSvojstva === null)
            throw new Error("The parameter 'vratitiSamoAktivnaSvojstva' cannot be null.");
        else if (vratitiSamoAktivnaSvojstva !== undefined)
            url_ += "VratitiSamoAktivnaSvojstva=" + encodeURIComponent("" + vratitiSamoAktivnaSvojstva) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajSvojstvaPojmaZaElementPorukeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSvojstvaPojmaZaElementPorukeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DajSvojstvaPojmaResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DajSvojstvaPojmaResponse>;
        }));
    }

    protected processDajSvojstvaPojmaZaElementPorukeId(response: HttpResponseBase): Observable<DajSvojstvaPojmaResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DajSvojstvaPojmaResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DajSvojstvaPojmaResponse>(null as any);
    }

    dajPrviNivoSvojstvaTipaZaStablo(tipId: number | undefined, putanjaSlozenogTipa: string | null | undefined): Observable<SvojstvoZaStabloResponse[]> {
        let url_ = this.baseUrl + "/api/Svojstvo/DajPrviNivoSvojstvaTipaZaStablo?";
        if (tipId === null)
            throw new Error("The parameter 'tipId' cannot be null.");
        else if (tipId !== undefined)
            url_ += "TipId=" + encodeURIComponent("" + tipId) + "&";
        if (putanjaSlozenogTipa !== undefined && putanjaSlozenogTipa !== null)
            url_ += "PutanjaSlozenogTipa=" + encodeURIComponent("" + putanjaSlozenogTipa) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajPrviNivoSvojstvaTipaZaStablo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajPrviNivoSvojstvaTipaZaStablo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SvojstvoZaStabloResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SvojstvoZaStabloResponse[]>;
        }));
    }

    protected processDajPrviNivoSvojstvaTipaZaStablo(response: HttpResponseBase): Observable<SvojstvoZaStabloResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SvojstvoZaStabloResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SvojstvoZaStabloResponse[]>(null as any);
    }

    dajPrviNivoSvojstvaTipaZaStabloZaIzborSvojstava(tipId: number | undefined, putanjaSlozenogTipa: string | null | undefined): Observable<SvojstvoZaStabloZaIzborResponse[]> {
        let url_ = this.baseUrl + "/api/Svojstvo/DajPrviNivoSvojstvaTipaZaStabloZaIzborSvojstava?";
        if (tipId === null)
            throw new Error("The parameter 'tipId' cannot be null.");
        else if (tipId !== undefined)
            url_ += "TipId=" + encodeURIComponent("" + tipId) + "&";
        if (putanjaSlozenogTipa !== undefined && putanjaSlozenogTipa !== null)
            url_ += "PutanjaSlozenogTipa=" + encodeURIComponent("" + putanjaSlozenogTipa) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajPrviNivoSvojstvaTipaZaStabloZaIzborSvojstava(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajPrviNivoSvojstvaTipaZaStabloZaIzborSvojstava(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SvojstvoZaStabloZaIzborResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SvojstvoZaStabloZaIzborResponse[]>;
        }));
    }

    protected processDajPrviNivoSvojstvaTipaZaStabloZaIzborSvojstava(response: HttpResponseBase): Observable<SvojstvoZaStabloZaIzborResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SvojstvoZaStabloZaIzborResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SvojstvoZaStabloZaIzborResponse[]>(null as any);
    }
}

export interface ITipoviPodatakaClient {
    dajSvaOgranicenjaZaSifruTipaPodatka(sifra: string | null | undefined): Observable<TipOgranicenjaResponse[]>;
}

@Injectable({
    providedIn: 'root'
})
export class TipoviPodatakaClient implements ITipoviPodatakaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:9112";
    }

    dajSvaOgranicenjaZaSifruTipaPodatka(sifra: string | null | undefined): Observable<TipOgranicenjaResponse[]> {
        let url_ = this.baseUrl + "/api/TipoviPodataka/DajSvaOgranicenjaZaSifruTipaPodatka?";
        if (sifra !== undefined && sifra !== null)
            url_ += "Sifra=" + encodeURIComponent("" + sifra) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDajSvaOgranicenjaZaSifruTipaPodatka(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDajSvaOgranicenjaZaSifruTipaPodatka(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipOgranicenjaResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipOgranicenjaResponse[]>;
        }));
    }

    protected processDajSvaOgranicenjaZaSifruTipaPodatka(response: HttpResponseBase): Observable<TipOgranicenjaResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TipOgranicenjaResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipOgranicenjaResponse[]>(null as any);
    }
}

export interface IHealthCheckClient {
    getLiveness(): Observable<FileResponse | null>;
    getReadiness(): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class HealthCheckClient implements IHealthCheckClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:9112";
    }

    getLiveness(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/live";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiveness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiveness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetLiveness(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(null as any);
    }

    getReadiness(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/ready";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReadiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReadiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetReadiness(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(null as any);
    }
}

export class PagedResponseOfDomenResponse implements IPagedResponseOfDomenResponse {
    items?: DomenResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfDomenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DomenResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfDomenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfDomenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfDomenResponse {
    items?: DomenResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class DomenResponse implements IDomenResponse {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivImenskogProstora?: string | undefined;
    skraceniNaziv?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IDomenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.nazivImenskogProstora = _data["nazivImenskogProstora"];
            this.skraceniNaziv = _data["skraceniNaziv"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): DomenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DomenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["nazivImenskogProstora"] = this.nazivImenskogProstora;
        data["skraceniNaziv"] = this.skraceniNaziv;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IDomenResponse {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivImenskogProstora?: string | undefined;
    skraceniNaziv?: string | undefined;
    opis?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class HttpValidationProblemDetails extends ProblemDetails implements IHttpValidationProblemDetails {
    errors!: { [key: string]: string[]; };

    [key: string]: any;

    constructor(data?: IHttpValidationProblemDetails) {
        super(data);
        if (!data) {
            this.errors = {};
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HttpValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HttpValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IHttpValidationProblemDetails extends IProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export class ValidationProblemDetails extends HttpValidationProblemDetails implements IValidationProblemDetails {
    errors!: { [key: string]: string[]; };

    [key: string]: any;

    constructor(data?: IValidationProblemDetails) {
        super(data);
        if (!data) {
            this.errors = {};
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IValidationProblemDetails extends IHttpValidationProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export class GenericActionResponseRP implements IGenericActionResponseRP {
    responseMessage?: string | undefined;
    responseBool!: boolean;
    warningMessage?: string | undefined;
    payload?: string | undefined;
    data?: any | undefined;

    constructor(data?: IGenericActionResponseRP) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseMessage = _data["responseMessage"];
            this.responseBool = _data["responseBool"];
            this.warningMessage = _data["warningMessage"];
            this.payload = _data["payload"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): GenericActionResponseRP {
        data = typeof data === 'object' ? data : {};
        let result = new GenericActionResponseRP();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseMessage"] = this.responseMessage;
        data["responseBool"] = this.responseBool;
        data["warningMessage"] = this.warningMessage;
        data["payload"] = this.payload;
        data["data"] = this.data;
        return data;
    }
}

export interface IGenericActionResponseRP {
    responseMessage?: string | undefined;
    responseBool: boolean;
    warningMessage?: string | undefined;
    payload?: string | undefined;
    data?: any | undefined;
}

export class IzmeniDomenCommand implements IIzmeniDomenCommand {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    skraceniNazivDomena?: string | undefined;

    constructor(data?: IIzmeniDomenCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.skraceniNazivDomena = _data["skraceniNazivDomena"];
        }
    }

    static fromJS(data: any): IzmeniDomenCommand {
        data = typeof data === 'object' ? data : {};
        let result = new IzmeniDomenCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["skraceniNazivDomena"] = this.skraceniNazivDomena;
        return data;
    }
}

export interface IIzmeniDomenCommand {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    skraceniNazivDomena?: string | undefined;
}

export class KreirajDomenCommand implements IKreirajDomenCommand {
    naziv?: string | undefined;
    skraceniNazivDomena?: string | undefined;

    constructor(data?: IKreirajDomenCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.skraceniNazivDomena = _data["skraceniNazivDomena"];
        }
    }

    static fromJS(data: any): KreirajDomenCommand {
        data = typeof data === 'object' ? data : {};
        let result = new KreirajDomenCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["skraceniNazivDomena"] = this.skraceniNazivDomena;
        return data;
    }
}

export interface IKreirajDomenCommand {
    naziv?: string | undefined;
    skraceniNazivDomena?: string | undefined;
}

export class ObrisiDomenCommand implements IObrisiDomenCommand {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivImenskogProstora?: string | undefined;
    skraceniNaziv?: string | undefined;

    constructor(data?: IObrisiDomenCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.nazivImenskogProstora = _data["nazivImenskogProstora"];
            this.skraceniNaziv = _data["skraceniNaziv"];
        }
    }

    static fromJS(data: any): ObrisiDomenCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObrisiDomenCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["nazivImenskogProstora"] = this.nazivImenskogProstora;
        data["skraceniNaziv"] = this.skraceniNaziv;
        return data;
    }
}

export interface IObrisiDomenCommand {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivImenskogProstora?: string | undefined;
    skraceniNaziv?: string | undefined;
}

export class DajElementePorukeResponse implements IDajElementePorukeResponse {
    elementiPoruke?: ElementPorukeShort[] | undefined;

    constructor(data?: IDajElementePorukeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elementiPoruke"])) {
                this.elementiPoruke = [] as any;
                for (let item of _data["elementiPoruke"])
                    this.elementiPoruke!.push(ElementPorukeShort.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DajElementePorukeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajElementePorukeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elementiPoruke)) {
            data["elementiPoruke"] = [];
            for (let item of this.elementiPoruke)
                data["elementiPoruke"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDajElementePorukeResponse {
    elementiPoruke?: ElementPorukeShort[] | undefined;
}

export class ElementPorukeShort implements IElementPorukeShort {
    id!: number;
    porukaId!: number;
    sifraPoruke?: string | undefined;
    nazivPoruke?: string | undefined;
    nazivElementa?: string | undefined;
    tehnickiNaziv?: string | undefined;
    nazivTipaPodatka?: string | undefined;
    putanja?: string | undefined;
    putanjaIzPojma?: string | undefined;
    definicija?: string | undefined;
    slozeniPojamId!: number;
    slozeniPojamNaziv?: string | undefined;
    pojamUSastavuId!: number;
    pojamUSastavuNaziv?: string | undefined;
    pojamUSastavuVrstaTipaId!: number;
    nadredjeniElementId?: number | undefined;
    nasledjenOdSvojstvaId?: number | undefined;
    kardinalnost?: string | undefined;
    minBrojPojavljivanja?: string | undefined;
    maxBrojPojavljivanja?: string | undefined;
    sufiksNaziva?: string | undefined;
    punNazivPorukeURecniku?: string | undefined;
    suzeniTipId?: number | undefined;
    suzeniTipNaziv?: string | undefined;
    vrstaTipaId!: number;
    skupVrednostiOgranicen!: boolean;
    jeKvalifikator!: boolean;
    statusId!: number;
    statusNaziv?: string | undefined;
    zaDeaktivaciju?: boolean | undefined;
    statusNaPojmuId?: number | undefined;
    statusNaTipuId!: number;
    jeSekcija!: boolean;
    nivo!: number;
    pripadaId?: number | undefined;
    redniBroj!: number;

    constructor(data?: IElementPorukeShort) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.porukaId = _data["porukaId"];
            this.sifraPoruke = _data["sifraPoruke"];
            this.nazivPoruke = _data["nazivPoruke"];
            this.nazivElementa = _data["nazivElementa"];
            this.tehnickiNaziv = _data["tehnickiNaziv"];
            this.nazivTipaPodatka = _data["nazivTipaPodatka"];
            this.putanja = _data["putanja"];
            this.putanjaIzPojma = _data["putanjaIzPojma"];
            this.definicija = _data["definicija"];
            this.slozeniPojamId = _data["slozeniPojamId"];
            this.slozeniPojamNaziv = _data["slozeniPojamNaziv"];
            this.pojamUSastavuId = _data["pojamUSastavuId"];
            this.pojamUSastavuNaziv = _data["pojamUSastavuNaziv"];
            this.pojamUSastavuVrstaTipaId = _data["pojamUSastavuVrstaTipaId"];
            this.nadredjeniElementId = _data["nadredjeniElementId"];
            this.nasledjenOdSvojstvaId = _data["nasledjenOdSvojstvaId"];
            this.kardinalnost = _data["kardinalnost"];
            this.minBrojPojavljivanja = _data["minBrojPojavljivanja"];
            this.maxBrojPojavljivanja = _data["maxBrojPojavljivanja"];
            this.sufiksNaziva = _data["sufiksNaziva"];
            this.punNazivPorukeURecniku = _data["punNazivPorukeURecniku"];
            this.suzeniTipId = _data["suzeniTipId"];
            this.suzeniTipNaziv = _data["suzeniTipNaziv"];
            this.vrstaTipaId = _data["vrstaTipaId"];
            this.skupVrednostiOgranicen = _data["skupVrednostiOgranicen"];
            this.jeKvalifikator = _data["jeKvalifikator"];
            this.statusId = _data["statusId"];
            this.statusNaziv = _data["statusNaziv"];
            this.zaDeaktivaciju = _data["zaDeaktivaciju"];
            this.statusNaPojmuId = _data["statusNaPojmuId"];
            this.statusNaTipuId = _data["statusNaTipuId"];
            this.jeSekcija = _data["jeSekcija"];
            this.nivo = _data["nivo"];
            this.pripadaId = _data["pripadaId"];
            this.redniBroj = _data["redniBroj"];
        }
    }

    static fromJS(data: any): ElementPorukeShort {
        data = typeof data === 'object' ? data : {};
        let result = new ElementPorukeShort();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["porukaId"] = this.porukaId;
        data["sifraPoruke"] = this.sifraPoruke;
        data["nazivPoruke"] = this.nazivPoruke;
        data["nazivElementa"] = this.nazivElementa;
        data["tehnickiNaziv"] = this.tehnickiNaziv;
        data["nazivTipaPodatka"] = this.nazivTipaPodatka;
        data["putanja"] = this.putanja;
        data["putanjaIzPojma"] = this.putanjaIzPojma;
        data["definicija"] = this.definicija;
        data["slozeniPojamId"] = this.slozeniPojamId;
        data["slozeniPojamNaziv"] = this.slozeniPojamNaziv;
        data["pojamUSastavuId"] = this.pojamUSastavuId;
        data["pojamUSastavuNaziv"] = this.pojamUSastavuNaziv;
        data["pojamUSastavuVrstaTipaId"] = this.pojamUSastavuVrstaTipaId;
        data["nadredjeniElementId"] = this.nadredjeniElementId;
        data["nasledjenOdSvojstvaId"] = this.nasledjenOdSvojstvaId;
        data["kardinalnost"] = this.kardinalnost;
        data["minBrojPojavljivanja"] = this.minBrojPojavljivanja;
        data["maxBrojPojavljivanja"] = this.maxBrojPojavljivanja;
        data["sufiksNaziva"] = this.sufiksNaziva;
        data["punNazivPorukeURecniku"] = this.punNazivPorukeURecniku;
        data["suzeniTipId"] = this.suzeniTipId;
        data["suzeniTipNaziv"] = this.suzeniTipNaziv;
        data["vrstaTipaId"] = this.vrstaTipaId;
        data["skupVrednostiOgranicen"] = this.skupVrednostiOgranicen;
        data["jeKvalifikator"] = this.jeKvalifikator;
        data["statusId"] = this.statusId;
        data["statusNaziv"] = this.statusNaziv;
        data["zaDeaktivaciju"] = this.zaDeaktivaciju;
        data["statusNaPojmuId"] = this.statusNaPojmuId;
        data["statusNaTipuId"] = this.statusNaTipuId;
        data["jeSekcija"] = this.jeSekcija;
        data["nivo"] = this.nivo;
        data["pripadaId"] = this.pripadaId;
        data["redniBroj"] = this.redniBroj;
        return data;
    }
}

export interface IElementPorukeShort {
    id: number;
    porukaId: number;
    sifraPoruke?: string | undefined;
    nazivPoruke?: string | undefined;
    nazivElementa?: string | undefined;
    tehnickiNaziv?: string | undefined;
    nazivTipaPodatka?: string | undefined;
    putanja?: string | undefined;
    putanjaIzPojma?: string | undefined;
    definicija?: string | undefined;
    slozeniPojamId: number;
    slozeniPojamNaziv?: string | undefined;
    pojamUSastavuId: number;
    pojamUSastavuNaziv?: string | undefined;
    pojamUSastavuVrstaTipaId: number;
    nadredjeniElementId?: number | undefined;
    nasledjenOdSvojstvaId?: number | undefined;
    kardinalnost?: string | undefined;
    minBrojPojavljivanja?: string | undefined;
    maxBrojPojavljivanja?: string | undefined;
    sufiksNaziva?: string | undefined;
    punNazivPorukeURecniku?: string | undefined;
    suzeniTipId?: number | undefined;
    suzeniTipNaziv?: string | undefined;
    vrstaTipaId: number;
    skupVrednostiOgranicen: boolean;
    jeKvalifikator: boolean;
    statusId: number;
    statusNaziv?: string | undefined;
    zaDeaktivaciju?: boolean | undefined;
    statusNaPojmuId?: number | undefined;
    statusNaTipuId: number;
    jeSekcija: boolean;
    nivo: number;
    pripadaId?: number | undefined;
    redniBroj: number;
}

export class ElementPorukeZaStabloResponse implements IElementPorukeZaStabloResponse {
    id!: number;
    suzeniTipId?: number | undefined;
    suzeniTipNaziv?: string | undefined;
    nazivElementa?: string | undefined;
    sifraPoruke?: string | undefined;
    nadredjeniElementId?: number | undefined;
    statusNaPojmuId?: number | undefined;
    redniBroj!: number;
    tehnickiNaziv?: string | undefined;
    pripadaId?: number | undefined;
    statusId!: number;
    zaDeaktivaciju?: boolean | undefined;
    pojamUSastavuVrstaTipaId!: number;
    pojamUSastavuNaziv?: string | undefined;
    pojamUSastavuTehnickiNaziv?: string | undefined;
    putanja?: string | undefined;
    nasledjenOdSvojstvaId?: number | undefined;

    constructor(data?: IElementPorukeZaStabloResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.suzeniTipId = _data["suzeniTipId"];
            this.suzeniTipNaziv = _data["suzeniTipNaziv"];
            this.nazivElementa = _data["nazivElementa"];
            this.sifraPoruke = _data["sifraPoruke"];
            this.nadredjeniElementId = _data["nadredjeniElementId"];
            this.statusNaPojmuId = _data["statusNaPojmuId"];
            this.redniBroj = _data["redniBroj"];
            this.tehnickiNaziv = _data["tehnickiNaziv"];
            this.pripadaId = _data["pripadaId"];
            this.statusId = _data["statusId"];
            this.zaDeaktivaciju = _data["zaDeaktivaciju"];
            this.pojamUSastavuVrstaTipaId = _data["pojamUSastavuVrstaTipaId"];
            this.pojamUSastavuNaziv = _data["pojamUSastavuNaziv"];
            this.pojamUSastavuTehnickiNaziv = _data["pojamUSastavuTehnickiNaziv"];
            this.putanja = _data["putanja"];
            this.nasledjenOdSvojstvaId = _data["nasledjenOdSvojstvaId"];
        }
    }

    static fromJS(data: any): ElementPorukeZaStabloResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ElementPorukeZaStabloResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["suzeniTipId"] = this.suzeniTipId;
        data["suzeniTipNaziv"] = this.suzeniTipNaziv;
        data["nazivElementa"] = this.nazivElementa;
        data["sifraPoruke"] = this.sifraPoruke;
        data["nadredjeniElementId"] = this.nadredjeniElementId;
        data["statusNaPojmuId"] = this.statusNaPojmuId;
        data["redniBroj"] = this.redniBroj;
        data["tehnickiNaziv"] = this.tehnickiNaziv;
        data["pripadaId"] = this.pripadaId;
        data["statusId"] = this.statusId;
        data["zaDeaktivaciju"] = this.zaDeaktivaciju;
        data["pojamUSastavuVrstaTipaId"] = this.pojamUSastavuVrstaTipaId;
        data["pojamUSastavuNaziv"] = this.pojamUSastavuNaziv;
        data["pojamUSastavuTehnickiNaziv"] = this.pojamUSastavuTehnickiNaziv;
        data["putanja"] = this.putanja;
        data["nasledjenOdSvojstvaId"] = this.nasledjenOdSvojstvaId;
        return data;
    }
}

export interface IElementPorukeZaStabloResponse {
    id: number;
    suzeniTipId?: number | undefined;
    suzeniTipNaziv?: string | undefined;
    nazivElementa?: string | undefined;
    sifraPoruke?: string | undefined;
    nadredjeniElementId?: number | undefined;
    statusNaPojmuId?: number | undefined;
    redniBroj: number;
    tehnickiNaziv?: string | undefined;
    pripadaId?: number | undefined;
    statusId: number;
    zaDeaktivaciju?: boolean | undefined;
    pojamUSastavuVrstaTipaId: number;
    pojamUSastavuNaziv?: string | undefined;
    pojamUSastavuTehnickiNaziv?: string | undefined;
    putanja?: string | undefined;
    nasledjenOdSvojstvaId?: number | undefined;
}

export class DajElementePorukeZaListuResponse implements IDajElementePorukeZaListuResponse {
    elementiPoruke?: ElementPorukeShort[] | undefined;

    constructor(data?: IDajElementePorukeZaListuResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elementiPoruke"])) {
                this.elementiPoruke = [] as any;
                for (let item of _data["elementiPoruke"])
                    this.elementiPoruke!.push(ElementPorukeShort.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DajElementePorukeZaListuResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajElementePorukeZaListuResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elementiPoruke)) {
            data["elementiPoruke"] = [];
            for (let item of this.elementiPoruke)
                data["elementiPoruke"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDajElementePorukeZaListuResponse {
    elementiPoruke?: ElementPorukeShort[] | undefined;
}

export class SacuvajElementPorukeCommand implements ISacuvajElementPorukeCommand {
    id!: number;
    porukaId!: number;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    definicija?: string | undefined;
    minBrojPojavljivanja?: string | undefined;
    maxBrojPojavljivanja?: string | undefined;
    statusId!: number;
    zaDeaktivaciju?: boolean | undefined;

    constructor(data?: ISacuvajElementPorukeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.porukaId = _data["porukaId"];
            this.naziv = _data["naziv"];
            this.tehnickiNaziv = _data["tehnickiNaziv"];
            this.definicija = _data["definicija"];
            this.minBrojPojavljivanja = _data["minBrojPojavljivanja"];
            this.maxBrojPojavljivanja = _data["maxBrojPojavljivanja"];
            this.statusId = _data["statusId"];
            this.zaDeaktivaciju = _data["zaDeaktivaciju"];
        }
    }

    static fromJS(data: any): SacuvajElementPorukeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SacuvajElementPorukeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["porukaId"] = this.porukaId;
        data["naziv"] = this.naziv;
        data["tehnickiNaziv"] = this.tehnickiNaziv;
        data["definicija"] = this.definicija;
        data["minBrojPojavljivanja"] = this.minBrojPojavljivanja;
        data["maxBrojPojavljivanja"] = this.maxBrojPojavljivanja;
        data["statusId"] = this.statusId;
        data["zaDeaktivaciju"] = this.zaDeaktivaciju;
        return data;
    }
}

export interface ISacuvajElementPorukeCommand {
    id: number;
    porukaId: number;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    definicija?: string | undefined;
    minBrojPojavljivanja?: string | undefined;
    maxBrojPojavljivanja?: string | undefined;
    statusId: number;
    zaDeaktivaciju?: boolean | undefined;
}

export class ElementPorukeZaIdResponse implements IElementPorukeZaIdResponse {
    id!: number;
    porukaId!: number;
    nazivElementa?: string | undefined;
    tehnickiNaziv?: string | undefined;
    definicija?: string | undefined;
    nazivTipaPodatka?: string | undefined;
    putanja?: string | undefined;
    putanjaIzPojma?: string | undefined;
    statusId!: number;
    statusNaziv?: string | undefined;
    minBrojPojavljivanja?: string | undefined;
    maxBrojPojavljivanja?: string | undefined;
    zaDeaktivaciju?: boolean | undefined;

    constructor(data?: IElementPorukeZaIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.porukaId = _data["porukaId"];
            this.nazivElementa = _data["nazivElementa"];
            this.tehnickiNaziv = _data["tehnickiNaziv"];
            this.definicija = _data["definicija"];
            this.nazivTipaPodatka = _data["nazivTipaPodatka"];
            this.putanja = _data["putanja"];
            this.putanjaIzPojma = _data["putanjaIzPojma"];
            this.statusId = _data["statusId"];
            this.statusNaziv = _data["statusNaziv"];
            this.minBrojPojavljivanja = _data["minBrojPojavljivanja"];
            this.maxBrojPojavljivanja = _data["maxBrojPojavljivanja"];
            this.zaDeaktivaciju = _data["zaDeaktivaciju"];
        }
    }

    static fromJS(data: any): ElementPorukeZaIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ElementPorukeZaIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["porukaId"] = this.porukaId;
        data["nazivElementa"] = this.nazivElementa;
        data["tehnickiNaziv"] = this.tehnickiNaziv;
        data["definicija"] = this.definicija;
        data["nazivTipaPodatka"] = this.nazivTipaPodatka;
        data["putanja"] = this.putanja;
        data["putanjaIzPojma"] = this.putanjaIzPojma;
        data["statusId"] = this.statusId;
        data["statusNaziv"] = this.statusNaziv;
        data["minBrojPojavljivanja"] = this.minBrojPojavljivanja;
        data["maxBrojPojavljivanja"] = this.maxBrojPojavljivanja;
        data["zaDeaktivaciju"] = this.zaDeaktivaciju;
        return data;
    }
}

export interface IElementPorukeZaIdResponse {
    id: number;
    porukaId: number;
    nazivElementa?: string | undefined;
    tehnickiNaziv?: string | undefined;
    definicija?: string | undefined;
    nazivTipaPodatka?: string | undefined;
    putanja?: string | undefined;
    putanjaIzPojma?: string | undefined;
    statusId: number;
    statusNaziv?: string | undefined;
    minBrojPojavljivanja?: string | undefined;
    maxBrojPojavljivanja?: string | undefined;
    zaDeaktivaciju?: boolean | undefined;
}

export class ObrisiElementPorukeCommand implements IObrisiElementPorukeCommand {
    idPoruke!: number;
    idElementa!: number;

    constructor(data?: IObrisiElementPorukeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPoruke = _data["idPoruke"];
            this.idElementa = _data["idElementa"];
        }
    }

    static fromJS(data: any): ObrisiElementPorukeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObrisiElementPorukeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPoruke"] = this.idPoruke;
        data["idElementa"] = this.idElementa;
        return data;
    }
}

export interface IObrisiElementPorukeCommand {
    idPoruke: number;
    idElementa: number;
}

export class DeaktivirajElementPorukeCommand implements IDeaktivirajElementPorukeCommand {
    idPoruke!: number;
    idElementa!: number;

    constructor(data?: IDeaktivirajElementPorukeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPoruke = _data["idPoruke"];
            this.idElementa = _data["idElementa"];
        }
    }

    static fromJS(data: any): DeaktivirajElementPorukeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeaktivirajElementPorukeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPoruke"] = this.idPoruke;
        data["idElementa"] = this.idElementa;
        return data;
    }
}

export interface IDeaktivirajElementPorukeCommand {
    idPoruke: number;
    idElementa: number;
}

export class ReaktivirajElementPorukeCommand implements IReaktivirajElementPorukeCommand {
    idPoruke!: number;
    idElementa!: number;

    constructor(data?: IReaktivirajElementPorukeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPoruke = _data["idPoruke"];
            this.idElementa = _data["idElementa"];
        }
    }

    static fromJS(data: any): ReaktivirajElementPorukeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReaktivirajElementPorukeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPoruke"] = this.idPoruke;
        data["idElementa"] = this.idElementa;
        return data;
    }
}

export interface IReaktivirajElementPorukeCommand {
    idPoruke: number;
    idElementa: number;
}

export class ObjaviElementePorukeCommand implements IObjaviElementePorukeCommand {
    idPoruke!: number;
    domenId!: number;
    definicija?: string | undefined;
    kljucneReci?: KljucnaRecCmd[] | undefined;

    constructor(data?: IObjaviElementePorukeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPoruke = _data["idPoruke"];
            this.domenId = _data["domenId"];
            this.definicija = _data["definicija"];
            if (Array.isArray(_data["kljucneReci"])) {
                this.kljucneReci = [] as any;
                for (let item of _data["kljucneReci"])
                    this.kljucneReci!.push(KljucnaRecCmd.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ObjaviElementePorukeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObjaviElementePorukeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPoruke"] = this.idPoruke;
        data["domenId"] = this.domenId;
        data["definicija"] = this.definicija;
        if (Array.isArray(this.kljucneReci)) {
            data["kljucneReci"] = [];
            for (let item of this.kljucneReci)
                data["kljucneReci"].push(item.toJSON());
        }
        return data;
    }
}

export interface IObjaviElementePorukeCommand {
    idPoruke: number;
    domenId: number;
    definicija?: string | undefined;
    kljucneReci?: KljucnaRecCmd[] | undefined;
}

export class KljucnaRecCmd implements IKljucnaRecCmd {
    tekst?: string | undefined;

    constructor(data?: IKljucnaRecCmd) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tekst = _data["tekst"];
        }
    }

    static fromJS(data: any): KljucnaRecCmd {
        data = typeof data === 'object' ? data : {};
        let result = new KljucnaRecCmd();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tekst"] = this.tekst;
        return data;
    }
}

export interface IKljucnaRecCmd {
    tekst?: string | undefined;
}

export class GenericActionResponseSE implements IGenericActionResponseSE {
    responseMessage?: string | undefined;
    responseBool!: boolean;
    warningMessage?: string | undefined;

    constructor(data?: IGenericActionResponseSE) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseMessage = _data["responseMessage"];
            this.responseBool = _data["responseBool"];
            this.warningMessage = _data["warningMessage"];
        }
    }

    static fromJS(data: any): GenericActionResponseSE {
        data = typeof data === 'object' ? data : {};
        let result = new GenericActionResponseSE();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseMessage"] = this.responseMessage;
        data["responseBool"] = this.responseBool;
        data["warningMessage"] = this.warningMessage;
        return data;
    }
}

export interface IGenericActionResponseSE {
    responseMessage?: string | undefined;
    responseBool: boolean;
    warningMessage?: string | undefined;
}

export class SacuvajSvojstvaReferentnogPojmaKaoElementePorukeCommand implements ISacuvajSvojstvaReferentnogPojmaKaoElementePorukeCommand {
    idPoruke!: number;
    pojamId!: number;
    svojstvaReferentnogPojma?: SvojstvoReferentnogPojma[] | undefined;

    constructor(data?: ISacuvajSvojstvaReferentnogPojmaKaoElementePorukeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPoruke = _data["idPoruke"];
            this.pojamId = _data["pojamId"];
            if (Array.isArray(_data["svojstvaReferentnogPojma"])) {
                this.svojstvaReferentnogPojma = [] as any;
                for (let item of _data["svojstvaReferentnogPojma"])
                    this.svojstvaReferentnogPojma!.push(SvojstvoReferentnogPojma.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SacuvajSvojstvaReferentnogPojmaKaoElementePorukeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SacuvajSvojstvaReferentnogPojmaKaoElementePorukeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPoruke"] = this.idPoruke;
        data["pojamId"] = this.pojamId;
        if (Array.isArray(this.svojstvaReferentnogPojma)) {
            data["svojstvaReferentnogPojma"] = [];
            for (let item of this.svojstvaReferentnogPojma)
                data["svojstvaReferentnogPojma"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISacuvajSvojstvaReferentnogPojmaKaoElementePorukeCommand {
    idPoruke: number;
    pojamId: number;
    svojstvaReferentnogPojma?: SvojstvoReferentnogPojma[] | undefined;
}

export class SvojstvoReferentnogPojma implements ISvojstvoReferentnogPojma {
    nadredjenoSvojstvoId?: number | undefined;
    svojstvoId!: number;
    putanja?: string | undefined;
    nadredjenaPutanja?: string | undefined;

    constructor(data?: ISvojstvoReferentnogPojma) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nadredjenoSvojstvoId = _data["nadredjenoSvojstvoId"];
            this.svojstvoId = _data["svojstvoId"];
            this.putanja = _data["putanja"];
            this.nadredjenaPutanja = _data["nadredjenaPutanja"];
        }
    }

    static fromJS(data: any): SvojstvoReferentnogPojma {
        data = typeof data === 'object' ? data : {};
        let result = new SvojstvoReferentnogPojma();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nadredjenoSvojstvoId"] = this.nadredjenoSvojstvoId;
        data["svojstvoId"] = this.svojstvoId;
        data["putanja"] = this.putanja;
        data["nadredjenaPutanja"] = this.nadredjenaPutanja;
        return data;
    }
}

export interface ISvojstvoReferentnogPojma {
    nadredjenoSvojstvoId?: number | undefined;
    svojstvoId: number;
    putanja?: string | undefined;
    nadredjenaPutanja?: string | undefined;
}

export class ZamenaRednihBrojevaElemenataPorukeCommand implements IZamenaRednihBrojevaElemenataPorukeCommand {
    gornjiElementId!: number;
    donjiElementId!: number;

    constructor(data?: IZamenaRednihBrojevaElemenataPorukeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gornjiElementId = _data["gornjiElementId"];
            this.donjiElementId = _data["donjiElementId"];
        }
    }

    static fromJS(data: any): ZamenaRednihBrojevaElemenataPorukeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ZamenaRednihBrojevaElemenataPorukeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gornjiElementId"] = this.gornjiElementId;
        data["donjiElementId"] = this.donjiElementId;
        return data;
    }
}

export interface IZamenaRednihBrojevaElemenataPorukeCommand {
    gornjiElementId: number;
    donjiElementId: number;
}

export class PagedResponseOfKlasifikacijaResponse implements IPagedResponseOfKlasifikacijaResponse {
    items?: KlasifikacijaResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfKlasifikacijaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(KlasifikacijaResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfKlasifikacijaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfKlasifikacijaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfKlasifikacijaResponse {
    items?: KlasifikacijaResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class KlasifikacijaResponse implements IKlasifikacijaResponse {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    opis?: string | undefined;
    vaziOd!: Date;
    vaziDo?: Date | undefined;
    statusId!: number;
    statusNaziv?: string | undefined;
    jeDozvoljenVisestrukiIzbor?: boolean | undefined;
    nadredjenaKlasifikacijaId?: number | undefined;
    nazivNadredjeneKlasifikacije?: string | undefined;

    constructor(data?: IKlasifikacijaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.opis = _data["opis"];
            this.vaziOd = _data["vaziOd"] ? new Date(_data["vaziOd"].toString()) : <any>undefined;
            this.vaziDo = _data["vaziDo"] ? new Date(_data["vaziDo"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.statusNaziv = _data["statusNaziv"];
            this.jeDozvoljenVisestrukiIzbor = _data["jeDozvoljenVisestrukiIzbor"];
            this.nadredjenaKlasifikacijaId = _data["nadredjenaKlasifikacijaId"];
            this.nazivNadredjeneKlasifikacije = _data["nazivNadredjeneKlasifikacije"];
        }
    }

    static fromJS(data: any): KlasifikacijaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new KlasifikacijaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["opis"] = this.opis;
        data["vaziOd"] = this.vaziOd ? this.vaziOd.toISOString() : <any>undefined;
        data["vaziDo"] = this.vaziDo ? this.vaziDo.toISOString() : <any>undefined;
        data["statusId"] = this.statusId;
        data["statusNaziv"] = this.statusNaziv;
        data["jeDozvoljenVisestrukiIzbor"] = this.jeDozvoljenVisestrukiIzbor;
        data["nadredjenaKlasifikacijaId"] = this.nadredjenaKlasifikacijaId;
        data["nazivNadredjeneKlasifikacije"] = this.nazivNadredjeneKlasifikacije;
        return data;
    }
}

export interface IKlasifikacijaResponse {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    opis?: string | undefined;
    vaziOd: Date;
    vaziDo?: Date | undefined;
    statusId: number;
    statusNaziv?: string | undefined;
    jeDozvoljenVisestrukiIzbor?: boolean | undefined;
    nadredjenaKlasifikacijaId?: number | undefined;
    nazivNadredjeneKlasifikacije?: string | undefined;
}

export class DajKlasifikacijeZaListuQuery implements IDajKlasifikacijeZaListuQuery {

    constructor(data?: IDajKlasifikacijeZaListuQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DajKlasifikacijeZaListuQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DajKlasifikacijeZaListuQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDajKlasifikacijeZaListuQuery {
}

export class SacuvajKlasifikacijuCommand implements ISacuvajKlasifikacijuCommand {
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
    opis?: string | undefined;
    vaziOd!: Date;
    vaziDo?: Date | undefined;
    statusId!: number;
    jeDozvoljenVisestrukiIzbor?: boolean | undefined;
    nadredjenaKlasifikacijaId?: number | undefined;

    constructor(data?: ISacuvajKlasifikacijuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.nazivLatinica = _data["nazivLatinica"];
            this.opis = _data["opis"];
            this.vaziOd = _data["vaziOd"] ? new Date(_data["vaziOd"].toString()) : <any>undefined;
            this.vaziDo = _data["vaziDo"] ? new Date(_data["vaziDo"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.jeDozvoljenVisestrukiIzbor = _data["jeDozvoljenVisestrukiIzbor"];
            this.nadredjenaKlasifikacijaId = _data["nadredjenaKlasifikacijaId"];
        }
    }

    static fromJS(data: any): SacuvajKlasifikacijuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SacuvajKlasifikacijuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["nazivLatinica"] = this.nazivLatinica;
        data["opis"] = this.opis;
        data["vaziOd"] = this.vaziOd ? this.vaziOd.toISOString() : <any>undefined;
        data["vaziDo"] = this.vaziDo ? this.vaziDo.toISOString() : <any>undefined;
        data["statusId"] = this.statusId;
        data["jeDozvoljenVisestrukiIzbor"] = this.jeDozvoljenVisestrukiIzbor;
        data["nadredjenaKlasifikacijaId"] = this.nadredjenaKlasifikacijaId;
        return data;
    }
}

export interface ISacuvajKlasifikacijuCommand {
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
    opis?: string | undefined;
    vaziOd: Date;
    vaziDo?: Date | undefined;
    statusId: number;
    jeDozvoljenVisestrukiIzbor?: boolean | undefined;
    nadredjenaKlasifikacijaId?: number | undefined;
}

export class ObrisiKlasifikacijuCommand implements IObrisiKlasifikacijuCommand {
    sifra?: string | undefined;

    constructor(data?: IObrisiKlasifikacijuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
        }
    }

    static fromJS(data: any): ObrisiKlasifikacijuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObrisiKlasifikacijuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        return data;
    }
}

export interface IObrisiKlasifikacijuCommand {
    sifra?: string | undefined;
}

export class SnimiOgranicenjeProstogPojmaCommand implements ISnimiOgranicenjeProstogPojmaCommand {
    id!: number;
    idPojma!: number;
    tipOgranicenjaId!: number;
    naziv?: string | undefined;
    opis?: string | undefined;
    vrednost?: string | undefined;

    constructor(data?: ISnimiOgranicenjeProstogPojmaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idPojma = _data["idPojma"];
            this.tipOgranicenjaId = _data["tipOgranicenjaId"];
            this.naziv = _data["naziv"];
            this.opis = _data["opis"];
            this.vrednost = _data["vrednost"];
        }
    }

    static fromJS(data: any): SnimiOgranicenjeProstogPojmaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SnimiOgranicenjeProstogPojmaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idPojma"] = this.idPojma;
        data["tipOgranicenjaId"] = this.tipOgranicenjaId;
        data["naziv"] = this.naziv;
        data["opis"] = this.opis;
        data["vrednost"] = this.vrednost;
        return data;
    }
}

export interface ISnimiOgranicenjeProstogPojmaCommand {
    id: number;
    idPojma: number;
    tipOgranicenjaId: number;
    naziv?: string | undefined;
    opis?: string | undefined;
    vrednost?: string | undefined;
}

export class OgranicenjePojmaResponse implements IOgranicenjePojmaResponse {
    id!: number;
    ogranicenjePojmaId!: number;
    naziv?: string | undefined;
    vrednost?: string | undefined;
    opis?: string | undefined;
    tipOgranicenjaId!: number;
    idOgranicenja!: number;
    pojamOdKogJeNasledjenoId?: number | undefined;

    constructor(data?: IOgranicenjePojmaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ogranicenjePojmaId = _data["ogranicenjePojmaId"];
            this.naziv = _data["naziv"];
            this.vrednost = _data["vrednost"];
            this.opis = _data["opis"];
            this.tipOgranicenjaId = _data["tipOgranicenjaId"];
            this.idOgranicenja = _data["idOgranicenja"];
            this.pojamOdKogJeNasledjenoId = _data["pojamOdKogJeNasledjenoId"];
        }
    }

    static fromJS(data: any): OgranicenjePojmaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OgranicenjePojmaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ogranicenjePojmaId"] = this.ogranicenjePojmaId;
        data["naziv"] = this.naziv;
        data["vrednost"] = this.vrednost;
        data["opis"] = this.opis;
        data["tipOgranicenjaId"] = this.tipOgranicenjaId;
        data["idOgranicenja"] = this.idOgranicenja;
        data["pojamOdKogJeNasledjenoId"] = this.pojamOdKogJeNasledjenoId;
        return data;
    }
}

export interface IOgranicenjePojmaResponse {
    id: number;
    ogranicenjePojmaId: number;
    naziv?: string | undefined;
    vrednost?: string | undefined;
    opis?: string | undefined;
    tipOgranicenjaId: number;
    idOgranicenja: number;
    pojamOdKogJeNasledjenoId?: number | undefined;
}

export class ObrisiOgranicenjePojmaCommand implements IObrisiOgranicenjePojmaCommand {
    idOgranicenjePojma!: number;

    constructor(data?: IObrisiOgranicenjePojmaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idOgranicenjePojma = _data["idOgranicenjePojma"];
        }
    }

    static fromJS(data: any): ObrisiOgranicenjePojmaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObrisiOgranicenjePojmaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idOgranicenjePojma"] = this.idOgranicenjePojma;
        return data;
    }
}

export interface IObrisiOgranicenjePojmaCommand {
    idOgranicenjePojma: number;
}

export class IzmeniOgranicenjeCommand implements IIzmeniOgranicenjeCommand {
    id!: number;
    idPojma!: number;
    tipOgranicenjaId!: number;
    naziv?: string | undefined;
    opis?: string | undefined;
    vrednost?: string | undefined;

    constructor(data?: IIzmeniOgranicenjeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idPojma = _data["idPojma"];
            this.tipOgranicenjaId = _data["tipOgranicenjaId"];
            this.naziv = _data["naziv"];
            this.opis = _data["opis"];
            this.vrednost = _data["vrednost"];
        }
    }

    static fromJS(data: any): IzmeniOgranicenjeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new IzmeniOgranicenjeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idPojma"] = this.idPojma;
        data["tipOgranicenjaId"] = this.tipOgranicenjaId;
        data["naziv"] = this.naziv;
        data["opis"] = this.opis;
        data["vrednost"] = this.vrednost;
        return data;
    }
}

export interface IIzmeniOgranicenjeCommand {
    id: number;
    idPojma: number;
    tipOgranicenjaId: number;
    naziv?: string | undefined;
    opis?: string | undefined;
    vrednost?: string | undefined;
}

export class SacuvajPojamCommand implements ISacuvajPojamCommand {
    sifra?: string | undefined;
    domenId!: number;
    vrstaTipaId!: number;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    punNazivTipaURecniku?: string | undefined;
    definicija?: string | undefined;
    jeSifarnickiPojam!: boolean;
    jeIzveden!: boolean;
    izvedenIzId?: number | undefined;
    osnovniPojamSifra?: string | undefined;
    verzija?: string | undefined;
    skupVrednostiOgranicen!: number;
    jeAsocijacija?: boolean | undefined;
    jeZavisan?: boolean | undefined;
    tipAgregacijeId?: number | undefined;
    kljucneReci?: KljucnaRecCmd[] | undefined;

    constructor(data?: ISacuvajPojamCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.domenId = _data["domenId"];
            this.vrstaTipaId = _data["vrstaTipaId"];
            this.naziv = _data["naziv"];
            this.tehnickiNaziv = _data["tehnickiNaziv"];
            this.punNazivTipaURecniku = _data["punNazivTipaURecniku"];
            this.definicija = _data["definicija"];
            this.jeSifarnickiPojam = _data["jeSifarnickiPojam"];
            this.jeIzveden = _data["jeIzveden"];
            this.izvedenIzId = _data["izvedenIzId"];
            this.osnovniPojamSifra = _data["osnovniPojamSifra"];
            this.verzija = _data["verzija"];
            this.skupVrednostiOgranicen = _data["skupVrednostiOgranicen"];
            this.jeAsocijacija = _data["jeAsocijacija"];
            this.jeZavisan = _data["jeZavisan"];
            this.tipAgregacijeId = _data["tipAgregacijeId"];
            if (Array.isArray(_data["kljucneReci"])) {
                this.kljucneReci = [] as any;
                for (let item of _data["kljucneReci"])
                    this.kljucneReci!.push(KljucnaRecCmd.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SacuvajPojamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SacuvajPojamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["domenId"] = this.domenId;
        data["vrstaTipaId"] = this.vrstaTipaId;
        data["naziv"] = this.naziv;
        data["tehnickiNaziv"] = this.tehnickiNaziv;
        data["punNazivTipaURecniku"] = this.punNazivTipaURecniku;
        data["definicija"] = this.definicija;
        data["jeSifarnickiPojam"] = this.jeSifarnickiPojam;
        data["jeIzveden"] = this.jeIzveden;
        data["izvedenIzId"] = this.izvedenIzId;
        data["osnovniPojamSifra"] = this.osnovniPojamSifra;
        data["verzija"] = this.verzija;
        data["skupVrednostiOgranicen"] = this.skupVrednostiOgranicen;
        data["jeAsocijacija"] = this.jeAsocijacija;
        data["jeZavisan"] = this.jeZavisan;
        data["tipAgregacijeId"] = this.tipAgregacijeId;
        if (Array.isArray(this.kljucneReci)) {
            data["kljucneReci"] = [];
            for (let item of this.kljucneReci)
                data["kljucneReci"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISacuvajPojamCommand {
    sifra?: string | undefined;
    domenId: number;
    vrstaTipaId: number;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    punNazivTipaURecniku?: string | undefined;
    definicija?: string | undefined;
    jeSifarnickiPojam: boolean;
    jeIzveden: boolean;
    izvedenIzId?: number | undefined;
    osnovniPojamSifra?: string | undefined;
    verzija?: string | undefined;
    skupVrednostiOgranicen: number;
    jeAsocijacija?: boolean | undefined;
    jeZavisan?: boolean | undefined;
    tipAgregacijeId?: number | undefined;
    kljucneReci?: KljucnaRecCmd[] | undefined;
}

export class PagedResponseOfPretragaPojmovaResponse implements IPagedResponseOfPretragaPojmovaResponse {
    items?: PretragaPojmovaResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfPretragaPojmovaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PretragaPojmovaResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfPretragaPojmovaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfPretragaPojmovaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfPretragaPojmovaResponse {
    items?: PretragaPojmovaResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class PretragaPojmovaResponse implements IPretragaPojmovaResponse {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    vrstaTipaId!: number;
    osnovniTipNaziv?: string | undefined;
    nazivPrimitivnogTipa?: string | undefined;
    nazivDomena?: string | undefined;
    skraceniNazivDomena?: string | undefined;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    definicija?: string | undefined;
    verzija?: string | undefined;
    datumDo?: Date | undefined;

    constructor(data?: IPretragaPojmovaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.vrstaTipaId = _data["vrstaTipaId"];
            this.osnovniTipNaziv = _data["osnovniTipNaziv"];
            this.nazivPrimitivnogTipa = _data["nazivPrimitivnogTipa"];
            this.nazivDomena = _data["nazivDomena"];
            this.skraceniNazivDomena = _data["skraceniNazivDomena"];
            this.statusSifra = _data["statusSifra"];
            this.statusNaziv = _data["statusNaziv"];
            this.definicija = _data["definicija"];
            this.verzija = _data["verzija"];
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PretragaPojmovaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PretragaPojmovaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["vrstaTipaId"] = this.vrstaTipaId;
        data["osnovniTipNaziv"] = this.osnovniTipNaziv;
        data["nazivPrimitivnogTipa"] = this.nazivPrimitivnogTipa;
        data["nazivDomena"] = this.nazivDomena;
        data["skraceniNazivDomena"] = this.skraceniNazivDomena;
        data["statusSifra"] = this.statusSifra;
        data["statusNaziv"] = this.statusNaziv;
        data["definicija"] = this.definicija;
        data["verzija"] = this.verzija;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPretragaPojmovaResponse {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    vrstaTipaId: number;
    osnovniTipNaziv?: string | undefined;
    nazivPrimitivnogTipa?: string | undefined;
    nazivDomena?: string | undefined;
    skraceniNazivDomena?: string | undefined;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    definicija?: string | undefined;
    verzija?: string | undefined;
    datumDo?: Date | undefined;
}

export class DajPojamPoSifriResponse implements IDajPojamPoSifriResponse {
    id!: number;
    sifraTipaPodatka?: string | undefined;
    sifra?: string | undefined;
    domenId!: number;
    domen?: DomenResponse | undefined;
    vrstaTipaId!: number;
    naziv?: string | undefined;
    kvalifikovaniNaziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    punNazivTipaURecniku?: string | undefined;
    definicija?: string | undefined;
    jeSifarnickiPojam!: boolean;
    jeIzveden!: boolean;
    izvedenIz?: IzvedenIzResponse | undefined;
    jeSlozen!: boolean;
    tipPodatkaId?: number | undefined;
    statusSifra?: string | undefined;
    verzija?: string | undefined;
    poslednjaVerzija!: boolean;
    statusVerzijeId!: number;
    datumOd!: Date;
    datumDo?: Date | undefined;
    skupVrednostiOgranicen!: number;
    kljucneReci?: KljucnaRecCmd[] | undefined;
    jeAsocijacija?: boolean | undefined;
    sifarnikSifra?: string | undefined;
    nazivSifarnika?: string | undefined;
    jeZavisan?: boolean | undefined;
    tipAgregacijeId?: number | undefined;

    constructor(data?: IDajPojamPoSifriResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifraTipaPodatka = _data["sifraTipaPodatka"];
            this.sifra = _data["sifra"];
            this.domenId = _data["domenId"];
            this.domen = _data["domen"] ? DomenResponse.fromJS(_data["domen"]) : <any>undefined;
            this.vrstaTipaId = _data["vrstaTipaId"];
            this.naziv = _data["naziv"];
            this.kvalifikovaniNaziv = _data["kvalifikovaniNaziv"];
            this.tehnickiNaziv = _data["tehnickiNaziv"];
            this.punNazivTipaURecniku = _data["punNazivTipaURecniku"];
            this.definicija = _data["definicija"];
            this.jeSifarnickiPojam = _data["jeSifarnickiPojam"];
            this.jeIzveden = _data["jeIzveden"];
            this.izvedenIz = _data["izvedenIz"] ? IzvedenIzResponse.fromJS(_data["izvedenIz"]) : <any>undefined;
            this.jeSlozen = _data["jeSlozen"];
            this.tipPodatkaId = _data["tipPodatkaId"];
            this.statusSifra = _data["statusSifra"];
            this.verzija = _data["verzija"];
            this.poslednjaVerzija = _data["poslednjaVerzija"];
            this.statusVerzijeId = _data["statusVerzijeId"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.skupVrednostiOgranicen = _data["skupVrednostiOgranicen"];
            if (Array.isArray(_data["kljucneReci"])) {
                this.kljucneReci = [] as any;
                for (let item of _data["kljucneReci"])
                    this.kljucneReci!.push(KljucnaRecCmd.fromJS(item));
            }
            this.jeAsocijacija = _data["jeAsocijacija"];
            this.sifarnikSifra = _data["sifarnikSifra"];
            this.nazivSifarnika = _data["nazivSifarnika"];
            this.jeZavisan = _data["jeZavisan"];
            this.tipAgregacijeId = _data["tipAgregacijeId"];
        }
    }

    static fromJS(data: any): DajPojamPoSifriResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajPojamPoSifriResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifraTipaPodatka"] = this.sifraTipaPodatka;
        data["sifra"] = this.sifra;
        data["domenId"] = this.domenId;
        data["domen"] = this.domen ? this.domen.toJSON() : <any>undefined;
        data["vrstaTipaId"] = this.vrstaTipaId;
        data["naziv"] = this.naziv;
        data["kvalifikovaniNaziv"] = this.kvalifikovaniNaziv;
        data["tehnickiNaziv"] = this.tehnickiNaziv;
        data["punNazivTipaURecniku"] = this.punNazivTipaURecniku;
        data["definicija"] = this.definicija;
        data["jeSifarnickiPojam"] = this.jeSifarnickiPojam;
        data["jeIzveden"] = this.jeIzveden;
        data["izvedenIz"] = this.izvedenIz ? this.izvedenIz.toJSON() : <any>undefined;
        data["jeSlozen"] = this.jeSlozen;
        data["tipPodatkaId"] = this.tipPodatkaId;
        data["statusSifra"] = this.statusSifra;
        data["verzija"] = this.verzija;
        data["poslednjaVerzija"] = this.poslednjaVerzija;
        data["statusVerzijeId"] = this.statusVerzijeId;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["skupVrednostiOgranicen"] = this.skupVrednostiOgranicen;
        if (Array.isArray(this.kljucneReci)) {
            data["kljucneReci"] = [];
            for (let item of this.kljucneReci)
                data["kljucneReci"].push(item.toJSON());
        }
        data["jeAsocijacija"] = this.jeAsocijacija;
        data["sifarnikSifra"] = this.sifarnikSifra;
        data["nazivSifarnika"] = this.nazivSifarnika;
        data["jeZavisan"] = this.jeZavisan;
        data["tipAgregacijeId"] = this.tipAgregacijeId;
        return data;
    }
}

export interface IDajPojamPoSifriResponse {
    id: number;
    sifraTipaPodatka?: string | undefined;
    sifra?: string | undefined;
    domenId: number;
    domen?: DomenResponse | undefined;
    vrstaTipaId: number;
    naziv?: string | undefined;
    kvalifikovaniNaziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    punNazivTipaURecniku?: string | undefined;
    definicija?: string | undefined;
    jeSifarnickiPojam: boolean;
    jeIzveden: boolean;
    izvedenIz?: IzvedenIzResponse | undefined;
    jeSlozen: boolean;
    tipPodatkaId?: number | undefined;
    statusSifra?: string | undefined;
    verzija?: string | undefined;
    poslednjaVerzija: boolean;
    statusVerzijeId: number;
    datumOd: Date;
    datumDo?: Date | undefined;
    skupVrednostiOgranicen: number;
    kljucneReci?: KljucnaRecCmd[] | undefined;
    jeAsocijacija?: boolean | undefined;
    sifarnikSifra?: string | undefined;
    nazivSifarnika?: string | undefined;
    jeZavisan?: boolean | undefined;
    tipAgregacijeId?: number | undefined;
}

export class IzvedenIzResponse implements IIzvedenIzResponse {
    id?: number | undefined;
    sifra?: string | undefined;
    naziv?: string | undefined;
    punNazivTipaURecniku?: string | undefined;
    vrstaTipaId!: number;
    izvedenIz?: IzvedenIzResponse | undefined;

    constructor(data?: IIzvedenIzResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.punNazivTipaURecniku = _data["punNazivTipaURecniku"];
            this.vrstaTipaId = _data["vrstaTipaId"];
            this.izvedenIz = _data["izvedenIz"] ? IzvedenIzResponse.fromJS(_data["izvedenIz"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IzvedenIzResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IzvedenIzResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["punNazivTipaURecniku"] = this.punNazivTipaURecniku;
        data["vrstaTipaId"] = this.vrstaTipaId;
        data["izvedenIz"] = this.izvedenIz ? this.izvedenIz.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIzvedenIzResponse {
    id?: number | undefined;
    sifra?: string | undefined;
    naziv?: string | undefined;
    punNazivTipaURecniku?: string | undefined;
    vrstaTipaId: number;
    izvedenIz?: IzvedenIzResponse | undefined;
}

export class DajPojamZaIdResponse implements IDajPojamZaIdResponse {
    id!: number;
    sifra?: string | undefined;
    vrstaTipaId!: number;
    naziv?: string | undefined;
    izvedenIz?: IzvedenIzResponse | undefined;
    verzija?: string | undefined;

    constructor(data?: IDajPojamZaIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.vrstaTipaId = _data["vrstaTipaId"];
            this.naziv = _data["naziv"];
            this.izvedenIz = _data["izvedenIz"] ? IzvedenIzResponse.fromJS(_data["izvedenIz"]) : <any>undefined;
            this.verzija = _data["verzija"];
        }
    }

    static fromJS(data: any): DajPojamZaIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajPojamZaIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["vrstaTipaId"] = this.vrstaTipaId;
        data["naziv"] = this.naziv;
        data["izvedenIz"] = this.izvedenIz ? this.izvedenIz.toJSON() : <any>undefined;
        data["verzija"] = this.verzija;
        return data;
    }
}

export interface IDajPojamZaIdResponse {
    id: number;
    sifra?: string | undefined;
    vrstaTipaId: number;
    naziv?: string | undefined;
    izvedenIz?: IzvedenIzResponse | undefined;
    verzija?: string | undefined;
}

export class PagedResponseOfVezanEntitetResponse implements IPagedResponseOfVezanEntitetResponse {
    items?: VezanEntitetResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfVezanEntitetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VezanEntitetResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfVezanEntitetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfVezanEntitetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfVezanEntitetResponse {
    items?: VezanEntitetResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class VezanEntitetResponse implements IVezanEntitetResponse {
    sifra?: string | undefined;
    verzija?: string | undefined;
    izvedenTip?: string | undefined;
    definicijaPojma?: string | undefined;
    jeSifarnickiPojam!: boolean;
    vrstaTipaId!: number;
    definicijaPovezanogSvojstva?: string | undefined;
    svojstvo?: string | undefined;
    tipPojam?: string | undefined;

    constructor(data?: IVezanEntitetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.verzija = _data["verzija"];
            this.izvedenTip = _data["izvedenTip"];
            this.definicijaPojma = _data["definicijaPojma"];
            this.jeSifarnickiPojam = _data["jeSifarnickiPojam"];
            this.vrstaTipaId = _data["vrstaTipaId"];
            this.definicijaPovezanogSvojstva = _data["definicijaPovezanogSvojstva"];
            this.svojstvo = _data["svojstvo"];
            this.tipPojam = _data["tipPojam"];
        }
    }

    static fromJS(data: any): VezanEntitetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VezanEntitetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["verzija"] = this.verzija;
        data["izvedenTip"] = this.izvedenTip;
        data["definicijaPojma"] = this.definicijaPojma;
        data["jeSifarnickiPojam"] = this.jeSifarnickiPojam;
        data["vrstaTipaId"] = this.vrstaTipaId;
        data["definicijaPovezanogSvojstva"] = this.definicijaPovezanogSvojstva;
        data["svojstvo"] = this.svojstvo;
        data["tipPojam"] = this.tipPojam;
        return data;
    }
}

export interface IVezanEntitetResponse {
    sifra?: string | undefined;
    verzija?: string | undefined;
    izvedenTip?: string | undefined;
    definicijaPojma?: string | undefined;
    jeSifarnickiPojam: boolean;
    vrstaTipaId: number;
    definicijaPovezanogSvojstva?: string | undefined;
    svojstvo?: string | undefined;
    tipPojam?: string | undefined;
}

export class DajSvePojmovePoStatusuResponse implements IDajSvePojmovePoStatusuResponse {
    pojmovi?: PojamShortResponse[] | undefined;

    constructor(data?: IDajSvePojmovePoStatusuResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pojmovi"])) {
                this.pojmovi = [] as any;
                for (let item of _data["pojmovi"])
                    this.pojmovi!.push(PojamShortResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DajSvePojmovePoStatusuResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajSvePojmovePoStatusuResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pojmovi)) {
            data["pojmovi"] = [];
            for (let item of this.pojmovi)
                data["pojmovi"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDajSvePojmovePoStatusuResponse {
    pojmovi?: PojamShortResponse[] | undefined;
}

export class PojamShortResponse implements IPojamShortResponse {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    jeSlozen!: boolean;
    punKvalifikovaniNaziv?: string | undefined;

    constructor(data?: IPojamShortResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.jeSlozen = _data["jeSlozen"];
            this.punKvalifikovaniNaziv = _data["punKvalifikovaniNaziv"];
        }
    }

    static fromJS(data: any): PojamShortResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PojamShortResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["jeSlozen"] = this.jeSlozen;
        data["punKvalifikovaniNaziv"] = this.punKvalifikovaniNaziv;
        return data;
    }
}

export interface IPojamShortResponse {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    jeSlozen: boolean;
    punKvalifikovaniNaziv?: string | undefined;
}

export class ObrisiPojamCommand implements IObrisiPojamCommand {
    idPojma!: number;

    constructor(data?: IObrisiPojamCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPojma = _data["idPojma"];
        }
    }

    static fromJS(data: any): ObrisiPojamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObrisiPojamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPojma"] = this.idPojma;
        return data;
    }
}

export interface IObrisiPojamCommand {
    idPojma: number;
}

export class ObjaviPojamCommand implements IObjaviPojamCommand {
    idPojma!: number;
    datumObjavljivanja!: Date;
    domenId!: number;
    definicija?: string | undefined;
    jeZavisan?: boolean | undefined;
    kljucneReci?: KljucnaRecCmd[] | undefined;

    constructor(data?: IObjaviPojamCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPojma = _data["idPojma"];
            this.datumObjavljivanja = _data["datumObjavljivanja"] ? new Date(_data["datumObjavljivanja"].toString()) : <any>undefined;
            this.domenId = _data["domenId"];
            this.definicija = _data["definicija"];
            this.jeZavisan = _data["jeZavisan"];
            if (Array.isArray(_data["kljucneReci"])) {
                this.kljucneReci = [] as any;
                for (let item of _data["kljucneReci"])
                    this.kljucneReci!.push(KljucnaRecCmd.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ObjaviPojamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObjaviPojamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPojma"] = this.idPojma;
        data["datumObjavljivanja"] = this.datumObjavljivanja ? this.datumObjavljivanja.toISOString() : <any>undefined;
        data["domenId"] = this.domenId;
        data["definicija"] = this.definicija;
        data["jeZavisan"] = this.jeZavisan;
        if (Array.isArray(this.kljucneReci)) {
            data["kljucneReci"] = [];
            for (let item of this.kljucneReci)
                data["kljucneReci"].push(item.toJSON());
        }
        return data;
    }
}

export interface IObjaviPojamCommand {
    idPojma: number;
    datumObjavljivanja: Date;
    domenId: number;
    definicija?: string | undefined;
    jeZavisan?: boolean | undefined;
    kljucneReci?: KljucnaRecCmd[] | undefined;
}

export class NapraviNovuVerzijuPojmaCommand implements INapraviNovuVerzijuPojmaCommand {
    sifraPojma?: string | undefined;

    constructor(data?: INapraviNovuVerzijuPojmaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifraPojma = _data["sifraPojma"];
        }
    }

    static fromJS(data: any): NapraviNovuVerzijuPojmaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new NapraviNovuVerzijuPojmaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifraPojma"] = this.sifraPojma;
        return data;
    }
}

export interface INapraviNovuVerzijuPojmaCommand {
    sifraPojma?: string | undefined;
}

export class DajSveVerzijePojmaResponse implements IDajSveVerzijePojmaResponse {
    verzije?: PojamVerzija[] | undefined;

    constructor(data?: IDajSveVerzijePojmaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["verzije"])) {
                this.verzije = [] as any;
                for (let item of _data["verzije"])
                    this.verzije!.push(PojamVerzija.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DajSveVerzijePojmaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajSveVerzijePojmaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.verzije)) {
            data["verzije"] = [];
            for (let item of this.verzije)
                data["verzije"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDajSveVerzijePojmaResponse {
    verzije?: PojamVerzija[] | undefined;
}

export class PojamVerzija implements IPojamVerzija {
    id!: number;
    sifra?: string | undefined;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    statusVerzijeSifra?: string | undefined;
    statusVerzijeNaziv?: string | undefined;
    datumOd!: Date;
    datumDo?: Date | undefined;
    verzija?: string | undefined;
    poslednjaVerzija!: boolean;

    constructor(data?: IPojamVerzija) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.statusSifra = _data["statusSifra"];
            this.statusNaziv = _data["statusNaziv"];
            this.statusVerzijeSifra = _data["statusVerzijeSifra"];
            this.statusVerzijeNaziv = _data["statusVerzijeNaziv"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.verzija = _data["verzija"];
            this.poslednjaVerzija = _data["poslednjaVerzija"];
        }
    }

    static fromJS(data: any): PojamVerzija {
        data = typeof data === 'object' ? data : {};
        let result = new PojamVerzija();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["statusSifra"] = this.statusSifra;
        data["statusNaziv"] = this.statusNaziv;
        data["statusVerzijeSifra"] = this.statusVerzijeSifra;
        data["statusVerzijeNaziv"] = this.statusVerzijeNaziv;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["verzija"] = this.verzija;
        data["poslednjaVerzija"] = this.poslednjaVerzija;
        return data;
    }
}

export interface IPojamVerzija {
    id: number;
    sifra?: string | undefined;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    statusVerzijeSifra?: string | undefined;
    statusVerzijeNaziv?: string | undefined;
    datumOd: Date;
    datumDo?: Date | undefined;
    verzija?: string | undefined;
    poslednjaVerzija: boolean;
}

export class PagedResponseOfPretragaPojmovaUpisanihURecnikResponse implements IPagedResponseOfPretragaPojmovaUpisanihURecnikResponse {
    items?: PretragaPojmovaUpisanihURecnikResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfPretragaPojmovaUpisanihURecnikResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PretragaPojmovaUpisanihURecnikResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfPretragaPojmovaUpisanihURecnikResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfPretragaPojmovaUpisanihURecnikResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfPretragaPojmovaUpisanihURecnikResponse {
    items?: PretragaPojmovaUpisanihURecnikResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class PretragaPojmovaUpisanihURecnikResponse implements IPretragaPojmovaUpisanihURecnikResponse {
    idPojma!: number;
    id!: number;
    nazivDomena?: string | undefined;
    nazivPojma?: string | undefined;
    skupVrednostiOgranicenja!: number;
    definicijaPojma?: string | undefined;
    sifra?: string | undefined;
    verzija?: string | undefined;
    punKvalifikovaniNaziv?: string | undefined;
    vrstaTipaId!: number;
    nazivSifarnika?: string | undefined;

    constructor(data?: IPretragaPojmovaUpisanihURecnikResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPojma = _data["idPojma"];
            this.id = _data["id"];
            this.nazivDomena = _data["nazivDomena"];
            this.nazivPojma = _data["nazivPojma"];
            this.skupVrednostiOgranicenja = _data["skupVrednostiOgranicenja"];
            this.definicijaPojma = _data["definicijaPojma"];
            this.sifra = _data["sifra"];
            this.verzija = _data["verzija"];
            this.punKvalifikovaniNaziv = _data["punKvalifikovaniNaziv"];
            this.vrstaTipaId = _data["vrstaTipaId"];
            this.nazivSifarnika = _data["nazivSifarnika"];
        }
    }

    static fromJS(data: any): PretragaPojmovaUpisanihURecnikResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PretragaPojmovaUpisanihURecnikResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPojma"] = this.idPojma;
        data["id"] = this.id;
        data["nazivDomena"] = this.nazivDomena;
        data["nazivPojma"] = this.nazivPojma;
        data["skupVrednostiOgranicenja"] = this.skupVrednostiOgranicenja;
        data["definicijaPojma"] = this.definicijaPojma;
        data["sifra"] = this.sifra;
        data["verzija"] = this.verzija;
        data["punKvalifikovaniNaziv"] = this.punKvalifikovaniNaziv;
        data["vrstaTipaId"] = this.vrstaTipaId;
        data["nazivSifarnika"] = this.nazivSifarnika;
        return data;
    }
}

export interface IPretragaPojmovaUpisanihURecnikResponse {
    idPojma: number;
    id: number;
    nazivDomena?: string | undefined;
    nazivPojma?: string | undefined;
    skupVrednostiOgranicenja: number;
    definicijaPojma?: string | undefined;
    sifra?: string | undefined;
    verzija?: string | undefined;
    punKvalifikovaniNaziv?: string | undefined;
    vrstaTipaId: number;
    nazivSifarnika?: string | undefined;
}

export class DeaktivirajPojamCommand implements IDeaktivirajPojamCommand {
    idPojma!: number;
    datumDeaktiviranja!: Date;
    razlogDeaktiviranja?: string | undefined;

    constructor(data?: IDeaktivirajPojamCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPojma = _data["idPojma"];
            this.datumDeaktiviranja = _data["datumDeaktiviranja"] ? new Date(_data["datumDeaktiviranja"].toString()) : <any>undefined;
            this.razlogDeaktiviranja = _data["razlogDeaktiviranja"];
        }
    }

    static fromJS(data: any): DeaktivirajPojamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeaktivirajPojamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPojma"] = this.idPojma;
        data["datumDeaktiviranja"] = this.datumDeaktiviranja ? this.datumDeaktiviranja.toISOString() : <any>undefined;
        data["razlogDeaktiviranja"] = this.razlogDeaktiviranja;
        return data;
    }
}

export interface IDeaktivirajPojamCommand {
    idPojma: number;
    datumDeaktiviranja: Date;
    razlogDeaktiviranja?: string | undefined;
}

export class ReaktivirajPojamCommand implements IReaktivirajPojamCommand {
    idPojma!: number;

    constructor(data?: IReaktivirajPojamCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPojma = _data["idPojma"];
        }
    }

    static fromJS(data: any): ReaktivirajPojamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReaktivirajPojamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPojma"] = this.idPojma;
        return data;
    }
}

export interface IReaktivirajPojamCommand {
    idPojma: number;
}

export class DajPojamZaPovezivanjeSaElementomQueryResponse implements IDajPojamZaPovezivanjeSaElementomQueryResponse {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    jeSlozen!: boolean;
    putanja?: string | undefined;
    tipPodatkaId?: number | undefined;
    daLiJeNegdeIzvorni!: boolean;
    izvorniElementId?: number | undefined;
    odgovarajuciPodatakUIzvornojEvidenciji?: string | undefined;
    se?: SluzbenaEvidencijaPodaciZaPojamResponse | undefined;

    constructor(data?: IDajPojamZaPovezivanjeSaElementomQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.jeSlozen = _data["jeSlozen"];
            this.putanja = _data["putanja"];
            this.tipPodatkaId = _data["tipPodatkaId"];
            this.daLiJeNegdeIzvorni = _data["daLiJeNegdeIzvorni"];
            this.izvorniElementId = _data["izvorniElementId"];
            this.odgovarajuciPodatakUIzvornojEvidenciji = _data["odgovarajuciPodatakUIzvornojEvidenciji"];
            this.se = _data["se"] ? SluzbenaEvidencijaPodaciZaPojamResponse.fromJS(_data["se"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DajPojamZaPovezivanjeSaElementomQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajPojamZaPovezivanjeSaElementomQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["jeSlozen"] = this.jeSlozen;
        data["putanja"] = this.putanja;
        data["tipPodatkaId"] = this.tipPodatkaId;
        data["daLiJeNegdeIzvorni"] = this.daLiJeNegdeIzvorni;
        data["izvorniElementId"] = this.izvorniElementId;
        data["odgovarajuciPodatakUIzvornojEvidenciji"] = this.odgovarajuciPodatakUIzvornojEvidenciji;
        data["se"] = this.se ? this.se.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDajPojamZaPovezivanjeSaElementomQueryResponse {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    jeSlozen: boolean;
    putanja?: string | undefined;
    tipPodatkaId?: number | undefined;
    daLiJeNegdeIzvorni: boolean;
    izvorniElementId?: number | undefined;
    odgovarajuciPodatakUIzvornojEvidenciji?: string | undefined;
    se?: SluzbenaEvidencijaPodaciZaPojamResponse | undefined;
}

export class SluzbenaEvidencijaPodaciZaPojamResponse implements ISluzbenaEvidencijaPodaciZaPojamResponse {
    sifra?: string | undefined;
    naziv?: string | undefined;

    constructor(data?: ISluzbenaEvidencijaPodaciZaPojamResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): SluzbenaEvidencijaPodaciZaPojamResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SluzbenaEvidencijaPodaciZaPojamResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface ISluzbenaEvidencijaPodaciZaPojamResponse {
    sifra?: string | undefined;
    naziv?: string | undefined;
}

export class DajPojmoveZaPreuzimanjeSvojstvaIzReferentnogPojmaResponse implements IDajPojmoveZaPreuzimanjeSvojstvaIzReferentnogPojmaResponse {
    pojmovi?: PojamZaPreuzimanjeSvojstvaResponse[] | undefined;

    constructor(data?: IDajPojmoveZaPreuzimanjeSvojstvaIzReferentnogPojmaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pojmovi"])) {
                this.pojmovi = [] as any;
                for (let item of _data["pojmovi"])
                    this.pojmovi!.push(PojamZaPreuzimanjeSvojstvaResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DajPojmoveZaPreuzimanjeSvojstvaIzReferentnogPojmaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajPojmoveZaPreuzimanjeSvojstvaIzReferentnogPojmaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pojmovi)) {
            data["pojmovi"] = [];
            for (let item of this.pojmovi)
                data["pojmovi"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDajPojmoveZaPreuzimanjeSvojstvaIzReferentnogPojmaResponse {
    pojmovi?: PojamZaPreuzimanjeSvojstvaResponse[] | undefined;
}

export class PojamZaPreuzimanjeSvojstvaResponse implements IPojamZaPreuzimanjeSvojstvaResponse {
    id!: number;
    sifraPojma?: string | undefined;
    nazivPojma?: string | undefined;
    slozeniPojamId?: number | undefined;
    pojamUSastavuId?: number | undefined;

    constructor(data?: IPojamZaPreuzimanjeSvojstvaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifraPojma = _data["sifraPojma"];
            this.nazivPojma = _data["nazivPojma"];
            this.slozeniPojamId = _data["slozeniPojamId"];
            this.pojamUSastavuId = _data["pojamUSastavuId"];
        }
    }

    static fromJS(data: any): PojamZaPreuzimanjeSvojstvaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PojamZaPreuzimanjeSvojstvaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifraPojma"] = this.sifraPojma;
        data["nazivPojma"] = this.nazivPojma;
        data["slozeniPojamId"] = this.slozeniPojamId;
        data["pojamUSastavuId"] = this.pojamUSastavuId;
        return data;
    }
}

export interface IPojamZaPreuzimanjeSvojstvaResponse {
    id: number;
    sifraPojma?: string | undefined;
    nazivPojma?: string | undefined;
    slozeniPojamId?: number | undefined;
    pojamUSastavuId?: number | undefined;
}

export class PojamOgranicenjeSifarnikomResponse implements IPojamOgranicenjeSifarnikomResponse {
    skupVrednostiOgranicen!: number;
    sifarnikId!: number;
    nazivSifarnika?: string | undefined;
    sifraEvidencije?: string | undefined;
    poljeIzSifarnikaId!: number;
    poljeIzSifarnikaNaziv?: string | undefined;
    sifraElementa?: string | undefined;

    constructor(data?: IPojamOgranicenjeSifarnikomResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skupVrednostiOgranicen = _data["skupVrednostiOgranicen"];
            this.sifarnikId = _data["sifarnikId"];
            this.nazivSifarnika = _data["nazivSifarnika"];
            this.sifraEvidencije = _data["sifraEvidencije"];
            this.poljeIzSifarnikaId = _data["poljeIzSifarnikaId"];
            this.poljeIzSifarnikaNaziv = _data["poljeIzSifarnikaNaziv"];
            this.sifraElementa = _data["sifraElementa"];
        }
    }

    static fromJS(data: any): PojamOgranicenjeSifarnikomResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PojamOgranicenjeSifarnikomResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skupVrednostiOgranicen"] = this.skupVrednostiOgranicen;
        data["sifarnikId"] = this.sifarnikId;
        data["nazivSifarnika"] = this.nazivSifarnika;
        data["sifraEvidencije"] = this.sifraEvidencije;
        data["poljeIzSifarnikaId"] = this.poljeIzSifarnikaId;
        data["poljeIzSifarnikaNaziv"] = this.poljeIzSifarnikaNaziv;
        data["sifraElementa"] = this.sifraElementa;
        return data;
    }
}

export interface IPojamOgranicenjeSifarnikomResponse {
    skupVrednostiOgranicen: number;
    sifarnikId: number;
    nazivSifarnika?: string | undefined;
    sifraEvidencije?: string | undefined;
    poljeIzSifarnikaId: number;
    poljeIzSifarnikaNaziv?: string | undefined;
    sifraElementa?: string | undefined;
}

export class PagedResponseOfIzvedenPojamResponse implements IPagedResponseOfIzvedenPojamResponse {
    items?: IzvedenPojamResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfIzvedenPojamResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IzvedenPojamResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfIzvedenPojamResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfIzvedenPojamResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfIzvedenPojamResponse {
    items?: IzvedenPojamResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class IzvedenPojamResponse implements IIzvedenPojamResponse {
    sifra?: string | undefined;
    verzija?: string | undefined;
    nazivIzvedenogPojma?: string | undefined;
    definicijaPojma?: string | undefined;
    vrstaTipaId!: number;
    jeSifarnickiPojam!: boolean;

    constructor(data?: IIzvedenPojamResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.verzija = _data["verzija"];
            this.nazivIzvedenogPojma = _data["nazivIzvedenogPojma"];
            this.definicijaPojma = _data["definicijaPojma"];
            this.vrstaTipaId = _data["vrstaTipaId"];
            this.jeSifarnickiPojam = _data["jeSifarnickiPojam"];
        }
    }

    static fromJS(data: any): IzvedenPojamResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IzvedenPojamResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["verzija"] = this.verzija;
        data["nazivIzvedenogPojma"] = this.nazivIzvedenogPojma;
        data["definicijaPojma"] = this.definicijaPojma;
        data["vrstaTipaId"] = this.vrstaTipaId;
        data["jeSifarnickiPojam"] = this.jeSifarnickiPojam;
        return data;
    }
}

export interface IIzvedenPojamResponse {
    sifra?: string | undefined;
    verzija?: string | undefined;
    nazivIzvedenogPojma?: string | undefined;
    definicijaPojma?: string | undefined;
    vrstaTipaId: number;
    jeSifarnickiPojam: boolean;
}

export class SifarnikIElementCijiJePoslovniTipKvalifikatorResponse implements ISifarnikIElementCijiJePoslovniTipKvalifikatorResponse {
    sifraEvidencije?: string | undefined;
    nazivEvidencije?: string | undefined;
    poljeIzSifarnika?: string | undefined;
    sifraElementa?: string | undefined;

    constructor(data?: ISifarnikIElementCijiJePoslovniTipKvalifikatorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifraEvidencije = _data["sifraEvidencije"];
            this.nazivEvidencije = _data["nazivEvidencije"];
            this.poljeIzSifarnika = _data["poljeIzSifarnika"];
            this.sifraElementa = _data["sifraElementa"];
        }
    }

    static fromJS(data: any): SifarnikIElementCijiJePoslovniTipKvalifikatorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SifarnikIElementCijiJePoslovniTipKvalifikatorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifraEvidencije"] = this.sifraEvidencije;
        data["nazivEvidencije"] = this.nazivEvidencije;
        data["poljeIzSifarnika"] = this.poljeIzSifarnika;
        data["sifraElementa"] = this.sifraElementa;
        return data;
    }
}

export interface ISifarnikIElementCijiJePoslovniTipKvalifikatorResponse {
    sifraEvidencije?: string | undefined;
    nazivEvidencije?: string | undefined;
    poljeIzSifarnika?: string | undefined;
    sifraElementa?: string | undefined;
}

export class VratiPoslovniTipZaElementEvidencijeResponse implements IVratiPoslovniTipZaElementEvidencijeResponse {
    id!: number;
    sifraTipa?: string | undefined;
    nazivTipa?: string | undefined;
    skupVrednostiOgranicen!: number;

    constructor(data?: IVratiPoslovniTipZaElementEvidencijeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifraTipa = _data["sifraTipa"];
            this.nazivTipa = _data["nazivTipa"];
            this.skupVrednostiOgranicen = _data["skupVrednostiOgranicen"];
        }
    }

    static fromJS(data: any): VratiPoslovniTipZaElementEvidencijeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VratiPoslovniTipZaElementEvidencijeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifraTipa"] = this.sifraTipa;
        data["nazivTipa"] = this.nazivTipa;
        data["skupVrednostiOgranicen"] = this.skupVrednostiOgranicen;
        return data;
    }
}

export interface IVratiPoslovniTipZaElementEvidencijeResponse {
    id: number;
    sifraTipa?: string | undefined;
    nazivTipa?: string | undefined;
    skupVrednostiOgranicen: number;
}

export class KlonirajPojamCommand implements IKlonirajPojamCommand {
    id!: number;

    constructor(data?: IKlonirajPojamCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): KlonirajPojamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new KlonirajPojamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IKlonirajPojamCommand {
    id: number;
}

export class DajTipZaUcitavanjePodstablaResponse implements IDajTipZaUcitavanjePodstablaResponse {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    izvedenIzId?: number | undefined;
    izvedenIzNaziv?: string | undefined;
    jeSifarnickiPojam!: boolean;
    skupVrednostiOgranicen!: number;

    constructor(data?: IDajTipZaUcitavanjePodstablaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.izvedenIzId = _data["izvedenIzId"];
            this.izvedenIzNaziv = _data["izvedenIzNaziv"];
            this.jeSifarnickiPojam = _data["jeSifarnickiPojam"];
            this.skupVrednostiOgranicen = _data["skupVrednostiOgranicen"];
        }
    }

    static fromJS(data: any): DajTipZaUcitavanjePodstablaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajTipZaUcitavanjePodstablaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["izvedenIzId"] = this.izvedenIzId;
        data["izvedenIzNaziv"] = this.izvedenIzNaziv;
        data["jeSifarnickiPojam"] = this.jeSifarnickiPojam;
        data["skupVrednostiOgranicen"] = this.skupVrednostiOgranicen;
        return data;
    }
}

export interface IDajTipZaUcitavanjePodstablaResponse {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    izvedenIzId?: number | undefined;
    izvedenIzNaziv?: string | undefined;
    jeSifarnickiPojam: boolean;
    skupVrednostiOgranicen: number;
}

export class PagedResponseOfPretragaPorukaResponse implements IPagedResponseOfPretragaPorukaResponse {
    items?: PretragaPorukaResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfPretragaPorukaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PretragaPorukaResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfPretragaPorukaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfPretragaPorukaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfPretragaPorukaResponse {
    items?: PretragaPorukaResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class PretragaPorukaResponse implements IPretragaPorukaResponse {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    vrstaTipaId!: number;
    vrstaTipaNaziv?: string | undefined;
    osnovniTipNaziv?: string | undefined;
    nazivDomena?: string | undefined;
    skraceniNazivDomena?: string | undefined;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    definicija?: string | undefined;
    verzija?: string | undefined;
    poslednjaVerzija!: boolean;
    datumOd!: Date;
    datumDo?: Date | undefined;
    checked?: boolean | undefined;

    constructor(data?: IPretragaPorukaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.vrstaTipaId = _data["vrstaTipaId"];
            this.vrstaTipaNaziv = _data["vrstaTipaNaziv"];
            this.osnovniTipNaziv = _data["osnovniTipNaziv"];
            this.nazivDomena = _data["nazivDomena"];
            this.skraceniNazivDomena = _data["skraceniNazivDomena"];
            this.statusSifra = _data["statusSifra"];
            this.statusNaziv = _data["statusNaziv"];
            this.definicija = _data["definicija"];
            this.verzija = _data["verzija"];
            this.poslednjaVerzija = _data["poslednjaVerzija"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.checked = _data["checked"];
        }
    }

    static fromJS(data: any): PretragaPorukaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PretragaPorukaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["vrstaTipaId"] = this.vrstaTipaId;
        data["vrstaTipaNaziv"] = this.vrstaTipaNaziv;
        data["osnovniTipNaziv"] = this.osnovniTipNaziv;
        data["nazivDomena"] = this.nazivDomena;
        data["skraceniNazivDomena"] = this.skraceniNazivDomena;
        data["statusSifra"] = this.statusSifra;
        data["statusNaziv"] = this.statusNaziv;
        data["definicija"] = this.definicija;
        data["verzija"] = this.verzija;
        data["poslednjaVerzija"] = this.poslednjaVerzija;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["checked"] = this.checked;
        return data;
    }
}

export interface IPretragaPorukaResponse {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    vrstaTipaId: number;
    vrstaTipaNaziv?: string | undefined;
    osnovniTipNaziv?: string | undefined;
    nazivDomena?: string | undefined;
    skraceniNazivDomena?: string | undefined;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    definicija?: string | undefined;
    verzija?: string | undefined;
    poslednjaVerzija: boolean;
    datumOd: Date;
    datumDo?: Date | undefined;
    checked?: boolean | undefined;
}

export class DajPorukuPoSifriResponse implements IDajPorukuPoSifriResponse {
    id!: number;
    sifra?: string | undefined;
    domenId!: number;
    vrstaPorukeId!: number;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    punNazivPorukeURecniku?: string | undefined;
    definicija?: string | undefined;
    izvedenIz?: IzvedenIzResponse | undefined;
    tipPodatkaId?: number | undefined;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    verzija?: string | undefined;
    poslednjaVerzija!: boolean;
    statusVerzijeId!: number;
    datumOd!: Date;
    datumDo?: Date | undefined;
    skupVrednostiOgranicen!: number;
    kljucneReci?: KljucnaRecPorukeCmd[] | undefined;

    constructor(data?: IDajPorukuPoSifriResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.domenId = _data["domenId"];
            this.vrstaPorukeId = _data["vrstaPorukeId"];
            this.naziv = _data["naziv"];
            this.tehnickiNaziv = _data["tehnickiNaziv"];
            this.punNazivPorukeURecniku = _data["punNazivPorukeURecniku"];
            this.definicija = _data["definicija"];
            this.izvedenIz = _data["izvedenIz"] ? IzvedenIzResponse.fromJS(_data["izvedenIz"]) : <any>undefined;
            this.tipPodatkaId = _data["tipPodatkaId"];
            this.statusSifra = _data["statusSifra"];
            this.statusNaziv = _data["statusNaziv"];
            this.verzija = _data["verzija"];
            this.poslednjaVerzija = _data["poslednjaVerzija"];
            this.statusVerzijeId = _data["statusVerzijeId"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.skupVrednostiOgranicen = _data["skupVrednostiOgranicen"];
            if (Array.isArray(_data["kljucneReci"])) {
                this.kljucneReci = [] as any;
                for (let item of _data["kljucneReci"])
                    this.kljucneReci!.push(KljucnaRecPorukeCmd.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DajPorukuPoSifriResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajPorukuPoSifriResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["domenId"] = this.domenId;
        data["vrstaPorukeId"] = this.vrstaPorukeId;
        data["naziv"] = this.naziv;
        data["tehnickiNaziv"] = this.tehnickiNaziv;
        data["punNazivPorukeURecniku"] = this.punNazivPorukeURecniku;
        data["definicija"] = this.definicija;
        data["izvedenIz"] = this.izvedenIz ? this.izvedenIz.toJSON() : <any>undefined;
        data["tipPodatkaId"] = this.tipPodatkaId;
        data["statusSifra"] = this.statusSifra;
        data["statusNaziv"] = this.statusNaziv;
        data["verzija"] = this.verzija;
        data["poslednjaVerzija"] = this.poslednjaVerzija;
        data["statusVerzijeId"] = this.statusVerzijeId;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["skupVrednostiOgranicen"] = this.skupVrednostiOgranicen;
        if (Array.isArray(this.kljucneReci)) {
            data["kljucneReci"] = [];
            for (let item of this.kljucneReci)
                data["kljucneReci"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDajPorukuPoSifriResponse {
    id: number;
    sifra?: string | undefined;
    domenId: number;
    vrstaPorukeId: number;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    punNazivPorukeURecniku?: string | undefined;
    definicija?: string | undefined;
    izvedenIz?: IzvedenIzResponse | undefined;
    tipPodatkaId?: number | undefined;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    verzija?: string | undefined;
    poslednjaVerzija: boolean;
    statusVerzijeId: number;
    datumOd: Date;
    datumDo?: Date | undefined;
    skupVrednostiOgranicen: number;
    kljucneReci?: KljucnaRecPorukeCmd[] | undefined;
}

export class KljucnaRecPorukeCmd implements IKljucnaRecPorukeCmd {
    tekst?: string | undefined;

    constructor(data?: IKljucnaRecPorukeCmd) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tekst = _data["tekst"];
        }
    }

    static fromJS(data: any): KljucnaRecPorukeCmd {
        data = typeof data === 'object' ? data : {};
        let result = new KljucnaRecPorukeCmd();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tekst"] = this.tekst;
        return data;
    }
}

export interface IKljucnaRecPorukeCmd {
    tekst?: string | undefined;
}

export class SacuvajPorukuCommand implements ISacuvajPorukuCommand {
    sifra?: string | undefined;
    domenId!: number;
    vrstaPorukeId!: number;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    punNazivPorukeURecniku?: string | undefined;
    definicija?: string | undefined;
    verzija?: string | undefined;
    kljucneReci?: KljucnaRecPorukeCmd[] | undefined;

    constructor(data?: ISacuvajPorukuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.domenId = _data["domenId"];
            this.vrstaPorukeId = _data["vrstaPorukeId"];
            this.naziv = _data["naziv"];
            this.tehnickiNaziv = _data["tehnickiNaziv"];
            this.punNazivPorukeURecniku = _data["punNazivPorukeURecniku"];
            this.definicija = _data["definicija"];
            this.verzija = _data["verzija"];
            if (Array.isArray(_data["kljucneReci"])) {
                this.kljucneReci = [] as any;
                for (let item of _data["kljucneReci"])
                    this.kljucneReci!.push(KljucnaRecPorukeCmd.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SacuvajPorukuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SacuvajPorukuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["domenId"] = this.domenId;
        data["vrstaPorukeId"] = this.vrstaPorukeId;
        data["naziv"] = this.naziv;
        data["tehnickiNaziv"] = this.tehnickiNaziv;
        data["punNazivPorukeURecniku"] = this.punNazivPorukeURecniku;
        data["definicija"] = this.definicija;
        data["verzija"] = this.verzija;
        if (Array.isArray(this.kljucneReci)) {
            data["kljucneReci"] = [];
            for (let item of this.kljucneReci)
                data["kljucneReci"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISacuvajPorukuCommand {
    sifra?: string | undefined;
    domenId: number;
    vrstaPorukeId: number;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    punNazivPorukeURecniku?: string | undefined;
    definicija?: string | undefined;
    verzija?: string | undefined;
    kljucneReci?: KljucnaRecPorukeCmd[] | undefined;
}

export class DajSveVerzijePorukeResponse implements IDajSveVerzijePorukeResponse {
    verzije?: PorukaVerzija[] | undefined;

    constructor(data?: IDajSveVerzijePorukeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["verzije"])) {
                this.verzije = [] as any;
                for (let item of _data["verzije"])
                    this.verzije!.push(PorukaVerzija.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DajSveVerzijePorukeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajSveVerzijePorukeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.verzije)) {
            data["verzije"] = [];
            for (let item of this.verzije)
                data["verzije"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDajSveVerzijePorukeResponse {
    verzije?: PorukaVerzija[] | undefined;
}

export class PorukaVerzija implements IPorukaVerzija {
    id!: number;
    sifra?: string | undefined;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    statusVerzijeSifra?: string | undefined;
    statusVerzijeNaziv?: string | undefined;
    datumOd!: Date;
    datumDo?: Date | undefined;
    verzija?: string | undefined;
    poslednjaVerzija!: boolean;

    constructor(data?: IPorukaVerzija) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.statusSifra = _data["statusSifra"];
            this.statusNaziv = _data["statusNaziv"];
            this.statusVerzijeSifra = _data["statusVerzijeSifra"];
            this.statusVerzijeNaziv = _data["statusVerzijeNaziv"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.verzija = _data["verzija"];
            this.poslednjaVerzija = _data["poslednjaVerzija"];
        }
    }

    static fromJS(data: any): PorukaVerzija {
        data = typeof data === 'object' ? data : {};
        let result = new PorukaVerzija();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["statusSifra"] = this.statusSifra;
        data["statusNaziv"] = this.statusNaziv;
        data["statusVerzijeSifra"] = this.statusVerzijeSifra;
        data["statusVerzijeNaziv"] = this.statusVerzijeNaziv;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["verzija"] = this.verzija;
        data["poslednjaVerzija"] = this.poslednjaVerzija;
        return data;
    }
}

export interface IPorukaVerzija {
    id: number;
    sifra?: string | undefined;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    statusVerzijeSifra?: string | undefined;
    statusVerzijeNaziv?: string | undefined;
    datumOd: Date;
    datumDo?: Date | undefined;
    verzija?: string | undefined;
    poslednjaVerzija: boolean;
}

export class ObrisiPorukuCommand implements IObrisiPorukuCommand {
    idPoruke!: number;

    constructor(data?: IObrisiPorukuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPoruke = _data["idPoruke"];
        }
    }

    static fromJS(data: any): ObrisiPorukuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObrisiPorukuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPoruke"] = this.idPoruke;
        return data;
    }
}

export interface IObrisiPorukuCommand {
    idPoruke: number;
}

export class ObjaviPorukuCommand implements IObjaviPorukuCommand {
    idPoruke!: number;
    datumObjavljivanja!: Date;
    definicija?: string | undefined;
    domenId!: number;
    kljucneReci?: KljucnaRecPorukeCmd[] | undefined;
    naziv?: string | undefined;

    constructor(data?: IObjaviPorukuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPoruke = _data["idPoruke"];
            this.datumObjavljivanja = _data["datumObjavljivanja"] ? new Date(_data["datumObjavljivanja"].toString()) : <any>undefined;
            this.definicija = _data["definicija"];
            this.domenId = _data["domenId"];
            if (Array.isArray(_data["kljucneReci"])) {
                this.kljucneReci = [] as any;
                for (let item of _data["kljucneReci"])
                    this.kljucneReci!.push(KljucnaRecPorukeCmd.fromJS(item));
            }
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): ObjaviPorukuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObjaviPorukuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPoruke"] = this.idPoruke;
        data["datumObjavljivanja"] = this.datumObjavljivanja ? this.datumObjavljivanja.toISOString() : <any>undefined;
        data["definicija"] = this.definicija;
        data["domenId"] = this.domenId;
        if (Array.isArray(this.kljucneReci)) {
            data["kljucneReci"] = [];
            for (let item of this.kljucneReci)
                data["kljucneReci"].push(item.toJSON());
        }
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IObjaviPorukuCommand {
    idPoruke: number;
    datumObjavljivanja: Date;
    definicija?: string | undefined;
    domenId: number;
    kljucneReci?: KljucnaRecPorukeCmd[] | undefined;
    naziv?: string | undefined;
}

export class DeaktivirajPorukuCommand implements IDeaktivirajPorukuCommand {
    idPoruke!: number;
    datumDeaktiviranja!: Date;
    razlogDeaktiviranja?: string | undefined;

    constructor(data?: IDeaktivirajPorukuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPoruke = _data["idPoruke"];
            this.datumDeaktiviranja = _data["datumDeaktiviranja"] ? new Date(_data["datumDeaktiviranja"].toString()) : <any>undefined;
            this.razlogDeaktiviranja = _data["razlogDeaktiviranja"];
        }
    }

    static fromJS(data: any): DeaktivirajPorukuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeaktivirajPorukuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPoruke"] = this.idPoruke;
        data["datumDeaktiviranja"] = this.datumDeaktiviranja ? this.datumDeaktiviranja.toISOString() : <any>undefined;
        data["razlogDeaktiviranja"] = this.razlogDeaktiviranja;
        return data;
    }
}

export interface IDeaktivirajPorukuCommand {
    idPoruke: number;
    datumDeaktiviranja: Date;
    razlogDeaktiviranja?: string | undefined;
}

export class ReaktivirajPorukuCommand implements IReaktivirajPorukuCommand {
    idPoruke!: number;

    constructor(data?: IReaktivirajPorukuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPoruke = _data["idPoruke"];
        }
    }

    static fromJS(data: any): ReaktivirajPorukuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReaktivirajPorukuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPoruke"] = this.idPoruke;
        return data;
    }
}

export interface IReaktivirajPorukuCommand {
    idPoruke: number;
}

export class PagedResponseOfPorukaKojaSeKoristiNaPojmuResponse implements IPagedResponseOfPorukaKojaSeKoristiNaPojmuResponse {
    items?: PorukaKojaSeKoristiNaPojmuResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfPorukaKojaSeKoristiNaPojmuResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PorukaKojaSeKoristiNaPojmuResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfPorukaKojaSeKoristiNaPojmuResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfPorukaKojaSeKoristiNaPojmuResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfPorukaKojaSeKoristiNaPojmuResponse {
    items?: PorukaKojaSeKoristiNaPojmuResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class PorukaKojaSeKoristiNaPojmuResponse implements IPorukaKojaSeKoristiNaPojmuResponse {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    verzija?: string | undefined;
    statusPorukeNaziv?: string | undefined;

    constructor(data?: IPorukaKojaSeKoristiNaPojmuResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.verzija = _data["verzija"];
            this.statusPorukeNaziv = _data["statusPorukeNaziv"];
        }
    }

    static fromJS(data: any): PorukaKojaSeKoristiNaPojmuResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PorukaKojaSeKoristiNaPojmuResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["verzija"] = this.verzija;
        data["statusPorukeNaziv"] = this.statusPorukeNaziv;
        return data;
    }
}

export interface IPorukaKojaSeKoristiNaPojmuResponse {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    verzija?: string | undefined;
    statusPorukeNaziv?: string | undefined;
}

export class VratiPorukeZaListuSifaraResponse implements IVratiPorukeZaListuSifaraResponse {
    poruke?: Poruka[] | undefined;
    uspesno!: boolean;

    constructor(data?: IVratiPorukeZaListuSifaraResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["poruke"])) {
                this.poruke = [] as any;
                for (let item of _data["poruke"])
                    this.poruke!.push(Poruka.fromJS(item));
            }
            this.uspesno = _data["uspesno"];
        }
    }

    static fromJS(data: any): VratiPorukeZaListuSifaraResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VratiPorukeZaListuSifaraResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.poruke)) {
            data["poruke"] = [];
            for (let item of this.poruke)
                data["poruke"].push(item.toJSON());
        }
        data["uspesno"] = this.uspesno;
        return data;
    }
}

export interface IVratiPorukeZaListuSifaraResponse {
    poruke?: Poruka[] | undefined;
    uspesno: boolean;
}

export class BaseEntity implements IBaseEntity {
    idSesijeKreiranja!: number;
    idSesijeIzmene?: number | undefined;
    jeObrisano?: boolean | undefined;

    constructor(data?: IBaseEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idSesijeKreiranja = _data["idSesijeKreiranja"];
            this.idSesijeIzmene = _data["idSesijeIzmene"];
            this.jeObrisano = _data["jeObrisano"];
        }
    }

    static fromJS(data: any): BaseEntity {
        data = typeof data === 'object' ? data : {};
        let result = new BaseEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idSesijeKreiranja"] = this.idSesijeKreiranja;
        data["idSesijeIzmene"] = this.idSesijeIzmene;
        data["jeObrisano"] = this.jeObrisano;
        return data;
    }
}

export interface IBaseEntity {
    idSesijeKreiranja: number;
    idSesijeIzmene?: number | undefined;
    jeObrisano?: boolean | undefined;
}

export class Poruka extends BaseEntity implements IPoruka {
    id!: number;
    sifra?: string | undefined;
    domenId!: number;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    punNazivPorukeURecniku?: string | undefined;
    definicija?: string | undefined;
    vrstaPorukeId!: number;
    statusId!: number;
    statusVerzijeId!: number;
    verzija?: string | undefined;
    poslednjaVerzija!: boolean;
    razlogDeaktiviranja?: string | undefined;
    datumOd!: Date;
    datumDo?: Date | undefined;
    vrstaPoruke?: VrstaPoruke | undefined;
    domen?: Domen | undefined;
    kljucneReci?: KljucnaRecPoruke[] | undefined;
    status?: StatusPoruke | undefined;
    statusVerzije?: StatusVerzijePoruke | undefined;
    elementi?: ElementPoruke[] | undefined;
    entityStatus!: EntityStatus;

    constructor(data?: IPoruka) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.domenId = _data["domenId"];
            this.naziv = _data["naziv"];
            this.tehnickiNaziv = _data["tehnickiNaziv"];
            this.punNazivPorukeURecniku = _data["punNazivPorukeURecniku"];
            this.definicija = _data["definicija"];
            this.vrstaPorukeId = _data["vrstaPorukeId"];
            this.statusId = _data["statusId"];
            this.statusVerzijeId = _data["statusVerzijeId"];
            this.verzija = _data["verzija"];
            this.poslednjaVerzija = _data["poslednjaVerzija"];
            this.razlogDeaktiviranja = _data["razlogDeaktiviranja"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.vrstaPoruke = _data["vrstaPoruke"] ? VrstaPoruke.fromJS(_data["vrstaPoruke"]) : <any>undefined;
            this.domen = _data["domen"] ? Domen.fromJS(_data["domen"]) : <any>undefined;
            if (Array.isArray(_data["kljucneReci"])) {
                this.kljucneReci = [] as any;
                for (let item of _data["kljucneReci"])
                    this.kljucneReci!.push(KljucnaRecPoruke.fromJS(item));
            }
            this.status = _data["status"] ? StatusPoruke.fromJS(_data["status"]) : <any>undefined;
            this.statusVerzije = _data["statusVerzije"] ? StatusVerzijePoruke.fromJS(_data["statusVerzije"]) : <any>undefined;
            if (Array.isArray(_data["elementi"])) {
                this.elementi = [] as any;
                for (let item of _data["elementi"])
                    this.elementi!.push(ElementPoruke.fromJS(item));
            }
            this.entityStatus = _data["entityStatus"];
        }
    }

    static fromJS(data: any): Poruka {
        data = typeof data === 'object' ? data : {};
        let result = new Poruka();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["domenId"] = this.domenId;
        data["naziv"] = this.naziv;
        data["tehnickiNaziv"] = this.tehnickiNaziv;
        data["punNazivPorukeURecniku"] = this.punNazivPorukeURecniku;
        data["definicija"] = this.definicija;
        data["vrstaPorukeId"] = this.vrstaPorukeId;
        data["statusId"] = this.statusId;
        data["statusVerzijeId"] = this.statusVerzijeId;
        data["verzija"] = this.verzija;
        data["poslednjaVerzija"] = this.poslednjaVerzija;
        data["razlogDeaktiviranja"] = this.razlogDeaktiviranja;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["vrstaPoruke"] = this.vrstaPoruke ? this.vrstaPoruke.toJSON() : <any>undefined;
        data["domen"] = this.domen ? this.domen.toJSON() : <any>undefined;
        if (Array.isArray(this.kljucneReci)) {
            data["kljucneReci"] = [];
            for (let item of this.kljucneReci)
                data["kljucneReci"].push(item.toJSON());
        }
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["statusVerzije"] = this.statusVerzije ? this.statusVerzije.toJSON() : <any>undefined;
        if (Array.isArray(this.elementi)) {
            data["elementi"] = [];
            for (let item of this.elementi)
                data["elementi"].push(item.toJSON());
        }
        data["entityStatus"] = this.entityStatus;
        super.toJSON(data);
        return data;
    }
}

export interface IPoruka extends IBaseEntity {
    id: number;
    sifra?: string | undefined;
    domenId: number;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    punNazivPorukeURecniku?: string | undefined;
    definicija?: string | undefined;
    vrstaPorukeId: number;
    statusId: number;
    statusVerzijeId: number;
    verzija?: string | undefined;
    poslednjaVerzija: boolean;
    razlogDeaktiviranja?: string | undefined;
    datumOd: Date;
    datumDo?: Date | undefined;
    vrstaPoruke?: VrstaPoruke | undefined;
    domen?: Domen | undefined;
    kljucneReci?: KljucnaRecPoruke[] | undefined;
    status?: StatusPoruke | undefined;
    statusVerzije?: StatusVerzijePoruke | undefined;
    elementi?: ElementPoruke[] | undefined;
    entityStatus: EntityStatus;
}

export class VrstaPoruke extends BaseEntity implements IVrstaPoruke {
    id!: number;
    naziv?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IVrstaPoruke) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): VrstaPoruke {
        data = typeof data === 'object' ? data : {};
        let result = new VrstaPoruke();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["opis"] = this.opis;
        super.toJSON(data);
        return data;
    }
}

export interface IVrstaPoruke extends IBaseEntity {
    id: number;
    naziv?: string | undefined;
    opis?: string | undefined;
}

export class Domen extends BaseEntity implements IDomen {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    skraceniNaziv?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IDomen) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.skraceniNaziv = _data["skraceniNaziv"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): Domen {
        data = typeof data === 'object' ? data : {};
        let result = new Domen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["skraceniNaziv"] = this.skraceniNaziv;
        data["opis"] = this.opis;
        super.toJSON(data);
        return data;
    }
}

export interface IDomen extends IBaseEntity {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    skraceniNaziv?: string | undefined;
    opis?: string | undefined;
}

export class KljucnaRecPoruke extends BaseEntity implements IKljucnaRecPoruke {
    id!: number;
    tekst?: string | undefined;
    porukaId!: number;
    poruka?: Poruka | undefined;

    constructor(data?: IKljucnaRecPoruke) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.tekst = _data["tekst"];
            this.porukaId = _data["porukaId"];
            this.poruka = _data["poruka"] ? Poruka.fromJS(_data["poruka"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KljucnaRecPoruke {
        data = typeof data === 'object' ? data : {};
        let result = new KljucnaRecPoruke();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tekst"] = this.tekst;
        data["porukaId"] = this.porukaId;
        data["poruka"] = this.poruka ? this.poruka.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IKljucnaRecPoruke extends IBaseEntity {
    id: number;
    tekst?: string | undefined;
    porukaId: number;
    poruka?: Poruka | undefined;
}

export class StatusPoruke extends BaseEntity implements IStatusPoruke {
    id!: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;

    constructor(data?: IStatusPoruke) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
            this.opisLatinica = _data["opisLatinica"];
        }
    }

    static fromJS(data: any): StatusPoruke {
        data = typeof data === 'object' ? data : {};
        let result = new StatusPoruke();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        data["opisLatinica"] = this.opisLatinica;
        super.toJSON(data);
        return data;
    }
}

export interface IStatusPoruke extends IBaseEntity {
    id: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;
}

export class StatusVerzijePoruke extends BaseEntity implements IStatusVerzijePoruke {
    id!: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;

    constructor(data?: IStatusVerzijePoruke) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
            this.opisLatinica = _data["opisLatinica"];
        }
    }

    static fromJS(data: any): StatusVerzijePoruke {
        data = typeof data === 'object' ? data : {};
        let result = new StatusVerzijePoruke();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        data["opisLatinica"] = this.opisLatinica;
        super.toJSON(data);
        return data;
    }
}

export interface IStatusVerzijePoruke extends IBaseEntity {
    id: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;
}

export class ElementPoruke extends BaseEntity implements IElementPoruke {
    id!: number;
    porukaId!: number;
    pojamUSastavuId!: number;
    pripadaId!: number;
    nadredjeniElementId?: number | undefined;
    nasledjenOdSvojstvaId?: number | undefined;
    nadredjenoSvojstvoId?: number | undefined;
    suzeniTipId?: number | undefined;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    definicija?: string | undefined;
    putanja?: string | undefined;
    putanjaLatinica?: string | undefined;
    minBrojPojavljivanja?: string | undefined;
    maxBrojPojavljivanja?: string | undefined;
    skupVrednostiOgranicen!: boolean;
    svojstvoSifarnickogPojmaId?: number | undefined;
    statusId!: number;
    zaDeaktivaciju?: boolean | undefined;
    punNazivElementaPorukeURecniku?: string | undefined;
    redniBroj!: number;
    poruka?: Poruka | undefined;
    pojamUSastavu?: Tip | undefined;
    pripadaPojmu?: Tip | undefined;
    prekopiranoOdTipa?: Tip | undefined;
    suzeniTip?: Tip | undefined;
    nadredjeniElement?: ElementPoruke | undefined;
    nadredjenoSvojstvo?: Svojstvo | undefined;
    nasledjenOdSvojstva?: Svojstvo | undefined;
    svojstvoSifarnickogPojma?: Svojstvo | undefined;
    status?: StatusElementaPoruke | undefined;

    constructor(data?: IElementPoruke) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.porukaId = _data["porukaId"];
            this.pojamUSastavuId = _data["pojamUSastavuId"];
            this.pripadaId = _data["pripadaId"];
            this.nadredjeniElementId = _data["nadredjeniElementId"];
            this.nasledjenOdSvojstvaId = _data["nasledjenOdSvojstvaId"];
            this.nadredjenoSvojstvoId = _data["nadredjenoSvojstvoId"];
            this.suzeniTipId = _data["suzeniTipId"];
            this.naziv = _data["naziv"];
            this.tehnickiNaziv = _data["tehnickiNaziv"];
            this.definicija = _data["definicija"];
            this.putanja = _data["putanja"];
            this.putanjaLatinica = _data["putanjaLatinica"];
            this.minBrojPojavljivanja = _data["minBrojPojavljivanja"];
            this.maxBrojPojavljivanja = _data["maxBrojPojavljivanja"];
            this.skupVrednostiOgranicen = _data["skupVrednostiOgranicen"];
            this.svojstvoSifarnickogPojmaId = _data["svojstvoSifarnickogPojmaId"];
            this.statusId = _data["statusId"];
            this.zaDeaktivaciju = _data["zaDeaktivaciju"];
            this.punNazivElementaPorukeURecniku = _data["punNazivElementaPorukeURecniku"];
            this.redniBroj = _data["redniBroj"];
            this.poruka = _data["poruka"] ? Poruka.fromJS(_data["poruka"]) : <any>undefined;
            this.pojamUSastavu = _data["pojamUSastavu"] ? Tip.fromJS(_data["pojamUSastavu"]) : <any>undefined;
            this.pripadaPojmu = _data["pripadaPojmu"] ? Tip.fromJS(_data["pripadaPojmu"]) : <any>undefined;
            this.prekopiranoOdTipa = _data["prekopiranoOdTipa"] ? Tip.fromJS(_data["prekopiranoOdTipa"]) : <any>undefined;
            this.suzeniTip = _data["suzeniTip"] ? Tip.fromJS(_data["suzeniTip"]) : <any>undefined;
            this.nadredjeniElement = _data["nadredjeniElement"] ? ElementPoruke.fromJS(_data["nadredjeniElement"]) : <any>undefined;
            this.nadredjenoSvojstvo = _data["nadredjenoSvojstvo"] ? Svojstvo.fromJS(_data["nadredjenoSvojstvo"]) : <any>undefined;
            this.nasledjenOdSvojstva = _data["nasledjenOdSvojstva"] ? Svojstvo.fromJS(_data["nasledjenOdSvojstva"]) : <any>undefined;
            this.svojstvoSifarnickogPojma = _data["svojstvoSifarnickogPojma"] ? Svojstvo.fromJS(_data["svojstvoSifarnickogPojma"]) : <any>undefined;
            this.status = _data["status"] ? StatusElementaPoruke.fromJS(_data["status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ElementPoruke {
        data = typeof data === 'object' ? data : {};
        let result = new ElementPoruke();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["porukaId"] = this.porukaId;
        data["pojamUSastavuId"] = this.pojamUSastavuId;
        data["pripadaId"] = this.pripadaId;
        data["nadredjeniElementId"] = this.nadredjeniElementId;
        data["nasledjenOdSvojstvaId"] = this.nasledjenOdSvojstvaId;
        data["nadredjenoSvojstvoId"] = this.nadredjenoSvojstvoId;
        data["suzeniTipId"] = this.suzeniTipId;
        data["naziv"] = this.naziv;
        data["tehnickiNaziv"] = this.tehnickiNaziv;
        data["definicija"] = this.definicija;
        data["putanja"] = this.putanja;
        data["putanjaLatinica"] = this.putanjaLatinica;
        data["minBrojPojavljivanja"] = this.minBrojPojavljivanja;
        data["maxBrojPojavljivanja"] = this.maxBrojPojavljivanja;
        data["skupVrednostiOgranicen"] = this.skupVrednostiOgranicen;
        data["svojstvoSifarnickogPojmaId"] = this.svojstvoSifarnickogPojmaId;
        data["statusId"] = this.statusId;
        data["zaDeaktivaciju"] = this.zaDeaktivaciju;
        data["punNazivElementaPorukeURecniku"] = this.punNazivElementaPorukeURecniku;
        data["redniBroj"] = this.redniBroj;
        data["poruka"] = this.poruka ? this.poruka.toJSON() : <any>undefined;
        data["pojamUSastavu"] = this.pojamUSastavu ? this.pojamUSastavu.toJSON() : <any>undefined;
        data["pripadaPojmu"] = this.pripadaPojmu ? this.pripadaPojmu.toJSON() : <any>undefined;
        data["prekopiranoOdTipa"] = this.prekopiranoOdTipa ? this.prekopiranoOdTipa.toJSON() : <any>undefined;
        data["suzeniTip"] = this.suzeniTip ? this.suzeniTip.toJSON() : <any>undefined;
        data["nadredjeniElement"] = this.nadredjeniElement ? this.nadredjeniElement.toJSON() : <any>undefined;
        data["nadredjenoSvojstvo"] = this.nadredjenoSvojstvo ? this.nadredjenoSvojstvo.toJSON() : <any>undefined;
        data["nasledjenOdSvojstva"] = this.nasledjenOdSvojstva ? this.nasledjenOdSvojstva.toJSON() : <any>undefined;
        data["svojstvoSifarnickogPojma"] = this.svojstvoSifarnickogPojma ? this.svojstvoSifarnickogPojma.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IElementPoruke extends IBaseEntity {
    id: number;
    porukaId: number;
    pojamUSastavuId: number;
    pripadaId: number;
    nadredjeniElementId?: number | undefined;
    nasledjenOdSvojstvaId?: number | undefined;
    nadredjenoSvojstvoId?: number | undefined;
    suzeniTipId?: number | undefined;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    definicija?: string | undefined;
    putanja?: string | undefined;
    putanjaLatinica?: string | undefined;
    minBrojPojavljivanja?: string | undefined;
    maxBrojPojavljivanja?: string | undefined;
    skupVrednostiOgranicen: boolean;
    svojstvoSifarnickogPojmaId?: number | undefined;
    statusId: number;
    zaDeaktivaciju?: boolean | undefined;
    punNazivElementaPorukeURecniku?: string | undefined;
    redniBroj: number;
    poruka?: Poruka | undefined;
    pojamUSastavu?: Tip | undefined;
    pripadaPojmu?: Tip | undefined;
    prekopiranoOdTipa?: Tip | undefined;
    suzeniTip?: Tip | undefined;
    nadredjeniElement?: ElementPoruke | undefined;
    nadredjenoSvojstvo?: Svojstvo | undefined;
    nasledjenOdSvojstva?: Svojstvo | undefined;
    svojstvoSifarnickogPojma?: Svojstvo | undefined;
    status?: StatusElementaPoruke | undefined;
}

export class Tip extends BaseEntity implements ITip {
    id!: number;
    sifra?: string | undefined;
    domenId!: number;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    punNazivTipaURecniku?: string | undefined;
    definicija?: string | undefined;
    jeSifarnickiPojam!: boolean;
    jeIzveden!: boolean;
    vrstaTipaId!: number;
    izvedenIzId?: number | undefined;
    tipPodatkaId?: number | undefined;
    statusId!: number;
    statusVerzijeId!: number;
    verzija?: string | undefined;
    poslednjaVerzija!: boolean;
    razlogDeaktiviranja?: string | undefined;
    datumOd!: Date;
    datumDo?: Date | undefined;
    tipAgregacijeId?: number | undefined;
    domen?: Domen | undefined;
    izvedenIz?: Tip | undefined;
    tipPodatka?: TipPodatka | undefined;
    ogranicenja?: Ogranicenje[] | undefined;
    kljucneReci?: KljucnaRec[] | undefined;
    status?: StatusTipa | undefined;
    tipAgregacije?: TipAgregacije | undefined;
    statusVerzije?: StatusVerzijeTipa | undefined;
    svojstva?: Svojstvo[] | undefined;
    mestaNaKojimaSeKoristiKaoSvojstvo?: Svojstvo[] | undefined;
    svojstvaPojma?: Svojstvo[] | undefined;
    sifarnickeEvidencije?: SluzbenaEvidencija[] | undefined;
    entityStatus!: EntityStatus;
    skupVrednostiOgranicen!: number;
    vrstaTipa?: VrstaTipa | undefined;
    jeAsocijacija?: boolean | undefined;
    jeZavisan?: boolean | undefined;
    elementi?: Element[] | undefined;

    constructor(data?: ITip) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.domenId = _data["domenId"];
            this.naziv = _data["naziv"];
            this.tehnickiNaziv = _data["tehnickiNaziv"];
            this.punNazivTipaURecniku = _data["punNazivTipaURecniku"];
            this.definicija = _data["definicija"];
            this.jeSifarnickiPojam = _data["jeSifarnickiPojam"];
            this.jeIzveden = _data["jeIzveden"];
            this.vrstaTipaId = _data["vrstaTipaId"];
            this.izvedenIzId = _data["izvedenIzId"];
            this.tipPodatkaId = _data["tipPodatkaId"];
            this.statusId = _data["statusId"];
            this.statusVerzijeId = _data["statusVerzijeId"];
            this.verzija = _data["verzija"];
            this.poslednjaVerzija = _data["poslednjaVerzija"];
            this.razlogDeaktiviranja = _data["razlogDeaktiviranja"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.tipAgregacijeId = _data["tipAgregacijeId"];
            this.domen = _data["domen"] ? Domen.fromJS(_data["domen"]) : <any>undefined;
            this.izvedenIz = _data["izvedenIz"] ? Tip.fromJS(_data["izvedenIz"]) : <any>undefined;
            this.tipPodatka = _data["tipPodatka"] ? TipPodatka.fromJS(_data["tipPodatka"]) : <any>undefined;
            if (Array.isArray(_data["ogranicenja"])) {
                this.ogranicenja = [] as any;
                for (let item of _data["ogranicenja"])
                    this.ogranicenja!.push(Ogranicenje.fromJS(item));
            }
            if (Array.isArray(_data["kljucneReci"])) {
                this.kljucneReci = [] as any;
                for (let item of _data["kljucneReci"])
                    this.kljucneReci!.push(KljucnaRec.fromJS(item));
            }
            this.status = _data["status"] ? StatusTipa.fromJS(_data["status"]) : <any>undefined;
            this.tipAgregacije = _data["tipAgregacije"] ? TipAgregacije.fromJS(_data["tipAgregacije"]) : <any>undefined;
            this.statusVerzije = _data["statusVerzije"] ? StatusVerzijeTipa.fromJS(_data["statusVerzije"]) : <any>undefined;
            if (Array.isArray(_data["svojstva"])) {
                this.svojstva = [] as any;
                for (let item of _data["svojstva"])
                    this.svojstva!.push(Svojstvo.fromJS(item));
            }
            if (Array.isArray(_data["mestaNaKojimaSeKoristiKaoSvojstvo"])) {
                this.mestaNaKojimaSeKoristiKaoSvojstvo = [] as any;
                for (let item of _data["mestaNaKojimaSeKoristiKaoSvojstvo"])
                    this.mestaNaKojimaSeKoristiKaoSvojstvo!.push(Svojstvo.fromJS(item));
            }
            if (Array.isArray(_data["svojstvaPojma"])) {
                this.svojstvaPojma = [] as any;
                for (let item of _data["svojstvaPojma"])
                    this.svojstvaPojma!.push(Svojstvo.fromJS(item));
            }
            if (Array.isArray(_data["sifarnickeEvidencije"])) {
                this.sifarnickeEvidencije = [] as any;
                for (let item of _data["sifarnickeEvidencije"])
                    this.sifarnickeEvidencije!.push(SluzbenaEvidencija.fromJS(item));
            }
            this.entityStatus = _data["entityStatus"];
            this.skupVrednostiOgranicen = _data["skupVrednostiOgranicen"];
            this.vrstaTipa = _data["vrstaTipa"] ? VrstaTipa.fromJS(_data["vrstaTipa"]) : <any>undefined;
            this.jeAsocijacija = _data["jeAsocijacija"];
            this.jeZavisan = _data["jeZavisan"];
            if (Array.isArray(_data["elementi"])) {
                this.elementi = [] as any;
                for (let item of _data["elementi"])
                    this.elementi!.push(Element.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Tip {
        data = typeof data === 'object' ? data : {};
        let result = new Tip();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["domenId"] = this.domenId;
        data["naziv"] = this.naziv;
        data["tehnickiNaziv"] = this.tehnickiNaziv;
        data["punNazivTipaURecniku"] = this.punNazivTipaURecniku;
        data["definicija"] = this.definicija;
        data["jeSifarnickiPojam"] = this.jeSifarnickiPojam;
        data["jeIzveden"] = this.jeIzveden;
        data["vrstaTipaId"] = this.vrstaTipaId;
        data["izvedenIzId"] = this.izvedenIzId;
        data["tipPodatkaId"] = this.tipPodatkaId;
        data["statusId"] = this.statusId;
        data["statusVerzijeId"] = this.statusVerzijeId;
        data["verzija"] = this.verzija;
        data["poslednjaVerzija"] = this.poslednjaVerzija;
        data["razlogDeaktiviranja"] = this.razlogDeaktiviranja;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["tipAgregacijeId"] = this.tipAgregacijeId;
        data["domen"] = this.domen ? this.domen.toJSON() : <any>undefined;
        data["izvedenIz"] = this.izvedenIz ? this.izvedenIz.toJSON() : <any>undefined;
        data["tipPodatka"] = this.tipPodatka ? this.tipPodatka.toJSON() : <any>undefined;
        if (Array.isArray(this.ogranicenja)) {
            data["ogranicenja"] = [];
            for (let item of this.ogranicenja)
                data["ogranicenja"].push(item.toJSON());
        }
        if (Array.isArray(this.kljucneReci)) {
            data["kljucneReci"] = [];
            for (let item of this.kljucneReci)
                data["kljucneReci"].push(item.toJSON());
        }
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["tipAgregacije"] = this.tipAgregacije ? this.tipAgregacije.toJSON() : <any>undefined;
        data["statusVerzije"] = this.statusVerzije ? this.statusVerzije.toJSON() : <any>undefined;
        if (Array.isArray(this.svojstva)) {
            data["svojstva"] = [];
            for (let item of this.svojstva)
                data["svojstva"].push(item.toJSON());
        }
        if (Array.isArray(this.mestaNaKojimaSeKoristiKaoSvojstvo)) {
            data["mestaNaKojimaSeKoristiKaoSvojstvo"] = [];
            for (let item of this.mestaNaKojimaSeKoristiKaoSvojstvo)
                data["mestaNaKojimaSeKoristiKaoSvojstvo"].push(item.toJSON());
        }
        if (Array.isArray(this.svojstvaPojma)) {
            data["svojstvaPojma"] = [];
            for (let item of this.svojstvaPojma)
                data["svojstvaPojma"].push(item.toJSON());
        }
        if (Array.isArray(this.sifarnickeEvidencije)) {
            data["sifarnickeEvidencije"] = [];
            for (let item of this.sifarnickeEvidencije)
                data["sifarnickeEvidencije"].push(item.toJSON());
        }
        data["entityStatus"] = this.entityStatus;
        data["skupVrednostiOgranicen"] = this.skupVrednostiOgranicen;
        data["vrstaTipa"] = this.vrstaTipa ? this.vrstaTipa.toJSON() : <any>undefined;
        data["jeAsocijacija"] = this.jeAsocijacija;
        data["jeZavisan"] = this.jeZavisan;
        if (Array.isArray(this.elementi)) {
            data["elementi"] = [];
            for (let item of this.elementi)
                data["elementi"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITip extends IBaseEntity {
    id: number;
    sifra?: string | undefined;
    domenId: number;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    punNazivTipaURecniku?: string | undefined;
    definicija?: string | undefined;
    jeSifarnickiPojam: boolean;
    jeIzveden: boolean;
    vrstaTipaId: number;
    izvedenIzId?: number | undefined;
    tipPodatkaId?: number | undefined;
    statusId: number;
    statusVerzijeId: number;
    verzija?: string | undefined;
    poslednjaVerzija: boolean;
    razlogDeaktiviranja?: string | undefined;
    datumOd: Date;
    datumDo?: Date | undefined;
    tipAgregacijeId?: number | undefined;
    domen?: Domen | undefined;
    izvedenIz?: Tip | undefined;
    tipPodatka?: TipPodatka | undefined;
    ogranicenja?: Ogranicenje[] | undefined;
    kljucneReci?: KljucnaRec[] | undefined;
    status?: StatusTipa | undefined;
    tipAgregacije?: TipAgregacije | undefined;
    statusVerzije?: StatusVerzijeTipa | undefined;
    svojstva?: Svojstvo[] | undefined;
    mestaNaKojimaSeKoristiKaoSvojstvo?: Svojstvo[] | undefined;
    svojstvaPojma?: Svojstvo[] | undefined;
    sifarnickeEvidencije?: SluzbenaEvidencija[] | undefined;
    entityStatus: EntityStatus;
    skupVrednostiOgranicen: number;
    vrstaTipa?: VrstaTipa | undefined;
    jeAsocijacija?: boolean | undefined;
    jeZavisan?: boolean | undefined;
    elementi?: Element[] | undefined;
}

export class TipPodatka extends BaseEntity implements ITipPodatka {
    id!: number;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
    sifra?: string | undefined;
    ogranicenjaTipaPodatka?: OgranicenjaTipaPodatka[] | undefined;

    constructor(data?: ITipPodatka) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.nazivLatinica = _data["nazivLatinica"];
            this.sifra = _data["sifra"];
            if (Array.isArray(_data["ogranicenjaTipaPodatka"])) {
                this.ogranicenjaTipaPodatka = [] as any;
                for (let item of _data["ogranicenjaTipaPodatka"])
                    this.ogranicenjaTipaPodatka!.push(OgranicenjaTipaPodatka.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TipPodatka {
        data = typeof data === 'object' ? data : {};
        let result = new TipPodatka();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["nazivLatinica"] = this.nazivLatinica;
        data["sifra"] = this.sifra;
        if (Array.isArray(this.ogranicenjaTipaPodatka)) {
            data["ogranicenjaTipaPodatka"] = [];
            for (let item of this.ogranicenjaTipaPodatka)
                data["ogranicenjaTipaPodatka"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITipPodatka extends IBaseEntity {
    id: number;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
    sifra?: string | undefined;
    ogranicenjaTipaPodatka?: OgranicenjaTipaPodatka[] | undefined;
}

export class OgranicenjaTipaPodatka extends BaseEntity implements IOgranicenjaTipaPodatka {
    id!: number;
    tipPodatkaZaUnosVrednosti?: string | undefined;
    tipPodatkaId!: number;
    tipOgranicenjaId!: number;
    tipPodatka?: TipPodatka | undefined;
    tipOgranicenja?: TipOgranicenja | undefined;

    constructor(data?: IOgranicenjaTipaPodatka) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.tipPodatkaZaUnosVrednosti = _data["tipPodatkaZaUnosVrednosti"];
            this.tipPodatkaId = _data["tipPodatkaId"];
            this.tipOgranicenjaId = _data["tipOgranicenjaId"];
            this.tipPodatka = _data["tipPodatka"] ? TipPodatka.fromJS(_data["tipPodatka"]) : <any>undefined;
            this.tipOgranicenja = _data["tipOgranicenja"] ? TipOgranicenja.fromJS(_data["tipOgranicenja"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OgranicenjaTipaPodatka {
        data = typeof data === 'object' ? data : {};
        let result = new OgranicenjaTipaPodatka();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tipPodatkaZaUnosVrednosti"] = this.tipPodatkaZaUnosVrednosti;
        data["tipPodatkaId"] = this.tipPodatkaId;
        data["tipOgranicenjaId"] = this.tipOgranicenjaId;
        data["tipPodatka"] = this.tipPodatka ? this.tipPodatka.toJSON() : <any>undefined;
        data["tipOgranicenja"] = this.tipOgranicenja ? this.tipOgranicenja.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IOgranicenjaTipaPodatka extends IBaseEntity {
    id: number;
    tipPodatkaZaUnosVrednosti?: string | undefined;
    tipPodatkaId: number;
    tipOgranicenjaId: number;
    tipPodatka?: TipPodatka | undefined;
    tipOgranicenja?: TipOgranicenja | undefined;
}

export class TipOgranicenja extends BaseEntity implements ITipOgranicenja {
    id!: number;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
    sifra?: string | undefined;

    constructor(data?: ITipOgranicenja) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.nazivLatinica = _data["nazivLatinica"];
            this.sifra = _data["sifra"];
        }
    }

    static fromJS(data: any): TipOgranicenja {
        data = typeof data === 'object' ? data : {};
        let result = new TipOgranicenja();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["nazivLatinica"] = this.nazivLatinica;
        data["sifra"] = this.sifra;
        super.toJSON(data);
        return data;
    }
}

export interface ITipOgranicenja extends IBaseEntity {
    id: number;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
    sifra?: string | undefined;
}

export class Ogranicenje extends BaseEntity implements IOgranicenje {
    id!: number;
    naziv?: string | undefined;
    opis?: string | undefined;
    vrednost?: string | undefined;
    tipId?: number | undefined;
    tipOdKogJeNasledjenoId?: number | undefined;
    tipOgranicenjaId!: number;
    tipOgranicenja?: TipOgranicenja | undefined;
    tip?: Tip | undefined;
    tipOdKogJeNasledjeno?: Tip | undefined;
    statusOgranicenjaId?: number | undefined;

    constructor(data?: IOgranicenje) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.opis = _data["opis"];
            this.vrednost = _data["vrednost"];
            this.tipId = _data["tipId"];
            this.tipOdKogJeNasledjenoId = _data["tipOdKogJeNasledjenoId"];
            this.tipOgranicenjaId = _data["tipOgranicenjaId"];
            this.tipOgranicenja = _data["tipOgranicenja"] ? TipOgranicenja.fromJS(_data["tipOgranicenja"]) : <any>undefined;
            this.tip = _data["tip"] ? Tip.fromJS(_data["tip"]) : <any>undefined;
            this.tipOdKogJeNasledjeno = _data["tipOdKogJeNasledjeno"] ? Tip.fromJS(_data["tipOdKogJeNasledjeno"]) : <any>undefined;
            this.statusOgranicenjaId = _data["statusOgranicenjaId"];
        }
    }

    static fromJS(data: any): Ogranicenje {
        data = typeof data === 'object' ? data : {};
        let result = new Ogranicenje();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["opis"] = this.opis;
        data["vrednost"] = this.vrednost;
        data["tipId"] = this.tipId;
        data["tipOdKogJeNasledjenoId"] = this.tipOdKogJeNasledjenoId;
        data["tipOgranicenjaId"] = this.tipOgranicenjaId;
        data["tipOgranicenja"] = this.tipOgranicenja ? this.tipOgranicenja.toJSON() : <any>undefined;
        data["tip"] = this.tip ? this.tip.toJSON() : <any>undefined;
        data["tipOdKogJeNasledjeno"] = this.tipOdKogJeNasledjeno ? this.tipOdKogJeNasledjeno.toJSON() : <any>undefined;
        data["statusOgranicenjaId"] = this.statusOgranicenjaId;
        super.toJSON(data);
        return data;
    }
}

export interface IOgranicenje extends IBaseEntity {
    id: number;
    naziv?: string | undefined;
    opis?: string | undefined;
    vrednost?: string | undefined;
    tipId?: number | undefined;
    tipOdKogJeNasledjenoId?: number | undefined;
    tipOgranicenjaId: number;
    tipOgranicenja?: TipOgranicenja | undefined;
    tip?: Tip | undefined;
    tipOdKogJeNasledjeno?: Tip | undefined;
    statusOgranicenjaId?: number | undefined;
}

export class KljucnaRec extends BaseEntity implements IKljucnaRec {
    id!: number;
    tekst?: string | undefined;
    pojamId!: number;
    tipId?: number | undefined;
    tip?: Tip | undefined;

    constructor(data?: IKljucnaRec) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.tekst = _data["tekst"];
            this.pojamId = _data["pojamId"];
            this.tipId = _data["tipId"];
            this.tip = _data["tip"] ? Tip.fromJS(_data["tip"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KljucnaRec {
        data = typeof data === 'object' ? data : {};
        let result = new KljucnaRec();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tekst"] = this.tekst;
        data["pojamId"] = this.pojamId;
        data["tipId"] = this.tipId;
        data["tip"] = this.tip ? this.tip.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IKljucnaRec extends IBaseEntity {
    id: number;
    tekst?: string | undefined;
    pojamId: number;
    tipId?: number | undefined;
    tip?: Tip | undefined;
}

export class StatusTipa extends BaseEntity implements IStatusTipa {
    id!: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;

    constructor(data?: IStatusTipa) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
            this.opisLatinica = _data["opisLatinica"];
        }
    }

    static fromJS(data: any): StatusTipa {
        data = typeof data === 'object' ? data : {};
        let result = new StatusTipa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        data["opisLatinica"] = this.opisLatinica;
        super.toJSON(data);
        return data;
    }
}

export interface IStatusTipa extends IBaseEntity {
    id: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;
}

export class TipAgregacije extends BaseEntity implements ITipAgregacije {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
    xsdTip?: string | undefined;

    constructor(data?: ITipAgregacije) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.nazivLatinica = _data["nazivLatinica"];
            this.xsdTip = _data["xsdTip"];
        }
    }

    static fromJS(data: any): TipAgregacije {
        data = typeof data === 'object' ? data : {};
        let result = new TipAgregacije();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["nazivLatinica"] = this.nazivLatinica;
        data["xsdTip"] = this.xsdTip;
        super.toJSON(data);
        return data;
    }
}

export interface ITipAgregacije extends IBaseEntity {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
    xsdTip?: string | undefined;
}

export class StatusVerzijeTipa extends BaseEntity implements IStatusVerzijeTipa {
    id!: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;

    constructor(data?: IStatusVerzijeTipa) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
            this.opisLatinica = _data["opisLatinica"];
        }
    }

    static fromJS(data: any): StatusVerzijeTipa {
        data = typeof data === 'object' ? data : {};
        let result = new StatusVerzijeTipa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        data["opisLatinica"] = this.opisLatinica;
        super.toJSON(data);
        return data;
    }
}

export interface IStatusVerzijeTipa extends IBaseEntity {
    id: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;
}

export class Svojstvo extends BaseEntity implements ISvojstvo {
    id!: number;
    slozeniPojamId!: number;
    pojamUSastavuId!: number;
    pripadaId?: number | undefined;
    prekopiranoOdId?: number | undefined;
    nadredjenoSvojstvoId?: number | undefined;
    nasledjenOdSvojstvaId?: number | undefined;
    suzeniTipId?: number | undefined;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    sufiksNaziva?: string | undefined;
    definicija?: string | undefined;
    putanja?: string | undefined;
    dopunskoSvojstvo!: boolean;
    minBrojPojavljivanja?: string | undefined;
    maxBrojPojavljivanja?: string | undefined;
    skupVrednostiOgranicen!: boolean;
    svojstvoSifarnickogPojmaId?: number | undefined;
    skupVrednostiOgranicenDrugimSifarnikom!: boolean;
    sifarnikSifra?: string | undefined;
    elementSifarnikaSifra?: string | undefined;
    jeKvalifikator!: boolean;
    punNazivSvojstvaURecniku?: string | undefined;
    redniBroj!: number;
    statusId!: number;
    zaDeaktivaciju?: boolean | undefined;
    nazivSaSufiksom?: string | undefined;
    defaultVrednost?: string | undefined;
    slozeniPojam?: Tip | undefined;
    pojamUSastavu?: Tip | undefined;
    pripadaTipu?: Tip | undefined;
    prekopiranoOdTipa?: Tip | undefined;
    suzeniTip?: Tip | undefined;
    nadredjenoSvojstvo?: Svojstvo | undefined;
    nasledjenOdSvojstva?: Svojstvo | undefined;
    svojstvoSifarnickogPojma?: Svojstvo | undefined;
    status?: StatusSvojstva | undefined;
    elementi?: Element[] | undefined;
    nadredjeniElementi?: Element[] | undefined;

    constructor(data?: ISvojstvo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.slozeniPojamId = _data["slozeniPojamId"];
            this.pojamUSastavuId = _data["pojamUSastavuId"];
            this.pripadaId = _data["pripadaId"];
            this.prekopiranoOdId = _data["prekopiranoOdId"];
            this.nadredjenoSvojstvoId = _data["nadredjenoSvojstvoId"];
            this.nasledjenOdSvojstvaId = _data["nasledjenOdSvojstvaId"];
            this.suzeniTipId = _data["suzeniTipId"];
            this.naziv = _data["naziv"];
            this.tehnickiNaziv = _data["tehnickiNaziv"];
            this.sufiksNaziva = _data["sufiksNaziva"];
            this.definicija = _data["definicija"];
            this.putanja = _data["putanja"];
            this.dopunskoSvojstvo = _data["dopunskoSvojstvo"];
            this.minBrojPojavljivanja = _data["minBrojPojavljivanja"];
            this.maxBrojPojavljivanja = _data["maxBrojPojavljivanja"];
            this.skupVrednostiOgranicen = _data["skupVrednostiOgranicen"];
            this.svojstvoSifarnickogPojmaId = _data["svojstvoSifarnickogPojmaId"];
            this.skupVrednostiOgranicenDrugimSifarnikom = _data["skupVrednostiOgranicenDrugimSifarnikom"];
            this.sifarnikSifra = _data["sifarnikSifra"];
            this.elementSifarnikaSifra = _data["elementSifarnikaSifra"];
            this.jeKvalifikator = _data["jeKvalifikator"];
            this.punNazivSvojstvaURecniku = _data["punNazivSvojstvaURecniku"];
            this.redniBroj = _data["redniBroj"];
            this.statusId = _data["statusId"];
            this.zaDeaktivaciju = _data["zaDeaktivaciju"];
            this.nazivSaSufiksom = _data["nazivSaSufiksom"];
            this.defaultVrednost = _data["defaultVrednost"];
            this.slozeniPojam = _data["slozeniPojam"] ? Tip.fromJS(_data["slozeniPojam"]) : <any>undefined;
            this.pojamUSastavu = _data["pojamUSastavu"] ? Tip.fromJS(_data["pojamUSastavu"]) : <any>undefined;
            this.pripadaTipu = _data["pripadaTipu"] ? Tip.fromJS(_data["pripadaTipu"]) : <any>undefined;
            this.prekopiranoOdTipa = _data["prekopiranoOdTipa"] ? Tip.fromJS(_data["prekopiranoOdTipa"]) : <any>undefined;
            this.suzeniTip = _data["suzeniTip"] ? Tip.fromJS(_data["suzeniTip"]) : <any>undefined;
            this.nadredjenoSvojstvo = _data["nadredjenoSvojstvo"] ? Svojstvo.fromJS(_data["nadredjenoSvojstvo"]) : <any>undefined;
            this.nasledjenOdSvojstva = _data["nasledjenOdSvojstva"] ? Svojstvo.fromJS(_data["nasledjenOdSvojstva"]) : <any>undefined;
            this.svojstvoSifarnickogPojma = _data["svojstvoSifarnickogPojma"] ? Svojstvo.fromJS(_data["svojstvoSifarnickogPojma"]) : <any>undefined;
            this.status = _data["status"] ? StatusSvojstva.fromJS(_data["status"]) : <any>undefined;
            if (Array.isArray(_data["elementi"])) {
                this.elementi = [] as any;
                for (let item of _data["elementi"])
                    this.elementi!.push(Element.fromJS(item));
            }
            if (Array.isArray(_data["nadredjeniElementi"])) {
                this.nadredjeniElementi = [] as any;
                for (let item of _data["nadredjeniElementi"])
                    this.nadredjeniElementi!.push(Element.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Svojstvo {
        data = typeof data === 'object' ? data : {};
        let result = new Svojstvo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slozeniPojamId"] = this.slozeniPojamId;
        data["pojamUSastavuId"] = this.pojamUSastavuId;
        data["pripadaId"] = this.pripadaId;
        data["prekopiranoOdId"] = this.prekopiranoOdId;
        data["nadredjenoSvojstvoId"] = this.nadredjenoSvojstvoId;
        data["nasledjenOdSvojstvaId"] = this.nasledjenOdSvojstvaId;
        data["suzeniTipId"] = this.suzeniTipId;
        data["naziv"] = this.naziv;
        data["tehnickiNaziv"] = this.tehnickiNaziv;
        data["sufiksNaziva"] = this.sufiksNaziva;
        data["definicija"] = this.definicija;
        data["putanja"] = this.putanja;
        data["dopunskoSvojstvo"] = this.dopunskoSvojstvo;
        data["minBrojPojavljivanja"] = this.minBrojPojavljivanja;
        data["maxBrojPojavljivanja"] = this.maxBrojPojavljivanja;
        data["skupVrednostiOgranicen"] = this.skupVrednostiOgranicen;
        data["svojstvoSifarnickogPojmaId"] = this.svojstvoSifarnickogPojmaId;
        data["skupVrednostiOgranicenDrugimSifarnikom"] = this.skupVrednostiOgranicenDrugimSifarnikom;
        data["sifarnikSifra"] = this.sifarnikSifra;
        data["elementSifarnikaSifra"] = this.elementSifarnikaSifra;
        data["jeKvalifikator"] = this.jeKvalifikator;
        data["punNazivSvojstvaURecniku"] = this.punNazivSvojstvaURecniku;
        data["redniBroj"] = this.redniBroj;
        data["statusId"] = this.statusId;
        data["zaDeaktivaciju"] = this.zaDeaktivaciju;
        data["nazivSaSufiksom"] = this.nazivSaSufiksom;
        data["defaultVrednost"] = this.defaultVrednost;
        data["slozeniPojam"] = this.slozeniPojam ? this.slozeniPojam.toJSON() : <any>undefined;
        data["pojamUSastavu"] = this.pojamUSastavu ? this.pojamUSastavu.toJSON() : <any>undefined;
        data["pripadaTipu"] = this.pripadaTipu ? this.pripadaTipu.toJSON() : <any>undefined;
        data["prekopiranoOdTipa"] = this.prekopiranoOdTipa ? this.prekopiranoOdTipa.toJSON() : <any>undefined;
        data["suzeniTip"] = this.suzeniTip ? this.suzeniTip.toJSON() : <any>undefined;
        data["nadredjenoSvojstvo"] = this.nadredjenoSvojstvo ? this.nadredjenoSvojstvo.toJSON() : <any>undefined;
        data["nasledjenOdSvojstva"] = this.nasledjenOdSvojstva ? this.nasledjenOdSvojstva.toJSON() : <any>undefined;
        data["svojstvoSifarnickogPojma"] = this.svojstvoSifarnickogPojma ? this.svojstvoSifarnickogPojma.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        if (Array.isArray(this.elementi)) {
            data["elementi"] = [];
            for (let item of this.elementi)
                data["elementi"].push(item.toJSON());
        }
        if (Array.isArray(this.nadredjeniElementi)) {
            data["nadredjeniElementi"] = [];
            for (let item of this.nadredjeniElementi)
                data["nadredjeniElementi"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISvojstvo extends IBaseEntity {
    id: number;
    slozeniPojamId: number;
    pojamUSastavuId: number;
    pripadaId?: number | undefined;
    prekopiranoOdId?: number | undefined;
    nadredjenoSvojstvoId?: number | undefined;
    nasledjenOdSvojstvaId?: number | undefined;
    suzeniTipId?: number | undefined;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    sufiksNaziva?: string | undefined;
    definicija?: string | undefined;
    putanja?: string | undefined;
    dopunskoSvojstvo: boolean;
    minBrojPojavljivanja?: string | undefined;
    maxBrojPojavljivanja?: string | undefined;
    skupVrednostiOgranicen: boolean;
    svojstvoSifarnickogPojmaId?: number | undefined;
    skupVrednostiOgranicenDrugimSifarnikom: boolean;
    sifarnikSifra?: string | undefined;
    elementSifarnikaSifra?: string | undefined;
    jeKvalifikator: boolean;
    punNazivSvojstvaURecniku?: string | undefined;
    redniBroj: number;
    statusId: number;
    zaDeaktivaciju?: boolean | undefined;
    nazivSaSufiksom?: string | undefined;
    defaultVrednost?: string | undefined;
    slozeniPojam?: Tip | undefined;
    pojamUSastavu?: Tip | undefined;
    pripadaTipu?: Tip | undefined;
    prekopiranoOdTipa?: Tip | undefined;
    suzeniTip?: Tip | undefined;
    nadredjenoSvojstvo?: Svojstvo | undefined;
    nasledjenOdSvojstva?: Svojstvo | undefined;
    svojstvoSifarnickogPojma?: Svojstvo | undefined;
    status?: StatusSvojstva | undefined;
    elementi?: Element[] | undefined;
    nadredjeniElementi?: Element[] | undefined;
}

export class StatusSvojstva extends BaseEntity implements IStatusSvojstva {
    id!: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;

    constructor(data?: IStatusSvojstva) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
            this.opisLatinica = _data["opisLatinica"];
        }
    }

    static fromJS(data: any): StatusSvojstva {
        data = typeof data === 'object' ? data : {};
        let result = new StatusSvojstva();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        data["opisLatinica"] = this.opisLatinica;
        super.toJSON(data);
        return data;
    }
}

export interface IStatusSvojstva extends IBaseEntity {
    id: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;
}

export class Element extends BaseEntity implements IElement {
    id!: number;
    sadrzajSluzbeneEvidencijeId!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    definicija?: string | undefined;
    tipPodatka?: string | undefined;
    svojstvoReferentnogPojma?: string | undefined;
    jeIzvorni!: boolean;
    jeElementZaIdentifikacionuOznaku!: boolean;
    redniBroj!: number;
    nadredjeniElementId?: number | undefined;
    nadredjeniElement?: Element | undefined;
    pojamId?: number | undefined;
    svojstvoId?: number | undefined;
    nadredjenoSvojstvoId?: number | undefined;
    pojam?: Tip | undefined;
    svojstvo?: Svojstvo | undefined;
    nadredjenoSvojstvo?: Svojstvo | undefined;
    sadrzajSluzbeneEvidencije?: SadrzajSluzbeneEvidencije | undefined;

    constructor(data?: IElement) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.sadrzajSluzbeneEvidencijeId = _data["sadrzajSluzbeneEvidencijeId"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.tehnickiNaziv = _data["tehnickiNaziv"];
            this.definicija = _data["definicija"];
            this.tipPodatka = _data["tipPodatka"];
            this.svojstvoReferentnogPojma = _data["svojstvoReferentnogPojma"];
            this.jeIzvorni = _data["jeIzvorni"];
            this.jeElementZaIdentifikacionuOznaku = _data["jeElementZaIdentifikacionuOznaku"];
            this.redniBroj = _data["redniBroj"];
            this.nadredjeniElementId = _data["nadredjeniElementId"];
            this.nadredjeniElement = _data["nadredjeniElement"] ? Element.fromJS(_data["nadredjeniElement"]) : <any>undefined;
            this.pojamId = _data["pojamId"];
            this.svojstvoId = _data["svojstvoId"];
            this.nadredjenoSvojstvoId = _data["nadredjenoSvojstvoId"];
            this.pojam = _data["pojam"] ? Tip.fromJS(_data["pojam"]) : <any>undefined;
            this.svojstvo = _data["svojstvo"] ? Svojstvo.fromJS(_data["svojstvo"]) : <any>undefined;
            this.nadredjenoSvojstvo = _data["nadredjenoSvojstvo"] ? Svojstvo.fromJS(_data["nadredjenoSvojstvo"]) : <any>undefined;
            this.sadrzajSluzbeneEvidencije = _data["sadrzajSluzbeneEvidencije"] ? SadrzajSluzbeneEvidencije.fromJS(_data["sadrzajSluzbeneEvidencije"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Element {
        data = typeof data === 'object' ? data : {};
        let result = new Element();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sadrzajSluzbeneEvidencijeId"] = this.sadrzajSluzbeneEvidencijeId;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["tehnickiNaziv"] = this.tehnickiNaziv;
        data["definicija"] = this.definicija;
        data["tipPodatka"] = this.tipPodatka;
        data["svojstvoReferentnogPojma"] = this.svojstvoReferentnogPojma;
        data["jeIzvorni"] = this.jeIzvorni;
        data["jeElementZaIdentifikacionuOznaku"] = this.jeElementZaIdentifikacionuOznaku;
        data["redniBroj"] = this.redniBroj;
        data["nadredjeniElementId"] = this.nadredjeniElementId;
        data["nadredjeniElement"] = this.nadredjeniElement ? this.nadredjeniElement.toJSON() : <any>undefined;
        data["pojamId"] = this.pojamId;
        data["svojstvoId"] = this.svojstvoId;
        data["nadredjenoSvojstvoId"] = this.nadredjenoSvojstvoId;
        data["pojam"] = this.pojam ? this.pojam.toJSON() : <any>undefined;
        data["svojstvo"] = this.svojstvo ? this.svojstvo.toJSON() : <any>undefined;
        data["nadredjenoSvojstvo"] = this.nadredjenoSvojstvo ? this.nadredjenoSvojstvo.toJSON() : <any>undefined;
        data["sadrzajSluzbeneEvidencije"] = this.sadrzajSluzbeneEvidencije ? this.sadrzajSluzbeneEvidencije.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IElement extends IBaseEntity {
    id: number;
    sadrzajSluzbeneEvidencijeId: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    definicija?: string | undefined;
    tipPodatka?: string | undefined;
    svojstvoReferentnogPojma?: string | undefined;
    jeIzvorni: boolean;
    jeElementZaIdentifikacionuOznaku: boolean;
    redniBroj: number;
    nadredjeniElementId?: number | undefined;
    nadredjeniElement?: Element | undefined;
    pojamId?: number | undefined;
    svojstvoId?: number | undefined;
    nadredjenoSvojstvoId?: number | undefined;
    pojam?: Tip | undefined;
    svojstvo?: Svojstvo | undefined;
    nadredjenoSvojstvo?: Svojstvo | undefined;
    sadrzajSluzbeneEvidencije?: SadrzajSluzbeneEvidencije | undefined;
}

export class SadrzajSluzbeneEvidencije extends BaseEntity implements ISadrzajSluzbeneEvidencije {
    id!: number;
    sifra?: string | undefined;
    datumOd!: Date;
    datumDo?: Date | undefined;
    statusId!: number;
    jePoslednjaVerzija!: boolean;
    statusVerzijeId!: number;
    verzija?: string | undefined;
    razlogDeaktivacije?: string | undefined;
    statusVerzije?: StatusVerzijeSluzbeneEvidencije | undefined;
    status?: StatusSluzbeneEvidencije | undefined;
    elementi?: Element[] | undefined;
    entityStatus!: EntityStatus;

    constructor(data?: ISadrzajSluzbeneEvidencije) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.jePoslednjaVerzija = _data["jePoslednjaVerzija"];
            this.statusVerzijeId = _data["statusVerzijeId"];
            this.verzija = _data["verzija"];
            this.razlogDeaktivacije = _data["razlogDeaktivacije"];
            this.statusVerzije = _data["statusVerzije"] ? StatusVerzijeSluzbeneEvidencije.fromJS(_data["statusVerzije"]) : <any>undefined;
            this.status = _data["status"] ? StatusSluzbeneEvidencije.fromJS(_data["status"]) : <any>undefined;
            if (Array.isArray(_data["elementi"])) {
                this.elementi = [] as any;
                for (let item of _data["elementi"])
                    this.elementi!.push(Element.fromJS(item));
            }
            this.entityStatus = _data["entityStatus"];
        }
    }

    static fromJS(data: any): SadrzajSluzbeneEvidencije {
        data = typeof data === 'object' ? data : {};
        let result = new SadrzajSluzbeneEvidencije();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["statusId"] = this.statusId;
        data["jePoslednjaVerzija"] = this.jePoslednjaVerzija;
        data["statusVerzijeId"] = this.statusVerzijeId;
        data["verzija"] = this.verzija;
        data["razlogDeaktivacije"] = this.razlogDeaktivacije;
        data["statusVerzije"] = this.statusVerzije ? this.statusVerzije.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        if (Array.isArray(this.elementi)) {
            data["elementi"] = [];
            for (let item of this.elementi)
                data["elementi"].push(item.toJSON());
        }
        data["entityStatus"] = this.entityStatus;
        super.toJSON(data);
        return data;
    }
}

export interface ISadrzajSluzbeneEvidencije extends IBaseEntity {
    id: number;
    sifra?: string | undefined;
    datumOd: Date;
    datumDo?: Date | undefined;
    statusId: number;
    jePoslednjaVerzija: boolean;
    statusVerzijeId: number;
    verzija?: string | undefined;
    razlogDeaktivacije?: string | undefined;
    statusVerzije?: StatusVerzijeSluzbeneEvidencije | undefined;
    status?: StatusSluzbeneEvidencije | undefined;
    elementi?: Element[] | undefined;
    entityStatus: EntityStatus;
}

export class StatusVerzijeSluzbeneEvidencije extends BaseEntity implements IStatusVerzijeSluzbeneEvidencije {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;

    constructor(data?: IStatusVerzijeSluzbeneEvidencije) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.nazivLatinica = _data["nazivLatinica"];
        }
    }

    static fromJS(data: any): StatusVerzijeSluzbeneEvidencije {
        data = typeof data === 'object' ? data : {};
        let result = new StatusVerzijeSluzbeneEvidencije();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["nazivLatinica"] = this.nazivLatinica;
        super.toJSON(data);
        return data;
    }
}

export interface IStatusVerzijeSluzbeneEvidencije extends IBaseEntity {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
}

export class StatusSluzbeneEvidencije extends BaseEntity implements IStatusSluzbeneEvidencije {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;

    constructor(data?: IStatusSluzbeneEvidencije) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.nazivLatinica = _data["nazivLatinica"];
        }
    }

    static fromJS(data: any): StatusSluzbeneEvidencije {
        data = typeof data === 'object' ? data : {};
        let result = new StatusSluzbeneEvidencije();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["nazivLatinica"] = this.nazivLatinica;
        super.toJSON(data);
        return data;
    }
}

export interface IStatusSluzbeneEvidencije extends IBaseEntity {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
}

export enum EntityStatus {
    NoAction = 0,
    Insert = 1,
    Update = 2,
    Deleted = 3,
    SpecialCase = 4,
    Active = 5,
}

export class SluzbenaEvidencija extends BaseEntity implements ISluzbenaEvidencija {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    skraceniNaziv?: string | undefined;
    sifraNadleznogOrgana?: string | undefined;
    tipSluzbeneEvidencijeId!: number;
    datumUspostavljanja?: Date | undefined;
    datumUkidanja?: Date | undefined;
    ucestalostAzuriranja?: string | undefined;
    rokCuvanja?: number | undefined;
    jeTrajnoCuvanje!: boolean;
    jeJavnoDostupno!: boolean;
    adresa?: string | undefined;
    jeCentralizovana!: boolean;
    jeElektronskiOblik!: boolean;
    elektronskiOblikPutemServisa?: string | undefined;
    pravniOsnov?: string | undefined;
    opis?: string | undefined;
    razlogDeaktivacije?: string | undefined;
    datumOd!: Date;
    datumDo?: Date | undefined;
    statusId!: number;
    verzija?: string | undefined;
    jePoslednjaVerzija!: boolean;
    statusVerzijeId!: number;
    sifarnickiPojamId?: number | undefined;
    status?: StatusSluzbeneEvidencije | undefined;
    tipSluzbeneEvidencije?: TipSluzbeneEvidencije | undefined;
    statusVerzije?: StatusVerzijeSluzbeneEvidencije | undefined;
    klasifikacijeSluzbenihEvidencija?: KlasifikacijeSluzbenihEvidencija[] | undefined;
    sifarnickiPojam?: Tip | undefined;
    entityStatus!: EntityStatus;

    constructor(data?: ISluzbenaEvidencija) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.skraceniNaziv = _data["skraceniNaziv"];
            this.sifraNadleznogOrgana = _data["sifraNadleznogOrgana"];
            this.tipSluzbeneEvidencijeId = _data["tipSluzbeneEvidencijeId"];
            this.datumUspostavljanja = _data["datumUspostavljanja"] ? new Date(_data["datumUspostavljanja"].toString()) : <any>undefined;
            this.datumUkidanja = _data["datumUkidanja"] ? new Date(_data["datumUkidanja"].toString()) : <any>undefined;
            this.ucestalostAzuriranja = _data["ucestalostAzuriranja"];
            this.rokCuvanja = _data["rokCuvanja"];
            this.jeTrajnoCuvanje = _data["jeTrajnoCuvanje"];
            this.jeJavnoDostupno = _data["jeJavnoDostupno"];
            this.adresa = _data["adresa"];
            this.jeCentralizovana = _data["jeCentralizovana"];
            this.jeElektronskiOblik = _data["jeElektronskiOblik"];
            this.elektronskiOblikPutemServisa = _data["elektronskiOblikPutemServisa"];
            this.pravniOsnov = _data["pravniOsnov"];
            this.opis = _data["opis"];
            this.razlogDeaktivacije = _data["razlogDeaktivacije"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.verzija = _data["verzija"];
            this.jePoslednjaVerzija = _data["jePoslednjaVerzija"];
            this.statusVerzijeId = _data["statusVerzijeId"];
            this.sifarnickiPojamId = _data["sifarnickiPojamId"];
            this.status = _data["status"] ? StatusSluzbeneEvidencije.fromJS(_data["status"]) : <any>undefined;
            this.tipSluzbeneEvidencije = _data["tipSluzbeneEvidencije"] ? TipSluzbeneEvidencije.fromJS(_data["tipSluzbeneEvidencije"]) : <any>undefined;
            this.statusVerzije = _data["statusVerzije"] ? StatusVerzijeSluzbeneEvidencije.fromJS(_data["statusVerzije"]) : <any>undefined;
            if (Array.isArray(_data["klasifikacijeSluzbenihEvidencija"])) {
                this.klasifikacijeSluzbenihEvidencija = [] as any;
                for (let item of _data["klasifikacijeSluzbenihEvidencija"])
                    this.klasifikacijeSluzbenihEvidencija!.push(KlasifikacijeSluzbenihEvidencija.fromJS(item));
            }
            this.sifarnickiPojam = _data["sifarnickiPojam"] ? Tip.fromJS(_data["sifarnickiPojam"]) : <any>undefined;
            this.entityStatus = _data["entityStatus"];
        }
    }

    static fromJS(data: any): SluzbenaEvidencija {
        data = typeof data === 'object' ? data : {};
        let result = new SluzbenaEvidencija();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["skraceniNaziv"] = this.skraceniNaziv;
        data["sifraNadleznogOrgana"] = this.sifraNadleznogOrgana;
        data["tipSluzbeneEvidencijeId"] = this.tipSluzbeneEvidencijeId;
        data["datumUspostavljanja"] = this.datumUspostavljanja ? this.datumUspostavljanja.toISOString() : <any>undefined;
        data["datumUkidanja"] = this.datumUkidanja ? this.datumUkidanja.toISOString() : <any>undefined;
        data["ucestalostAzuriranja"] = this.ucestalostAzuriranja;
        data["rokCuvanja"] = this.rokCuvanja;
        data["jeTrajnoCuvanje"] = this.jeTrajnoCuvanje;
        data["jeJavnoDostupno"] = this.jeJavnoDostupno;
        data["adresa"] = this.adresa;
        data["jeCentralizovana"] = this.jeCentralizovana;
        data["jeElektronskiOblik"] = this.jeElektronskiOblik;
        data["elektronskiOblikPutemServisa"] = this.elektronskiOblikPutemServisa;
        data["pravniOsnov"] = this.pravniOsnov;
        data["opis"] = this.opis;
        data["razlogDeaktivacije"] = this.razlogDeaktivacije;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["statusId"] = this.statusId;
        data["verzija"] = this.verzija;
        data["jePoslednjaVerzija"] = this.jePoslednjaVerzija;
        data["statusVerzijeId"] = this.statusVerzijeId;
        data["sifarnickiPojamId"] = this.sifarnickiPojamId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["tipSluzbeneEvidencije"] = this.tipSluzbeneEvidencije ? this.tipSluzbeneEvidencije.toJSON() : <any>undefined;
        data["statusVerzije"] = this.statusVerzije ? this.statusVerzije.toJSON() : <any>undefined;
        if (Array.isArray(this.klasifikacijeSluzbenihEvidencija)) {
            data["klasifikacijeSluzbenihEvidencija"] = [];
            for (let item of this.klasifikacijeSluzbenihEvidencija)
                data["klasifikacijeSluzbenihEvidencija"].push(item.toJSON());
        }
        data["sifarnickiPojam"] = this.sifarnickiPojam ? this.sifarnickiPojam.toJSON() : <any>undefined;
        data["entityStatus"] = this.entityStatus;
        super.toJSON(data);
        return data;
    }
}

export interface ISluzbenaEvidencija extends IBaseEntity {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    skraceniNaziv?: string | undefined;
    sifraNadleznogOrgana?: string | undefined;
    tipSluzbeneEvidencijeId: number;
    datumUspostavljanja?: Date | undefined;
    datumUkidanja?: Date | undefined;
    ucestalostAzuriranja?: string | undefined;
    rokCuvanja?: number | undefined;
    jeTrajnoCuvanje: boolean;
    jeJavnoDostupno: boolean;
    adresa?: string | undefined;
    jeCentralizovana: boolean;
    jeElektronskiOblik: boolean;
    elektronskiOblikPutemServisa?: string | undefined;
    pravniOsnov?: string | undefined;
    opis?: string | undefined;
    razlogDeaktivacije?: string | undefined;
    datumOd: Date;
    datumDo?: Date | undefined;
    statusId: number;
    verzija?: string | undefined;
    jePoslednjaVerzija: boolean;
    statusVerzijeId: number;
    sifarnickiPojamId?: number | undefined;
    status?: StatusSluzbeneEvidencije | undefined;
    tipSluzbeneEvidencije?: TipSluzbeneEvidencije | undefined;
    statusVerzije?: StatusVerzijeSluzbeneEvidencije | undefined;
    klasifikacijeSluzbenihEvidencija?: KlasifikacijeSluzbenihEvidencija[] | undefined;
    sifarnickiPojam?: Tip | undefined;
    entityStatus: EntityStatus;
}

export class TipSluzbeneEvidencije extends BaseEntity implements ITipSluzbeneEvidencije {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;

    constructor(data?: ITipSluzbeneEvidencije) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.nazivLatinica = _data["nazivLatinica"];
        }
    }

    static fromJS(data: any): TipSluzbeneEvidencije {
        data = typeof data === 'object' ? data : {};
        let result = new TipSluzbeneEvidencije();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["nazivLatinica"] = this.nazivLatinica;
        super.toJSON(data);
        return data;
    }
}

export interface ITipSluzbeneEvidencije extends IBaseEntity {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
}

export class KlasifikacijeSluzbenihEvidencija extends BaseEntity implements IKlasifikacijeSluzbenihEvidencija {
    id!: number;
    klasifikacijaId!: number;
    sluzbenaEvidencijaId!: number;
    sluzbenaEvidencija?: SluzbenaEvidencija | undefined;
    klasifikacija?: KlasifikacijaSluzbeneEvidencije | undefined;
    entityStatus!: EntityStatus;

    constructor(data?: IKlasifikacijeSluzbenihEvidencija) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.klasifikacijaId = _data["klasifikacijaId"];
            this.sluzbenaEvidencijaId = _data["sluzbenaEvidencijaId"];
            this.sluzbenaEvidencija = _data["sluzbenaEvidencija"] ? SluzbenaEvidencija.fromJS(_data["sluzbenaEvidencija"]) : <any>undefined;
            this.klasifikacija = _data["klasifikacija"] ? KlasifikacijaSluzbeneEvidencije.fromJS(_data["klasifikacija"]) : <any>undefined;
            this.entityStatus = _data["entityStatus"];
        }
    }

    static fromJS(data: any): KlasifikacijeSluzbenihEvidencija {
        data = typeof data === 'object' ? data : {};
        let result = new KlasifikacijeSluzbenihEvidencija();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["klasifikacijaId"] = this.klasifikacijaId;
        data["sluzbenaEvidencijaId"] = this.sluzbenaEvidencijaId;
        data["sluzbenaEvidencija"] = this.sluzbenaEvidencija ? this.sluzbenaEvidencija.toJSON() : <any>undefined;
        data["klasifikacija"] = this.klasifikacija ? this.klasifikacija.toJSON() : <any>undefined;
        data["entityStatus"] = this.entityStatus;
        super.toJSON(data);
        return data;
    }
}

export interface IKlasifikacijeSluzbenihEvidencija extends IBaseEntity {
    id: number;
    klasifikacijaId: number;
    sluzbenaEvidencijaId: number;
    sluzbenaEvidencija?: SluzbenaEvidencija | undefined;
    klasifikacija?: KlasifikacijaSluzbeneEvidencije | undefined;
    entityStatus: EntityStatus;
}

export class KlasifikacijaSluzbeneEvidencije extends BaseEntity implements IKlasifikacijaSluzbeneEvidencije {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
    jeDozvoljenVisestrukiIzbor?: boolean | undefined;
    opis?: string | undefined;
    vaziOd!: Date;
    vaziDo?: Date | undefined;
    statusId!: number;
    nadredjenaKlasifikacijaId?: number | undefined;
    nadredjenaKlasifikacija?: KlasifikacijaSluzbeneEvidencije | undefined;
    status?: StatusKlasifikacije | undefined;
    klasifikacijeEvidencija?: KlasifikacijeSluzbenihEvidencija[] | undefined;

    constructor(data?: IKlasifikacijaSluzbeneEvidencije) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.nazivLatinica = _data["nazivLatinica"];
            this.jeDozvoljenVisestrukiIzbor = _data["jeDozvoljenVisestrukiIzbor"];
            this.opis = _data["opis"];
            this.vaziOd = _data["vaziOd"] ? new Date(_data["vaziOd"].toString()) : <any>undefined;
            this.vaziDo = _data["vaziDo"] ? new Date(_data["vaziDo"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.nadredjenaKlasifikacijaId = _data["nadredjenaKlasifikacijaId"];
            this.nadredjenaKlasifikacija = _data["nadredjenaKlasifikacija"] ? KlasifikacijaSluzbeneEvidencije.fromJS(_data["nadredjenaKlasifikacija"]) : <any>undefined;
            this.status = _data["status"] ? StatusKlasifikacije.fromJS(_data["status"]) : <any>undefined;
            if (Array.isArray(_data["klasifikacijeEvidencija"])) {
                this.klasifikacijeEvidencija = [] as any;
                for (let item of _data["klasifikacijeEvidencija"])
                    this.klasifikacijeEvidencija!.push(KlasifikacijeSluzbenihEvidencija.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KlasifikacijaSluzbeneEvidencije {
        data = typeof data === 'object' ? data : {};
        let result = new KlasifikacijaSluzbeneEvidencije();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["nazivLatinica"] = this.nazivLatinica;
        data["jeDozvoljenVisestrukiIzbor"] = this.jeDozvoljenVisestrukiIzbor;
        data["opis"] = this.opis;
        data["vaziOd"] = this.vaziOd ? this.vaziOd.toISOString() : <any>undefined;
        data["vaziDo"] = this.vaziDo ? this.vaziDo.toISOString() : <any>undefined;
        data["statusId"] = this.statusId;
        data["nadredjenaKlasifikacijaId"] = this.nadredjenaKlasifikacijaId;
        data["nadredjenaKlasifikacija"] = this.nadredjenaKlasifikacija ? this.nadredjenaKlasifikacija.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        if (Array.isArray(this.klasifikacijeEvidencija)) {
            data["klasifikacijeEvidencija"] = [];
            for (let item of this.klasifikacijeEvidencija)
                data["klasifikacijeEvidencija"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IKlasifikacijaSluzbeneEvidencije extends IBaseEntity {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
    jeDozvoljenVisestrukiIzbor?: boolean | undefined;
    opis?: string | undefined;
    vaziOd: Date;
    vaziDo?: Date | undefined;
    statusId: number;
    nadredjenaKlasifikacijaId?: number | undefined;
    nadredjenaKlasifikacija?: KlasifikacijaSluzbeneEvidencije | undefined;
    status?: StatusKlasifikacije | undefined;
    klasifikacijeEvidencija?: KlasifikacijeSluzbenihEvidencija[] | undefined;
}

export class StatusKlasifikacije extends BaseEntity implements IStatusKlasifikacije {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;

    constructor(data?: IStatusKlasifikacije) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.nazivLatinica = _data["nazivLatinica"];
        }
    }

    static fromJS(data: any): StatusKlasifikacije {
        data = typeof data === 'object' ? data : {};
        let result = new StatusKlasifikacije();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["nazivLatinica"] = this.nazivLatinica;
        super.toJSON(data);
        return data;
    }
}

export interface IStatusKlasifikacije extends IBaseEntity {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
}

export class VrstaTipa extends BaseEntity implements IVrstaTipa {
    id!: number;
    naziv?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IVrstaTipa) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): VrstaTipa {
        data = typeof data === 'object' ? data : {};
        let result = new VrstaTipa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["opis"] = this.opis;
        super.toJSON(data);
        return data;
    }
}

export interface IVrstaTipa extends IBaseEntity {
    id: number;
    naziv?: string | undefined;
    opis?: string | undefined;
}

export class StatusElementaPoruke extends BaseEntity implements IStatusElementaPoruke {
    id!: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;

    constructor(data?: IStatusElementaPoruke) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
            this.opisLatinica = _data["opisLatinica"];
        }
    }

    static fromJS(data: any): StatusElementaPoruke {
        data = typeof data === 'object' ? data : {};
        let result = new StatusElementaPoruke();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        data["opisLatinica"] = this.opisLatinica;
        super.toJSON(data);
        return data;
    }
}

export interface IStatusElementaPoruke extends IBaseEntity {
    id: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;
}

export class DajPorukuPoIDuResponse implements IDajPorukuPoIDuResponse {
    id!: number;
    sifra?: string | undefined;
    domenId!: number;
    vrstaPorukeId!: number;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    punNazivPorukeURecniku?: string | undefined;
    definicija?: string | undefined;
    izvedenIz?: IzvedenIzResponse | undefined;
    tipPodatkaId?: number | undefined;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    verzija?: string | undefined;
    poslednjaVerzija!: boolean;
    statusVerzijeId!: number;
    datumOd!: Date;
    datumDo?: Date | undefined;
    skupVrednostiOgranicen!: number;
    kljucneReci?: KljucnaRecPorukeCmd[] | undefined;

    constructor(data?: IDajPorukuPoIDuResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.domenId = _data["domenId"];
            this.vrstaPorukeId = _data["vrstaPorukeId"];
            this.naziv = _data["naziv"];
            this.tehnickiNaziv = _data["tehnickiNaziv"];
            this.punNazivPorukeURecniku = _data["punNazivPorukeURecniku"];
            this.definicija = _data["definicija"];
            this.izvedenIz = _data["izvedenIz"] ? IzvedenIzResponse.fromJS(_data["izvedenIz"]) : <any>undefined;
            this.tipPodatkaId = _data["tipPodatkaId"];
            this.statusSifra = _data["statusSifra"];
            this.statusNaziv = _data["statusNaziv"];
            this.verzija = _data["verzija"];
            this.poslednjaVerzija = _data["poslednjaVerzija"];
            this.statusVerzijeId = _data["statusVerzijeId"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.skupVrednostiOgranicen = _data["skupVrednostiOgranicen"];
            if (Array.isArray(_data["kljucneReci"])) {
                this.kljucneReci = [] as any;
                for (let item of _data["kljucneReci"])
                    this.kljucneReci!.push(KljucnaRecPorukeCmd.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DajPorukuPoIDuResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajPorukuPoIDuResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["domenId"] = this.domenId;
        data["vrstaPorukeId"] = this.vrstaPorukeId;
        data["naziv"] = this.naziv;
        data["tehnickiNaziv"] = this.tehnickiNaziv;
        data["punNazivPorukeURecniku"] = this.punNazivPorukeURecniku;
        data["definicija"] = this.definicija;
        data["izvedenIz"] = this.izvedenIz ? this.izvedenIz.toJSON() : <any>undefined;
        data["tipPodatkaId"] = this.tipPodatkaId;
        data["statusSifra"] = this.statusSifra;
        data["statusNaziv"] = this.statusNaziv;
        data["verzija"] = this.verzija;
        data["poslednjaVerzija"] = this.poslednjaVerzija;
        data["statusVerzijeId"] = this.statusVerzijeId;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["skupVrednostiOgranicen"] = this.skupVrednostiOgranicen;
        if (Array.isArray(this.kljucneReci)) {
            data["kljucneReci"] = [];
            for (let item of this.kljucneReci)
                data["kljucneReci"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDajPorukuPoIDuResponse {
    id: number;
    sifra?: string | undefined;
    domenId: number;
    vrstaPorukeId: number;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    punNazivPorukeURecniku?: string | undefined;
    definicija?: string | undefined;
    izvedenIz?: IzvedenIzResponse | undefined;
    tipPodatkaId?: number | undefined;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    verzija?: string | undefined;
    poslednjaVerzija: boolean;
    statusVerzijeId: number;
    datumOd: Date;
    datumDo?: Date | undefined;
    skupVrednostiOgranicen: number;
    kljucneReci?: KljucnaRecPorukeCmd[] | undefined;
}

export class PagedResponseOfServisNaPoruciResponse implements IPagedResponseOfServisNaPoruciResponse {
    items?: ServisNaPoruciResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfServisNaPoruciResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServisNaPoruciResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfServisNaPoruciResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfServisNaPoruciResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfServisNaPoruciResponse {
    items?: ServisNaPoruciResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class ServisNaPoruciResponse implements IServisNaPoruciResponse {
    id!: number;
    kategorizacijaServisa?: string | undefined;
    sifraServisa?: string | undefined;
    protokol?: string | undefined;
    tehnickiNazivServisa?: string | undefined;
    nazivOrgana?: string | undefined;
    statusServisaNaziv?: string | undefined;

    constructor(data?: IServisNaPoruciResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kategorizacijaServisa = _data["kategorizacijaServisa"];
            this.sifraServisa = _data["sifraServisa"];
            this.protokol = _data["protokol"];
            this.tehnickiNazivServisa = _data["tehnickiNazivServisa"];
            this.nazivOrgana = _data["nazivOrgana"];
            this.statusServisaNaziv = _data["statusServisaNaziv"];
        }
    }

    static fromJS(data: any): ServisNaPoruciResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServisNaPoruciResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kategorizacijaServisa"] = this.kategorizacijaServisa;
        data["sifraServisa"] = this.sifraServisa;
        data["protokol"] = this.protokol;
        data["tehnickiNazivServisa"] = this.tehnickiNazivServisa;
        data["nazivOrgana"] = this.nazivOrgana;
        data["statusServisaNaziv"] = this.statusServisaNaziv;
        return data;
    }
}

export interface IServisNaPoruciResponse {
    id: number;
    kategorizacijaServisa?: string | undefined;
    sifraServisa?: string | undefined;
    protokol?: string | undefined;
    tehnickiNazivServisa?: string | undefined;
    nazivOrgana?: string | undefined;
    statusServisaNaziv?: string | undefined;
}

export class PagedResponseOfPretragaMetaregistraResponse implements IPagedResponseOfPretragaMetaregistraResponse {
    items?: PretragaMetaregistraResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfPretragaMetaregistraResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PretragaMetaregistraResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfPretragaMetaregistraResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfPretragaMetaregistraResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfPretragaMetaregistraResponse {
    items?: PretragaMetaregistraResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class PretragaMetaregistraResponse implements IPretragaMetaregistraResponse {
    id!: number;
    domen?: string | undefined;
    vrstaEntiteta?: string | undefined;
    nazivEntiteta?: string | undefined;
    definicijaEntiteta?: string | undefined;
    tip?: string | undefined;
    pripadaEntitetu?: string | undefined;
    pripadaEntitetuId?: number | undefined;
    sifraEntiteta?: string | undefined;
    verzija?: string | undefined;
    vrstaTipa?: number | undefined;
    jeSifarnickiPojam?: boolean | undefined;
    datumDo?: Date | undefined;
    statusEntiteta!: number;
    idTipaEntiteta?: number | undefined;
    sifraTipaEntiteta?: string | undefined;
    nazivTipaEntiteta?: string | undefined;
    nadredjeniElementId?: number | undefined;
    statusNaTipuId?: number | undefined;

    constructor(data?: IPretragaMetaregistraResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.domen = _data["domen"];
            this.vrstaEntiteta = _data["vrstaEntiteta"];
            this.nazivEntiteta = _data["nazivEntiteta"];
            this.definicijaEntiteta = _data["definicijaEntiteta"];
            this.tip = _data["tip"];
            this.pripadaEntitetu = _data["pripadaEntitetu"];
            this.pripadaEntitetuId = _data["pripadaEntitetuId"];
            this.sifraEntiteta = _data["sifraEntiteta"];
            this.verzija = _data["verzija"];
            this.vrstaTipa = _data["vrstaTipa"];
            this.jeSifarnickiPojam = _data["jeSifarnickiPojam"];
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.statusEntiteta = _data["statusEntiteta"];
            this.idTipaEntiteta = _data["idTipaEntiteta"];
            this.sifraTipaEntiteta = _data["sifraTipaEntiteta"];
            this.nazivTipaEntiteta = _data["nazivTipaEntiteta"];
            this.nadredjeniElementId = _data["nadredjeniElementId"];
            this.statusNaTipuId = _data["statusNaTipuId"];
        }
    }

    static fromJS(data: any): PretragaMetaregistraResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PretragaMetaregistraResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["domen"] = this.domen;
        data["vrstaEntiteta"] = this.vrstaEntiteta;
        data["nazivEntiteta"] = this.nazivEntiteta;
        data["definicijaEntiteta"] = this.definicijaEntiteta;
        data["tip"] = this.tip;
        data["pripadaEntitetu"] = this.pripadaEntitetu;
        data["pripadaEntitetuId"] = this.pripadaEntitetuId;
        data["sifraEntiteta"] = this.sifraEntiteta;
        data["verzija"] = this.verzija;
        data["vrstaTipa"] = this.vrstaTipa;
        data["jeSifarnickiPojam"] = this.jeSifarnickiPojam;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["statusEntiteta"] = this.statusEntiteta;
        data["idTipaEntiteta"] = this.idTipaEntiteta;
        data["sifraTipaEntiteta"] = this.sifraTipaEntiteta;
        data["nazivTipaEntiteta"] = this.nazivTipaEntiteta;
        data["nadredjeniElementId"] = this.nadredjeniElementId;
        data["statusNaTipuId"] = this.statusNaTipuId;
        return data;
    }
}

export interface IPretragaMetaregistraResponse {
    id: number;
    domen?: string | undefined;
    vrstaEntiteta?: string | undefined;
    nazivEntiteta?: string | undefined;
    definicijaEntiteta?: string | undefined;
    tip?: string | undefined;
    pripadaEntitetu?: string | undefined;
    pripadaEntitetuId?: number | undefined;
    sifraEntiteta?: string | undefined;
    verzija?: string | undefined;
    vrstaTipa?: number | undefined;
    jeSifarnickiPojam?: boolean | undefined;
    datumDo?: Date | undefined;
    statusEntiteta: number;
    idTipaEntiteta?: number | undefined;
    sifraTipaEntiteta?: string | undefined;
    nazivTipaEntiteta?: string | undefined;
    nadredjeniElementId?: number | undefined;
    statusNaTipuId?: number | undefined;
}

export class PagedResponseOfObjedinjenaPretragaResponse implements IPagedResponseOfObjedinjenaPretragaResponse {
    items?: ObjedinjenaPretragaResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfObjedinjenaPretragaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ObjedinjenaPretragaResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfObjedinjenaPretragaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfObjedinjenaPretragaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfObjedinjenaPretragaResponse {
    items?: ObjedinjenaPretragaResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class ObjedinjenaPretragaResponse implements IObjedinjenaPretragaResponse {
    id!: number;
    nazivEntiteta?: string | undefined;
    tip?: string | undefined;
    porekloSvojstvaId?: number | undefined;
    definicijaEntiteta?: string | undefined;
    kompleksnostTipaId?: number | undefined;
    vrstaTipaSvojstvaId?: number | undefined;
    vrstaTipa?: number | undefined;
    domen?: string | undefined;
    vrstaEntiteta?: string | undefined;
    pripadaEntitetu?: string | undefined;
    pripadaEntitetuId?: number | undefined;
    sifraEntiteta?: string | undefined;
    verzija?: string | undefined;
    jeSifarnickiPojam?: boolean | undefined;
    nazivNadleznogOrgana?: string | undefined;
    nadredjeniElementId?: number | undefined;
    idTipaEntiteta?: number | undefined;
    sifraTipaEntiteta?: string | undefined;
    nazivTipaEntiteta?: string | undefined;
    statusNaTipuId?: number | undefined;

    constructor(data?: IObjedinjenaPretragaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nazivEntiteta = _data["nazivEntiteta"];
            this.tip = _data["tip"];
            this.porekloSvojstvaId = _data["porekloSvojstvaId"];
            this.definicijaEntiteta = _data["definicijaEntiteta"];
            this.kompleksnostTipaId = _data["kompleksnostTipaId"];
            this.vrstaTipaSvojstvaId = _data["vrstaTipaSvojstvaId"];
            this.vrstaTipa = _data["vrstaTipa"];
            this.domen = _data["domen"];
            this.vrstaEntiteta = _data["vrstaEntiteta"];
            this.pripadaEntitetu = _data["pripadaEntitetu"];
            this.pripadaEntitetuId = _data["pripadaEntitetuId"];
            this.sifraEntiteta = _data["sifraEntiteta"];
            this.verzija = _data["verzija"];
            this.jeSifarnickiPojam = _data["jeSifarnickiPojam"];
            this.nazivNadleznogOrgana = _data["nazivNadleznogOrgana"];
            this.nadredjeniElementId = _data["nadredjeniElementId"];
            this.idTipaEntiteta = _data["idTipaEntiteta"];
            this.sifraTipaEntiteta = _data["sifraTipaEntiteta"];
            this.nazivTipaEntiteta = _data["nazivTipaEntiteta"];
            this.statusNaTipuId = _data["statusNaTipuId"];
        }
    }

    static fromJS(data: any): ObjedinjenaPretragaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ObjedinjenaPretragaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nazivEntiteta"] = this.nazivEntiteta;
        data["tip"] = this.tip;
        data["porekloSvojstvaId"] = this.porekloSvojstvaId;
        data["definicijaEntiteta"] = this.definicijaEntiteta;
        data["kompleksnostTipaId"] = this.kompleksnostTipaId;
        data["vrstaTipaSvojstvaId"] = this.vrstaTipaSvojstvaId;
        data["vrstaTipa"] = this.vrstaTipa;
        data["domen"] = this.domen;
        data["vrstaEntiteta"] = this.vrstaEntiteta;
        data["pripadaEntitetu"] = this.pripadaEntitetu;
        data["pripadaEntitetuId"] = this.pripadaEntitetuId;
        data["sifraEntiteta"] = this.sifraEntiteta;
        data["verzija"] = this.verzija;
        data["jeSifarnickiPojam"] = this.jeSifarnickiPojam;
        data["nazivNadleznogOrgana"] = this.nazivNadleznogOrgana;
        data["nadredjeniElementId"] = this.nadredjeniElementId;
        data["idTipaEntiteta"] = this.idTipaEntiteta;
        data["sifraTipaEntiteta"] = this.sifraTipaEntiteta;
        data["nazivTipaEntiteta"] = this.nazivTipaEntiteta;
        data["statusNaTipuId"] = this.statusNaTipuId;
        return data;
    }
}

export interface IObjedinjenaPretragaResponse {
    id: number;
    nazivEntiteta?: string | undefined;
    tip?: string | undefined;
    porekloSvojstvaId?: number | undefined;
    definicijaEntiteta?: string | undefined;
    kompleksnostTipaId?: number | undefined;
    vrstaTipaSvojstvaId?: number | undefined;
    vrstaTipa?: number | undefined;
    domen?: string | undefined;
    vrstaEntiteta?: string | undefined;
    pripadaEntitetu?: string | undefined;
    pripadaEntitetuId?: number | undefined;
    sifraEntiteta?: string | undefined;
    verzija?: string | undefined;
    jeSifarnickiPojam?: boolean | undefined;
    nazivNadleznogOrgana?: string | undefined;
    nadredjeniElementId?: number | undefined;
    idTipaEntiteta?: number | undefined;
    sifraTipaEntiteta?: string | undefined;
    nazivTipaEntiteta?: string | undefined;
    statusNaTipuId?: number | undefined;
}

export class DajSveSifarnikeZaRecnikPojmovaResponse implements IDajSveSifarnikeZaRecnikPojmovaResponse {
    tipoviPodataka?: TipPodatkaResponse[] | undefined;
    tipoviOgranicenja?: TipOgranicenjaResponse[] | undefined;
    tipoviAgregacije?: TipAgregacijeResponse[] | undefined;
    statusiVerzijePojma?: StatusVerzijePojmaResponse[] | undefined;
    statusiPojmova?: StatusPojmaResponse[] | undefined;
    statusiPoruka?: StatusPorukeResponse[] | undefined;
    statusiSvojstava?: StatusSvojstvaResponse[] | undefined;
    statusiElemenataPoruke?: StatusElementaPorukeResponse[] | undefined;
    vrsteTipova?: VrstaTipaResponse[] | undefined;
    primitivniTipovi?: PojamResponse[] | undefined;
    predefinisaniTipovi?: PojamResponse[] | undefined;
    sviTipoviSluzbeneEvidencije?: TipSluzbeneEvidencijeResponse[] | undefined;
    statusiSluzbeneEvidencije?: StatusSluzbeneEvidencijeResponse[] | undefined;
    statusiVerzijeSluzbeneEvidencije?: StatusVerzijeSluzbeneEvidencijeResponse[] | undefined;
    klasifikacijaSluzbeneEvidencije?: KlasifikacijaSluzbeneEvidencijeResponse[] | undefined;
    statusiKlasifikacijaSluzbeneEvidencije?: StatusKlasifikacijeResponse[] | undefined;
    statusiStavkeSifarnika?: StatusStavkeSifarnikaResponse[] | undefined;

    constructor(data?: IDajSveSifarnikeZaRecnikPojmovaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tipoviPodataka"])) {
                this.tipoviPodataka = [] as any;
                for (let item of _data["tipoviPodataka"])
                    this.tipoviPodataka!.push(TipPodatkaResponse.fromJS(item));
            }
            if (Array.isArray(_data["tipoviOgranicenja"])) {
                this.tipoviOgranicenja = [] as any;
                for (let item of _data["tipoviOgranicenja"])
                    this.tipoviOgranicenja!.push(TipOgranicenjaResponse.fromJS(item));
            }
            if (Array.isArray(_data["tipoviAgregacije"])) {
                this.tipoviAgregacije = [] as any;
                for (let item of _data["tipoviAgregacije"])
                    this.tipoviAgregacije!.push(TipAgregacijeResponse.fromJS(item));
            }
            if (Array.isArray(_data["statusiVerzijePojma"])) {
                this.statusiVerzijePojma = [] as any;
                for (let item of _data["statusiVerzijePojma"])
                    this.statusiVerzijePojma!.push(StatusVerzijePojmaResponse.fromJS(item));
            }
            if (Array.isArray(_data["statusiPojmova"])) {
                this.statusiPojmova = [] as any;
                for (let item of _data["statusiPojmova"])
                    this.statusiPojmova!.push(StatusPojmaResponse.fromJS(item));
            }
            if (Array.isArray(_data["statusiPoruka"])) {
                this.statusiPoruka = [] as any;
                for (let item of _data["statusiPoruka"])
                    this.statusiPoruka!.push(StatusPorukeResponse.fromJS(item));
            }
            if (Array.isArray(_data["statusiSvojstava"])) {
                this.statusiSvojstava = [] as any;
                for (let item of _data["statusiSvojstava"])
                    this.statusiSvojstava!.push(StatusSvojstvaResponse.fromJS(item));
            }
            if (Array.isArray(_data["statusiElemenataPoruke"])) {
                this.statusiElemenataPoruke = [] as any;
                for (let item of _data["statusiElemenataPoruke"])
                    this.statusiElemenataPoruke!.push(StatusElementaPorukeResponse.fromJS(item));
            }
            if (Array.isArray(_data["vrsteTipova"])) {
                this.vrsteTipova = [] as any;
                for (let item of _data["vrsteTipova"])
                    this.vrsteTipova!.push(VrstaTipaResponse.fromJS(item));
            }
            if (Array.isArray(_data["primitivniTipovi"])) {
                this.primitivniTipovi = [] as any;
                for (let item of _data["primitivniTipovi"])
                    this.primitivniTipovi!.push(PojamResponse.fromJS(item));
            }
            if (Array.isArray(_data["predefinisaniTipovi"])) {
                this.predefinisaniTipovi = [] as any;
                for (let item of _data["predefinisaniTipovi"])
                    this.predefinisaniTipovi!.push(PojamResponse.fromJS(item));
            }
            if (Array.isArray(_data["sviTipoviSluzbeneEvidencije"])) {
                this.sviTipoviSluzbeneEvidencije = [] as any;
                for (let item of _data["sviTipoviSluzbeneEvidencije"])
                    this.sviTipoviSluzbeneEvidencije!.push(TipSluzbeneEvidencijeResponse.fromJS(item));
            }
            if (Array.isArray(_data["statusiSluzbeneEvidencije"])) {
                this.statusiSluzbeneEvidencije = [] as any;
                for (let item of _data["statusiSluzbeneEvidencije"])
                    this.statusiSluzbeneEvidencije!.push(StatusSluzbeneEvidencijeResponse.fromJS(item));
            }
            if (Array.isArray(_data["statusiVerzijeSluzbeneEvidencije"])) {
                this.statusiVerzijeSluzbeneEvidencije = [] as any;
                for (let item of _data["statusiVerzijeSluzbeneEvidencije"])
                    this.statusiVerzijeSluzbeneEvidencije!.push(StatusVerzijeSluzbeneEvidencijeResponse.fromJS(item));
            }
            if (Array.isArray(_data["klasifikacijaSluzbeneEvidencije"])) {
                this.klasifikacijaSluzbeneEvidencije = [] as any;
                for (let item of _data["klasifikacijaSluzbeneEvidencije"])
                    this.klasifikacijaSluzbeneEvidencije!.push(KlasifikacijaSluzbeneEvidencijeResponse.fromJS(item));
            }
            if (Array.isArray(_data["statusiKlasifikacijaSluzbeneEvidencije"])) {
                this.statusiKlasifikacijaSluzbeneEvidencije = [] as any;
                for (let item of _data["statusiKlasifikacijaSluzbeneEvidencije"])
                    this.statusiKlasifikacijaSluzbeneEvidencije!.push(StatusKlasifikacijeResponse.fromJS(item));
            }
            if (Array.isArray(_data["statusiStavkeSifarnika"])) {
                this.statusiStavkeSifarnika = [] as any;
                for (let item of _data["statusiStavkeSifarnika"])
                    this.statusiStavkeSifarnika!.push(StatusStavkeSifarnikaResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DajSveSifarnikeZaRecnikPojmovaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajSveSifarnikeZaRecnikPojmovaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tipoviPodataka)) {
            data["tipoviPodataka"] = [];
            for (let item of this.tipoviPodataka)
                data["tipoviPodataka"].push(item.toJSON());
        }
        if (Array.isArray(this.tipoviOgranicenja)) {
            data["tipoviOgranicenja"] = [];
            for (let item of this.tipoviOgranicenja)
                data["tipoviOgranicenja"].push(item.toJSON());
        }
        if (Array.isArray(this.tipoviAgregacije)) {
            data["tipoviAgregacije"] = [];
            for (let item of this.tipoviAgregacije)
                data["tipoviAgregacije"].push(item.toJSON());
        }
        if (Array.isArray(this.statusiVerzijePojma)) {
            data["statusiVerzijePojma"] = [];
            for (let item of this.statusiVerzijePojma)
                data["statusiVerzijePojma"].push(item.toJSON());
        }
        if (Array.isArray(this.statusiPojmova)) {
            data["statusiPojmova"] = [];
            for (let item of this.statusiPojmova)
                data["statusiPojmova"].push(item.toJSON());
        }
        if (Array.isArray(this.statusiPoruka)) {
            data["statusiPoruka"] = [];
            for (let item of this.statusiPoruka)
                data["statusiPoruka"].push(item.toJSON());
        }
        if (Array.isArray(this.statusiSvojstava)) {
            data["statusiSvojstava"] = [];
            for (let item of this.statusiSvojstava)
                data["statusiSvojstava"].push(item.toJSON());
        }
        if (Array.isArray(this.statusiElemenataPoruke)) {
            data["statusiElemenataPoruke"] = [];
            for (let item of this.statusiElemenataPoruke)
                data["statusiElemenataPoruke"].push(item.toJSON());
        }
        if (Array.isArray(this.vrsteTipova)) {
            data["vrsteTipova"] = [];
            for (let item of this.vrsteTipova)
                data["vrsteTipova"].push(item.toJSON());
        }
        if (Array.isArray(this.primitivniTipovi)) {
            data["primitivniTipovi"] = [];
            for (let item of this.primitivniTipovi)
                data["primitivniTipovi"].push(item.toJSON());
        }
        if (Array.isArray(this.predefinisaniTipovi)) {
            data["predefinisaniTipovi"] = [];
            for (let item of this.predefinisaniTipovi)
                data["predefinisaniTipovi"].push(item.toJSON());
        }
        if (Array.isArray(this.sviTipoviSluzbeneEvidencije)) {
            data["sviTipoviSluzbeneEvidencije"] = [];
            for (let item of this.sviTipoviSluzbeneEvidencije)
                data["sviTipoviSluzbeneEvidencije"].push(item.toJSON());
        }
        if (Array.isArray(this.statusiSluzbeneEvidencije)) {
            data["statusiSluzbeneEvidencije"] = [];
            for (let item of this.statusiSluzbeneEvidencije)
                data["statusiSluzbeneEvidencije"].push(item.toJSON());
        }
        if (Array.isArray(this.statusiVerzijeSluzbeneEvidencije)) {
            data["statusiVerzijeSluzbeneEvidencije"] = [];
            for (let item of this.statusiVerzijeSluzbeneEvidencije)
                data["statusiVerzijeSluzbeneEvidencije"].push(item.toJSON());
        }
        if (Array.isArray(this.klasifikacijaSluzbeneEvidencije)) {
            data["klasifikacijaSluzbeneEvidencije"] = [];
            for (let item of this.klasifikacijaSluzbeneEvidencije)
                data["klasifikacijaSluzbeneEvidencije"].push(item.toJSON());
        }
        if (Array.isArray(this.statusiKlasifikacijaSluzbeneEvidencije)) {
            data["statusiKlasifikacijaSluzbeneEvidencije"] = [];
            for (let item of this.statusiKlasifikacijaSluzbeneEvidencije)
                data["statusiKlasifikacijaSluzbeneEvidencije"].push(item.toJSON());
        }
        if (Array.isArray(this.statusiStavkeSifarnika)) {
            data["statusiStavkeSifarnika"] = [];
            for (let item of this.statusiStavkeSifarnika)
                data["statusiStavkeSifarnika"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDajSveSifarnikeZaRecnikPojmovaResponse {
    tipoviPodataka?: TipPodatkaResponse[] | undefined;
    tipoviOgranicenja?: TipOgranicenjaResponse[] | undefined;
    tipoviAgregacije?: TipAgregacijeResponse[] | undefined;
    statusiVerzijePojma?: StatusVerzijePojmaResponse[] | undefined;
    statusiPojmova?: StatusPojmaResponse[] | undefined;
    statusiPoruka?: StatusPorukeResponse[] | undefined;
    statusiSvojstava?: StatusSvojstvaResponse[] | undefined;
    statusiElemenataPoruke?: StatusElementaPorukeResponse[] | undefined;
    vrsteTipova?: VrstaTipaResponse[] | undefined;
    primitivniTipovi?: PojamResponse[] | undefined;
    predefinisaniTipovi?: PojamResponse[] | undefined;
    sviTipoviSluzbeneEvidencije?: TipSluzbeneEvidencijeResponse[] | undefined;
    statusiSluzbeneEvidencije?: StatusSluzbeneEvidencijeResponse[] | undefined;
    statusiVerzijeSluzbeneEvidencije?: StatusVerzijeSluzbeneEvidencijeResponse[] | undefined;
    klasifikacijaSluzbeneEvidencije?: KlasifikacijaSluzbeneEvidencijeResponse[] | undefined;
    statusiKlasifikacijaSluzbeneEvidencije?: StatusKlasifikacijeResponse[] | undefined;
    statusiStavkeSifarnika?: StatusStavkeSifarnikaResponse[] | undefined;
}

export class TipPodatkaResponse implements ITipPodatkaResponse {
    id!: number;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
    sifra?: string | undefined;

    constructor(data?: ITipPodatkaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.nazivLatinica = _data["nazivLatinica"];
            this.sifra = _data["sifra"];
        }
    }

    static fromJS(data: any): TipPodatkaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TipPodatkaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["nazivLatinica"] = this.nazivLatinica;
        data["sifra"] = this.sifra;
        return data;
    }
}

export interface ITipPodatkaResponse {
    id: number;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
    sifra?: string | undefined;
}

export class TipOgranicenjaResponse implements ITipOgranicenjaResponse {
    id!: number;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
    sifra?: string | undefined;
    tipPodatkaZaUnosVrednosti?: string | undefined;

    constructor(data?: ITipOgranicenjaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.nazivLatinica = _data["nazivLatinica"];
            this.sifra = _data["sifra"];
            this.tipPodatkaZaUnosVrednosti = _data["tipPodatkaZaUnosVrednosti"];
        }
    }

    static fromJS(data: any): TipOgranicenjaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TipOgranicenjaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["nazivLatinica"] = this.nazivLatinica;
        data["sifra"] = this.sifra;
        data["tipPodatkaZaUnosVrednosti"] = this.tipPodatkaZaUnosVrednosti;
        return data;
    }
}

export interface ITipOgranicenjaResponse {
    id: number;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
    sifra?: string | undefined;
    tipPodatkaZaUnosVrednosti?: string | undefined;
}

export class TipAgregacijeResponse implements ITipAgregacijeResponse {
    id!: number;
    naziv?: string | undefined;

    constructor(data?: ITipAgregacijeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): TipAgregacijeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TipAgregacijeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface ITipAgregacijeResponse {
    id: number;
    naziv?: string | undefined;
}

export class StatusVerzijePojmaResponse implements IStatusVerzijePojmaResponse {
    id!: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;

    constructor(data?: IStatusVerzijePojmaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
            this.opisLatinica = _data["opisLatinica"];
        }
    }

    static fromJS(data: any): StatusVerzijePojmaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatusVerzijePojmaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        data["opisLatinica"] = this.opisLatinica;
        return data;
    }
}

export interface IStatusVerzijePojmaResponse {
    id: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;
}

export class StatusPojmaResponse implements IStatusPojmaResponse {
    id!: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;

    constructor(data?: IStatusPojmaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
            this.opisLatinica = _data["opisLatinica"];
        }
    }

    static fromJS(data: any): StatusPojmaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatusPojmaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        data["opisLatinica"] = this.opisLatinica;
        return data;
    }
}

export interface IStatusPojmaResponse {
    id: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;
}

export class StatusPorukeResponse implements IStatusPorukeResponse {
    id!: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;

    constructor(data?: IStatusPorukeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
            this.opisLatinica = _data["opisLatinica"];
        }
    }

    static fromJS(data: any): StatusPorukeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatusPorukeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        data["opisLatinica"] = this.opisLatinica;
        return data;
    }
}

export interface IStatusPorukeResponse {
    id: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;
}

export class StatusSvojstvaResponse implements IStatusSvojstvaResponse {
    id!: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;

    constructor(data?: IStatusSvojstvaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
            this.opisLatinica = _data["opisLatinica"];
        }
    }

    static fromJS(data: any): StatusSvojstvaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatusSvojstvaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        data["opisLatinica"] = this.opisLatinica;
        return data;
    }
}

export interface IStatusSvojstvaResponse {
    id: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;
}

export class StatusElementaPorukeResponse implements IStatusElementaPorukeResponse {
    id!: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;

    constructor(data?: IStatusElementaPorukeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.opis = _data["opis"];
            this.opisLatinica = _data["opisLatinica"];
        }
    }

    static fromJS(data: any): StatusElementaPorukeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatusElementaPorukeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["opis"] = this.opis;
        data["opisLatinica"] = this.opisLatinica;
        return data;
    }
}

export interface IStatusElementaPorukeResponse {
    id: number;
    sifra?: string | undefined;
    opis?: string | undefined;
    opisLatinica?: string | undefined;
}

export class VrstaTipaResponse implements IVrstaTipaResponse {
    id!: number;
    naziv?: string | undefined;
    opis?: string | undefined;

    constructor(data?: IVrstaTipaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.opis = _data["opis"];
        }
    }

    static fromJS(data: any): VrstaTipaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VrstaTipaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["opis"] = this.opis;
        return data;
    }
}

export interface IVrstaTipaResponse {
    id: number;
    naziv?: string | undefined;
    opis?: string | undefined;
}

export class PojamResponse implements IPojamResponse {
    id!: number;
    sifra?: string | undefined;
    domenId!: number;
    naziv?: string | undefined;
    statusId!: number;
    tipPodatkaId?: number | undefined;
    punNazivTipaURecniku?: string | undefined;

    constructor(data?: IPojamResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.domenId = _data["domenId"];
            this.naziv = _data["naziv"];
            this.statusId = _data["statusId"];
            this.tipPodatkaId = _data["tipPodatkaId"];
            this.punNazivTipaURecniku = _data["punNazivTipaURecniku"];
        }
    }

    static fromJS(data: any): PojamResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PojamResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["domenId"] = this.domenId;
        data["naziv"] = this.naziv;
        data["statusId"] = this.statusId;
        data["tipPodatkaId"] = this.tipPodatkaId;
        data["punNazivTipaURecniku"] = this.punNazivTipaURecniku;
        return data;
    }
}

export interface IPojamResponse {
    id: number;
    sifra?: string | undefined;
    domenId: number;
    naziv?: string | undefined;
    statusId: number;
    tipPodatkaId?: number | undefined;
    punNazivTipaURecniku?: string | undefined;
}

export class TipSluzbeneEvidencijeResponse implements ITipSluzbeneEvidencijeResponse {
    sifra?: string | undefined;
    naziv?: string | undefined;

    constructor(data?: ITipSluzbeneEvidencijeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): TipSluzbeneEvidencijeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TipSluzbeneEvidencijeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface ITipSluzbeneEvidencijeResponse {
    sifra?: string | undefined;
    naziv?: string | undefined;
}

export class StatusSluzbeneEvidencijeResponse implements IStatusSluzbeneEvidencijeResponse {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;

    constructor(data?: IStatusSluzbeneEvidencijeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.nazivLatinica = _data["nazivLatinica"];
        }
    }

    static fromJS(data: any): StatusSluzbeneEvidencijeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatusSluzbeneEvidencijeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["nazivLatinica"] = this.nazivLatinica;
        return data;
    }
}

export interface IStatusSluzbeneEvidencijeResponse {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
}

export class StatusVerzijeSluzbeneEvidencijeResponse implements IStatusVerzijeSluzbeneEvidencijeResponse {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;

    constructor(data?: IStatusVerzijeSluzbeneEvidencijeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.nazivLatinica = _data["nazivLatinica"];
        }
    }

    static fromJS(data: any): StatusVerzijeSluzbeneEvidencijeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatusVerzijeSluzbeneEvidencijeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["nazivLatinica"] = this.nazivLatinica;
        return data;
    }
}

export interface IStatusVerzijeSluzbeneEvidencijeResponse {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
}

export class KlasifikacijaSluzbeneEvidencijeResponse implements IKlasifikacijaSluzbeneEvidencijeResponse {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
    nadredjenaKlasifikacijaId?: number | undefined;

    constructor(data?: IKlasifikacijaSluzbeneEvidencijeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.nazivLatinica = _data["nazivLatinica"];
            this.nadredjenaKlasifikacijaId = _data["nadredjenaKlasifikacijaId"];
        }
    }

    static fromJS(data: any): KlasifikacijaSluzbeneEvidencijeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new KlasifikacijaSluzbeneEvidencijeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["nazivLatinica"] = this.nazivLatinica;
        data["nadredjenaKlasifikacijaId"] = this.nadredjenaKlasifikacijaId;
        return data;
    }
}

export interface IKlasifikacijaSluzbeneEvidencijeResponse {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
    nadredjenaKlasifikacijaId?: number | undefined;
}

export class StatusKlasifikacijeResponse implements IStatusKlasifikacijeResponse {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;

    constructor(data?: IStatusKlasifikacijeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.nazivLatinica = _data["nazivLatinica"];
        }
    }

    static fromJS(data: any): StatusKlasifikacijeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatusKlasifikacijeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["nazivLatinica"] = this.nazivLatinica;
        return data;
    }
}

export interface IStatusKlasifikacijeResponse {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
}

export class StatusStavkeSifarnikaResponse implements IStatusStavkeSifarnikaResponse {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;

    constructor(data?: IStatusStavkeSifarnikaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.nazivLatinica = _data["nazivLatinica"];
        }
    }

    static fromJS(data: any): StatusStavkeSifarnikaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatusStavkeSifarnikaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["nazivLatinica"] = this.nazivLatinica;
        return data;
    }
}

export interface IStatusStavkeSifarnikaResponse {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    nazivLatinica?: string | undefined;
}

export class DajSveSifarnikeZaRecnikPojmovaQuery implements IDajSveSifarnikeZaRecnikPojmovaQuery {

    constructor(data?: IDajSveSifarnikeZaRecnikPojmovaQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DajSveSifarnikeZaRecnikPojmovaQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DajSveSifarnikeZaRecnikPojmovaQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDajSveSifarnikeZaRecnikPojmovaQuery {
}

export class GenericActionResponseWithItemsSEOfString extends GenericActionResponseSE implements IGenericActionResponseWithItemsSEOfString {
    items?: string | undefined;

    constructor(data?: IGenericActionResponseWithItemsSEOfString) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.items = _data["items"];
        }
    }

    static fromJS(data: any): GenericActionResponseWithItemsSEOfString {
        data = typeof data === 'object' ? data : {};
        let result = new GenericActionResponseWithItemsSEOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["items"] = this.items;
        super.toJSON(data);
        return data;
    }
}

export interface IGenericActionResponseWithItemsSEOfString extends IGenericActionResponseSE {
    items?: string | undefined;
}

export class SacuvajSluzbenuEvidencijuCommand implements ISacuvajSluzbenuEvidencijuCommand {
    sifra?: string | undefined;
    naziv?: string | undefined;
    skraceniNaziv?: string | undefined;
    sifraNadleznogOrgana?: string | undefined;
    ucestalostAzuriranja?: string | undefined;
    rokCuvanja?: number | undefined;
    jeTrajnoCuvanje!: boolean;
    jeJavnoDostupno!: boolean;
    adresa?: string | undefined;
    jeCentralizovana!: boolean;
    jeElektronskiOblik!: boolean;
    elektronskiOblikPutemServisa?: string | undefined;
    pravniOsnov?: string | undefined;
    opis?: string | undefined;
    verzija?: string | undefined;
    datumOd!: Date;
    sifarnickiPojamId?: number | undefined;
    statusSifra?: string | undefined;
    statusVerzijeSifra?: string | undefined;
    sifreKlasifikacija?: string[] | undefined;
    tipEvidencijeSifra?: string | undefined;
    datumUspostavljanja?: Date | undefined;
    datumUkidanja?: Date | undefined;

    constructor(data?: ISacuvajSluzbenuEvidencijuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.skraceniNaziv = _data["skraceniNaziv"];
            this.sifraNadleznogOrgana = _data["sifraNadleznogOrgana"];
            this.ucestalostAzuriranja = _data["ucestalostAzuriranja"];
            this.rokCuvanja = _data["rokCuvanja"];
            this.jeTrajnoCuvanje = _data["jeTrajnoCuvanje"];
            this.jeJavnoDostupno = _data["jeJavnoDostupno"];
            this.adresa = _data["adresa"];
            this.jeCentralizovana = _data["jeCentralizovana"];
            this.jeElektronskiOblik = _data["jeElektronskiOblik"];
            this.elektronskiOblikPutemServisa = _data["elektronskiOblikPutemServisa"];
            this.pravniOsnov = _data["pravniOsnov"];
            this.opis = _data["opis"];
            this.verzija = _data["verzija"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.sifarnickiPojamId = _data["sifarnickiPojamId"];
            this.statusSifra = _data["statusSifra"];
            this.statusVerzijeSifra = _data["statusVerzijeSifra"];
            if (Array.isArray(_data["sifreKlasifikacija"])) {
                this.sifreKlasifikacija = [] as any;
                for (let item of _data["sifreKlasifikacija"])
                    this.sifreKlasifikacija!.push(item);
            }
            this.tipEvidencijeSifra = _data["tipEvidencijeSifra"];
            this.datumUspostavljanja = _data["datumUspostavljanja"] ? new Date(_data["datumUspostavljanja"].toString()) : <any>undefined;
            this.datumUkidanja = _data["datumUkidanja"] ? new Date(_data["datumUkidanja"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SacuvajSluzbenuEvidencijuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SacuvajSluzbenuEvidencijuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["skraceniNaziv"] = this.skraceniNaziv;
        data["sifraNadleznogOrgana"] = this.sifraNadleznogOrgana;
        data["ucestalostAzuriranja"] = this.ucestalostAzuriranja;
        data["rokCuvanja"] = this.rokCuvanja;
        data["jeTrajnoCuvanje"] = this.jeTrajnoCuvanje;
        data["jeJavnoDostupno"] = this.jeJavnoDostupno;
        data["adresa"] = this.adresa;
        data["jeCentralizovana"] = this.jeCentralizovana;
        data["jeElektronskiOblik"] = this.jeElektronskiOblik;
        data["elektronskiOblikPutemServisa"] = this.elektronskiOblikPutemServisa;
        data["pravniOsnov"] = this.pravniOsnov;
        data["opis"] = this.opis;
        data["verzija"] = this.verzija;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["sifarnickiPojamId"] = this.sifarnickiPojamId;
        data["statusSifra"] = this.statusSifra;
        data["statusVerzijeSifra"] = this.statusVerzijeSifra;
        if (Array.isArray(this.sifreKlasifikacija)) {
            data["sifreKlasifikacija"] = [];
            for (let item of this.sifreKlasifikacija)
                data["sifreKlasifikacija"].push(item);
        }
        data["tipEvidencijeSifra"] = this.tipEvidencijeSifra;
        data["datumUspostavljanja"] = this.datumUspostavljanja ? this.datumUspostavljanja.toISOString() : <any>undefined;
        data["datumUkidanja"] = this.datumUkidanja ? this.datumUkidanja.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISacuvajSluzbenuEvidencijuCommand {
    sifra?: string | undefined;
    naziv?: string | undefined;
    skraceniNaziv?: string | undefined;
    sifraNadleznogOrgana?: string | undefined;
    ucestalostAzuriranja?: string | undefined;
    rokCuvanja?: number | undefined;
    jeTrajnoCuvanje: boolean;
    jeJavnoDostupno: boolean;
    adresa?: string | undefined;
    jeCentralizovana: boolean;
    jeElektronskiOblik: boolean;
    elektronskiOblikPutemServisa?: string | undefined;
    pravniOsnov?: string | undefined;
    opis?: string | undefined;
    verzija?: string | undefined;
    datumOd: Date;
    sifarnickiPojamId?: number | undefined;
    statusSifra?: string | undefined;
    statusVerzijeSifra?: string | undefined;
    sifreKlasifikacija?: string[] | undefined;
    tipEvidencijeSifra?: string | undefined;
    datumUspostavljanja?: Date | undefined;
    datumUkidanja?: Date | undefined;
}

export class GenericActionResponseWithItemsSEOfSluzbenaEvidencijaResponse extends GenericActionResponseSE implements IGenericActionResponseWithItemsSEOfSluzbenaEvidencijaResponse {
    items?: SluzbenaEvidencijaResponse | undefined;

    constructor(data?: IGenericActionResponseWithItemsSEOfSluzbenaEvidencijaResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.items = _data["items"] ? SluzbenaEvidencijaResponse.fromJS(_data["items"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GenericActionResponseWithItemsSEOfSluzbenaEvidencijaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GenericActionResponseWithItemsSEOfSluzbenaEvidencijaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["items"] = this.items ? this.items.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGenericActionResponseWithItemsSEOfSluzbenaEvidencijaResponse extends IGenericActionResponseSE {
    items?: SluzbenaEvidencijaResponse | undefined;
}

export class SluzbenaEvidencijaResponse implements ISluzbenaEvidencijaResponse {
    sifra?: string | undefined;
    naziv?: string | undefined;
    skraceniNaziv?: string | undefined;
    sifraNadleznogOrgana?: string | undefined;
    ucestalostAzuriranja?: string | undefined;
    rokCuvanja?: number | undefined;
    jeTrajnoCuvanje!: boolean;
    jeJavnoDostupno!: boolean;
    adresa?: string | undefined;
    jeCentralizovana!: boolean;
    jeElektronskiOblik!: boolean;
    pravniOsnov?: string | undefined;
    opis?: string | undefined;
    verzija?: string | undefined;
    datumOd!: Date;
    datumDo?: Date | undefined;
    statusSifra?: string | undefined;
    statusVerzijeSifra?: string | undefined;
    sifreKlasifikacija?: string[] | undefined;
    tipEvidencijeSifra?: string | undefined;

    constructor(data?: ISluzbenaEvidencijaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.skraceniNaziv = _data["skraceniNaziv"];
            this.sifraNadleznogOrgana = _data["sifraNadleznogOrgana"];
            this.ucestalostAzuriranja = _data["ucestalostAzuriranja"];
            this.rokCuvanja = _data["rokCuvanja"];
            this.jeTrajnoCuvanje = _data["jeTrajnoCuvanje"];
            this.jeJavnoDostupno = _data["jeJavnoDostupno"];
            this.adresa = _data["adresa"];
            this.jeCentralizovana = _data["jeCentralizovana"];
            this.jeElektronskiOblik = _data["jeElektronskiOblik"];
            this.pravniOsnov = _data["pravniOsnov"];
            this.opis = _data["opis"];
            this.verzija = _data["verzija"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.statusSifra = _data["statusSifra"];
            this.statusVerzijeSifra = _data["statusVerzijeSifra"];
            if (Array.isArray(_data["sifreKlasifikacija"])) {
                this.sifreKlasifikacija = [] as any;
                for (let item of _data["sifreKlasifikacija"])
                    this.sifreKlasifikacija!.push(item);
            }
            this.tipEvidencijeSifra = _data["tipEvidencijeSifra"];
        }
    }

    static fromJS(data: any): SluzbenaEvidencijaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SluzbenaEvidencijaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["skraceniNaziv"] = this.skraceniNaziv;
        data["sifraNadleznogOrgana"] = this.sifraNadleznogOrgana;
        data["ucestalostAzuriranja"] = this.ucestalostAzuriranja;
        data["rokCuvanja"] = this.rokCuvanja;
        data["jeTrajnoCuvanje"] = this.jeTrajnoCuvanje;
        data["jeJavnoDostupno"] = this.jeJavnoDostupno;
        data["adresa"] = this.adresa;
        data["jeCentralizovana"] = this.jeCentralizovana;
        data["jeElektronskiOblik"] = this.jeElektronskiOblik;
        data["pravniOsnov"] = this.pravniOsnov;
        data["opis"] = this.opis;
        data["verzija"] = this.verzija;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["statusSifra"] = this.statusSifra;
        data["statusVerzijeSifra"] = this.statusVerzijeSifra;
        if (Array.isArray(this.sifreKlasifikacija)) {
            data["sifreKlasifikacija"] = [];
            for (let item of this.sifreKlasifikacija)
                data["sifreKlasifikacija"].push(item);
        }
        data["tipEvidencijeSifra"] = this.tipEvidencijeSifra;
        return data;
    }
}

export interface ISluzbenaEvidencijaResponse {
    sifra?: string | undefined;
    naziv?: string | undefined;
    skraceniNaziv?: string | undefined;
    sifraNadleznogOrgana?: string | undefined;
    ucestalostAzuriranja?: string | undefined;
    rokCuvanja?: number | undefined;
    jeTrajnoCuvanje: boolean;
    jeJavnoDostupno: boolean;
    adresa?: string | undefined;
    jeCentralizovana: boolean;
    jeElektronskiOblik: boolean;
    pravniOsnov?: string | undefined;
    opis?: string | undefined;
    verzija?: string | undefined;
    datumOd: Date;
    datumDo?: Date | undefined;
    statusSifra?: string | undefined;
    statusVerzijeSifra?: string | undefined;
    sifreKlasifikacija?: string[] | undefined;
    tipEvidencijeSifra?: string | undefined;
}

export class KreirajNovuVerzijuSluzbeneEvidencijeCommand implements IKreirajNovuVerzijuSluzbeneEvidencijeCommand {
    sifra?: string | undefined;

    constructor(data?: IKreirajNovuVerzijuSluzbeneEvidencijeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
        }
    }

    static fromJS(data: any): KreirajNovuVerzijuSluzbeneEvidencijeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new KreirajNovuVerzijuSluzbeneEvidencijeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        return data;
    }
}

export interface IKreirajNovuVerzijuSluzbeneEvidencijeCommand {
    sifra?: string | undefined;
}

export class ObjaviSluzbenuEvidencijuCommand implements IObjaviSluzbenuEvidencijuCommand {
    sifra?: string | undefined;
    datumObjavljivanja!: Date;

    constructor(data?: IObjaviSluzbenuEvidencijuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.datumObjavljivanja = _data["datumObjavljivanja"] ? new Date(_data["datumObjavljivanja"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ObjaviSluzbenuEvidencijuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObjaviSluzbenuEvidencijuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["datumObjavljivanja"] = this.datumObjavljivanja ? this.datumObjavljivanja.toISOString() : <any>undefined;
        return data;
    }
}

export interface IObjaviSluzbenuEvidencijuCommand {
    sifra?: string | undefined;
    datumObjavljivanja: Date;
}

export class DeaktivirajSluzbenuEvidencijuCommand implements IDeaktivirajSluzbenuEvidencijuCommand {
    sifra?: string | undefined;
    razlogDeaktivacije?: string | undefined;
    datumDeaktivacije!: Date;
    potvrdaBrisanjaVerzijeUPripremi!: boolean;

    constructor(data?: IDeaktivirajSluzbenuEvidencijuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.razlogDeaktivacije = _data["razlogDeaktivacije"];
            this.datumDeaktivacije = _data["datumDeaktivacije"] ? new Date(_data["datumDeaktivacije"].toString()) : <any>undefined;
            this.potvrdaBrisanjaVerzijeUPripremi = _data["potvrdaBrisanjaVerzijeUPripremi"];
        }
    }

    static fromJS(data: any): DeaktivirajSluzbenuEvidencijuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeaktivirajSluzbenuEvidencijuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["razlogDeaktivacije"] = this.razlogDeaktivacije;
        data["datumDeaktivacije"] = this.datumDeaktivacije ? this.datumDeaktivacije.toISOString() : <any>undefined;
        data["potvrdaBrisanjaVerzijeUPripremi"] = this.potvrdaBrisanjaVerzijeUPripremi;
        return data;
    }
}

export interface IDeaktivirajSluzbenuEvidencijuCommand {
    sifra?: string | undefined;
    razlogDeaktivacije?: string | undefined;
    datumDeaktivacije: Date;
    potvrdaBrisanjaVerzijeUPripremi: boolean;
}

export class ObrisiSluzbenuEvidencijuCommand implements IObrisiSluzbenuEvidencijuCommand {
    sifra?: string | undefined;

    constructor(data?: IObrisiSluzbenuEvidencijuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
        }
    }

    static fromJS(data: any): ObrisiSluzbenuEvidencijuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObrisiSluzbenuEvidencijuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        return data;
    }
}

export interface IObrisiSluzbenuEvidencijuCommand {
    sifra?: string | undefined;
}

export class ReaktivirajSluzbenuEvidencijuCommand implements IReaktivirajSluzbenuEvidencijuCommand {
    sifra?: string | undefined;
    datumOd?: Date | undefined;

    constructor(data?: IReaktivirajSluzbenuEvidencijuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReaktivirajSluzbenuEvidencijuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReaktivirajSluzbenuEvidencijuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        return data;
    }
}

export interface IReaktivirajSluzbenuEvidencijuCommand {
    sifra?: string | undefined;
    datumOd?: Date | undefined;
}

export class PagedResponseOfPretragaObjavljenihSEQueryResponse implements IPagedResponseOfPretragaObjavljenihSEQueryResponse {
    items?: PretragaObjavljenihSEQueryResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfPretragaObjavljenihSEQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PretragaObjavljenihSEQueryResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfPretragaObjavljenihSEQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfPretragaObjavljenihSEQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfPretragaObjavljenihSEQueryResponse {
    items?: PretragaObjavljenihSEQueryResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class PretragaObjavljenihSEQueryResponse implements IPretragaObjavljenihSEQueryResponse {
    sifra?: string | undefined;
    naziv?: string | undefined;
    skraceniNaziv?: string | undefined;
    sifraNadleznogOrgana?: string | undefined;
    punNazivNadleznogOrgana?: string | undefined;
    pravniOsnov?: string | undefined;
    opis?: string | undefined;
    tipEvidencijeNaziv?: string | undefined;
    jeJavnoDostupno!: boolean;
    jeElektronskiOblik!: boolean;
    dostupnoUElektronskomOblikuPutemServisa?: string | undefined;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    statusVerzijeNaziv?: string | undefined;
    verzija?: string | undefined;
    datumOd!: Date;
    datumDo?: Date | undefined;
    jePoslednjaVerzija!: boolean;
    skupVrednostiOgranicen?: number | undefined;
    skupVrednostiOgranicenNaziv?: string | undefined;

    constructor(data?: IPretragaObjavljenihSEQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.skraceniNaziv = _data["skraceniNaziv"];
            this.sifraNadleznogOrgana = _data["sifraNadleznogOrgana"];
            this.punNazivNadleznogOrgana = _data["punNazivNadleznogOrgana"];
            this.pravniOsnov = _data["pravniOsnov"];
            this.opis = _data["opis"];
            this.tipEvidencijeNaziv = _data["tipEvidencijeNaziv"];
            this.jeJavnoDostupno = _data["jeJavnoDostupno"];
            this.jeElektronskiOblik = _data["jeElektronskiOblik"];
            this.dostupnoUElektronskomOblikuPutemServisa = _data["dostupnoUElektronskomOblikuPutemServisa"];
            this.statusSifra = _data["statusSifra"];
            this.statusNaziv = _data["statusNaziv"];
            this.statusVerzijeNaziv = _data["statusVerzijeNaziv"];
            this.verzija = _data["verzija"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.jePoslednjaVerzija = _data["jePoslednjaVerzija"];
            this.skupVrednostiOgranicen = _data["skupVrednostiOgranicen"];
            this.skupVrednostiOgranicenNaziv = _data["skupVrednostiOgranicenNaziv"];
        }
    }

    static fromJS(data: any): PretragaObjavljenihSEQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PretragaObjavljenihSEQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["skraceniNaziv"] = this.skraceniNaziv;
        data["sifraNadleznogOrgana"] = this.sifraNadleznogOrgana;
        data["punNazivNadleznogOrgana"] = this.punNazivNadleznogOrgana;
        data["pravniOsnov"] = this.pravniOsnov;
        data["opis"] = this.opis;
        data["tipEvidencijeNaziv"] = this.tipEvidencijeNaziv;
        data["jeJavnoDostupno"] = this.jeJavnoDostupno;
        data["jeElektronskiOblik"] = this.jeElektronskiOblik;
        data["dostupnoUElektronskomOblikuPutemServisa"] = this.dostupnoUElektronskomOblikuPutemServisa;
        data["statusSifra"] = this.statusSifra;
        data["statusNaziv"] = this.statusNaziv;
        data["statusVerzijeNaziv"] = this.statusVerzijeNaziv;
        data["verzija"] = this.verzija;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["jePoslednjaVerzija"] = this.jePoslednjaVerzija;
        data["skupVrednostiOgranicen"] = this.skupVrednostiOgranicen;
        data["skupVrednostiOgranicenNaziv"] = this.skupVrednostiOgranicenNaziv;
        return data;
    }
}

export interface IPretragaObjavljenihSEQueryResponse {
    sifra?: string | undefined;
    naziv?: string | undefined;
    skraceniNaziv?: string | undefined;
    sifraNadleznogOrgana?: string | undefined;
    punNazivNadleznogOrgana?: string | undefined;
    pravniOsnov?: string | undefined;
    opis?: string | undefined;
    tipEvidencijeNaziv?: string | undefined;
    jeJavnoDostupno: boolean;
    jeElektronskiOblik: boolean;
    dostupnoUElektronskomOblikuPutemServisa?: string | undefined;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    statusVerzijeNaziv?: string | undefined;
    verzija?: string | undefined;
    datumOd: Date;
    datumDo?: Date | undefined;
    jePoslednjaVerzija: boolean;
    skupVrednostiOgranicen?: number | undefined;
    skupVrednostiOgranicenNaziv?: string | undefined;
}

export class DajSluzbenuEvidencijuPoSifriResponse implements IDajSluzbenuEvidencijuPoSifriResponse {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    skraceniNaziv?: string | undefined;
    sifraNadleznogOrgana?: string | undefined;
    nazivOrgana?: string | undefined;
    tipSluzbeneEvidencijeSifra?: string | undefined;
    ucestalostAzuriranja?: string | undefined;
    rokCuvanja?: number | undefined;
    jeTrajnoCuvanje!: boolean;
    jeJavnoDostupno!: boolean;
    adresa?: string | undefined;
    jeCentralizovana!: boolean;
    jeElektronskiOblik!: boolean;
    elektronskiOblikPutemServisa?: string | undefined;
    pravniOsnov?: string | undefined;
    opis?: string | undefined;
    razlogDeaktivacije?: string | undefined;
    datumOd!: Date;
    datumDo?: Date | undefined;
    verzija?: string | undefined;
    jePoslednjaVerzija!: boolean;
    statusSifra?: string | undefined;
    klasifikacijaSifre?: string[] | undefined;
    datumUspostavljanja?: Date | undefined;
    datumUkidanja?: Date | undefined;
    sifarnickiPojamId?: number | undefined;
    daLiJeSifarnikNastaoOdEksternogSifarnickogPojma!: boolean;
    skupVrednostiOgranicen?: number | undefined;

    constructor(data?: IDajSluzbenuEvidencijuPoSifriResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.skraceniNaziv = _data["skraceniNaziv"];
            this.sifraNadleznogOrgana = _data["sifraNadleznogOrgana"];
            this.nazivOrgana = _data["nazivOrgana"];
            this.tipSluzbeneEvidencijeSifra = _data["tipSluzbeneEvidencijeSifra"];
            this.ucestalostAzuriranja = _data["ucestalostAzuriranja"];
            this.rokCuvanja = _data["rokCuvanja"];
            this.jeTrajnoCuvanje = _data["jeTrajnoCuvanje"];
            this.jeJavnoDostupno = _data["jeJavnoDostupno"];
            this.adresa = _data["adresa"];
            this.jeCentralizovana = _data["jeCentralizovana"];
            this.jeElektronskiOblik = _data["jeElektronskiOblik"];
            this.elektronskiOblikPutemServisa = _data["elektronskiOblikPutemServisa"];
            this.pravniOsnov = _data["pravniOsnov"];
            this.opis = _data["opis"];
            this.razlogDeaktivacije = _data["razlogDeaktivacije"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.verzija = _data["verzija"];
            this.jePoslednjaVerzija = _data["jePoslednjaVerzija"];
            this.statusSifra = _data["statusSifra"];
            if (Array.isArray(_data["klasifikacijaSifre"])) {
                this.klasifikacijaSifre = [] as any;
                for (let item of _data["klasifikacijaSifre"])
                    this.klasifikacijaSifre!.push(item);
            }
            this.datumUspostavljanja = _data["datumUspostavljanja"] ? new Date(_data["datumUspostavljanja"].toString()) : <any>undefined;
            this.datumUkidanja = _data["datumUkidanja"] ? new Date(_data["datumUkidanja"].toString()) : <any>undefined;
            this.sifarnickiPojamId = _data["sifarnickiPojamId"];
            this.daLiJeSifarnikNastaoOdEksternogSifarnickogPojma = _data["daLiJeSifarnikNastaoOdEksternogSifarnickogPojma"];
            this.skupVrednostiOgranicen = _data["skupVrednostiOgranicen"];
        }
    }

    static fromJS(data: any): DajSluzbenuEvidencijuPoSifriResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajSluzbenuEvidencijuPoSifriResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["skraceniNaziv"] = this.skraceniNaziv;
        data["sifraNadleznogOrgana"] = this.sifraNadleznogOrgana;
        data["nazivOrgana"] = this.nazivOrgana;
        data["tipSluzbeneEvidencijeSifra"] = this.tipSluzbeneEvidencijeSifra;
        data["ucestalostAzuriranja"] = this.ucestalostAzuriranja;
        data["rokCuvanja"] = this.rokCuvanja;
        data["jeTrajnoCuvanje"] = this.jeTrajnoCuvanje;
        data["jeJavnoDostupno"] = this.jeJavnoDostupno;
        data["adresa"] = this.adresa;
        data["jeCentralizovana"] = this.jeCentralizovana;
        data["jeElektronskiOblik"] = this.jeElektronskiOblik;
        data["elektronskiOblikPutemServisa"] = this.elektronskiOblikPutemServisa;
        data["pravniOsnov"] = this.pravniOsnov;
        data["opis"] = this.opis;
        data["razlogDeaktivacije"] = this.razlogDeaktivacije;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["verzija"] = this.verzija;
        data["jePoslednjaVerzija"] = this.jePoslednjaVerzija;
        data["statusSifra"] = this.statusSifra;
        if (Array.isArray(this.klasifikacijaSifre)) {
            data["klasifikacijaSifre"] = [];
            for (let item of this.klasifikacijaSifre)
                data["klasifikacijaSifre"].push(item);
        }
        data["datumUspostavljanja"] = this.datumUspostavljanja ? this.datumUspostavljanja.toISOString() : <any>undefined;
        data["datumUkidanja"] = this.datumUkidanja ? this.datumUkidanja.toISOString() : <any>undefined;
        data["sifarnickiPojamId"] = this.sifarnickiPojamId;
        data["daLiJeSifarnikNastaoOdEksternogSifarnickogPojma"] = this.daLiJeSifarnikNastaoOdEksternogSifarnickogPojma;
        data["skupVrednostiOgranicen"] = this.skupVrednostiOgranicen;
        return data;
    }
}

export interface IDajSluzbenuEvidencijuPoSifriResponse {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    skraceniNaziv?: string | undefined;
    sifraNadleznogOrgana?: string | undefined;
    nazivOrgana?: string | undefined;
    tipSluzbeneEvidencijeSifra?: string | undefined;
    ucestalostAzuriranja?: string | undefined;
    rokCuvanja?: number | undefined;
    jeTrajnoCuvanje: boolean;
    jeJavnoDostupno: boolean;
    adresa?: string | undefined;
    jeCentralizovana: boolean;
    jeElektronskiOblik: boolean;
    elektronskiOblikPutemServisa?: string | undefined;
    pravniOsnov?: string | undefined;
    opis?: string | undefined;
    razlogDeaktivacije?: string | undefined;
    datumOd: Date;
    datumDo?: Date | undefined;
    verzija?: string | undefined;
    jePoslednjaVerzija: boolean;
    statusSifra?: string | undefined;
    klasifikacijaSifre?: string[] | undefined;
    datumUspostavljanja?: Date | undefined;
    datumUkidanja?: Date | undefined;
    sifarnickiPojamId?: number | undefined;
    daLiJeSifarnikNastaoOdEksternogSifarnickogPojma: boolean;
    skupVrednostiOgranicen?: number | undefined;
}

export class PagedResponseOfVezaPojmaSaSluzbenomEvidencijomResponse implements IPagedResponseOfVezaPojmaSaSluzbenomEvidencijomResponse {
    items?: VezaPojmaSaSluzbenomEvidencijomResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfVezaPojmaSaSluzbenomEvidencijomResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VezaPojmaSaSluzbenomEvidencijomResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfVezaPojmaSaSluzbenomEvidencijomResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfVezaPojmaSaSluzbenomEvidencijomResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfVezaPojmaSaSluzbenomEvidencijomResponse {
    items?: VezaPojmaSaSluzbenomEvidencijomResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class VezaPojmaSaSluzbenomEvidencijomResponse implements IVezaPojmaSaSluzbenomEvidencijomResponse {
    nazivSluzbeneEvidencije?: string | undefined;
    verzijaSluzbeneEvidencije?: string | undefined;
    sifraSadrzajaSluzbeneEvidencije?: string | undefined;
    verzijaSadrzajaSluzbeneEvidencije?: string | undefined;
    nazivNadleznogOrgana?: string | undefined;
    nazivElementa?: string | undefined;
    izvorniUEvidenciji!: boolean;

    constructor(data?: IVezaPojmaSaSluzbenomEvidencijomResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nazivSluzbeneEvidencije = _data["nazivSluzbeneEvidencije"];
            this.verzijaSluzbeneEvidencije = _data["verzijaSluzbeneEvidencije"];
            this.sifraSadrzajaSluzbeneEvidencije = _data["sifraSadrzajaSluzbeneEvidencije"];
            this.verzijaSadrzajaSluzbeneEvidencije = _data["verzijaSadrzajaSluzbeneEvidencije"];
            this.nazivNadleznogOrgana = _data["nazivNadleznogOrgana"];
            this.nazivElementa = _data["nazivElementa"];
            this.izvorniUEvidenciji = _data["izvorniUEvidenciji"];
        }
    }

    static fromJS(data: any): VezaPojmaSaSluzbenomEvidencijomResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VezaPojmaSaSluzbenomEvidencijomResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nazivSluzbeneEvidencije"] = this.nazivSluzbeneEvidencije;
        data["verzijaSluzbeneEvidencije"] = this.verzijaSluzbeneEvidencije;
        data["sifraSadrzajaSluzbeneEvidencije"] = this.sifraSadrzajaSluzbeneEvidencije;
        data["verzijaSadrzajaSluzbeneEvidencije"] = this.verzijaSadrzajaSluzbeneEvidencije;
        data["nazivNadleznogOrgana"] = this.nazivNadleznogOrgana;
        data["nazivElementa"] = this.nazivElementa;
        data["izvorniUEvidenciji"] = this.izvorniUEvidenciji;
        return data;
    }
}

export interface IVezaPojmaSaSluzbenomEvidencijomResponse {
    nazivSluzbeneEvidencije?: string | undefined;
    verzijaSluzbeneEvidencije?: string | undefined;
    sifraSadrzajaSluzbeneEvidencije?: string | undefined;
    verzijaSadrzajaSluzbeneEvidencije?: string | undefined;
    nazivNadleznogOrgana?: string | undefined;
    nazivElementa?: string | undefined;
    izvorniUEvidenciji: boolean;
}

export class PagedResponseOfVezaSvojstvaSaSluzbenomEvidencijomResponse implements IPagedResponseOfVezaSvojstvaSaSluzbenomEvidencijomResponse {
    items?: VezaSvojstvaSaSluzbenomEvidencijomResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfVezaSvojstvaSaSluzbenomEvidencijomResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VezaSvojstvaSaSluzbenomEvidencijomResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfVezaSvojstvaSaSluzbenomEvidencijomResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfVezaSvojstvaSaSluzbenomEvidencijomResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfVezaSvojstvaSaSluzbenomEvidencijomResponse {
    items?: VezaSvojstvaSaSluzbenomEvidencijomResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class VezaSvojstvaSaSluzbenomEvidencijomResponse implements IVezaSvojstvaSaSluzbenomEvidencijomResponse {
    nazivSluzbeneEvidencije?: string | undefined;
    verzijaSluzbeneEvidencije?: string | undefined;
    sifraSadrzajaSluzbeneEvidencije?: string | undefined;
    verzijaSadrzajaSluzbeneEvidencije?: string | undefined;
    elementId!: number;
    nazivElementa?: string | undefined;
    izvorniUEvidenciji!: boolean;

    constructor(data?: IVezaSvojstvaSaSluzbenomEvidencijomResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nazivSluzbeneEvidencije = _data["nazivSluzbeneEvidencije"];
            this.verzijaSluzbeneEvidencije = _data["verzijaSluzbeneEvidencije"];
            this.sifraSadrzajaSluzbeneEvidencije = _data["sifraSadrzajaSluzbeneEvidencije"];
            this.verzijaSadrzajaSluzbeneEvidencije = _data["verzijaSadrzajaSluzbeneEvidencije"];
            this.elementId = _data["elementId"];
            this.nazivElementa = _data["nazivElementa"];
            this.izvorniUEvidenciji = _data["izvorniUEvidenciji"];
        }
    }

    static fromJS(data: any): VezaSvojstvaSaSluzbenomEvidencijomResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VezaSvojstvaSaSluzbenomEvidencijomResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nazivSluzbeneEvidencije"] = this.nazivSluzbeneEvidencije;
        data["verzijaSluzbeneEvidencije"] = this.verzijaSluzbeneEvidencije;
        data["sifraSadrzajaSluzbeneEvidencije"] = this.sifraSadrzajaSluzbeneEvidencije;
        data["verzijaSadrzajaSluzbeneEvidencije"] = this.verzijaSadrzajaSluzbeneEvidencije;
        data["elementId"] = this.elementId;
        data["nazivElementa"] = this.nazivElementa;
        data["izvorniUEvidenciji"] = this.izvorniUEvidenciji;
        return data;
    }
}

export interface IVezaSvojstvaSaSluzbenomEvidencijomResponse {
    nazivSluzbeneEvidencije?: string | undefined;
    verzijaSluzbeneEvidencije?: string | undefined;
    sifraSadrzajaSluzbeneEvidencije?: string | undefined;
    verzijaSadrzajaSluzbeneEvidencije?: string | undefined;
    elementId: number;
    nazivElementa?: string | undefined;
    izvorniUEvidenciji: boolean;
}

export class PagedResponseOfPretragaObjavljenihSluzbenihEvidencijaPoNazivuQueryResponse implements IPagedResponseOfPretragaObjavljenihSluzbenihEvidencijaPoNazivuQueryResponse {
    items?: PretragaObjavljenihSluzbenihEvidencijaPoNazivuQueryResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfPretragaObjavljenihSluzbenihEvidencijaPoNazivuQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PretragaObjavljenihSluzbenihEvidencijaPoNazivuQueryResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfPretragaObjavljenihSluzbenihEvidencijaPoNazivuQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfPretragaObjavljenihSluzbenihEvidencijaPoNazivuQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfPretragaObjavljenihSluzbenihEvidencijaPoNazivuQueryResponse {
    items?: PretragaObjavljenihSluzbenihEvidencijaPoNazivuQueryResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class PretragaObjavljenihSluzbenihEvidencijaPoNazivuQueryResponse implements IPretragaObjavljenihSluzbenihEvidencijaPoNazivuQueryResponse {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;

    constructor(data?: IPretragaObjavljenihSluzbenihEvidencijaPoNazivuQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): PretragaObjavljenihSluzbenihEvidencijaPoNazivuQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PretragaObjavljenihSluzbenihEvidencijaPoNazivuQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IPretragaObjavljenihSluzbenihEvidencijaPoNazivuQueryResponse {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
}

export class PagedResponseOfPretragaSluzbenihEvidencijaZaKSQueryResponse implements IPagedResponseOfPretragaSluzbenihEvidencijaZaKSQueryResponse {
    items?: PretragaSluzbenihEvidencijaZaKSQueryResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfPretragaSluzbenihEvidencijaZaKSQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PretragaSluzbenihEvidencijaZaKSQueryResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfPretragaSluzbenihEvidencijaZaKSQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfPretragaSluzbenihEvidencijaZaKSQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfPretragaSluzbenihEvidencijaZaKSQueryResponse {
    items?: PretragaSluzbenihEvidencijaZaKSQueryResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class PretragaSluzbenihEvidencijaZaKSQueryResponse implements IPretragaSluzbenihEvidencijaZaKSQueryResponse {
    sifra?: string | undefined;
    naziv?: string | undefined;
    tipSifra?: string | undefined;
    tipNaziv?: string | undefined;
    sifraOrgana?: string | undefined;
    nazivOrgana?: string | undefined;
    skraceniNazivOrgana?: string | undefined;

    constructor(data?: IPretragaSluzbenihEvidencijaZaKSQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.tipSifra = _data["tipSifra"];
            this.tipNaziv = _data["tipNaziv"];
            this.sifraOrgana = _data["sifraOrgana"];
            this.nazivOrgana = _data["nazivOrgana"];
            this.skraceniNazivOrgana = _data["skraceniNazivOrgana"];
        }
    }

    static fromJS(data: any): PretragaSluzbenihEvidencijaZaKSQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PretragaSluzbenihEvidencijaZaKSQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["tipSifra"] = this.tipSifra;
        data["tipNaziv"] = this.tipNaziv;
        data["sifraOrgana"] = this.sifraOrgana;
        data["nazivOrgana"] = this.nazivOrgana;
        data["skraceniNazivOrgana"] = this.skraceniNazivOrgana;
        return data;
    }
}

export interface IPretragaSluzbenihEvidencijaZaKSQueryResponse {
    sifra?: string | undefined;
    naziv?: string | undefined;
    tipSifra?: string | undefined;
    tipNaziv?: string | undefined;
    sifraOrgana?: string | undefined;
    nazivOrgana?: string | undefined;
    skraceniNazivOrgana?: string | undefined;
}

export class PovratakEvidencijeNaStatusUPripremiCommand implements IPovratakEvidencijeNaStatusUPripremiCommand {
    sifra?: string | undefined;
    verzija?: string | undefined;

    constructor(data?: IPovratakEvidencijeNaStatusUPripremiCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.verzija = _data["verzija"];
        }
    }

    static fromJS(data: any): PovratakEvidencijeNaStatusUPripremiCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PovratakEvidencijeNaStatusUPripremiCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["verzija"] = this.verzija;
        return data;
    }
}

export interface IPovratakEvidencijeNaStatusUPripremiCommand {
    sifra?: string | undefined;
    verzija?: string | undefined;
}

export class ObrisiKlasifikacijuIzSECommand implements IObrisiKlasifikacijuIzSECommand {
    klasifikacijaId!: number;
    sluzbenaEvidencijaId!: number;

    constructor(data?: IObrisiKlasifikacijuIzSECommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.klasifikacijaId = _data["klasifikacijaId"];
            this.sluzbenaEvidencijaId = _data["sluzbenaEvidencijaId"];
        }
    }

    static fromJS(data: any): ObrisiKlasifikacijuIzSECommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObrisiKlasifikacijuIzSECommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["klasifikacijaId"] = this.klasifikacijaId;
        data["sluzbenaEvidencijaId"] = this.sluzbenaEvidencijaId;
        return data;
    }
}

export interface IObrisiKlasifikacijuIzSECommand {
    klasifikacijaId: number;
    sluzbenaEvidencijaId: number;
}

export class KreirajNovuVerzijuSadrzajaSluzbeneEvidencijeCommand implements IKreirajNovuVerzijuSadrzajaSluzbeneEvidencijeCommand {
    sadrzajSifra?: string | undefined;

    constructor(data?: IKreirajNovuVerzijuSadrzajaSluzbeneEvidencijeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sadrzajSifra = _data["sadrzajSifra"];
        }
    }

    static fromJS(data: any): KreirajNovuVerzijuSadrzajaSluzbeneEvidencijeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new KreirajNovuVerzijuSadrzajaSluzbeneEvidencijeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sadrzajSifra"] = this.sadrzajSifra;
        return data;
    }
}

export interface IKreirajNovuVerzijuSadrzajaSluzbeneEvidencijeCommand {
    sadrzajSifra?: string | undefined;
}

export class ObrisiSadrzajSluzbeneEvidencijeCommand implements IObrisiSadrzajSluzbeneEvidencijeCommand {
    sifra?: string | undefined;
    verzija?: string | undefined;

    constructor(data?: IObrisiSadrzajSluzbeneEvidencijeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.verzija = _data["verzija"];
        }
    }

    static fromJS(data: any): ObrisiSadrzajSluzbeneEvidencijeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObrisiSadrzajSluzbeneEvidencijeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["verzija"] = this.verzija;
        return data;
    }
}

export interface IObrisiSadrzajSluzbeneEvidencijeCommand {
    sifra?: string | undefined;
    verzija?: string | undefined;
}

export class ObjaviSadrzajSluzbeneEvidencijeCommand implements IObjaviSadrzajSluzbeneEvidencijeCommand {
    sifra?: string | undefined;
    datumOd!: Date;

    constructor(data?: IObjaviSadrzajSluzbeneEvidencijeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ObjaviSadrzajSluzbeneEvidencijeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObjaviSadrzajSluzbeneEvidencijeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        return data;
    }
}

export interface IObjaviSadrzajSluzbeneEvidencijeCommand {
    sifra?: string | undefined;
    datumOd: Date;
}

export class DeaktivirajSadrzajSluzbeneEvidencijeCommand implements IDeaktivirajSadrzajSluzbeneEvidencijeCommand {
    sifra?: string | undefined;
    razlogDeaktivacije?: string | undefined;
    datumDo!: Date;
    potvrdaBrisanjaVerzijeUPripremi!: boolean;

    constructor(data?: IDeaktivirajSadrzajSluzbeneEvidencijeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.razlogDeaktivacije = _data["razlogDeaktivacije"];
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.potvrdaBrisanjaVerzijeUPripremi = _data["potvrdaBrisanjaVerzijeUPripremi"];
        }
    }

    static fromJS(data: any): DeaktivirajSadrzajSluzbeneEvidencijeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeaktivirajSadrzajSluzbeneEvidencijeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["razlogDeaktivacije"] = this.razlogDeaktivacije;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["potvrdaBrisanjaVerzijeUPripremi"] = this.potvrdaBrisanjaVerzijeUPripremi;
        return data;
    }
}

export interface IDeaktivirajSadrzajSluzbeneEvidencijeCommand {
    sifra?: string | undefined;
    razlogDeaktivacije?: string | undefined;
    datumDo: Date;
    potvrdaBrisanjaVerzijeUPripremi: boolean;
}

export class ReaktivirajSadrzajSluzbeneEvidencijeCommand implements IReaktivirajSadrzajSluzbeneEvidencijeCommand {
    sifra?: string | undefined;
    datumOd?: Date | undefined;

    constructor(data?: IReaktivirajSadrzajSluzbeneEvidencijeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReaktivirajSadrzajSluzbeneEvidencijeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReaktivirajSadrzajSluzbeneEvidencijeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        return data;
    }
}

export interface IReaktivirajSadrzajSluzbeneEvidencijeCommand {
    sifra?: string | undefined;
    datumOd?: Date | undefined;
}

export class DajSveVerzijeSluzbeneEvidencijeResponse implements IDajSveVerzijeSluzbeneEvidencijeResponse {
    verzije?: SluzbenaEvidencijaVerzija[] | undefined;

    constructor(data?: IDajSveVerzijeSluzbeneEvidencijeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["verzije"])) {
                this.verzije = [] as any;
                for (let item of _data["verzije"])
                    this.verzije!.push(SluzbenaEvidencijaVerzija.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DajSveVerzijeSluzbeneEvidencijeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajSveVerzijeSluzbeneEvidencijeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.verzije)) {
            data["verzije"] = [];
            for (let item of this.verzije)
                data["verzije"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDajSveVerzijeSluzbeneEvidencijeResponse {
    verzije?: SluzbenaEvidencijaVerzija[] | undefined;
}

export class SluzbenaEvidencijaVerzija implements ISluzbenaEvidencijaVerzija {
    sifra?: string | undefined;
    naziv?: string | undefined;
    skraceniNaziv?: string | undefined;
    sifraNadleznogOrgana?: string | undefined;
    pravniOsnov?: string | undefined;
    opis?: string | undefined;
    tipEvidencijeNaziv?: string | undefined;
    jeJavnoDostupno!: boolean;
    jeElektronskiOblik!: boolean;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    statusVerzijeNaziv?: string | undefined;
    verzija?: string | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    jePoslednjaVerzija!: boolean;

    constructor(data?: ISluzbenaEvidencijaVerzija) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.skraceniNaziv = _data["skraceniNaziv"];
            this.sifraNadleznogOrgana = _data["sifraNadleznogOrgana"];
            this.pravniOsnov = _data["pravniOsnov"];
            this.opis = _data["opis"];
            this.tipEvidencijeNaziv = _data["tipEvidencijeNaziv"];
            this.jeJavnoDostupno = _data["jeJavnoDostupno"];
            this.jeElektronskiOblik = _data["jeElektronskiOblik"];
            this.statusSifra = _data["statusSifra"];
            this.statusNaziv = _data["statusNaziv"];
            this.statusVerzijeNaziv = _data["statusVerzijeNaziv"];
            this.verzija = _data["verzija"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.jePoslednjaVerzija = _data["jePoslednjaVerzija"];
        }
    }

    static fromJS(data: any): SluzbenaEvidencijaVerzija {
        data = typeof data === 'object' ? data : {};
        let result = new SluzbenaEvidencijaVerzija();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["skraceniNaziv"] = this.skraceniNaziv;
        data["sifraNadleznogOrgana"] = this.sifraNadleznogOrgana;
        data["pravniOsnov"] = this.pravniOsnov;
        data["opis"] = this.opis;
        data["tipEvidencijeNaziv"] = this.tipEvidencijeNaziv;
        data["jeJavnoDostupno"] = this.jeJavnoDostupno;
        data["jeElektronskiOblik"] = this.jeElektronskiOblik;
        data["statusSifra"] = this.statusSifra;
        data["statusNaziv"] = this.statusNaziv;
        data["statusVerzijeNaziv"] = this.statusVerzijeNaziv;
        data["verzija"] = this.verzija;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["jePoslednjaVerzija"] = this.jePoslednjaVerzija;
        return data;
    }
}

export interface ISluzbenaEvidencijaVerzija {
    sifra?: string | undefined;
    naziv?: string | undefined;
    skraceniNaziv?: string | undefined;
    sifraNadleznogOrgana?: string | undefined;
    pravniOsnov?: string | undefined;
    opis?: string | undefined;
    tipEvidencijeNaziv?: string | undefined;
    jeJavnoDostupno: boolean;
    jeElektronskiOblik: boolean;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    statusVerzijeNaziv?: string | undefined;
    verzija?: string | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    jePoslednjaVerzija: boolean;
}

export class DajSveVerzijeSadrzajaSluzbeneEvidencijeResponse implements IDajSveVerzijeSadrzajaSluzbeneEvidencijeResponse {
    verzije?: SadrzajVerzija[] | undefined;

    constructor(data?: IDajSveVerzijeSadrzajaSluzbeneEvidencijeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["verzije"])) {
                this.verzije = [] as any;
                for (let item of _data["verzije"])
                    this.verzije!.push(SadrzajVerzija.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DajSveVerzijeSadrzajaSluzbeneEvidencijeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajSveVerzijeSadrzajaSluzbeneEvidencijeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.verzije)) {
            data["verzije"] = [];
            for (let item of this.verzije)
                data["verzije"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDajSveVerzijeSadrzajaSluzbeneEvidencijeResponse {
    verzije?: SadrzajVerzija[] | undefined;
}

export class SadrzajVerzija implements ISadrzajVerzija {
    sifraSadrzaja?: string | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    statusVerzijeSifra?: string | undefined;
    statusVerzijeNaziv?: string | undefined;
    verzija?: string | undefined;
    jePoslednjaVerzija!: boolean;

    constructor(data?: ISadrzajVerzija) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifraSadrzaja = _data["sifraSadrzaja"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.statusSifra = _data["statusSifra"];
            this.statusNaziv = _data["statusNaziv"];
            this.statusVerzijeSifra = _data["statusVerzijeSifra"];
            this.statusVerzijeNaziv = _data["statusVerzijeNaziv"];
            this.verzija = _data["verzija"];
            this.jePoslednjaVerzija = _data["jePoslednjaVerzija"];
        }
    }

    static fromJS(data: any): SadrzajVerzija {
        data = typeof data === 'object' ? data : {};
        let result = new SadrzajVerzija();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifraSadrzaja"] = this.sifraSadrzaja;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["statusSifra"] = this.statusSifra;
        data["statusNaziv"] = this.statusNaziv;
        data["statusVerzijeSifra"] = this.statusVerzijeSifra;
        data["statusVerzijeNaziv"] = this.statusVerzijeNaziv;
        data["verzija"] = this.verzija;
        data["jePoslednjaVerzija"] = this.jePoslednjaVerzija;
        return data;
    }
}

export interface ISadrzajVerzija {
    sifraSadrzaja?: string | undefined;
    datumOd?: Date | undefined;
    datumDo?: Date | undefined;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    statusVerzijeSifra?: string | undefined;
    statusVerzijeNaziv?: string | undefined;
    verzija?: string | undefined;
    jePoslednjaVerzija: boolean;
}

export class DajSadrzajPoSifriResponse implements IDajSadrzajPoSifriResponse {
    sifraSluzbeneEvidencije?: string | undefined;
    verzijaSluzbeneEvidencije?: string | undefined;
    nazivSluzbeneEvidencije?: string | undefined;
    verzijaSadrzaja?: string | undefined;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    jePoslednjaVerzija!: boolean;
    datumOd!: Date;
    datumDo?: Date | undefined;
    nadlezniOrganSifra?: string | undefined;
    elementi?: ElementShortResponse[] | undefined;

    constructor(data?: IDajSadrzajPoSifriResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifraSluzbeneEvidencije = _data["sifraSluzbeneEvidencije"];
            this.verzijaSluzbeneEvidencije = _data["verzijaSluzbeneEvidencije"];
            this.nazivSluzbeneEvidencije = _data["nazivSluzbeneEvidencije"];
            this.verzijaSadrzaja = _data["verzijaSadrzaja"];
            this.statusSifra = _data["statusSifra"];
            this.statusNaziv = _data["statusNaziv"];
            this.jePoslednjaVerzija = _data["jePoslednjaVerzija"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
            this.datumDo = _data["datumDo"] ? new Date(_data["datumDo"].toString()) : <any>undefined;
            this.nadlezniOrganSifra = _data["nadlezniOrganSifra"];
            if (Array.isArray(_data["elementi"])) {
                this.elementi = [] as any;
                for (let item of _data["elementi"])
                    this.elementi!.push(ElementShortResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DajSadrzajPoSifriResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajSadrzajPoSifriResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifraSluzbeneEvidencije"] = this.sifraSluzbeneEvidencije;
        data["verzijaSluzbeneEvidencije"] = this.verzijaSluzbeneEvidencije;
        data["nazivSluzbeneEvidencije"] = this.nazivSluzbeneEvidencije;
        data["verzijaSadrzaja"] = this.verzijaSadrzaja;
        data["statusSifra"] = this.statusSifra;
        data["statusNaziv"] = this.statusNaziv;
        data["jePoslednjaVerzija"] = this.jePoslednjaVerzija;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        data["datumDo"] = this.datumDo ? this.datumDo.toISOString() : <any>undefined;
        data["nadlezniOrganSifra"] = this.nadlezniOrganSifra;
        if (Array.isArray(this.elementi)) {
            data["elementi"] = [];
            for (let item of this.elementi)
                data["elementi"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDajSadrzajPoSifriResponse {
    sifraSluzbeneEvidencije?: string | undefined;
    verzijaSluzbeneEvidencije?: string | undefined;
    nazivSluzbeneEvidencije?: string | undefined;
    verzijaSadrzaja?: string | undefined;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    jePoslednjaVerzija: boolean;
    datumOd: Date;
    datumDo?: Date | undefined;
    nadlezniOrganSifra?: string | undefined;
    elementi?: ElementShortResponse[] | undefined;
}

export class ElementShortResponse implements IElementShortResponse {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    definicija?: string | undefined;
    jePojam!: boolean;
    jeSekcija!: boolean;
    tipPodatka?: string | undefined;
    jeIzvorni!: boolean;
    jeElementZaIdentifikacionuOznaku!: boolean;
    svojstvoReferentnogPojma?: string | undefined;
    nazivPoslovnogTipa?: string | undefined;
    nadredjeniElementId?: number | undefined;
    statusId!: number;
    statusNaTipuId?: number | undefined;
    svojstvoId?: number | undefined;
    nadredjenoSvojstvoId?: number | undefined;
    pojamId?: number | undefined;
    nivo!: number;
    redniBroj!: number;

    constructor(data?: IElementShortResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.definicija = _data["definicija"];
            this.jePojam = _data["jePojam"];
            this.jeSekcija = _data["jeSekcija"];
            this.tipPodatka = _data["tipPodatka"];
            this.jeIzvorni = _data["jeIzvorni"];
            this.jeElementZaIdentifikacionuOznaku = _data["jeElementZaIdentifikacionuOznaku"];
            this.svojstvoReferentnogPojma = _data["svojstvoReferentnogPojma"];
            this.nazivPoslovnogTipa = _data["nazivPoslovnogTipa"];
            this.nadredjeniElementId = _data["nadredjeniElementId"];
            this.statusId = _data["statusId"];
            this.statusNaTipuId = _data["statusNaTipuId"];
            this.svojstvoId = _data["svojstvoId"];
            this.nadredjenoSvojstvoId = _data["nadredjenoSvojstvoId"];
            this.pojamId = _data["pojamId"];
            this.nivo = _data["nivo"];
            this.redniBroj = _data["redniBroj"];
        }
    }

    static fromJS(data: any): ElementShortResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ElementShortResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["definicija"] = this.definicija;
        data["jePojam"] = this.jePojam;
        data["jeSekcija"] = this.jeSekcija;
        data["tipPodatka"] = this.tipPodatka;
        data["jeIzvorni"] = this.jeIzvorni;
        data["jeElementZaIdentifikacionuOznaku"] = this.jeElementZaIdentifikacionuOznaku;
        data["svojstvoReferentnogPojma"] = this.svojstvoReferentnogPojma;
        data["nazivPoslovnogTipa"] = this.nazivPoslovnogTipa;
        data["nadredjeniElementId"] = this.nadredjeniElementId;
        data["statusId"] = this.statusId;
        data["statusNaTipuId"] = this.statusNaTipuId;
        data["svojstvoId"] = this.svojstvoId;
        data["nadredjenoSvojstvoId"] = this.nadredjenoSvojstvoId;
        data["pojamId"] = this.pojamId;
        data["nivo"] = this.nivo;
        data["redniBroj"] = this.redniBroj;
        return data;
    }
}

export interface IElementShortResponse {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    definicija?: string | undefined;
    jePojam: boolean;
    jeSekcija: boolean;
    tipPodatka?: string | undefined;
    jeIzvorni: boolean;
    jeElementZaIdentifikacionuOznaku: boolean;
    svojstvoReferentnogPojma?: string | undefined;
    nazivPoslovnogTipa?: string | undefined;
    nadredjeniElementId?: number | undefined;
    statusId: number;
    statusNaTipuId?: number | undefined;
    svojstvoId?: number | undefined;
    nadredjenoSvojstvoId?: number | undefined;
    pojamId?: number | undefined;
    nivo: number;
    redniBroj: number;
}

export class SacuvajSadrzajSluzbeneEvidencijeCommand implements ISacuvajSadrzajSluzbeneEvidencijeCommand {
    sifra?: string | undefined;
    datumOd!: Date;

    constructor(data?: ISacuvajSadrzajSluzbeneEvidencijeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.datumOd = _data["datumOd"] ? new Date(_data["datumOd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SacuvajSadrzajSluzbeneEvidencijeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SacuvajSadrzajSluzbeneEvidencijeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["datumOd"] = this.datumOd ? this.datumOd.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISacuvajSadrzajSluzbeneEvidencijeCommand {
    sifra?: string | undefined;
    datumOd: Date;
}

export class PovratakSadrzajaEvidencijeNaStatusUPripremiCommand implements IPovratakSadrzajaEvidencijeNaStatusUPripremiCommand {
    sifra?: string | undefined;
    verzija?: string | undefined;

    constructor(data?: IPovratakSadrzajaEvidencijeNaStatusUPripremiCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.verzija = _data["verzija"];
        }
    }

    static fromJS(data: any): PovratakSadrzajaEvidencijeNaStatusUPripremiCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PovratakSadrzajaEvidencijeNaStatusUPripremiCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["verzija"] = this.verzija;
        return data;
    }
}

export interface IPovratakSadrzajaEvidencijeNaStatusUPripremiCommand {
    sifra?: string | undefined;
    verzija?: string | undefined;
}

export class PagedResponseOfPretragaElemenataZaPovezivanjeQueryResponse implements IPagedResponseOfPretragaElemenataZaPovezivanjeQueryResponse {
    items?: PretragaElemenataZaPovezivanjeQueryResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfPretragaElemenataZaPovezivanjeQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PretragaElemenataZaPovezivanjeQueryResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfPretragaElemenataZaPovezivanjeQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfPretragaElemenataZaPovezivanjeQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfPretragaElemenataZaPovezivanjeQueryResponse {
    items?: PretragaElemenataZaPovezivanjeQueryResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class PretragaElemenataZaPovezivanjeQueryResponse implements IPretragaElemenataZaPovezivanjeQueryResponse {
    sifra?: string | undefined;
    nazivSluzbeneEvidencije?: string | undefined;
    nazivPojma?: string | undefined;
    jePodatak!: boolean;

    constructor(data?: IPretragaElemenataZaPovezivanjeQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.nazivSluzbeneEvidencije = _data["nazivSluzbeneEvidencije"];
            this.nazivPojma = _data["nazivPojma"];
            this.jePodatak = _data["jePodatak"];
        }
    }

    static fromJS(data: any): PretragaElemenataZaPovezivanjeQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PretragaElemenataZaPovezivanjeQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["nazivSluzbeneEvidencije"] = this.nazivSluzbeneEvidencije;
        data["nazivPojma"] = this.nazivPojma;
        data["jePodatak"] = this.jePodatak;
        return data;
    }
}

export interface IPretragaElemenataZaPovezivanjeQueryResponse {
    sifra?: string | undefined;
    nazivSluzbeneEvidencije?: string | undefined;
    nazivPojma?: string | undefined;
    jePodatak: boolean;
}

export class PagedResponseOfElementShortResponse implements IPagedResponseOfElementShortResponse {
    items?: ElementShortResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfElementShortResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ElementShortResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfElementShortResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfElementShortResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfElementShortResponse {
    items?: ElementShortResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class SacuvajElementCommand implements ISacuvajElementCommand {
    sifra?: string | undefined;
    sadrzajSluzbeneEvidencijeSifra?: string | undefined;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    definicija?: string | undefined;
    tipPodatka?: string | undefined;
    svojstvoReferentnogPojma?: string | undefined;
    jeIzvorni!: boolean;
    jeElementZaIdentifikacionuOznaku!: boolean;
    svojstvoId!: number;

    constructor(data?: ISacuvajElementCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.sadrzajSluzbeneEvidencijeSifra = _data["sadrzajSluzbeneEvidencijeSifra"];
            this.naziv = _data["naziv"];
            this.tehnickiNaziv = _data["tehnickiNaziv"];
            this.definicija = _data["definicija"];
            this.tipPodatka = _data["tipPodatka"];
            this.svojstvoReferentnogPojma = _data["svojstvoReferentnogPojma"];
            this.jeIzvorni = _data["jeIzvorni"];
            this.jeElementZaIdentifikacionuOznaku = _data["jeElementZaIdentifikacionuOznaku"];
            this.svojstvoId = _data["svojstvoId"];
        }
    }

    static fromJS(data: any): SacuvajElementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SacuvajElementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["sadrzajSluzbeneEvidencijeSifra"] = this.sadrzajSluzbeneEvidencijeSifra;
        data["naziv"] = this.naziv;
        data["tehnickiNaziv"] = this.tehnickiNaziv;
        data["definicija"] = this.definicija;
        data["tipPodatka"] = this.tipPodatka;
        data["svojstvoReferentnogPojma"] = this.svojstvoReferentnogPojma;
        data["jeIzvorni"] = this.jeIzvorni;
        data["jeElementZaIdentifikacionuOznaku"] = this.jeElementZaIdentifikacionuOznaku;
        data["svojstvoId"] = this.svojstvoId;
        return data;
    }
}

export interface ISacuvajElementCommand {
    sifra?: string | undefined;
    sadrzajSluzbeneEvidencijeSifra?: string | undefined;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    definicija?: string | undefined;
    tipPodatka?: string | undefined;
    svojstvoReferentnogPojma?: string | undefined;
    jeIzvorni: boolean;
    jeElementZaIdentifikacionuOznaku: boolean;
    svojstvoId: number;
}

export class DajElementPoSifriResponse implements IDajElementPoSifriResponse {
    id!: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    definicija?: string | undefined;
    tipPodatka?: string | undefined;
    svojstvoReferentnogPojma?: string | undefined;
    jeIzvorni!: boolean;
    odgovarajuciPodatakUIzvornojEvidenciji?: string | undefined;
    izvornaEvidencija?: string | undefined;
    izvorniElementId?: number | undefined;
    jeElementZaIdentifikacionuOznaku!: boolean;
    nadredjeniElementId?: number | undefined;
    nadredjeniElementSifra?: string | undefined;
    svojstvoId!: number;
    pojamZaPovezivanje?: DajPojamPoSifriResponse | undefined;

    constructor(data?: IDajElementPoSifriResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.naziv = _data["naziv"];
            this.tehnickiNaziv = _data["tehnickiNaziv"];
            this.definicija = _data["definicija"];
            this.tipPodatka = _data["tipPodatka"];
            this.svojstvoReferentnogPojma = _data["svojstvoReferentnogPojma"];
            this.jeIzvorni = _data["jeIzvorni"];
            this.odgovarajuciPodatakUIzvornojEvidenciji = _data["odgovarajuciPodatakUIzvornojEvidenciji"];
            this.izvornaEvidencija = _data["izvornaEvidencija"];
            this.izvorniElementId = _data["izvorniElementId"];
            this.jeElementZaIdentifikacionuOznaku = _data["jeElementZaIdentifikacionuOznaku"];
            this.nadredjeniElementId = _data["nadredjeniElementId"];
            this.nadredjeniElementSifra = _data["nadredjeniElementSifra"];
            this.svojstvoId = _data["svojstvoId"];
            this.pojamZaPovezivanje = _data["pojamZaPovezivanje"] ? DajPojamPoSifriResponse.fromJS(_data["pojamZaPovezivanje"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DajElementPoSifriResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajElementPoSifriResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["naziv"] = this.naziv;
        data["tehnickiNaziv"] = this.tehnickiNaziv;
        data["definicija"] = this.definicija;
        data["tipPodatka"] = this.tipPodatka;
        data["svojstvoReferentnogPojma"] = this.svojstvoReferentnogPojma;
        data["jeIzvorni"] = this.jeIzvorni;
        data["odgovarajuciPodatakUIzvornojEvidenciji"] = this.odgovarajuciPodatakUIzvornojEvidenciji;
        data["izvornaEvidencija"] = this.izvornaEvidencija;
        data["izvorniElementId"] = this.izvorniElementId;
        data["jeElementZaIdentifikacionuOznaku"] = this.jeElementZaIdentifikacionuOznaku;
        data["nadredjeniElementId"] = this.nadredjeniElementId;
        data["nadredjeniElementSifra"] = this.nadredjeniElementSifra;
        data["svojstvoId"] = this.svojstvoId;
        data["pojamZaPovezivanje"] = this.pojamZaPovezivanje ? this.pojamZaPovezivanje.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDajElementPoSifriResponse {
    id: number;
    sifra?: string | undefined;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    definicija?: string | undefined;
    tipPodatka?: string | undefined;
    svojstvoReferentnogPojma?: string | undefined;
    jeIzvorni: boolean;
    odgovarajuciPodatakUIzvornojEvidenciji?: string | undefined;
    izvornaEvidencija?: string | undefined;
    izvorniElementId?: number | undefined;
    jeElementZaIdentifikacionuOznaku: boolean;
    nadredjeniElementId?: number | undefined;
    nadredjeniElementSifra?: string | undefined;
    svojstvoId: number;
    pojamZaPovezivanje?: DajPojamPoSifriResponse | undefined;
}

export class ObrisiElementCommand implements IObrisiElementCommand {
    sifraElementa?: string | undefined;
    sifraSadrzaja?: string | undefined;
    verzijaSadrzaja?: string | undefined;

    constructor(data?: IObrisiElementCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifraElementa = _data["sifraElementa"];
            this.sifraSadrzaja = _data["sifraSadrzaja"];
            this.verzijaSadrzaja = _data["verzijaSadrzaja"];
        }
    }

    static fromJS(data: any): ObrisiElementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObrisiElementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifraElementa"] = this.sifraElementa;
        data["sifraSadrzaja"] = this.sifraSadrzaja;
        data["verzijaSadrzaja"] = this.verzijaSadrzaja;
        return data;
    }
}

export interface IObrisiElementCommand {
    sifraElementa?: string | undefined;
    sifraSadrzaja?: string | undefined;
    verzijaSadrzaja?: string | undefined;
}

export class ObrisiElementeCommand implements IObrisiElementeCommand {
    sifreElemenata?: string[] | undefined;
    sifraSadrzaja?: string | undefined;
    verzijaSadrzaja?: string | undefined;

    constructor(data?: IObrisiElementeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sifreElemenata"])) {
                this.sifreElemenata = [] as any;
                for (let item of _data["sifreElemenata"])
                    this.sifreElemenata!.push(item);
            }
            this.sifraSadrzaja = _data["sifraSadrzaja"];
            this.verzijaSadrzaja = _data["verzijaSadrzaja"];
        }
    }

    static fromJS(data: any): ObrisiElementeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObrisiElementeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sifreElemenata)) {
            data["sifreElemenata"] = [];
            for (let item of this.sifreElemenata)
                data["sifreElemenata"].push(item);
        }
        data["sifraSadrzaja"] = this.sifraSadrzaja;
        data["verzijaSadrzaja"] = this.verzijaSadrzaja;
        return data;
    }
}

export interface IObrisiElementeCommand {
    sifreElemenata?: string[] | undefined;
    sifraSadrzaja?: string | undefined;
    verzijaSadrzaja?: string | undefined;
}

export class SacuvajSvojstvaReferentnogPojmaKaoElementeCommand implements ISacuvajSvojstvaReferentnogPojmaKaoElementeCommand {
    referentniPojam?: ReferentniPojamCommand | undefined;
    svojstvaReferentnogPojma?: SvojstvoReferentnogPojma[] | undefined;

    constructor(data?: ISacuvajSvojstvaReferentnogPojmaKaoElementeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referentniPojam = _data["referentniPojam"] ? ReferentniPojamCommand.fromJS(_data["referentniPojam"]) : <any>undefined;
            if (Array.isArray(_data["svojstvaReferentnogPojma"])) {
                this.svojstvaReferentnogPojma = [] as any;
                for (let item of _data["svojstvaReferentnogPojma"])
                    this.svojstvaReferentnogPojma!.push(SvojstvoReferentnogPojma.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SacuvajSvojstvaReferentnogPojmaKaoElementeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SacuvajSvojstvaReferentnogPojmaKaoElementeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referentniPojam"] = this.referentniPojam ? this.referentniPojam.toJSON() : <any>undefined;
        if (Array.isArray(this.svojstvaReferentnogPojma)) {
            data["svojstvaReferentnogPojma"] = [];
            for (let item of this.svojstvaReferentnogPojma)
                data["svojstvaReferentnogPojma"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISacuvajSvojstvaReferentnogPojmaKaoElementeCommand {
    referentniPojam?: ReferentniPojamCommand | undefined;
    svojstvaReferentnogPojma?: SvojstvoReferentnogPojma[] | undefined;
}

export class ReferentniPojamCommand implements IReferentniPojamCommand {
    sifra?: string | undefined;
    sadrzajSluzbeneEvidencijeSifra?: string | undefined;
    pojamId?: number | undefined;
    svojstvoId?: number | undefined;

    constructor(data?: IReferentniPojamCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sifra = _data["sifra"];
            this.sadrzajSluzbeneEvidencijeSifra = _data["sadrzajSluzbeneEvidencijeSifra"];
            this.pojamId = _data["pojamId"];
            this.svojstvoId = _data["svojstvoId"];
        }
    }

    static fromJS(data: any): ReferentniPojamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReferentniPojamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sifra"] = this.sifra;
        data["sadrzajSluzbeneEvidencijeSifra"] = this.sadrzajSluzbeneEvidencijeSifra;
        data["pojamId"] = this.pojamId;
        data["svojstvoId"] = this.svojstvoId;
        return data;
    }
}

export interface IReferentniPojamCommand {
    sifra?: string | undefined;
    sadrzajSluzbeneEvidencijeSifra?: string | undefined;
    pojamId?: number | undefined;
    svojstvoId?: number | undefined;
}

export class ElementSifarnikaResponse implements IElementSifarnikaResponse {
    naziv?: string | undefined;
    id!: number;
    sifra?: string | undefined;
    tipPodatkaNaziv?: string | undefined;
    ogranicenja?: OgranicenjeElementaResponse[] | undefined;
    skupVrednostiOgranicenDrugimSifarnikom!: boolean;
    sifarnikSifra?: string | undefined;
    elementSifarnikaSifra?: string | undefined;

    constructor(data?: IElementSifarnikaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.id = _data["id"];
            this.sifra = _data["sifra"];
            this.tipPodatkaNaziv = _data["tipPodatkaNaziv"];
            if (Array.isArray(_data["ogranicenja"])) {
                this.ogranicenja = [] as any;
                for (let item of _data["ogranicenja"])
                    this.ogranicenja!.push(OgranicenjeElementaResponse.fromJS(item));
            }
            this.skupVrednostiOgranicenDrugimSifarnikom = _data["skupVrednostiOgranicenDrugimSifarnikom"];
            this.sifarnikSifra = _data["sifarnikSifra"];
            this.elementSifarnikaSifra = _data["elementSifarnikaSifra"];
        }
    }

    static fromJS(data: any): ElementSifarnikaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ElementSifarnikaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["id"] = this.id;
        data["sifra"] = this.sifra;
        data["tipPodatkaNaziv"] = this.tipPodatkaNaziv;
        if (Array.isArray(this.ogranicenja)) {
            data["ogranicenja"] = [];
            for (let item of this.ogranicenja)
                data["ogranicenja"].push(item.toJSON());
        }
        data["skupVrednostiOgranicenDrugimSifarnikom"] = this.skupVrednostiOgranicenDrugimSifarnikom;
        data["sifarnikSifra"] = this.sifarnikSifra;
        data["elementSifarnikaSifra"] = this.elementSifarnikaSifra;
        return data;
    }
}

export interface IElementSifarnikaResponse {
    naziv?: string | undefined;
    id: number;
    sifra?: string | undefined;
    tipPodatkaNaziv?: string | undefined;
    ogranicenja?: OgranicenjeElementaResponse[] | undefined;
    skupVrednostiOgranicenDrugimSifarnikom: boolean;
    sifarnikSifra?: string | undefined;
    elementSifarnikaSifra?: string | undefined;
}

export class OgranicenjeElementaResponse implements IOgranicenjeElementaResponse {
    tipOgranicenjaId!: number;
    tipOgranicenjaNaziv?: string | undefined;
    ogranicenjeVrednost?: string | undefined;

    constructor(data?: IOgranicenjeElementaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipOgranicenjaId = _data["tipOgranicenjaId"];
            this.tipOgranicenjaNaziv = _data["tipOgranicenjaNaziv"];
            this.ogranicenjeVrednost = _data["ogranicenjeVrednost"];
        }
    }

    static fromJS(data: any): OgranicenjeElementaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OgranicenjeElementaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipOgranicenjaId"] = this.tipOgranicenjaId;
        data["tipOgranicenjaNaziv"] = this.tipOgranicenjaNaziv;
        data["ogranicenjeVrednost"] = this.ogranicenjeVrednost;
        return data;
    }
}

export interface IOgranicenjeElementaResponse {
    tipOgranicenjaId: number;
    tipOgranicenjaNaziv?: string | undefined;
    ogranicenjeVrednost?: string | undefined;
}

export class OznaciIzvornostViseElemenataCommand implements IOznaciIzvornostViseElemenataCommand {
    sifreElemenata?: string[] | undefined;
    sifraSadrzaja?: string | undefined;
    verzijaSadrzaja?: string | undefined;

    constructor(data?: IOznaciIzvornostViseElemenataCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sifreElemenata"])) {
                this.sifreElemenata = [] as any;
                for (let item of _data["sifreElemenata"])
                    this.sifreElemenata!.push(item);
            }
            this.sifraSadrzaja = _data["sifraSadrzaja"];
            this.verzijaSadrzaja = _data["verzijaSadrzaja"];
        }
    }

    static fromJS(data: any): OznaciIzvornostViseElemenataCommand {
        data = typeof data === 'object' ? data : {};
        let result = new OznaciIzvornostViseElemenataCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sifreElemenata)) {
            data["sifreElemenata"] = [];
            for (let item of this.sifreElemenata)
                data["sifreElemenata"].push(item);
        }
        data["sifraSadrzaja"] = this.sifraSadrzaja;
        data["verzijaSadrzaja"] = this.verzijaSadrzaja;
        return data;
    }
}

export interface IOznaciIzvornostViseElemenataCommand {
    sifreElemenata?: string[] | undefined;
    sifraSadrzaja?: string | undefined;
    verzijaSadrzaja?: string | undefined;
}

export class ZamenaRednihBrojevaElemenataEvidencijeCommand implements IZamenaRednihBrojevaElemenataEvidencijeCommand {
    gornjiElementId!: number;
    donjiElementId!: number;

    constructor(data?: IZamenaRednihBrojevaElemenataEvidencijeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gornjiElementId = _data["gornjiElementId"];
            this.donjiElementId = _data["donjiElementId"];
        }
    }

    static fromJS(data: any): ZamenaRednihBrojevaElemenataEvidencijeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ZamenaRednihBrojevaElemenataEvidencijeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gornjiElementId"] = this.gornjiElementId;
        data["donjiElementId"] = this.donjiElementId;
        return data;
    }
}

export interface IZamenaRednihBrojevaElemenataEvidencijeCommand {
    gornjiElementId: number;
    donjiElementId: number;
}

export class PagedResponseOfStavkaSifarnikaResponse implements IPagedResponseOfStavkaSifarnikaResponse {
    items?: StavkaSifarnikaResponse[] | undefined;
    totalCount!: number;
    pageNumber!: number;
    pageSize!: number;
    totalPages!: number;
    hasNextPage!: boolean;
    hasPreviousPage!: boolean;

    constructor(data?: IPagedResponseOfStavkaSifarnikaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StavkaSifarnikaResponse.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPreviousPage = _data["hasPreviousPage"];
        }
    }

    static fromJS(data: any): PagedResponseOfStavkaSifarnikaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfStavkaSifarnikaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPreviousPage"] = this.hasPreviousPage;
        return data;
    }
}

export interface IPagedResponseOfStavkaSifarnikaResponse {
    items?: StavkaSifarnikaResponse[] | undefined;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export class StavkaSifarnikaResponse implements IStavkaSifarnikaResponse {
    id!: number;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    datumPocetkaVazenja!: Date;
    datumPrestankaVazenja?: Date | undefined;
    dodatneKolone?: string | undefined;

    constructor(data?: IStavkaSifarnikaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusSifra = _data["statusSifra"];
            this.statusNaziv = _data["statusNaziv"];
            this.datumPocetkaVazenja = _data["datumPocetkaVazenja"] ? new Date(_data["datumPocetkaVazenja"].toString()) : <any>undefined;
            this.datumPrestankaVazenja = _data["datumPrestankaVazenja"] ? new Date(_data["datumPrestankaVazenja"].toString()) : <any>undefined;
            this.dodatneKolone = _data["dodatneKolone"];
        }
    }

    static fromJS(data: any): StavkaSifarnikaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StavkaSifarnikaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusSifra"] = this.statusSifra;
        data["statusNaziv"] = this.statusNaziv;
        data["datumPocetkaVazenja"] = this.datumPocetkaVazenja ? this.datumPocetkaVazenja.toISOString() : <any>undefined;
        data["datumPrestankaVazenja"] = this.datumPrestankaVazenja ? this.datumPrestankaVazenja.toISOString() : <any>undefined;
        data["dodatneKolone"] = this.dodatneKolone;
        return data;
    }
}

export interface IStavkaSifarnikaResponse {
    id: number;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    datumPocetkaVazenja: Date;
    datumPrestankaVazenja?: Date | undefined;
    dodatneKolone?: string | undefined;
}

export class DajStavkuSifarnikaPoSifriResponse implements IDajStavkuSifarnikaPoSifriResponse {
    id!: number;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    datumPocetkaVazenja!: Date;
    datumPrestankaVazenja?: Date | undefined;
    dodatneKolone?: string | undefined;
    sifarnikNaziv?: string | undefined;

    constructor(data?: IDajStavkuSifarnikaPoSifriResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusSifra = _data["statusSifra"];
            this.statusNaziv = _data["statusNaziv"];
            this.datumPocetkaVazenja = _data["datumPocetkaVazenja"] ? new Date(_data["datumPocetkaVazenja"].toString()) : <any>undefined;
            this.datumPrestankaVazenja = _data["datumPrestankaVazenja"] ? new Date(_data["datumPrestankaVazenja"].toString()) : <any>undefined;
            this.dodatneKolone = _data["dodatneKolone"];
            this.sifarnikNaziv = _data["sifarnikNaziv"];
        }
    }

    static fromJS(data: any): DajStavkuSifarnikaPoSifriResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajStavkuSifarnikaPoSifriResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusSifra"] = this.statusSifra;
        data["statusNaziv"] = this.statusNaziv;
        data["datumPocetkaVazenja"] = this.datumPocetkaVazenja ? this.datumPocetkaVazenja.toISOString() : <any>undefined;
        data["datumPrestankaVazenja"] = this.datumPrestankaVazenja ? this.datumPrestankaVazenja.toISOString() : <any>undefined;
        data["dodatneKolone"] = this.dodatneKolone;
        data["sifarnikNaziv"] = this.sifarnikNaziv;
        return data;
    }
}

export interface IDajStavkuSifarnikaPoSifriResponse {
    id: number;
    statusSifra?: string | undefined;
    statusNaziv?: string | undefined;
    datumPocetkaVazenja: Date;
    datumPrestankaVazenja?: Date | undefined;
    dodatneKolone?: string | undefined;
    sifarnikNaziv?: string | undefined;
}

export class SacuvajStavkuSifarnikaCommand implements ISacuvajStavkuSifarnikaCommand {
    id?: number | undefined;
    sifarnikSifra?: string | undefined;
    datumPocetkaVazenja!: Date;
    datumPrestankaVazenja?: Date | undefined;
    dodatneKolone?: string | undefined;

    constructor(data?: ISacuvajStavkuSifarnikaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifarnikSifra = _data["sifarnikSifra"];
            this.datumPocetkaVazenja = _data["datumPocetkaVazenja"] ? new Date(_data["datumPocetkaVazenja"].toString()) : <any>undefined;
            this.datumPrestankaVazenja = _data["datumPrestankaVazenja"] ? new Date(_data["datumPrestankaVazenja"].toString()) : <any>undefined;
            this.dodatneKolone = _data["dodatneKolone"];
        }
    }

    static fromJS(data: any): SacuvajStavkuSifarnikaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SacuvajStavkuSifarnikaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifarnikSifra"] = this.sifarnikSifra;
        data["datumPocetkaVazenja"] = this.datumPocetkaVazenja ? this.datumPocetkaVazenja.toISOString() : <any>undefined;
        data["datumPrestankaVazenja"] = this.datumPrestankaVazenja ? this.datumPrestankaVazenja.toISOString() : <any>undefined;
        data["dodatneKolone"] = this.dodatneKolone;
        return data;
    }
}

export interface ISacuvajStavkuSifarnikaCommand {
    id?: number | undefined;
    sifarnikSifra?: string | undefined;
    datumPocetkaVazenja: Date;
    datumPrestankaVazenja?: Date | undefined;
    dodatneKolone?: string | undefined;
}

export class ObrisiStavkuSifarnikaCommand implements IObrisiStavkuSifarnikaCommand {
    id!: number;

    constructor(data?: IObrisiStavkuSifarnikaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ObrisiStavkuSifarnikaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObrisiStavkuSifarnikaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IObrisiStavkuSifarnikaCommand {
    id: number;
}

export class SacuvajSvojstvoCommand implements ISacuvajSvojstvoCommand {
    id!: number;
    slozeniPojamSifra?: string | undefined;
    pojamUSastavuSifra?: string | undefined;
    suzeniTipId?: number | undefined;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    definicija?: string | undefined;
    dopunskoSvojstvo!: boolean;
    minBrojPojavljivanja?: string | undefined;
    maxBrojPojavljivanja?: string | undefined;
    sufiksNaziva?: string | undefined;
    punNazivSvojstvaURecniku?: string | undefined;
    skupVrednostiOgranicen!: boolean;
    svojstvoSifarnickogPojmaId?: number | undefined;
    jeKvalifikator!: boolean;
    skupVrednostiOgranicenDrugimSifarnikom!: boolean;
    sifarnikSifra?: string | undefined;
    elementSifarnikaSifra?: string | undefined;
    defaultVrednost?: string | undefined;
    svojstvaTipaKojaDodeljujemoPojmu?: SvojstvoTipaKojaDodeljujemoPojmu[] | undefined;

    constructor(data?: ISacuvajSvojstvoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.slozeniPojamSifra = _data["slozeniPojamSifra"];
            this.pojamUSastavuSifra = _data["pojamUSastavuSifra"];
            this.suzeniTipId = _data["suzeniTipId"];
            this.naziv = _data["naziv"];
            this.tehnickiNaziv = _data["tehnickiNaziv"];
            this.definicija = _data["definicija"];
            this.dopunskoSvojstvo = _data["dopunskoSvojstvo"];
            this.minBrojPojavljivanja = _data["minBrojPojavljivanja"];
            this.maxBrojPojavljivanja = _data["maxBrojPojavljivanja"];
            this.sufiksNaziva = _data["sufiksNaziva"];
            this.punNazivSvojstvaURecniku = _data["punNazivSvojstvaURecniku"];
            this.skupVrednostiOgranicen = _data["skupVrednostiOgranicen"];
            this.svojstvoSifarnickogPojmaId = _data["svojstvoSifarnickogPojmaId"];
            this.jeKvalifikator = _data["jeKvalifikator"];
            this.skupVrednostiOgranicenDrugimSifarnikom = _data["skupVrednostiOgranicenDrugimSifarnikom"];
            this.sifarnikSifra = _data["sifarnikSifra"];
            this.elementSifarnikaSifra = _data["elementSifarnikaSifra"];
            this.defaultVrednost = _data["defaultVrednost"];
            if (Array.isArray(_data["svojstvaTipaKojaDodeljujemoPojmu"])) {
                this.svojstvaTipaKojaDodeljujemoPojmu = [] as any;
                for (let item of _data["svojstvaTipaKojaDodeljujemoPojmu"])
                    this.svojstvaTipaKojaDodeljujemoPojmu!.push(SvojstvoTipaKojaDodeljujemoPojmu.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SacuvajSvojstvoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SacuvajSvojstvoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slozeniPojamSifra"] = this.slozeniPojamSifra;
        data["pojamUSastavuSifra"] = this.pojamUSastavuSifra;
        data["suzeniTipId"] = this.suzeniTipId;
        data["naziv"] = this.naziv;
        data["tehnickiNaziv"] = this.tehnickiNaziv;
        data["definicija"] = this.definicija;
        data["dopunskoSvojstvo"] = this.dopunskoSvojstvo;
        data["minBrojPojavljivanja"] = this.minBrojPojavljivanja;
        data["maxBrojPojavljivanja"] = this.maxBrojPojavljivanja;
        data["sufiksNaziva"] = this.sufiksNaziva;
        data["punNazivSvojstvaURecniku"] = this.punNazivSvojstvaURecniku;
        data["skupVrednostiOgranicen"] = this.skupVrednostiOgranicen;
        data["svojstvoSifarnickogPojmaId"] = this.svojstvoSifarnickogPojmaId;
        data["jeKvalifikator"] = this.jeKvalifikator;
        data["skupVrednostiOgranicenDrugimSifarnikom"] = this.skupVrednostiOgranicenDrugimSifarnikom;
        data["sifarnikSifra"] = this.sifarnikSifra;
        data["elementSifarnikaSifra"] = this.elementSifarnikaSifra;
        data["defaultVrednost"] = this.defaultVrednost;
        if (Array.isArray(this.svojstvaTipaKojaDodeljujemoPojmu)) {
            data["svojstvaTipaKojaDodeljujemoPojmu"] = [];
            for (let item of this.svojstvaTipaKojaDodeljujemoPojmu)
                data["svojstvaTipaKojaDodeljujemoPojmu"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISacuvajSvojstvoCommand {
    id: number;
    slozeniPojamSifra?: string | undefined;
    pojamUSastavuSifra?: string | undefined;
    suzeniTipId?: number | undefined;
    naziv?: string | undefined;
    tehnickiNaziv?: string | undefined;
    definicija?: string | undefined;
    dopunskoSvojstvo: boolean;
    minBrojPojavljivanja?: string | undefined;
    maxBrojPojavljivanja?: string | undefined;
    sufiksNaziva?: string | undefined;
    punNazivSvojstvaURecniku?: string | undefined;
    skupVrednostiOgranicen: boolean;
    svojstvoSifarnickogPojmaId?: number | undefined;
    jeKvalifikator: boolean;
    skupVrednostiOgranicenDrugimSifarnikom: boolean;
    sifarnikSifra?: string | undefined;
    elementSifarnikaSifra?: string | undefined;
    defaultVrednost?: string | undefined;
    svojstvaTipaKojaDodeljujemoPojmu?: SvojstvoTipaKojaDodeljujemoPojmu[] | undefined;
}

export class SvojstvoTipaKojaDodeljujemoPojmu implements ISvojstvoTipaKojaDodeljujemoPojmu {
    id!: number;
    nadredjeniId?: number | undefined;
    putanjaIzTipa?: string | undefined;

    constructor(data?: ISvojstvoTipaKojaDodeljujemoPojmu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nadredjeniId = _data["nadredjeniId"];
            this.putanjaIzTipa = _data["putanjaIzTipa"];
        }
    }

    static fromJS(data: any): SvojstvoTipaKojaDodeljujemoPojmu {
        data = typeof data === 'object' ? data : {};
        let result = new SvojstvoTipaKojaDodeljujemoPojmu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nadredjeniId"] = this.nadredjeniId;
        data["putanjaIzTipa"] = this.putanjaIzTipa;
        return data;
    }
}

export interface ISvojstvoTipaKojaDodeljujemoPojmu {
    id: number;
    nadredjeniId?: number | undefined;
    putanjaIzTipa?: string | undefined;
}

export class DajSvojstvaPojmaResponse implements IDajSvojstvaPojmaResponse {
    svojstvaPojma?: SvojstvoPojmaShort[] | undefined;

    constructor(data?: IDajSvojstvaPojmaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["svojstvaPojma"])) {
                this.svojstvaPojma = [] as any;
                for (let item of _data["svojstvaPojma"])
                    this.svojstvaPojma!.push(SvojstvoPojmaShort.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DajSvojstvaPojmaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajSvojstvaPojmaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.svojstvaPojma)) {
            data["svojstvaPojma"] = [];
            for (let item of this.svojstvaPojma)
                data["svojstvaPojma"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDajSvojstvaPojmaResponse {
    svojstvaPojma?: SvojstvoPojmaShort[] | undefined;
}

export class SvojstvoPojmaShort implements ISvojstvoPojmaShort {
    redniBroj!: number;
    id!: number;
    sifraPojma?: string | undefined;
    nazivPojma?: string | undefined;
    nazivSvojstva?: string | undefined;
    tehnickiNaziv?: string | undefined;
    nazivTipaPodatka?: string | undefined;
    putanja?: string | undefined;
    putanjaIzTipa?: string | undefined;
    definicija?: string | undefined;
    slozeniPojamId!: number;
    slozeniPojamNaziv?: string | undefined;
    pojamUSastavuId!: number;
    pojamUSastavuNaziv?: string | undefined;
    pojamUSastavuVrstaTipaId!: number;
    nadredjenoSvojstvoId?: number | undefined;
    nadredjenoSuzenoSvojstvoId?: number | undefined;
    dopunskoSvojstvo!: boolean;
    kardinalnost?: string | undefined;
    minBrojPojavljivanja?: string | undefined;
    maxBrojPojavljivanja?: string | undefined;
    minBrojPojavljivanjaIzvedenogIz?: string | undefined;
    maxBrojPojavljivanjaIzvedenogIz?: string | undefined;
    sufiksNaziva?: string | undefined;
    punNazivTipaURecniku?: string | undefined;
    suzeniTipId?: number | undefined;
    suzeniTipNaziv?: string | undefined;
    vrstaTipaId!: number;
    skupVrednostiOgranicen!: boolean;
    svojstvoSifarnickogPojmaId?: number | undefined;
    svojstvoSifarnickogPojmaNaziv?: string | undefined;
    nazivSifarnika?: string | undefined;
    elementSifarnika?: string | undefined;
    jeKvalifikator!: boolean;
    statusId!: number;
    statusSvojstvaNaziv?: string | undefined;
    zaDeaktivaciju?: boolean | undefined;
    statusNaTipuId!: number;
    skupVrednostiOgranicenDrugimSifarnikom!: boolean;
    sifarnikSifra?: string | undefined;
    elementSifarnikaSifra?: string | undefined;
    jeElement!: boolean;
    punNazivSvojstvaURecniku?: string | undefined;
    putanjaNadredjenogSvojstva?: string | undefined;
    defaultVrednost?: string | undefined;

    constructor(data?: ISvojstvoPojmaShort) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.redniBroj = _data["redniBroj"];
            this.id = _data["id"];
            this.sifraPojma = _data["sifraPojma"];
            this.nazivPojma = _data["nazivPojma"];
            this.nazivSvojstva = _data["nazivSvojstva"];
            this.tehnickiNaziv = _data["tehnickiNaziv"];
            this.nazivTipaPodatka = _data["nazivTipaPodatka"];
            this.putanja = _data["putanja"];
            this.putanjaIzTipa = _data["putanjaIzTipa"];
            this.definicija = _data["definicija"];
            this.slozeniPojamId = _data["slozeniPojamId"];
            this.slozeniPojamNaziv = _data["slozeniPojamNaziv"];
            this.pojamUSastavuId = _data["pojamUSastavuId"];
            this.pojamUSastavuNaziv = _data["pojamUSastavuNaziv"];
            this.pojamUSastavuVrstaTipaId = _data["pojamUSastavuVrstaTipaId"];
            this.nadredjenoSvojstvoId = _data["nadredjenoSvojstvoId"];
            this.nadredjenoSuzenoSvojstvoId = _data["nadredjenoSuzenoSvojstvoId"];
            this.dopunskoSvojstvo = _data["dopunskoSvojstvo"];
            this.kardinalnost = _data["kardinalnost"];
            this.minBrojPojavljivanja = _data["minBrojPojavljivanja"];
            this.maxBrojPojavljivanja = _data["maxBrojPojavljivanja"];
            this.minBrojPojavljivanjaIzvedenogIz = _data["minBrojPojavljivanjaIzvedenogIz"];
            this.maxBrojPojavljivanjaIzvedenogIz = _data["maxBrojPojavljivanjaIzvedenogIz"];
            this.sufiksNaziva = _data["sufiksNaziva"];
            this.punNazivTipaURecniku = _data["punNazivTipaURecniku"];
            this.suzeniTipId = _data["suzeniTipId"];
            this.suzeniTipNaziv = _data["suzeniTipNaziv"];
            this.vrstaTipaId = _data["vrstaTipaId"];
            this.skupVrednostiOgranicen = _data["skupVrednostiOgranicen"];
            this.svojstvoSifarnickogPojmaId = _data["svojstvoSifarnickogPojmaId"];
            this.svojstvoSifarnickogPojmaNaziv = _data["svojstvoSifarnickogPojmaNaziv"];
            this.nazivSifarnika = _data["nazivSifarnika"];
            this.elementSifarnika = _data["elementSifarnika"];
            this.jeKvalifikator = _data["jeKvalifikator"];
            this.statusId = _data["statusId"];
            this.statusSvojstvaNaziv = _data["statusSvojstvaNaziv"];
            this.zaDeaktivaciju = _data["zaDeaktivaciju"];
            this.statusNaTipuId = _data["statusNaTipuId"];
            this.skupVrednostiOgranicenDrugimSifarnikom = _data["skupVrednostiOgranicenDrugimSifarnikom"];
            this.sifarnikSifra = _data["sifarnikSifra"];
            this.elementSifarnikaSifra = _data["elementSifarnikaSifra"];
            this.jeElement = _data["jeElement"];
            this.punNazivSvojstvaURecniku = _data["punNazivSvojstvaURecniku"];
            this.putanjaNadredjenogSvojstva = _data["putanjaNadredjenogSvojstva"];
            this.defaultVrednost = _data["defaultVrednost"];
        }
    }

    static fromJS(data: any): SvojstvoPojmaShort {
        data = typeof data === 'object' ? data : {};
        let result = new SvojstvoPojmaShort();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redniBroj"] = this.redniBroj;
        data["id"] = this.id;
        data["sifraPojma"] = this.sifraPojma;
        data["nazivPojma"] = this.nazivPojma;
        data["nazivSvojstva"] = this.nazivSvojstva;
        data["tehnickiNaziv"] = this.tehnickiNaziv;
        data["nazivTipaPodatka"] = this.nazivTipaPodatka;
        data["putanja"] = this.putanja;
        data["putanjaIzTipa"] = this.putanjaIzTipa;
        data["definicija"] = this.definicija;
        data["slozeniPojamId"] = this.slozeniPojamId;
        data["slozeniPojamNaziv"] = this.slozeniPojamNaziv;
        data["pojamUSastavuId"] = this.pojamUSastavuId;
        data["pojamUSastavuNaziv"] = this.pojamUSastavuNaziv;
        data["pojamUSastavuVrstaTipaId"] = this.pojamUSastavuVrstaTipaId;
        data["nadredjenoSvojstvoId"] = this.nadredjenoSvojstvoId;
        data["nadredjenoSuzenoSvojstvoId"] = this.nadredjenoSuzenoSvojstvoId;
        data["dopunskoSvojstvo"] = this.dopunskoSvojstvo;
        data["kardinalnost"] = this.kardinalnost;
        data["minBrojPojavljivanja"] = this.minBrojPojavljivanja;
        data["maxBrojPojavljivanja"] = this.maxBrojPojavljivanja;
        data["minBrojPojavljivanjaIzvedenogIz"] = this.minBrojPojavljivanjaIzvedenogIz;
        data["maxBrojPojavljivanjaIzvedenogIz"] = this.maxBrojPojavljivanjaIzvedenogIz;
        data["sufiksNaziva"] = this.sufiksNaziva;
        data["punNazivTipaURecniku"] = this.punNazivTipaURecniku;
        data["suzeniTipId"] = this.suzeniTipId;
        data["suzeniTipNaziv"] = this.suzeniTipNaziv;
        data["vrstaTipaId"] = this.vrstaTipaId;
        data["skupVrednostiOgranicen"] = this.skupVrednostiOgranicen;
        data["svojstvoSifarnickogPojmaId"] = this.svojstvoSifarnickogPojmaId;
        data["svojstvoSifarnickogPojmaNaziv"] = this.svojstvoSifarnickogPojmaNaziv;
        data["nazivSifarnika"] = this.nazivSifarnika;
        data["elementSifarnika"] = this.elementSifarnika;
        data["jeKvalifikator"] = this.jeKvalifikator;
        data["statusId"] = this.statusId;
        data["statusSvojstvaNaziv"] = this.statusSvojstvaNaziv;
        data["zaDeaktivaciju"] = this.zaDeaktivaciju;
        data["statusNaTipuId"] = this.statusNaTipuId;
        data["skupVrednostiOgranicenDrugimSifarnikom"] = this.skupVrednostiOgranicenDrugimSifarnikom;
        data["sifarnikSifra"] = this.sifarnikSifra;
        data["elementSifarnikaSifra"] = this.elementSifarnikaSifra;
        data["jeElement"] = this.jeElement;
        data["punNazivSvojstvaURecniku"] = this.punNazivSvojstvaURecniku;
        data["putanjaNadredjenogSvojstva"] = this.putanjaNadredjenogSvojstva;
        data["defaultVrednost"] = this.defaultVrednost;
        return data;
    }
}

export interface ISvojstvoPojmaShort {
    redniBroj: number;
    id: number;
    sifraPojma?: string | undefined;
    nazivPojma?: string | undefined;
    nazivSvojstva?: string | undefined;
    tehnickiNaziv?: string | undefined;
    nazivTipaPodatka?: string | undefined;
    putanja?: string | undefined;
    putanjaIzTipa?: string | undefined;
    definicija?: string | undefined;
    slozeniPojamId: number;
    slozeniPojamNaziv?: string | undefined;
    pojamUSastavuId: number;
    pojamUSastavuNaziv?: string | undefined;
    pojamUSastavuVrstaTipaId: number;
    nadredjenoSvojstvoId?: number | undefined;
    nadredjenoSuzenoSvojstvoId?: number | undefined;
    dopunskoSvojstvo: boolean;
    kardinalnost?: string | undefined;
    minBrojPojavljivanja?: string | undefined;
    maxBrojPojavljivanja?: string | undefined;
    minBrojPojavljivanjaIzvedenogIz?: string | undefined;
    maxBrojPojavljivanjaIzvedenogIz?: string | undefined;
    sufiksNaziva?: string | undefined;
    punNazivTipaURecniku?: string | undefined;
    suzeniTipId?: number | undefined;
    suzeniTipNaziv?: string | undefined;
    vrstaTipaId: number;
    skupVrednostiOgranicen: boolean;
    svojstvoSifarnickogPojmaId?: number | undefined;
    svojstvoSifarnickogPojmaNaziv?: string | undefined;
    nazivSifarnika?: string | undefined;
    elementSifarnika?: string | undefined;
    jeKvalifikator: boolean;
    statusId: number;
    statusSvojstvaNaziv?: string | undefined;
    zaDeaktivaciju?: boolean | undefined;
    statusNaTipuId: number;
    skupVrednostiOgranicenDrugimSifarnikom: boolean;
    sifarnikSifra?: string | undefined;
    elementSifarnikaSifra?: string | undefined;
    jeElement: boolean;
    punNazivSvojstvaURecniku?: string | undefined;
    putanjaNadredjenogSvojstva?: string | undefined;
    defaultVrednost?: string | undefined;
}

export class DajSvojstvaTipaZaStabloResponse implements IDajSvojstvaTipaZaStabloResponse {
    id!: number;
    sifraPojma?: string | undefined;
    nazivSvojstva?: string | undefined;
    putanja?: string | undefined;
    putanjaNadredjenogSvojstva?: string | undefined;
    pojamUSastavuId!: number;
    pojamUSastavuVrstaTipaId!: number;
    pojamUSastavuNaziv?: string | undefined;
    pojamUSastavuIzvedenIzId?: number | undefined;
    slozeniPojamId!: number;
    slozeniPojamNaziv?: string | undefined;
    statusId!: number;
    nadredjenoSvojstvoId?: number | undefined;
    redniBroj!: number;

    constructor(data?: IDajSvojstvaTipaZaStabloResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sifraPojma = _data["sifraPojma"];
            this.nazivSvojstva = _data["nazivSvojstva"];
            this.putanja = _data["putanja"];
            this.putanjaNadredjenogSvojstva = _data["putanjaNadredjenogSvojstva"];
            this.pojamUSastavuId = _data["pojamUSastavuId"];
            this.pojamUSastavuVrstaTipaId = _data["pojamUSastavuVrstaTipaId"];
            this.pojamUSastavuNaziv = _data["pojamUSastavuNaziv"];
            this.pojamUSastavuIzvedenIzId = _data["pojamUSastavuIzvedenIzId"];
            this.slozeniPojamId = _data["slozeniPojamId"];
            this.slozeniPojamNaziv = _data["slozeniPojamNaziv"];
            this.statusId = _data["statusId"];
            this.nadredjenoSvojstvoId = _data["nadredjenoSvojstvoId"];
            this.redniBroj = _data["redniBroj"];
        }
    }

    static fromJS(data: any): DajSvojstvaTipaZaStabloResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajSvojstvaTipaZaStabloResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sifraPojma"] = this.sifraPojma;
        data["nazivSvojstva"] = this.nazivSvojstva;
        data["putanja"] = this.putanja;
        data["putanjaNadredjenogSvojstva"] = this.putanjaNadredjenogSvojstva;
        data["pojamUSastavuId"] = this.pojamUSastavuId;
        data["pojamUSastavuVrstaTipaId"] = this.pojamUSastavuVrstaTipaId;
        data["pojamUSastavuNaziv"] = this.pojamUSastavuNaziv;
        data["pojamUSastavuIzvedenIzId"] = this.pojamUSastavuIzvedenIzId;
        data["slozeniPojamId"] = this.slozeniPojamId;
        data["slozeniPojamNaziv"] = this.slozeniPojamNaziv;
        data["statusId"] = this.statusId;
        data["nadredjenoSvojstvoId"] = this.nadredjenoSvojstvoId;
        data["redniBroj"] = this.redniBroj;
        return data;
    }
}

export interface IDajSvojstvaTipaZaStabloResponse {
    id: number;
    sifraPojma?: string | undefined;
    nazivSvojstva?: string | undefined;
    putanja?: string | undefined;
    putanjaNadredjenogSvojstva?: string | undefined;
    pojamUSastavuId: number;
    pojamUSastavuVrstaTipaId: number;
    pojamUSastavuNaziv?: string | undefined;
    pojamUSastavuIzvedenIzId?: number | undefined;
    slozeniPojamId: number;
    slozeniPojamNaziv?: string | undefined;
    statusId: number;
    nadredjenoSvojstvoId?: number | undefined;
    redniBroj: number;
}

export class DajSvojstvaPojmaZaListuResponse implements IDajSvojstvaPojmaZaListuResponse {
    svojstvaPojma?: SvojstvoPojmaZaListuResponse[] | undefined;
    svojstvaOsnovnogPojma?: SvojstvoPojmaZaListuResponse[] | undefined;
    nasledjeniPojmovi?: number[] | undefined;

    constructor(data?: IDajSvojstvaPojmaZaListuResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["svojstvaPojma"])) {
                this.svojstvaPojma = [] as any;
                for (let item of _data["svojstvaPojma"])
                    this.svojstvaPojma!.push(SvojstvoPojmaZaListuResponse.fromJS(item));
            }
            if (Array.isArray(_data["svojstvaOsnovnogPojma"])) {
                this.svojstvaOsnovnogPojma = [] as any;
                for (let item of _data["svojstvaOsnovnogPojma"])
                    this.svojstvaOsnovnogPojma!.push(SvojstvoPojmaZaListuResponse.fromJS(item));
            }
            if (Array.isArray(_data["nasledjeniPojmovi"])) {
                this.nasledjeniPojmovi = [] as any;
                for (let item of _data["nasledjeniPojmovi"])
                    this.nasledjeniPojmovi!.push(item);
            }
        }
    }

    static fromJS(data: any): DajSvojstvaPojmaZaListuResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DajSvojstvaPojmaZaListuResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.svojstvaPojma)) {
            data["svojstvaPojma"] = [];
            for (let item of this.svojstvaPojma)
                data["svojstvaPojma"].push(item.toJSON());
        }
        if (Array.isArray(this.svojstvaOsnovnogPojma)) {
            data["svojstvaOsnovnogPojma"] = [];
            for (let item of this.svojstvaOsnovnogPojma)
                data["svojstvaOsnovnogPojma"].push(item.toJSON());
        }
        if (Array.isArray(this.nasledjeniPojmovi)) {
            data["nasledjeniPojmovi"] = [];
            for (let item of this.nasledjeniPojmovi)
                data["nasledjeniPojmovi"].push(item);
        }
        return data;
    }
}

export interface IDajSvojstvaPojmaZaListuResponse {
    svojstvaPojma?: SvojstvoPojmaZaListuResponse[] | undefined;
    svojstvaOsnovnogPojma?: SvojstvoPojmaZaListuResponse[] | undefined;
    nasledjeniPojmovi?: number[] | undefined;
}

export class SvojstvoPojmaZaListuResponse implements ISvojstvoPojmaZaListuResponse {
    id!: number;
    slozeniPojamId!: number;
    nazivSvojstva?: string | undefined;
    nazivTipaPodatka?: string | undefined;
    putanjaIzTipa?: string | undefined;
    definicija?: string | undefined;
    pojamUSastavuNaziv?: string | undefined;
    pojamUSastavuVrstaTipaId!: number;
    dopunskoSvojstvo!: boolean;
    kardinalnost?: string | undefined;
    skupVrednostiOgranicen!: boolean;
    statusId!: number;
    statusSvojstvaNaziv?: string | undefined;
    zaDeaktivaciju?: boolean | undefined;
    defaultVrednost?: string | undefined;
    redniBroj!: number;
    nadredjenoSvojstvoId?: number | undefined;
    putanja?: string | undefined;
    suzeniTipNaziv?: string | undefined;
    punNazivTipaURecniku?: string | undefined;

    constructor(data?: ISvojstvoPojmaZaListuResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.slozeniPojamId = _data["slozeniPojamId"];
            this.nazivSvojstva = _data["nazivSvojstva"];
            this.nazivTipaPodatka = _data["nazivTipaPodatka"];
            this.putanjaIzTipa = _data["putanjaIzTipa"];
            this.definicija = _data["definicija"];
            this.pojamUSastavuNaziv = _data["pojamUSastavuNaziv"];
            this.pojamUSastavuVrstaTipaId = _data["pojamUSastavuVrstaTipaId"];
            this.dopunskoSvojstvo = _data["dopunskoSvojstvo"];
            this.kardinalnost = _data["kardinalnost"];
            this.skupVrednostiOgranicen = _data["skupVrednostiOgranicen"];
            this.statusId = _data["statusId"];
            this.statusSvojstvaNaziv = _data["statusSvojstvaNaziv"];
            this.zaDeaktivaciju = _data["zaDeaktivaciju"];
            this.defaultVrednost = _data["defaultVrednost"];
            this.redniBroj = _data["redniBroj"];
            this.nadredjenoSvojstvoId = _data["nadredjenoSvojstvoId"];
            this.putanja = _data["putanja"];
            this.suzeniTipNaziv = _data["suzeniTipNaziv"];
            this.punNazivTipaURecniku = _data["punNazivTipaURecniku"];
        }
    }

    static fromJS(data: any): SvojstvoPojmaZaListuResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SvojstvoPojmaZaListuResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slozeniPojamId"] = this.slozeniPojamId;
        data["nazivSvojstva"] = this.nazivSvojstva;
        data["nazivTipaPodatka"] = this.nazivTipaPodatka;
        data["putanjaIzTipa"] = this.putanjaIzTipa;
        data["definicija"] = this.definicija;
        data["pojamUSastavuNaziv"] = this.pojamUSastavuNaziv;
        data["pojamUSastavuVrstaTipaId"] = this.pojamUSastavuVrstaTipaId;
        data["dopunskoSvojstvo"] = this.dopunskoSvojstvo;
        data["kardinalnost"] = this.kardinalnost;
        data["skupVrednostiOgranicen"] = this.skupVrednostiOgranicen;
        data["statusId"] = this.statusId;
        data["statusSvojstvaNaziv"] = this.statusSvojstvaNaziv;
        data["zaDeaktivaciju"] = this.zaDeaktivaciju;
        data["defaultVrednost"] = this.defaultVrednost;
        data["redniBroj"] = this.redniBroj;
        data["nadredjenoSvojstvoId"] = this.nadredjenoSvojstvoId;
        data["putanja"] = this.putanja;
        data["suzeniTipNaziv"] = this.suzeniTipNaziv;
        data["punNazivTipaURecniku"] = this.punNazivTipaURecniku;
        return data;
    }
}

export interface ISvojstvoPojmaZaListuResponse {
    id: number;
    slozeniPojamId: number;
    nazivSvojstva?: string | undefined;
    nazivTipaPodatka?: string | undefined;
    putanjaIzTipa?: string | undefined;
    definicija?: string | undefined;
    pojamUSastavuNaziv?: string | undefined;
    pojamUSastavuVrstaTipaId: number;
    dopunskoSvojstvo: boolean;
    kardinalnost?: string | undefined;
    skupVrednostiOgranicen: boolean;
    statusId: number;
    statusSvojstvaNaziv?: string | undefined;
    zaDeaktivaciju?: boolean | undefined;
    defaultVrednost?: string | undefined;
    redniBroj: number;
    nadredjenoSvojstvoId?: number | undefined;
    putanja?: string | undefined;
    suzeniTipNaziv?: string | undefined;
    punNazivTipaURecniku?: string | undefined;
}

export class ObrisiSvojstvoCommand implements IObrisiSvojstvoCommand {
    idSlozenogPojma!: number;
    idSvojstva!: number;

    constructor(data?: IObrisiSvojstvoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idSlozenogPojma = _data["idSlozenogPojma"];
            this.idSvojstva = _data["idSvojstva"];
        }
    }

    static fromJS(data: any): ObrisiSvojstvoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObrisiSvojstvoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idSlozenogPojma"] = this.idSlozenogPojma;
        data["idSvojstva"] = this.idSvojstva;
        return data;
    }
}

export interface IObrisiSvojstvoCommand {
    idSlozenogPojma: number;
    idSvojstva: number;
}

export class DeaktivirajSvojstvoCommand implements IDeaktivirajSvojstvoCommand {
    idSlozenogPojma!: number;
    idSvojstva!: number;

    constructor(data?: IDeaktivirajSvojstvoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idSlozenogPojma = _data["idSlozenogPojma"];
            this.idSvojstva = _data["idSvojstva"];
        }
    }

    static fromJS(data: any): DeaktivirajSvojstvoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeaktivirajSvojstvoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idSlozenogPojma"] = this.idSlozenogPojma;
        data["idSvojstva"] = this.idSvojstva;
        return data;
    }
}

export interface IDeaktivirajSvojstvoCommand {
    idSlozenogPojma: number;
    idSvojstva: number;
}

export class ReaktivirajSvojstvoCommand implements IReaktivirajSvojstvoCommand {
    idSlozenogPojma!: number;
    idSvojstva!: number;

    constructor(data?: IReaktivirajSvojstvoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idSlozenogPojma = _data["idSlozenogPojma"];
            this.idSvojstva = _data["idSvojstva"];
        }
    }

    static fromJS(data: any): ReaktivirajSvojstvoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReaktivirajSvojstvoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idSlozenogPojma"] = this.idSlozenogPojma;
        data["idSvojstva"] = this.idSvojstva;
        return data;
    }
}

export interface IReaktivirajSvojstvoCommand {
    idSlozenogPojma: number;
    idSvojstva: number;
}

export class ObjaviSvojstvaPojmaCommand implements IObjaviSvojstvaPojmaCommand {
    idPojma!: number;
    domenId!: number;
    definicija?: string | undefined;
    kljucneReci?: KljucnaRecCmd[] | undefined;

    constructor(data?: IObjaviSvojstvaPojmaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPojma = _data["idPojma"];
            this.domenId = _data["domenId"];
            this.definicija = _data["definicija"];
            if (Array.isArray(_data["kljucneReci"])) {
                this.kljucneReci = [] as any;
                for (let item of _data["kljucneReci"])
                    this.kljucneReci!.push(KljucnaRecCmd.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ObjaviSvojstvaPojmaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ObjaviSvojstvaPojmaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPojma"] = this.idPojma;
        data["domenId"] = this.domenId;
        data["definicija"] = this.definicija;
        if (Array.isArray(this.kljucneReci)) {
            data["kljucneReci"] = [];
            for (let item of this.kljucneReci)
                data["kljucneReci"].push(item.toJSON());
        }
        return data;
    }
}

export interface IObjaviSvojstvaPojmaCommand {
    idPojma: number;
    domenId: number;
    definicija?: string | undefined;
    kljucneReci?: KljucnaRecCmd[] | undefined;
}

export class DuplikacijaSvojstvaPojmaCommand extends SacuvajSvojstvoCommand implements IDuplikacijaSvojstvaPojmaCommand {

    constructor(data?: IDuplikacijaSvojstvaPojmaCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DuplikacijaSvojstvaPojmaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DuplikacijaSvojstvaPojmaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDuplikacijaSvojstvaPojmaCommand extends ISacuvajSvojstvoCommand {
}

export class DodajSvojstvaTipaNaPojamKaoPodstabloCommand implements IDodajSvojstvaTipaNaPojamKaoPodstabloCommand {
    pripadaId!: number;
    rootSvojstvoId!: number;
    svojstvaTipaKojaDodeljujemoPojmu?: SvojstvoTipaKojaDodeljujemoPojmu[] | undefined;

    constructor(data?: IDodajSvojstvaTipaNaPojamKaoPodstabloCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pripadaId = _data["pripadaId"];
            this.rootSvojstvoId = _data["rootSvojstvoId"];
            if (Array.isArray(_data["svojstvaTipaKojaDodeljujemoPojmu"])) {
                this.svojstvaTipaKojaDodeljujemoPojmu = [] as any;
                for (let item of _data["svojstvaTipaKojaDodeljujemoPojmu"])
                    this.svojstvaTipaKojaDodeljujemoPojmu!.push(SvojstvoTipaKojaDodeljujemoPojmu.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DodajSvojstvaTipaNaPojamKaoPodstabloCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DodajSvojstvaTipaNaPojamKaoPodstabloCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pripadaId"] = this.pripadaId;
        data["rootSvojstvoId"] = this.rootSvojstvoId;
        if (Array.isArray(this.svojstvaTipaKojaDodeljujemoPojmu)) {
            data["svojstvaTipaKojaDodeljujemoPojmu"] = [];
            for (let item of this.svojstvaTipaKojaDodeljujemoPojmu)
                data["svojstvaTipaKojaDodeljujemoPojmu"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDodajSvojstvaTipaNaPojamKaoPodstabloCommand {
    pripadaId: number;
    rootSvojstvoId: number;
    svojstvaTipaKojaDodeljujemoPojmu?: SvojstvoTipaKojaDodeljujemoPojmu[] | undefined;
}

export class ZamenaRednihBrojevaSvojstavaCommand implements IZamenaRednihBrojevaSvojstavaCommand {
    gornjeSvojstvoId!: number;
    donjeSvojstvoId!: number;

    constructor(data?: IZamenaRednihBrojevaSvojstavaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gornjeSvojstvoId = _data["gornjeSvojstvoId"];
            this.donjeSvojstvoId = _data["donjeSvojstvoId"];
        }
    }

    static fromJS(data: any): ZamenaRednihBrojevaSvojstavaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ZamenaRednihBrojevaSvojstavaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gornjeSvojstvoId"] = this.gornjeSvojstvoId;
        data["donjeSvojstvoId"] = this.donjeSvojstvoId;
        return data;
    }
}

export interface IZamenaRednihBrojevaSvojstavaCommand {
    gornjeSvojstvoId: number;
    donjeSvojstvoId: number;
}

export class SvojstvoZaStabloResponse implements ISvojstvoZaStabloResponse {
    id!: number;
    pojamUSastavuId!: number;
    nazivSvojstva?: string | undefined;
    vrstaTipaPojmaUSastavuId!: number;
    putanja?: string | undefined;
    putanjaNadredjenog?: string | undefined;
    statusId!: number;

    constructor(data?: ISvojstvoZaStabloResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pojamUSastavuId = _data["pojamUSastavuId"];
            this.nazivSvojstva = _data["nazivSvojstva"];
            this.vrstaTipaPojmaUSastavuId = _data["vrstaTipaPojmaUSastavuId"];
            this.putanja = _data["putanja"];
            this.putanjaNadredjenog = _data["putanjaNadredjenog"];
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): SvojstvoZaStabloResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SvojstvoZaStabloResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pojamUSastavuId"] = this.pojamUSastavuId;
        data["nazivSvojstva"] = this.nazivSvojstva;
        data["vrstaTipaPojmaUSastavuId"] = this.vrstaTipaPojmaUSastavuId;
        data["putanja"] = this.putanja;
        data["putanjaNadredjenog"] = this.putanjaNadredjenog;
        data["statusId"] = this.statusId;
        return data;
    }
}

export interface ISvojstvoZaStabloResponse {
    id: number;
    pojamUSastavuId: number;
    nazivSvojstva?: string | undefined;
    vrstaTipaPojmaUSastavuId: number;
    putanja?: string | undefined;
    putanjaNadredjenog?: string | undefined;
    statusId: number;
}

export class SvojstvoZaStabloZaIzborResponse implements ISvojstvoZaStabloZaIzborResponse {
    id!: number;
    pojamUSastavuId!: number;
    nazivSvojstva?: string | undefined;
    nazivSvojstvaSaTipom?: string | undefined;
    vrstaTipaPojmaUSastavuId!: number;
    tipAgregacijeId!: number;
    putanja?: string | undefined;
    putanjaNadredjenog?: string | undefined;

    constructor(data?: ISvojstvoZaStabloZaIzborResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pojamUSastavuId = _data["pojamUSastavuId"];
            this.nazivSvojstva = _data["nazivSvojstva"];
            this.nazivSvojstvaSaTipom = _data["nazivSvojstvaSaTipom"];
            this.vrstaTipaPojmaUSastavuId = _data["vrstaTipaPojmaUSastavuId"];
            this.tipAgregacijeId = _data["tipAgregacijeId"];
            this.putanja = _data["putanja"];
            this.putanjaNadredjenog = _data["putanjaNadredjenog"];
        }
    }

    static fromJS(data: any): SvojstvoZaStabloZaIzborResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SvojstvoZaStabloZaIzborResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pojamUSastavuId"] = this.pojamUSastavuId;
        data["nazivSvojstva"] = this.nazivSvojstva;
        data["nazivSvojstvaSaTipom"] = this.nazivSvojstvaSaTipom;
        data["vrstaTipaPojmaUSastavuId"] = this.vrstaTipaPojmaUSastavuId;
        data["tipAgregacijeId"] = this.tipAgregacijeId;
        data["putanja"] = this.putanja;
        data["putanjaNadredjenog"] = this.putanjaNadredjenog;
        return data;
    }
}

export interface ISvojstvoZaStabloZaIzborResponse {
    id: number;
    pojamUSastavuId: number;
    nazivSvojstva?: string | undefined;
    nazivSvojstvaSaTipom?: string | undefined;
    vrstaTipaPojmaUSastavuId: number;
    tipAgregacijeId: number;
    putanja?: string | undefined;
    putanjaNadredjenog?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}